import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
class TypeDeclaration_TriggerDataType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "UNIT": return 101;
        case "ABILITY": return 201;
        case "WEAPON": return 301;
        case "BEHAVIOR": return 401;
        case "EFFECT": return 501;
        case "AREA_SEARCH_EFFECT": return 502;
        case "EXPRESSION": return 601;
        case "VALIDATOR": return 701;
        case "MOVER": return 801;
        case "ACTOR": return 901;
        case "UNIT_ACTOR": return 902;
        case "SITE_OPERATION": return 903;
        case "ACTOR_EVENT_MACRO": return 1001;
        case "SPAWN_PATTERN": return 1101;
        case "SPAWN_PATTERN_GROUP": return 1201;
        case "WAY_POINT": return 1301;
        case "DATA_UPGRADE": return 1401;
        case "ICON": return 1501;
        case "MUSIC": return 1601;
        case "SOUND": return 1701;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return TypeDeclaration_TriggerDataType.fromJson(value);
  }
  static fromReact(e) {
    return TypeDeclaration_TriggerDataType.fromJson(e);
  }
}
TypeDeclaration_TriggerDataType.NONE = 0;
TypeDeclaration_TriggerDataType.UNIT = 101;
TypeDeclaration_TriggerDataType.ABILITY = 201;
TypeDeclaration_TriggerDataType.WEAPON = 301;
TypeDeclaration_TriggerDataType.BEHAVIOR = 401;
TypeDeclaration_TriggerDataType.EFFECT = 501;
TypeDeclaration_TriggerDataType.AREA_SEARCH_EFFECT = 502;
TypeDeclaration_TriggerDataType.EXPRESSION = 601;
TypeDeclaration_TriggerDataType.VALIDATOR = 701;
TypeDeclaration_TriggerDataType.MOVER = 801;
TypeDeclaration_TriggerDataType.ACTOR = 901;
TypeDeclaration_TriggerDataType.UNIT_ACTOR = 902;
TypeDeclaration_TriggerDataType.SITE_OPERATION = 903;
TypeDeclaration_TriggerDataType.ACTOR_EVENT_MACRO = 1001;
TypeDeclaration_TriggerDataType.SPAWN_PATTERN = 1101;
TypeDeclaration_TriggerDataType.SPAWN_PATTERN_GROUP = 1201;
TypeDeclaration_TriggerDataType.WAY_POINT = 1301;
TypeDeclaration_TriggerDataType.DATA_UPGRADE = 1401;
TypeDeclaration_TriggerDataType.ICON = 1501;
TypeDeclaration_TriggerDataType.MUSIC = 1601;
TypeDeclaration_TriggerDataType.SOUND = 1701;
TypeDeclaration_TriggerDataType.default = 0;
TypeDeclaration_TriggerDataType.values = {
  NONE: 0,
  UNIT: 101,
  ABILITY: 201,
  WEAPON: 301,
  BEHAVIOR: 401,
  EFFECT: 501,
  AREA_SEARCH_EFFECT: 502,
  EXPRESSION: 601,
  VALIDATOR: 701,
  MOVER: 801,
  ACTOR: 901,
  UNIT_ACTOR: 902,
  SITE_OPERATION: 903,
  ACTOR_EVENT_MACRO: 1001,
  SPAWN_PATTERN: 1101,
  SPAWN_PATTERN_GROUP: 1201,
  WAY_POINT: 1301,
  DATA_UPGRADE: 1401,
  ICON: 1501,
  MUSIC: 1601,
  SOUND: 1701,
};
TypeDeclaration_TriggerDataType.names = {
  0: "NONE",
  101: "UNIT",
  201: "ABILITY",
  301: "WEAPON",
  401: "BEHAVIOR",
  501: "EFFECT",
  502: "AREA_SEARCH_EFFECT",
  601: "EXPRESSION",
  701: "VALIDATOR",
  801: "MOVER",
  901: "ACTOR",
  902: "UNIT_ACTOR",
  903: "SITE_OPERATION",
  1001: "ACTOR_EVENT_MACRO",
  1101: "SPAWN_PATTERN",
  1201: "SPAWN_PATTERN_GROUP",
  1301: "WAY_POINT",
  1401: "DATA_UPGRADE",
  1501: "ICON",
  1601: "MUSIC",
  1701: "SOUND",
};
export class TypeDeclaration {
  get descriptor() {
    return TypeDeclaration.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValueType = false;
    this._valueType = null;
    this._hasStringValueType = false;
    this._stringValueType = null;
    this._hasVariableType = false;
    this._variableType = null;
  }
  isEmpty() {
    if (this._hasValueType) return false;
    if (this._hasStringValueType) return false;
    if (this._hasVariableType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TypeDeclaration) {
      return value;
    }
    return TypeDeclaration.fromJson(value);
  }
  static fromJson(json) {
    const result = new TypeDeclaration();
    if (json.valueType != null) {
      result._hasValueType = true;
      result._valueType = ValueType.fromJson(json.valueType);
    }
    if (json.stringValueType != null) {
      result._hasStringValueType = true;
      result._stringValueType = JsonToString.fromJson(json.stringValueType);
    }
    if (json.variableType != null) {
      result._hasVariableType = true;
      result._variableType = VariableType.fromJson(json.variableType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValueType) {
      result.valueType = ValueType.toJson(this._valueType);
    }
    if (this._hasStringValueType) {
      result.stringValueType = JsonToString.toJson(this._stringValueType);
    }
    if (this._hasVariableType) {
      result.variableType = VariableType.toJson(this._variableType);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get valueType() {
    return this._hasValueType ? this._valueType : ValueType.default;
  }
  get hasValueType() {
    return this._hasValueType;
  }
  setValueType(path, value) {
    return {type: 'SET', path: path.concat(['valueType']), value};
  }
  deleteValueType(path) {
    return {type: 'DELETE', path: path.concat(['valueType'])};
  }
  /**
   * @returns {string}
   */
  get stringValueType() {
    return this._hasStringValueType ? this._stringValueType : JsonToString.default;
  }
  get hasStringValueType() {
    return this._hasStringValueType;
  }
  setStringValueType(path, value) {
    return {type: 'SET', path: path.concat(['stringValueType']), value};
  }
  deleteStringValueType(path) {
    return {type: 'DELETE', path: path.concat(['stringValueType'])};
  }
  /**
   * @returns {number}
   */
  get variableType() {
    return this._hasVariableType ? this._variableType : VariableType.default;
  }
  get hasVariableType() {
    return this._hasVariableType;
  }
  setVariableType(path, value) {
    return {type: 'SET', path: path.concat(['variableType']), value};
  }
  deleteVariableType(path) {
    return {type: 'DELETE', path: path.concat(['variableType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "valueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TypeDeclaration(this);
              copy._hasValueType = true;
              copy._valueType = ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueType) {
                return this;
              }
              const copy = new TypeDeclaration(this);
              copy._hasValueType = false;
              copy._valueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stringValueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TypeDeclaration(this);
              copy._hasStringValueType = true;
              copy._stringValueType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStringValueType) {
                return this;
              }
              const copy = new TypeDeclaration(this);
              copy._hasStringValueType = false;
              copy._stringValueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "variableType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TypeDeclaration(this);
              copy._hasVariableType = true;
              copy._variableType = VariableType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVariableType) {
                return this;
              }
              const copy = new TypeDeclaration(this);
              copy._hasVariableType = false;
              copy._variableType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TypeDeclaration} other
   * @returns {TypeDeclaration}
   */
  merge(other) {
    const copy = new TypeDeclaration(this);
    if (other._hasValueType) {
      copy._hasValueType = true;
      copy._valueType = other._valueType;
    }
    if (other._hasStringValueType) {
      copy._hasStringValueType = true;
      copy._stringValueType = other._stringValueType;
    }
    if (other._hasVariableType) {
      copy._hasVariableType = true;
      copy._variableType = other._variableType;
    }
    return copy;
  }
}
TypeDeclaration.default = new TypeDeclaration();
TypeDeclaration.TriggerDataType = TypeDeclaration_TriggerDataType;
class TypeDeclaration_Builder {
  constructor(value) {
    this._value = new TypeDeclaration(value);
  }
  build() {
    return new TypeDeclaration(this._value);
  }
  setValueType(value) {
    this._value._hasValueType = true;
    this._value._valueType = value;
    return this;
  }
  deleteValueType() {
    this._value._hasValueType = false;
    this._value._valueType = null;
    return this;
  }
  setStringValueType(value) {
    this._value._hasStringValueType = true;
    this._value._stringValueType = value;
    return this;
  }
  deleteStringValueType() {
    this._value._hasStringValueType = false;
    this._value._stringValueType = null;
    return this;
  }
  setVariableType(value) {
    this._value._hasVariableType = true;
    this._value._variableType = value;
    return this;
  }
  deleteVariableType() {
    this._value._hasVariableType = false;
    this._value._variableType = null;
    return this;
  }
}
TypeDeclaration.Builder = TypeDeclaration_Builder;
class TypeDeclaration_WithParent {
  /**
   * @param {TypeDeclaration} value
   * @param {TypeDeclaration_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TypeDeclaration.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValueType() {
    if (this._cachedHasValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedHasValueType = true;
      } else {
        this._cachedHasValueType = this._parent ? this._parent.hasValueType : false;
      }
    }
    return this._cachedHasValueType;
  }
  get valueType() {
    if (this._cachedValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedValueType = this._value.valueType;
      } else {
        this._cachedValueType = this._parent ? this._parent.valueType : this._value.valueType;
      }
    }
    return this._cachedValueType;
  }
  get hasStringValueType() {
    if (this._cachedHasStringValueType === undefined) {
      if (this._value.hasStringValueType) {
        this._cachedHasStringValueType = true;
      } else {
        this._cachedHasStringValueType = this._parent ? this._parent.hasStringValueType : false;
      }
    }
    return this._cachedHasStringValueType;
  }
  get stringValueType() {
    if (this._cachedStringValueType === undefined) {
      if (this._value.hasStringValueType) {
        this._cachedStringValueType = this._value.stringValueType;
      } else {
        this._cachedStringValueType = this._parent ? this._parent.stringValueType : this._value.stringValueType;
      }
    }
    return this._cachedStringValueType;
  }
  get hasVariableType() {
    if (this._cachedHasVariableType === undefined) {
      if (this._value.hasVariableType) {
        this._cachedHasVariableType = true;
      } else {
        this._cachedHasVariableType = this._parent ? this._parent.hasVariableType : false;
      }
    }
    return this._cachedHasVariableType;
  }
  get variableType() {
    if (this._cachedVariableType === undefined) {
      if (this._value.hasVariableType) {
        this._cachedVariableType = this._value.variableType;
      } else {
        this._cachedVariableType = this._parent ? this._parent.variableType : this._value.variableType;
      }
    }
    return this._cachedVariableType;
  }
  update(current, parent) {
    const result = new TypeDeclaration_WithParent(current, parent);
    return result;
  }
}
TypeDeclaration_WithParent.default = new TypeDeclaration_WithParent(TypeDeclaration.default, null);
TypeDeclaration.WithParent = TypeDeclaration_WithParent;
class TypeDeclaration_Descriptor {
  get valueType() {
    if (!this._valueType) {
      this._valueType = {
        name: "valueType",
        Name: "ValueType",
        number: 1,
        protoType: 14,
        protoName: "value_type",
        type: ValueType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueType;
  }
  get stringValueType() {
    if (!this._stringValueType) {
      this._stringValueType = {
        name: "stringValueType",
        Name: "StringValueType",
        number: 2,
        protoType: 9,
        protoName: "string_value_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stringValueType;
  }
  get variableType() {
    if (!this._variableType) {
      this._variableType = {
        name: "variableType",
        Name: "VariableType",
        number: 3,
        protoType: 14,
        protoName: "variable_type",
        type: VariableType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._variableType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.valueType,
        this.stringValueType,
        this.variableType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValueType",
        Name: "DummyOneofForValueType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStringValueType",
        Name: "DummyOneofForStringValueType",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVariableType",
        Name: "DummyOneofForVariableType",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
TypeDeclaration.descriptor = new TypeDeclaration_Descriptor();
class VariableDefinition_VariableSource {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "LOCAL": return 1;
        case "GLOBAL": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return VariableDefinition_VariableSource.fromJson(value);
  }
  static fromReact(e) {
    return VariableDefinition_VariableSource.fromJson(e);
  }
}
VariableDefinition_VariableSource.NONE = 0;
VariableDefinition_VariableSource.LOCAL = 1;
VariableDefinition_VariableSource.GLOBAL = 2;
VariableDefinition_VariableSource.default = 0;
VariableDefinition_VariableSource.values = {
  NONE: 0,
  LOCAL: 1,
  GLOBAL: 2,
};
VariableDefinition_VariableSource.names = {
  0: "NONE",
  1: "LOCAL",
  2: "GLOBAL",
};
export class VariableDefinition {
  get descriptor() {
    return VariableDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasType = false;
    this._type = null;
    this._hasStringValueType = false;
    this._stringValueType = null;
    this._hasVariableType = false;
    this._variableType = null;
    this._hasName = false;
    this._name = null;
    this._hasInstanceId = false;
    this._instanceId = null;
    this._hasSource = false;
    this._source = null;
    this._hasInitialExpression = false;
    this._initialExpression = null;
  }
  isEmpty() {
    if (this._hasType) return false;
    if (this._hasStringValueType) return false;
    if (this._hasVariableType) return false;
    if (this._hasName) return false;
    if (this._hasInstanceId) return false;
    if (this._hasSource) return false;
    if (this._hasInitialExpression && !this._initialExpression.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof VariableDefinition) {
      return value;
    }
    return VariableDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new VariableDefinition();
    if (json.type != null) {
      result._hasType = true;
      result._type = ValueType.fromJson(json.type);
    }
    if (json.stringValueType != null) {
      result._hasStringValueType = true;
      result._stringValueType = JsonToString.fromJson(json.stringValueType);
    }
    if (json.variableType != null) {
      result._hasVariableType = true;
      result._variableType = VariableType.fromJson(json.variableType);
    }
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.instanceId != null) {
      result._hasInstanceId = true;
      result._instanceId = JsonToString.fromJson(json.instanceId);
    }
    if (json.source != null) {
      result._hasSource = true;
      result._source = VariableDefinition_VariableSource.fromJson(json.source);
    }
    if (json.initialExpression != null) {
      result._hasInitialExpression = true;
      result._initialExpression = Expression.fromJson(json.initialExpression);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasType) {
      result.type = ValueType.toJson(this._type);
    }
    if (this._hasStringValueType) {
      result.stringValueType = JsonToString.toJson(this._stringValueType);
    }
    if (this._hasVariableType) {
      result.variableType = VariableType.toJson(this._variableType);
    }
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasInstanceId) {
      result.instanceId = JsonToString.toJson(this._instanceId);
    }
    if (this._hasSource) {
      result.source = VariableDefinition_VariableSource.toJson(this._source);
    }
    if (this._hasInitialExpression && !this._initialExpression.isEmpty()) {
      result.initialExpression = Expression.toJson(this._initialExpression);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get type() {
    return this._hasType ? this._type : ValueType.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {string}
   */
  get stringValueType() {
    return this._hasStringValueType ? this._stringValueType : JsonToString.default;
  }
  get hasStringValueType() {
    return this._hasStringValueType;
  }
  setStringValueType(path, value) {
    return {type: 'SET', path: path.concat(['stringValueType']), value};
  }
  deleteStringValueType(path) {
    return {type: 'DELETE', path: path.concat(['stringValueType'])};
  }
  /**
   * @returns {number}
   */
  get variableType() {
    return this._hasVariableType ? this._variableType : VariableType.default;
  }
  get hasVariableType() {
    return this._hasVariableType;
  }
  setVariableType(path, value) {
    return {type: 'SET', path: path.concat(['variableType']), value};
  }
  deleteVariableType(path) {
    return {type: 'DELETE', path: path.concat(['variableType'])};
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string}
   */
  get instanceId() {
    return this._hasInstanceId ? this._instanceId : JsonToString.default;
  }
  get hasInstanceId() {
    return this._hasInstanceId;
  }
  setInstanceId(path, value) {
    return {type: 'SET', path: path.concat(['instanceId']), value};
  }
  deleteInstanceId(path) {
    return {type: 'DELETE', path: path.concat(['instanceId'])};
  }
  /**
   * @returns {number}
   */
  get source() {
    return this._hasSource ? this._source : VariableDefinition_VariableSource.default;
  }
  get hasSource() {
    return this._hasSource;
  }
  setSource(path, value) {
    return {type: 'SET', path: path.concat(['source']), value};
  }
  deleteSource(path) {
    return {type: 'DELETE', path: path.concat(['source'])};
  }
  /**
   * @returns {Expression}
   */
  get initialExpression() {
    return this._hasInitialExpression ? this._initialExpression : Expression.default;
  }
  get hasInitialExpression() {
    return this._hasInitialExpression;
  }
  setInitialExpression(path, value) {
    return {type: 'SET', path: path.concat(['initialExpression']), value: value.toJson()};
  }
  deleteInitialExpression(path) {
    return {type: 'DELETE', path: path.concat(['initialExpression'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new VariableDefinition(this);
              copy._hasType = true;
              copy._type = ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new VariableDefinition(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stringValueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new VariableDefinition(this);
              copy._hasStringValueType = true;
              copy._stringValueType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStringValueType) {
                return this;
              }
              const copy = new VariableDefinition(this);
              copy._hasStringValueType = false;
              copy._stringValueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "variableType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new VariableDefinition(this);
              copy._hasVariableType = true;
              copy._variableType = VariableType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVariableType) {
                return this;
              }
              const copy = new VariableDefinition(this);
              copy._hasVariableType = false;
              copy._variableType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new VariableDefinition(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new VariableDefinition(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "instanceId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new VariableDefinition(this);
              copy._hasInstanceId = true;
              copy._instanceId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInstanceId) {
                return this;
              }
              const copy = new VariableDefinition(this);
              copy._hasInstanceId = false;
              copy._instanceId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "source": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new VariableDefinition(this);
              copy._hasSource = true;
              copy._source = VariableDefinition_VariableSource.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSource) {
                return this;
              }
              const copy = new VariableDefinition(this);
              copy._hasSource = false;
              copy._source = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "initialExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new VariableDefinition(this);
              copy._hasInitialExpression = true;
              copy._initialExpression = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInitialExpression) {
                return this;
              }
              const copy = new VariableDefinition(this);
              copy._hasInitialExpression = false;
              copy._initialExpression = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasInitialExpression) {
            const copy = new VariableDefinition(this);
            copy._hasInitialExpression = true;
            copy._initialExpression = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._initialExpression.apply(type, path.slice(1), value);
          if (newValue === this._initialExpression) {
            return this;
          }
          const copy = new VariableDefinition(this);
          copy._initialExpression = copy._initialExpression.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {VariableDefinition} other
   * @returns {VariableDefinition}
   */
  merge(other) {
    const copy = new VariableDefinition(this);
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    if (other._hasStringValueType) {
      copy._hasStringValueType = true;
      copy._stringValueType = other._stringValueType;
    }
    if (other._hasVariableType) {
      copy._hasVariableType = true;
      copy._variableType = other._variableType;
    }
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasInstanceId) {
      copy._hasInstanceId = true;
      copy._instanceId = other._instanceId;
    }
    if (other._hasSource) {
      copy._hasSource = true;
      copy._source = other._source;
    }
    if (other._hasInitialExpression) {
      if (copy._hasInitialExpression) {
        copy._initialExpression = copy.initialExpression.merge(other.initialExpression);
      } else {
        copy._initialExpression = other._initialExpression;
      }
      copy._hasInitialExpression = true;
    }
    return copy;
  }
}
VariableDefinition.default = new VariableDefinition();
VariableDefinition.VariableSource = VariableDefinition_VariableSource;
class VariableDefinition_Builder {
  constructor(value) {
    this._value = new VariableDefinition(value);
  }
  build() {
    return new VariableDefinition(this._value);
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  setStringValueType(value) {
    this._value._hasStringValueType = true;
    this._value._stringValueType = value;
    return this;
  }
  deleteStringValueType() {
    this._value._hasStringValueType = false;
    this._value._stringValueType = null;
    return this;
  }
  setVariableType(value) {
    this._value._hasVariableType = true;
    this._value._variableType = value;
    return this;
  }
  deleteVariableType() {
    this._value._hasVariableType = false;
    this._value._variableType = null;
    return this;
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setInstanceId(value) {
    this._value._hasInstanceId = true;
    this._value._instanceId = value;
    return this;
  }
  deleteInstanceId() {
    this._value._hasInstanceId = false;
    this._value._instanceId = null;
    return this;
  }
  setSource(value) {
    this._value._hasSource = true;
    this._value._source = value;
    return this;
  }
  deleteSource() {
    this._value._hasSource = false;
    this._value._source = null;
    return this;
  }
  setInitialExpression(value) {
    this._value._hasInitialExpression = true;
    this._value._initialExpression = value;
    return this;
  }
  deleteInitialExpression() {
    this._value._hasInitialExpression = false;
    this._value._initialExpression = null;
    return this;
  }
}
VariableDefinition.Builder = VariableDefinition_Builder;
class VariableDefinition_WithParent {
  /**
   * @param {VariableDefinition} value
   * @param {VariableDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return VariableDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get hasStringValueType() {
    if (this._cachedHasStringValueType === undefined) {
      if (this._value.hasStringValueType) {
        this._cachedHasStringValueType = true;
      } else {
        this._cachedHasStringValueType = this._parent ? this._parent.hasStringValueType : false;
      }
    }
    return this._cachedHasStringValueType;
  }
  get stringValueType() {
    if (this._cachedStringValueType === undefined) {
      if (this._value.hasStringValueType) {
        this._cachedStringValueType = this._value.stringValueType;
      } else {
        this._cachedStringValueType = this._parent ? this._parent.stringValueType : this._value.stringValueType;
      }
    }
    return this._cachedStringValueType;
  }
  get hasVariableType() {
    if (this._cachedHasVariableType === undefined) {
      if (this._value.hasVariableType) {
        this._cachedHasVariableType = true;
      } else {
        this._cachedHasVariableType = this._parent ? this._parent.hasVariableType : false;
      }
    }
    return this._cachedHasVariableType;
  }
  get variableType() {
    if (this._cachedVariableType === undefined) {
      if (this._value.hasVariableType) {
        this._cachedVariableType = this._value.variableType;
      } else {
        this._cachedVariableType = this._parent ? this._parent.variableType : this._value.variableType;
      }
    }
    return this._cachedVariableType;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasInstanceId() {
    if (this._cachedHasInstanceId === undefined) {
      if (this._value.hasInstanceId) {
        this._cachedHasInstanceId = true;
      } else {
        this._cachedHasInstanceId = this._parent ? this._parent.hasInstanceId : false;
      }
    }
    return this._cachedHasInstanceId;
  }
  get instanceId() {
    if (this._cachedInstanceId === undefined) {
      if (this._value.hasInstanceId) {
        this._cachedInstanceId = this._value.instanceId;
      } else {
        this._cachedInstanceId = this._parent ? this._parent.instanceId : this._value.instanceId;
      }
    }
    return this._cachedInstanceId;
  }
  get hasSource() {
    if (this._cachedHasSource === undefined) {
      if (this._value.hasSource) {
        this._cachedHasSource = true;
      } else {
        this._cachedHasSource = this._parent ? this._parent.hasSource : false;
      }
    }
    return this._cachedHasSource;
  }
  get source() {
    if (this._cachedSource === undefined) {
      if (this._value.hasSource) {
        this._cachedSource = this._value.source;
      } else {
        this._cachedSource = this._parent ? this._parent.source : this._value.source;
      }
    }
    return this._cachedSource;
  }
  get hasInitialExpression() {
    if (this._cachedHasInitialExpression === undefined) {
      if (this._value.hasInitialExpression) {
        this._cachedHasInitialExpression = true;
      } else {
        this._cachedHasInitialExpression = this._parent ? this._parent.hasInitialExpression : false;
      }
    }
    return this._cachedHasInitialExpression;
  }
  get initialExpression() {
    if (!this._cachedInitialExpression) {
      if (this._value.hasInitialExpression) {
        this._cachedInitialExpression = new Expression.WithParent(this._value.initialExpression, this._parent && this._parent.hasInitialExpression ? this._parent.initialExpression : null);
      } else {
        this._cachedInitialExpression = this._parent ? new Expression.WithParent(Expression.default, this._parent.initialExpression) : Expression.WithParent.default;
      }
    }
    return this._cachedInitialExpression;
  }
  update(current, parent) {
    const result = new VariableDefinition_WithParent(current, parent);
    if (this._cachedInitialExpression && this._value.hasInitialExpression && current.hasInitialExpression) {
      if (this._value.initialExpression === current.initialExpression && this._parent === parent) {
        result._cachedInitialExpression = this._cachedInitialExpression;
      } else {
        result._cachedInitialExpression = this._cachedInitialExpression.update(current.initialExpression, parent && parent.hasInitialExpression ? parent.initialExpression : null);
      }
    }
    return result;
  }
}
VariableDefinition_WithParent.default = new VariableDefinition_WithParent(VariableDefinition.default, null);
VariableDefinition.WithParent = VariableDefinition_WithParent;
class VariableDefinition_Descriptor {
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 1,
        protoType: 14,
        protoName: "type",
        type: ValueType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get stringValueType() {
    if (!this._stringValueType) {
      this._stringValueType = {
        name: "stringValueType",
        Name: "StringValueType",
        number: 7,
        protoType: 9,
        protoName: "string_value_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stringValueType;
  }
  get variableType() {
    if (!this._variableType) {
      this._variableType = {
        name: "variableType",
        Name: "VariableType",
        number: 6,
        protoType: 14,
        protoName: "variable_type",
        type: VariableType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._variableType;
  }
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 2,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get instanceId() {
    if (!this._instanceId) {
      this._instanceId = {
        name: "instanceId",
        Name: "InstanceId",
        number: 3,
        protoType: 9,
        protoName: "instance_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._instanceId;
  }
  get source() {
    if (!this._source) {
      this._source = {
        name: "source",
        Name: "Source",
        number: 4,
        protoType: 14,
        protoName: "source",
        type: VariableDefinition_VariableSource,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._source;
  }
  get initialExpression() {
    if (!this._initialExpression) {
      this._initialExpression = {
        name: "initialExpression",
        Name: "InitialExpression",
        number: 5,
        protoType: 11,
        protoName: "initialExpression",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._initialExpression;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.type,
        this.stringValueType,
        this.variableType,
        this.name,
        this.instanceId,
        this.source,
        this.initialExpression,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStringValueType",
        Name: "DummyOneofForStringValueType",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVariableType",
        Name: "DummyOneofForVariableType",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInstanceId",
        Name: "DummyOneofForInstanceId",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSource",
        Name: "DummyOneofForSource",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInitialExpression",
        Name: "DummyOneofForInitialExpression",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
VariableDefinition.descriptor = new VariableDefinition_Descriptor();
export class FunctionCall {
  get descriptor() {
    return FunctionCall.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFunctionName = false;
    this._functionName = null;
    this._parameters = [];
  }
  isEmpty() {
    if (this._hasFunctionName) return false;
    if (this._parameters.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FunctionCall) {
      return value;
    }
    return FunctionCall.fromJson(value);
  }
  static fromJson(json) {
    const result = new FunctionCall();
    if (json.functionName != null) {
      result._hasFunctionName = true;
      result._functionName = JsonToString.fromJson(json.functionName);
    }
    result._parameters = JsonToList(json.parameters, Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFunctionName) {
      result.functionName = JsonToString.toJson(this._functionName);
    }
    if (this._parameters.length > 0) {
      result.parameters = ArrayToJson(this._parameters, Expression);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get functionName() {
    return this._hasFunctionName ? this._functionName : JsonToString.default;
  }
  get hasFunctionName() {
    return this._hasFunctionName;
  }
  setFunctionName(path, value) {
    return {type: 'SET', path: path.concat(['functionName']), value};
  }
  deleteFunctionName(path) {
    return {type: 'DELETE', path: path.concat(['functionName'])};
  }
  /**
   * @returns {Expression[]}
   */
  get parameters() {
    return this._parameters;
  }
  addParameters(path, value) {
    return {type: 'ADD', path: path.concat(['parameters']), value: value.toJson()};
  }
  setParameters(path, value) {
    return {type: 'SET', path: path.concat(['parameters']), value: ArrayToJson(value, Expression)};
  }
  setParametersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['parameters', key]), value: value.toJson()};
  }
  deleteParameters(path) {
    return {type: 'DELETE', path: path.concat(['parameters'])};
  }
  deleteParametersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['parameters', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "functionName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FunctionCall(this);
              copy._hasFunctionName = true;
              copy._functionName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFunctionName) {
                return this;
              }
              const copy = new FunctionCall(this);
              copy._hasFunctionName = false;
              copy._functionName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parameters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FunctionCall(this);
              copy._parameters = [];        for (let i of value) {
                copy._parameters.push(Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new FunctionCall(this);
              copy._parameters = copy._parameters.concat([Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._parameters.length === 0) {
                return this;
              }
              const copy = new FunctionCall(this);
              copy._parameters = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new FunctionCall(this);
              copy._parameters = copy._parameters.slice();
              copy._parameters[path[1]] = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new FunctionCall(this);
              copy._parameters = copy._parameters.slice(0, path[1]).concat(copy._parameters.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          const oldValue = this._parameters[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new FunctionCall(this);
          copy._parameters = copy._parameters.slice();
          copy._parameters[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FunctionCall} other
   * @returns {FunctionCall}
   */
  merge(other) {
    const copy = new FunctionCall(this);
    if (other._hasFunctionName) {
      copy._hasFunctionName = true;
      copy._functionName = other._functionName;
    }
    copy._parameters = this._parameters.concat(other._parameters);
    return copy;
  }
}
FunctionCall.default = new FunctionCall();
class FunctionCall_Builder {
  constructor(value) {
    this._value = new FunctionCall(value);
  }
  build() {
    return new FunctionCall(this._value);
  }
  setFunctionName(value) {
    this._value._hasFunctionName = true;
    this._value._functionName = value;
    return this;
  }
  deleteFunctionName() {
    this._value._hasFunctionName = false;
    this._value._functionName = null;
    return this;
  }
  addAllParameters(values) {
    this._value._parameters = this._value._parameters.concat(values);
    return this;
  }
  addParameters(value) {
    this._value._parameters = this._value._parameters.concat([value]);
    return this;
  }
  setParameters(index, value) {
    this._value._parameters = this._value._parameters.concat();
    this._value._parameters[index] = value;
    return this;
  }
  clearParameters() {
    this._value._parameters = [];
    return this;
  }
}
FunctionCall.Builder = FunctionCall_Builder;
class FunctionCall_WithParent {
  /**
   * @param {FunctionCall} value
   * @param {FunctionCall_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FunctionCall.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFunctionName() {
    if (this._cachedHasFunctionName === undefined) {
      if (this._value.hasFunctionName) {
        this._cachedHasFunctionName = true;
      } else {
        this._cachedHasFunctionName = this._parent ? this._parent.hasFunctionName : false;
      }
    }
    return this._cachedHasFunctionName;
  }
  get functionName() {
    if (this._cachedFunctionName === undefined) {
      if (this._value.hasFunctionName) {
        this._cachedFunctionName = this._value.functionName;
      } else {
        this._cachedFunctionName = this._parent ? this._parent.functionName : this._value.functionName;
      }
    }
    return this._cachedFunctionName;
  }
  get selfParameters() {
    if (!this._selfParameters) {
      this._selfParameters = [];
      for (let i of this._value.parameters) {
        this._selfParameters.push(new Expression.WithParent(i, null));
      }
    }
    return this._selfParameters;
  }
  get inherentParameters() {
    if (!this._inherentParameters) {
      this._inherentParameters = this._parent ? this._parent.parameters : [];
    }
    return this._inherentParameters;
  }
  get parameters() {
    if (!this._allParameters) {
      this._allParameters = this._parent ? this._parent.parameters.concat(this.selfParameters) : this.selfParameters;
    }
    return this._allParameters;
  }
  update(current, parent) {
    const result = new FunctionCall_WithParent(current, parent);
    if (this._selfParameters) {
      if (this._value.parameters === current.parameters) {
        result._selfParameters = this._selfParameters;
      } else {
        result._selfParameters = [];
        for (let i = 0; i < current.parameters.length; i++) {
          const oldValue = this._value.parameters[i];
          if (oldValue) {
            const oldCache = this._selfParameters[i];
            if (oldValue === current.parameters[i]) {
              result._selfParameters[i] = oldCache;
            } else {
              result._selfParameters[i] = oldCache.update(current.parameters[i], null);
            }
          } else {
            result._selfParameters[i] = new Expression.WithParent(current.parameters[i], null);
          }
        }
      }
    }
    return result;
  }
}
FunctionCall_WithParent.default = new FunctionCall_WithParent(FunctionCall.default, null);
FunctionCall.WithParent = FunctionCall_WithParent;
class FunctionCall_Descriptor {
  get functionName() {
    if (!this._functionName) {
      this._functionName = {
        name: "functionName",
        Name: "FunctionName",
        number: 1,
        protoType: 9,
        protoName: "function_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._functionName;
  }
  get parameters() {
    if (!this._parameters) {
      this._parameters = {
        name: "parameters",
        Name: "Parameters",
        number: 2,
        protoType: 11,
        protoName: "parameters",
        type: Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parameters;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.functionName,
        this.parameters,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFunctionName",
        Name: "DummyOneofForFunctionName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
FunctionCall.descriptor = new FunctionCall_Descriptor();
export class Literal {
  get descriptor() {
    return Literal.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasType = false;
    this._type = null;
    this._hasStringValue = false;
    this._stringValue = null;
  }
  isEmpty() {
    if (this._hasType) return false;
    if (this._hasStringValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Literal) {
      return value;
    }
    return Literal.fromJson(value);
  }
  static fromJson(json) {
    const result = new Literal();
    if (json.type != null) {
      result._hasType = true;
      result._type = ValueType.fromJson(json.type);
    }
    if (json.stringValue != null) {
      result._hasStringValue = true;
      result._stringValue = JsonToString.fromJson(json.stringValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasType) {
      result.type = ValueType.toJson(this._type);
    }
    if (this._hasStringValue) {
      result.stringValue = JsonToString.toJson(this._stringValue);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get type() {
    return this._hasType ? this._type : ValueType.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {string}
   */
  get stringValue() {
    return this._hasStringValue ? this._stringValue : JsonToString.default;
  }
  get hasStringValue() {
    return this._hasStringValue;
  }
  setStringValue(path, value) {
    return {type: 'SET', path: path.concat(['stringValue']), value};
  }
  deleteStringValue(path) {
    return {type: 'DELETE', path: path.concat(['stringValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Literal(this);
              copy._hasType = true;
              copy._type = ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new Literal(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stringValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Literal(this);
              copy._hasStringValue = true;
              copy._stringValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStringValue) {
                return this;
              }
              const copy = new Literal(this);
              copy._hasStringValue = false;
              copy._stringValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Literal} other
   * @returns {Literal}
   */
  merge(other) {
    const copy = new Literal(this);
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    if (other._hasStringValue) {
      copy._hasStringValue = true;
      copy._stringValue = other._stringValue;
    }
    return copy;
  }
}
Literal.default = new Literal();
class Literal_Builder {
  constructor(value) {
    this._value = new Literal(value);
  }
  build() {
    return new Literal(this._value);
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  setStringValue(value) {
    this._value._hasStringValue = true;
    this._value._stringValue = value;
    return this;
  }
  deleteStringValue() {
    this._value._hasStringValue = false;
    this._value._stringValue = null;
    return this;
  }
}
Literal.Builder = Literal_Builder;
class Literal_WithParent {
  /**
   * @param {Literal} value
   * @param {Literal_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Literal.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get hasStringValue() {
    if (this._cachedHasStringValue === undefined) {
      if (this._value.hasStringValue) {
        this._cachedHasStringValue = true;
      } else {
        this._cachedHasStringValue = this._parent ? this._parent.hasStringValue : false;
      }
    }
    return this._cachedHasStringValue;
  }
  get stringValue() {
    if (this._cachedStringValue === undefined) {
      if (this._value.hasStringValue) {
        this._cachedStringValue = this._value.stringValue;
      } else {
        this._cachedStringValue = this._parent ? this._parent.stringValue : this._value.stringValue;
      }
    }
    return this._cachedStringValue;
  }
  update(current, parent) {
    const result = new Literal_WithParent(current, parent);
    return result;
  }
}
Literal_WithParent.default = new Literal_WithParent(Literal.default, null);
Literal.WithParent = Literal_WithParent;
class Literal_Descriptor {
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 1,
        protoType: 14,
        protoName: "type",
        type: ValueType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get stringValue() {
    if (!this._stringValue) {
      this._stringValue = {
        name: "stringValue",
        Name: "StringValue",
        number: 2,
        protoType: 9,
        protoName: "string_value",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stringValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.type,
        this.stringValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStringValue",
        Name: "DummyOneofForStringValue",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Literal.descriptor = new Literal_Descriptor();
export class VariableRef {
  get descriptor() {
    return VariableRef.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasVariableId = false;
    this._variableId = null;
  }
  isEmpty() {
    if (this._hasVariableId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof VariableRef) {
      return value;
    }
    return VariableRef.fromJson(value);
  }
  static fromJson(json) {
    const result = new VariableRef();
    if (json.variableId != null) {
      result._hasVariableId = true;
      result._variableId = JsonToString.fromJson(json.variableId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasVariableId) {
      result.variableId = JsonToString.toJson(this._variableId);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get variableId() {
    return this._hasVariableId ? this._variableId : JsonToString.default;
  }
  get hasVariableId() {
    return this._hasVariableId;
  }
  setVariableId(path, value) {
    return {type: 'SET', path: path.concat(['variableId']), value};
  }
  deleteVariableId(path) {
    return {type: 'DELETE', path: path.concat(['variableId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "variableId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new VariableRef(this);
              copy._hasVariableId = true;
              copy._variableId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVariableId) {
                return this;
              }
              const copy = new VariableRef(this);
              copy._hasVariableId = false;
              copy._variableId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {VariableRef} other
   * @returns {VariableRef}
   */
  merge(other) {
    const copy = new VariableRef(this);
    if (other._hasVariableId) {
      copy._hasVariableId = true;
      copy._variableId = other._variableId;
    }
    return copy;
  }
}
VariableRef.default = new VariableRef();
class VariableRef_Builder {
  constructor(value) {
    this._value = new VariableRef(value);
  }
  build() {
    return new VariableRef(this._value);
  }
  setVariableId(value) {
    this._value._hasVariableId = true;
    this._value._variableId = value;
    return this;
  }
  deleteVariableId() {
    this._value._hasVariableId = false;
    this._value._variableId = null;
    return this;
  }
}
VariableRef.Builder = VariableRef_Builder;
class VariableRef_WithParent {
  /**
   * @param {VariableRef} value
   * @param {VariableRef_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return VariableRef.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasVariableId() {
    if (this._cachedHasVariableId === undefined) {
      if (this._value.hasVariableId) {
        this._cachedHasVariableId = true;
      } else {
        this._cachedHasVariableId = this._parent ? this._parent.hasVariableId : false;
      }
    }
    return this._cachedHasVariableId;
  }
  get variableId() {
    if (this._cachedVariableId === undefined) {
      if (this._value.hasVariableId) {
        this._cachedVariableId = this._value.variableId;
      } else {
        this._cachedVariableId = this._parent ? this._parent.variableId : this._value.variableId;
      }
    }
    return this._cachedVariableId;
  }
  update(current, parent) {
    const result = new VariableRef_WithParent(current, parent);
    return result;
  }
}
VariableRef_WithParent.default = new VariableRef_WithParent(VariableRef.default, null);
VariableRef.WithParent = VariableRef_WithParent;
class VariableRef_Descriptor {
  get variableId() {
    if (!this._variableId) {
      this._variableId = {
        name: "variableId",
        Name: "VariableId",
        number: 1,
        protoType: 9,
        protoName: "variable_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._variableId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.variableId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForVariableId",
        Name: "DummyOneofForVariableId",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
VariableRef.descriptor = new VariableRef_Descriptor();
export class AndExpression {
  get descriptor() {
    return AndExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeftOperand = false;
    this._leftOperand = null;
    this._hasRightOperand = false;
    this._rightOperand = null;
  }
  isEmpty() {
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) return false;
    if (this._hasRightOperand && !this._rightOperand.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AndExpression) {
      return value;
    }
    return AndExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new AndExpression();
    if (json.leftOperand != null) {
      result._hasLeftOperand = true;
      result._leftOperand = Expression.fromJson(json.leftOperand);
    }
    if (json.rightOperand != null) {
      result._hasRightOperand = true;
      result._rightOperand = Expression.fromJson(json.rightOperand);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) {
      result.leftOperand = Expression.toJson(this._leftOperand);
    }
    if (this._hasRightOperand && !this._rightOperand.isEmpty()) {
      result.rightOperand = Expression.toJson(this._rightOperand);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get leftOperand() {
    return this._hasLeftOperand ? this._leftOperand : Expression.default;
  }
  get hasLeftOperand() {
    return this._hasLeftOperand;
  }
  setLeftOperand(path, value) {
    return {type: 'SET', path: path.concat(['leftOperand']), value: value.toJson()};
  }
  deleteLeftOperand(path) {
    return {type: 'DELETE', path: path.concat(['leftOperand'])};
  }
  /**
   * @returns {Expression}
   */
  get rightOperand() {
    return this._hasRightOperand ? this._rightOperand : Expression.default;
  }
  get hasRightOperand() {
    return this._hasRightOperand;
  }
  setRightOperand(path, value) {
    return {type: 'SET', path: path.concat(['rightOperand']), value: value.toJson()};
  }
  deleteRightOperand(path) {
    return {type: 'DELETE', path: path.concat(['rightOperand'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "leftOperand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AndExpression(this);
              copy._hasLeftOperand = true;
              copy._leftOperand = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeftOperand) {
                return this;
              }
              const copy = new AndExpression(this);
              copy._hasLeftOperand = false;
              copy._leftOperand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeftOperand) {
            const copy = new AndExpression(this);
            copy._hasLeftOperand = true;
            copy._leftOperand = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._leftOperand.apply(type, path.slice(1), value);
          if (newValue === this._leftOperand) {
            return this;
          }
          const copy = new AndExpression(this);
          copy._leftOperand = copy._leftOperand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "rightOperand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AndExpression(this);
              copy._hasRightOperand = true;
              copy._rightOperand = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRightOperand) {
                return this;
              }
              const copy = new AndExpression(this);
              copy._hasRightOperand = false;
              copy._rightOperand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRightOperand) {
            const copy = new AndExpression(this);
            copy._hasRightOperand = true;
            copy._rightOperand = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._rightOperand.apply(type, path.slice(1), value);
          if (newValue === this._rightOperand) {
            return this;
          }
          const copy = new AndExpression(this);
          copy._rightOperand = copy._rightOperand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AndExpression} other
   * @returns {AndExpression}
   */
  merge(other) {
    const copy = new AndExpression(this);
    if (other._hasLeftOperand) {
      if (copy._hasLeftOperand) {
        copy._leftOperand = copy.leftOperand.merge(other.leftOperand);
      } else {
        copy._leftOperand = other._leftOperand;
      }
      copy._hasLeftOperand = true;
    }
    if (other._hasRightOperand) {
      if (copy._hasRightOperand) {
        copy._rightOperand = copy.rightOperand.merge(other.rightOperand);
      } else {
        copy._rightOperand = other._rightOperand;
      }
      copy._hasRightOperand = true;
    }
    return copy;
  }
}
AndExpression.default = new AndExpression();
class AndExpression_Builder {
  constructor(value) {
    this._value = new AndExpression(value);
  }
  build() {
    return new AndExpression(this._value);
  }
  setLeftOperand(value) {
    this._value._hasLeftOperand = true;
    this._value._leftOperand = value;
    return this;
  }
  deleteLeftOperand() {
    this._value._hasLeftOperand = false;
    this._value._leftOperand = null;
    return this;
  }
  setRightOperand(value) {
    this._value._hasRightOperand = true;
    this._value._rightOperand = value;
    return this;
  }
  deleteRightOperand() {
    this._value._hasRightOperand = false;
    this._value._rightOperand = null;
    return this;
  }
}
AndExpression.Builder = AndExpression_Builder;
class AndExpression_WithParent {
  /**
   * @param {AndExpression} value
   * @param {AndExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AndExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeftOperand() {
    if (this._cachedHasLeftOperand === undefined) {
      if (this._value.hasLeftOperand) {
        this._cachedHasLeftOperand = true;
      } else {
        this._cachedHasLeftOperand = this._parent ? this._parent.hasLeftOperand : false;
      }
    }
    return this._cachedHasLeftOperand;
  }
  get leftOperand() {
    if (!this._cachedLeftOperand) {
      if (this._value.hasLeftOperand) {
        this._cachedLeftOperand = new Expression.WithParent(this._value.leftOperand, this._parent && this._parent.hasLeftOperand ? this._parent.leftOperand : null);
      } else {
        this._cachedLeftOperand = this._parent ? new Expression.WithParent(Expression.default, this._parent.leftOperand) : Expression.WithParent.default;
      }
    }
    return this._cachedLeftOperand;
  }
  get hasRightOperand() {
    if (this._cachedHasRightOperand === undefined) {
      if (this._value.hasRightOperand) {
        this._cachedHasRightOperand = true;
      } else {
        this._cachedHasRightOperand = this._parent ? this._parent.hasRightOperand : false;
      }
    }
    return this._cachedHasRightOperand;
  }
  get rightOperand() {
    if (!this._cachedRightOperand) {
      if (this._value.hasRightOperand) {
        this._cachedRightOperand = new Expression.WithParent(this._value.rightOperand, this._parent && this._parent.hasRightOperand ? this._parent.rightOperand : null);
      } else {
        this._cachedRightOperand = this._parent ? new Expression.WithParent(Expression.default, this._parent.rightOperand) : Expression.WithParent.default;
      }
    }
    return this._cachedRightOperand;
  }
  update(current, parent) {
    const result = new AndExpression_WithParent(current, parent);
    if (this._cachedLeftOperand && this._value.hasLeftOperand && current.hasLeftOperand) {
      if (this._value.leftOperand === current.leftOperand && this._parent === parent) {
        result._cachedLeftOperand = this._cachedLeftOperand;
      } else {
        result._cachedLeftOperand = this._cachedLeftOperand.update(current.leftOperand, parent && parent.hasLeftOperand ? parent.leftOperand : null);
      }
    }
    if (this._cachedRightOperand && this._value.hasRightOperand && current.hasRightOperand) {
      if (this._value.rightOperand === current.rightOperand && this._parent === parent) {
        result._cachedRightOperand = this._cachedRightOperand;
      } else {
        result._cachedRightOperand = this._cachedRightOperand.update(current.rightOperand, parent && parent.hasRightOperand ? parent.rightOperand : null);
      }
    }
    return result;
  }
}
AndExpression_WithParent.default = new AndExpression_WithParent(AndExpression.default, null);
AndExpression.WithParent = AndExpression_WithParent;
class AndExpression_Descriptor {
  get leftOperand() {
    if (!this._leftOperand) {
      this._leftOperand = {
        name: "leftOperand",
        Name: "LeftOperand",
        number: 1,
        protoType: 11,
        protoName: "left_operand",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leftOperand;
  }
  get rightOperand() {
    if (!this._rightOperand) {
      this._rightOperand = {
        name: "rightOperand",
        Name: "RightOperand",
        number: 2,
        protoType: 11,
        protoName: "right_operand",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rightOperand;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.leftOperand,
        this.rightOperand,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeftOperand",
        Name: "DummyOneofForLeftOperand",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRightOperand",
        Name: "DummyOneofForRightOperand",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
AndExpression.descriptor = new AndExpression_Descriptor();
export class OrExpression {
  get descriptor() {
    return OrExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeftOperand = false;
    this._leftOperand = null;
    this._hasRightOperand = false;
    this._rightOperand = null;
  }
  isEmpty() {
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) return false;
    if (this._hasRightOperand && !this._rightOperand.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof OrExpression) {
      return value;
    }
    return OrExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new OrExpression();
    if (json.leftOperand != null) {
      result._hasLeftOperand = true;
      result._leftOperand = Expression.fromJson(json.leftOperand);
    }
    if (json.rightOperand != null) {
      result._hasRightOperand = true;
      result._rightOperand = Expression.fromJson(json.rightOperand);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) {
      result.leftOperand = Expression.toJson(this._leftOperand);
    }
    if (this._hasRightOperand && !this._rightOperand.isEmpty()) {
      result.rightOperand = Expression.toJson(this._rightOperand);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get leftOperand() {
    return this._hasLeftOperand ? this._leftOperand : Expression.default;
  }
  get hasLeftOperand() {
    return this._hasLeftOperand;
  }
  setLeftOperand(path, value) {
    return {type: 'SET', path: path.concat(['leftOperand']), value: value.toJson()};
  }
  deleteLeftOperand(path) {
    return {type: 'DELETE', path: path.concat(['leftOperand'])};
  }
  /**
   * @returns {Expression}
   */
  get rightOperand() {
    return this._hasRightOperand ? this._rightOperand : Expression.default;
  }
  get hasRightOperand() {
    return this._hasRightOperand;
  }
  setRightOperand(path, value) {
    return {type: 'SET', path: path.concat(['rightOperand']), value: value.toJson()};
  }
  deleteRightOperand(path) {
    return {type: 'DELETE', path: path.concat(['rightOperand'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "leftOperand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OrExpression(this);
              copy._hasLeftOperand = true;
              copy._leftOperand = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeftOperand) {
                return this;
              }
              const copy = new OrExpression(this);
              copy._hasLeftOperand = false;
              copy._leftOperand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeftOperand) {
            const copy = new OrExpression(this);
            copy._hasLeftOperand = true;
            copy._leftOperand = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._leftOperand.apply(type, path.slice(1), value);
          if (newValue === this._leftOperand) {
            return this;
          }
          const copy = new OrExpression(this);
          copy._leftOperand = copy._leftOperand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "rightOperand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OrExpression(this);
              copy._hasRightOperand = true;
              copy._rightOperand = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRightOperand) {
                return this;
              }
              const copy = new OrExpression(this);
              copy._hasRightOperand = false;
              copy._rightOperand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRightOperand) {
            const copy = new OrExpression(this);
            copy._hasRightOperand = true;
            copy._rightOperand = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._rightOperand.apply(type, path.slice(1), value);
          if (newValue === this._rightOperand) {
            return this;
          }
          const copy = new OrExpression(this);
          copy._rightOperand = copy._rightOperand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {OrExpression} other
   * @returns {OrExpression}
   */
  merge(other) {
    const copy = new OrExpression(this);
    if (other._hasLeftOperand) {
      if (copy._hasLeftOperand) {
        copy._leftOperand = copy.leftOperand.merge(other.leftOperand);
      } else {
        copy._leftOperand = other._leftOperand;
      }
      copy._hasLeftOperand = true;
    }
    if (other._hasRightOperand) {
      if (copy._hasRightOperand) {
        copy._rightOperand = copy.rightOperand.merge(other.rightOperand);
      } else {
        copy._rightOperand = other._rightOperand;
      }
      copy._hasRightOperand = true;
    }
    return copy;
  }
}
OrExpression.default = new OrExpression();
class OrExpression_Builder {
  constructor(value) {
    this._value = new OrExpression(value);
  }
  build() {
    return new OrExpression(this._value);
  }
  setLeftOperand(value) {
    this._value._hasLeftOperand = true;
    this._value._leftOperand = value;
    return this;
  }
  deleteLeftOperand() {
    this._value._hasLeftOperand = false;
    this._value._leftOperand = null;
    return this;
  }
  setRightOperand(value) {
    this._value._hasRightOperand = true;
    this._value._rightOperand = value;
    return this;
  }
  deleteRightOperand() {
    this._value._hasRightOperand = false;
    this._value._rightOperand = null;
    return this;
  }
}
OrExpression.Builder = OrExpression_Builder;
class OrExpression_WithParent {
  /**
   * @param {OrExpression} value
   * @param {OrExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return OrExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeftOperand() {
    if (this._cachedHasLeftOperand === undefined) {
      if (this._value.hasLeftOperand) {
        this._cachedHasLeftOperand = true;
      } else {
        this._cachedHasLeftOperand = this._parent ? this._parent.hasLeftOperand : false;
      }
    }
    return this._cachedHasLeftOperand;
  }
  get leftOperand() {
    if (!this._cachedLeftOperand) {
      if (this._value.hasLeftOperand) {
        this._cachedLeftOperand = new Expression.WithParent(this._value.leftOperand, this._parent && this._parent.hasLeftOperand ? this._parent.leftOperand : null);
      } else {
        this._cachedLeftOperand = this._parent ? new Expression.WithParent(Expression.default, this._parent.leftOperand) : Expression.WithParent.default;
      }
    }
    return this._cachedLeftOperand;
  }
  get hasRightOperand() {
    if (this._cachedHasRightOperand === undefined) {
      if (this._value.hasRightOperand) {
        this._cachedHasRightOperand = true;
      } else {
        this._cachedHasRightOperand = this._parent ? this._parent.hasRightOperand : false;
      }
    }
    return this._cachedHasRightOperand;
  }
  get rightOperand() {
    if (!this._cachedRightOperand) {
      if (this._value.hasRightOperand) {
        this._cachedRightOperand = new Expression.WithParent(this._value.rightOperand, this._parent && this._parent.hasRightOperand ? this._parent.rightOperand : null);
      } else {
        this._cachedRightOperand = this._parent ? new Expression.WithParent(Expression.default, this._parent.rightOperand) : Expression.WithParent.default;
      }
    }
    return this._cachedRightOperand;
  }
  update(current, parent) {
    const result = new OrExpression_WithParent(current, parent);
    if (this._cachedLeftOperand && this._value.hasLeftOperand && current.hasLeftOperand) {
      if (this._value.leftOperand === current.leftOperand && this._parent === parent) {
        result._cachedLeftOperand = this._cachedLeftOperand;
      } else {
        result._cachedLeftOperand = this._cachedLeftOperand.update(current.leftOperand, parent && parent.hasLeftOperand ? parent.leftOperand : null);
      }
    }
    if (this._cachedRightOperand && this._value.hasRightOperand && current.hasRightOperand) {
      if (this._value.rightOperand === current.rightOperand && this._parent === parent) {
        result._cachedRightOperand = this._cachedRightOperand;
      } else {
        result._cachedRightOperand = this._cachedRightOperand.update(current.rightOperand, parent && parent.hasRightOperand ? parent.rightOperand : null);
      }
    }
    return result;
  }
}
OrExpression_WithParent.default = new OrExpression_WithParent(OrExpression.default, null);
OrExpression.WithParent = OrExpression_WithParent;
class OrExpression_Descriptor {
  get leftOperand() {
    if (!this._leftOperand) {
      this._leftOperand = {
        name: "leftOperand",
        Name: "LeftOperand",
        number: 1,
        protoType: 11,
        protoName: "left_operand",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leftOperand;
  }
  get rightOperand() {
    if (!this._rightOperand) {
      this._rightOperand = {
        name: "rightOperand",
        Name: "RightOperand",
        number: 2,
        protoType: 11,
        protoName: "right_operand",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rightOperand;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.leftOperand,
        this.rightOperand,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeftOperand",
        Name: "DummyOneofForLeftOperand",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRightOperand",
        Name: "DummyOneofForRightOperand",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
OrExpression.descriptor = new OrExpression_Descriptor();
export class NotExpression {
  get descriptor() {
    return NotExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasOperand = false;
    this._operand = null;
  }
  isEmpty() {
    if (this._hasOperand && !this._operand.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof NotExpression) {
      return value;
    }
    return NotExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new NotExpression();
    if (json.operand != null) {
      result._hasOperand = true;
      result._operand = Expression.fromJson(json.operand);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasOperand && !this._operand.isEmpty()) {
      result.operand = Expression.toJson(this._operand);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get operand() {
    return this._hasOperand ? this._operand : Expression.default;
  }
  get hasOperand() {
    return this._hasOperand;
  }
  setOperand(path, value) {
    return {type: 'SET', path: path.concat(['operand']), value: value.toJson()};
  }
  deleteOperand(path) {
    return {type: 'DELETE', path: path.concat(['operand'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "operand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new NotExpression(this);
              copy._hasOperand = true;
              copy._operand = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOperand) {
                return this;
              }
              const copy = new NotExpression(this);
              copy._hasOperand = false;
              copy._operand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasOperand) {
            const copy = new NotExpression(this);
            copy._hasOperand = true;
            copy._operand = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._operand.apply(type, path.slice(1), value);
          if (newValue === this._operand) {
            return this;
          }
          const copy = new NotExpression(this);
          copy._operand = copy._operand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {NotExpression} other
   * @returns {NotExpression}
   */
  merge(other) {
    const copy = new NotExpression(this);
    if (other._hasOperand) {
      if (copy._hasOperand) {
        copy._operand = copy.operand.merge(other.operand);
      } else {
        copy._operand = other._operand;
      }
      copy._hasOperand = true;
    }
    return copy;
  }
}
NotExpression.default = new NotExpression();
class NotExpression_Builder {
  constructor(value) {
    this._value = new NotExpression(value);
  }
  build() {
    return new NotExpression(this._value);
  }
  setOperand(value) {
    this._value._hasOperand = true;
    this._value._operand = value;
    return this;
  }
  deleteOperand() {
    this._value._hasOperand = false;
    this._value._operand = null;
    return this;
  }
}
NotExpression.Builder = NotExpression_Builder;
class NotExpression_WithParent {
  /**
   * @param {NotExpression} value
   * @param {NotExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return NotExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasOperand() {
    if (this._cachedHasOperand === undefined) {
      if (this._value.hasOperand) {
        this._cachedHasOperand = true;
      } else {
        this._cachedHasOperand = this._parent ? this._parent.hasOperand : false;
      }
    }
    return this._cachedHasOperand;
  }
  get operand() {
    if (!this._cachedOperand) {
      if (this._value.hasOperand) {
        this._cachedOperand = new Expression.WithParent(this._value.operand, this._parent && this._parent.hasOperand ? this._parent.operand : null);
      } else {
        this._cachedOperand = this._parent ? new Expression.WithParent(Expression.default, this._parent.operand) : Expression.WithParent.default;
      }
    }
    return this._cachedOperand;
  }
  update(current, parent) {
    const result = new NotExpression_WithParent(current, parent);
    if (this._cachedOperand && this._value.hasOperand && current.hasOperand) {
      if (this._value.operand === current.operand && this._parent === parent) {
        result._cachedOperand = this._cachedOperand;
      } else {
        result._cachedOperand = this._cachedOperand.update(current.operand, parent && parent.hasOperand ? parent.operand : null);
      }
    }
    return result;
  }
}
NotExpression_WithParent.default = new NotExpression_WithParent(NotExpression.default, null);
NotExpression.WithParent = NotExpression_WithParent;
class NotExpression_Descriptor {
  get operand() {
    if (!this._operand) {
      this._operand = {
        name: "operand",
        Name: "Operand",
        number: 1,
        protoType: 11,
        protoName: "operand",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._operand;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.operand,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOperand",
        Name: "DummyOneofForOperand",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
NotExpression.descriptor = new NotExpression_Descriptor();
class ComparisonExpression_OperatorType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "NOT_EUQAL": return 1;
        case "LESS_THAN": return 2;
        case "LESS_THAN_EQUAL": return 3;
        case "EQUAL": return 4;
        case "GREATER_THAN": return 5;
        case "GREATER_THAN_EQUAL": return 6;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ComparisonExpression_OperatorType.fromJson(value);
  }
  static fromReact(e) {
    return ComparisonExpression_OperatorType.fromJson(e);
  }
}
ComparisonExpression_OperatorType.NONE = 0;
ComparisonExpression_OperatorType.NOT_EUQAL = 1;
ComparisonExpression_OperatorType.LESS_THAN = 2;
ComparisonExpression_OperatorType.LESS_THAN_EQUAL = 3;
ComparisonExpression_OperatorType.EQUAL = 4;
ComparisonExpression_OperatorType.GREATER_THAN = 5;
ComparisonExpression_OperatorType.GREATER_THAN_EQUAL = 6;
ComparisonExpression_OperatorType.default = 0;
ComparisonExpression_OperatorType.values = {
  NONE: 0,
  NOT_EUQAL: 1,
  LESS_THAN: 2,
  LESS_THAN_EQUAL: 3,
  EQUAL: 4,
  GREATER_THAN: 5,
  GREATER_THAN_EQUAL: 6,
};
ComparisonExpression_OperatorType.names = {
  0: "NONE",
  1: "NOT_EUQAL",
  2: "LESS_THAN",
  3: "LESS_THAN_EQUAL",
  4: "EQUAL",
  5: "GREATER_THAN",
  6: "GREATER_THAN_EQUAL",
};
export class ComparisonExpression {
  get descriptor() {
    return ComparisonExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasOperatorType = false;
    this._operatorType = null;
    this._hasLeftOperand = false;
    this._leftOperand = null;
    this._hasRightOperand = false;
    this._rightOperand = null;
  }
  isEmpty() {
    if (this._hasOperatorType) return false;
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) return false;
    if (this._hasRightOperand && !this._rightOperand.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ComparisonExpression) {
      return value;
    }
    return ComparisonExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ComparisonExpression();
    if (json.operatorType != null) {
      result._hasOperatorType = true;
      result._operatorType = ComparisonExpression_OperatorType.fromJson(json.operatorType);
    }
    if (json.leftOperand != null) {
      result._hasLeftOperand = true;
      result._leftOperand = Expression.fromJson(json.leftOperand);
    }
    if (json.rightOperand != null) {
      result._hasRightOperand = true;
      result._rightOperand = Expression.fromJson(json.rightOperand);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasOperatorType) {
      result.operatorType = ComparisonExpression_OperatorType.toJson(this._operatorType);
    }
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) {
      result.leftOperand = Expression.toJson(this._leftOperand);
    }
    if (this._hasRightOperand && !this._rightOperand.isEmpty()) {
      result.rightOperand = Expression.toJson(this._rightOperand);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get operatorType() {
    return this._hasOperatorType ? this._operatorType : ComparisonExpression_OperatorType.default;
  }
  get hasOperatorType() {
    return this._hasOperatorType;
  }
  setOperatorType(path, value) {
    return {type: 'SET', path: path.concat(['operatorType']), value};
  }
  deleteOperatorType(path) {
    return {type: 'DELETE', path: path.concat(['operatorType'])};
  }
  /**
   * @returns {Expression}
   */
  get leftOperand() {
    return this._hasLeftOperand ? this._leftOperand : Expression.default;
  }
  get hasLeftOperand() {
    return this._hasLeftOperand;
  }
  setLeftOperand(path, value) {
    return {type: 'SET', path: path.concat(['leftOperand']), value: value.toJson()};
  }
  deleteLeftOperand(path) {
    return {type: 'DELETE', path: path.concat(['leftOperand'])};
  }
  /**
   * @returns {Expression}
   */
  get rightOperand() {
    return this._hasRightOperand ? this._rightOperand : Expression.default;
  }
  get hasRightOperand() {
    return this._hasRightOperand;
  }
  setRightOperand(path, value) {
    return {type: 'SET', path: path.concat(['rightOperand']), value: value.toJson()};
  }
  deleteRightOperand(path) {
    return {type: 'DELETE', path: path.concat(['rightOperand'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "operatorType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ComparisonExpression(this);
              copy._hasOperatorType = true;
              copy._operatorType = ComparisonExpression_OperatorType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOperatorType) {
                return this;
              }
              const copy = new ComparisonExpression(this);
              copy._hasOperatorType = false;
              copy._operatorType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "leftOperand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ComparisonExpression(this);
              copy._hasLeftOperand = true;
              copy._leftOperand = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeftOperand) {
                return this;
              }
              const copy = new ComparisonExpression(this);
              copy._hasLeftOperand = false;
              copy._leftOperand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeftOperand) {
            const copy = new ComparisonExpression(this);
            copy._hasLeftOperand = true;
            copy._leftOperand = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._leftOperand.apply(type, path.slice(1), value);
          if (newValue === this._leftOperand) {
            return this;
          }
          const copy = new ComparisonExpression(this);
          copy._leftOperand = copy._leftOperand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "rightOperand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ComparisonExpression(this);
              copy._hasRightOperand = true;
              copy._rightOperand = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRightOperand) {
                return this;
              }
              const copy = new ComparisonExpression(this);
              copy._hasRightOperand = false;
              copy._rightOperand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRightOperand) {
            const copy = new ComparisonExpression(this);
            copy._hasRightOperand = true;
            copy._rightOperand = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._rightOperand.apply(type, path.slice(1), value);
          if (newValue === this._rightOperand) {
            return this;
          }
          const copy = new ComparisonExpression(this);
          copy._rightOperand = copy._rightOperand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ComparisonExpression} other
   * @returns {ComparisonExpression}
   */
  merge(other) {
    const copy = new ComparisonExpression(this);
    if (other._hasOperatorType) {
      copy._hasOperatorType = true;
      copy._operatorType = other._operatorType;
    }
    if (other._hasLeftOperand) {
      if (copy._hasLeftOperand) {
        copy._leftOperand = copy.leftOperand.merge(other.leftOperand);
      } else {
        copy._leftOperand = other._leftOperand;
      }
      copy._hasLeftOperand = true;
    }
    if (other._hasRightOperand) {
      if (copy._hasRightOperand) {
        copy._rightOperand = copy.rightOperand.merge(other.rightOperand);
      } else {
        copy._rightOperand = other._rightOperand;
      }
      copy._hasRightOperand = true;
    }
    return copy;
  }
}
ComparisonExpression.default = new ComparisonExpression();
ComparisonExpression.OperatorType = ComparisonExpression_OperatorType;
class ComparisonExpression_Builder {
  constructor(value) {
    this._value = new ComparisonExpression(value);
  }
  build() {
    return new ComparisonExpression(this._value);
  }
  setOperatorType(value) {
    this._value._hasOperatorType = true;
    this._value._operatorType = value;
    return this;
  }
  deleteOperatorType() {
    this._value._hasOperatorType = false;
    this._value._operatorType = null;
    return this;
  }
  setLeftOperand(value) {
    this._value._hasLeftOperand = true;
    this._value._leftOperand = value;
    return this;
  }
  deleteLeftOperand() {
    this._value._hasLeftOperand = false;
    this._value._leftOperand = null;
    return this;
  }
  setRightOperand(value) {
    this._value._hasRightOperand = true;
    this._value._rightOperand = value;
    return this;
  }
  deleteRightOperand() {
    this._value._hasRightOperand = false;
    this._value._rightOperand = null;
    return this;
  }
}
ComparisonExpression.Builder = ComparisonExpression_Builder;
class ComparisonExpression_WithParent {
  /**
   * @param {ComparisonExpression} value
   * @param {ComparisonExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ComparisonExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasOperatorType() {
    if (this._cachedHasOperatorType === undefined) {
      if (this._value.hasOperatorType) {
        this._cachedHasOperatorType = true;
      } else {
        this._cachedHasOperatorType = this._parent ? this._parent.hasOperatorType : false;
      }
    }
    return this._cachedHasOperatorType;
  }
  get operatorType() {
    if (this._cachedOperatorType === undefined) {
      if (this._value.hasOperatorType) {
        this._cachedOperatorType = this._value.operatorType;
      } else {
        this._cachedOperatorType = this._parent ? this._parent.operatorType : this._value.operatorType;
      }
    }
    return this._cachedOperatorType;
  }
  get hasLeftOperand() {
    if (this._cachedHasLeftOperand === undefined) {
      if (this._value.hasLeftOperand) {
        this._cachedHasLeftOperand = true;
      } else {
        this._cachedHasLeftOperand = this._parent ? this._parent.hasLeftOperand : false;
      }
    }
    return this._cachedHasLeftOperand;
  }
  get leftOperand() {
    if (!this._cachedLeftOperand) {
      if (this._value.hasLeftOperand) {
        this._cachedLeftOperand = new Expression.WithParent(this._value.leftOperand, this._parent && this._parent.hasLeftOperand ? this._parent.leftOperand : null);
      } else {
        this._cachedLeftOperand = this._parent ? new Expression.WithParent(Expression.default, this._parent.leftOperand) : Expression.WithParent.default;
      }
    }
    return this._cachedLeftOperand;
  }
  get hasRightOperand() {
    if (this._cachedHasRightOperand === undefined) {
      if (this._value.hasRightOperand) {
        this._cachedHasRightOperand = true;
      } else {
        this._cachedHasRightOperand = this._parent ? this._parent.hasRightOperand : false;
      }
    }
    return this._cachedHasRightOperand;
  }
  get rightOperand() {
    if (!this._cachedRightOperand) {
      if (this._value.hasRightOperand) {
        this._cachedRightOperand = new Expression.WithParent(this._value.rightOperand, this._parent && this._parent.hasRightOperand ? this._parent.rightOperand : null);
      } else {
        this._cachedRightOperand = this._parent ? new Expression.WithParent(Expression.default, this._parent.rightOperand) : Expression.WithParent.default;
      }
    }
    return this._cachedRightOperand;
  }
  update(current, parent) {
    const result = new ComparisonExpression_WithParent(current, parent);
    if (this._cachedLeftOperand && this._value.hasLeftOperand && current.hasLeftOperand) {
      if (this._value.leftOperand === current.leftOperand && this._parent === parent) {
        result._cachedLeftOperand = this._cachedLeftOperand;
      } else {
        result._cachedLeftOperand = this._cachedLeftOperand.update(current.leftOperand, parent && parent.hasLeftOperand ? parent.leftOperand : null);
      }
    }
    if (this._cachedRightOperand && this._value.hasRightOperand && current.hasRightOperand) {
      if (this._value.rightOperand === current.rightOperand && this._parent === parent) {
        result._cachedRightOperand = this._cachedRightOperand;
      } else {
        result._cachedRightOperand = this._cachedRightOperand.update(current.rightOperand, parent && parent.hasRightOperand ? parent.rightOperand : null);
      }
    }
    return result;
  }
}
ComparisonExpression_WithParent.default = new ComparisonExpression_WithParent(ComparisonExpression.default, null);
ComparisonExpression.WithParent = ComparisonExpression_WithParent;
class ComparisonExpression_Descriptor {
  get operatorType() {
    if (!this._operatorType) {
      this._operatorType = {
        name: "operatorType",
        Name: "OperatorType",
        number: 1,
        protoType: 14,
        protoName: "operator_type",
        type: ComparisonExpression_OperatorType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._operatorType;
  }
  get leftOperand() {
    if (!this._leftOperand) {
      this._leftOperand = {
        name: "leftOperand",
        Name: "LeftOperand",
        number: 2,
        protoType: 11,
        protoName: "left_operand",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leftOperand;
  }
  get rightOperand() {
    if (!this._rightOperand) {
      this._rightOperand = {
        name: "rightOperand",
        Name: "RightOperand",
        number: 3,
        protoType: 11,
        protoName: "right_operand",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rightOperand;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.operatorType,
        this.leftOperand,
        this.rightOperand,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOperatorType",
        Name: "DummyOneofForOperatorType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLeftOperand",
        Name: "DummyOneofForLeftOperand",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRightOperand",
        Name: "DummyOneofForRightOperand",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ComparisonExpression.descriptor = new ComparisonExpression_Descriptor();
export class LogicalExpression {
  get descriptor() {
    return LogicalExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._logicalExpressionTypeCase = 0;
    this._logicalExpressionTypeValue = null;
  }
  isEmpty() {
    if (this._logicalExpressionTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof LogicalExpression) {
      return value;
    }
    return LogicalExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new LogicalExpression();
    if (json.andExpression != null) {
      result._logicalExpressionTypeCase = 1;
      result._logicalExpressionTypeValue = AndExpression.fromJson(json.andExpression);
    }
    if (json.orExpression != null) {
      result._logicalExpressionTypeCase = 2;
      result._logicalExpressionTypeValue = OrExpression.fromJson(json.orExpression);
    }
    if (json.notExpression != null) {
      result._logicalExpressionTypeCase = 3;
      result._logicalExpressionTypeValue = NotExpression.fromJson(json.notExpression);
    }
    if (json.comparisonExpression != null) {
      result._logicalExpressionTypeCase = 4;
      result._logicalExpressionTypeValue = ComparisonExpression.fromJson(json.comparisonExpression);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._logicalExpressionTypeCase) {
      case 1:
        result.andExpression = AndExpression.toJson(this._logicalExpressionTypeValue);
        break;
      case 2:
        result.orExpression = OrExpression.toJson(this._logicalExpressionTypeValue);
        break;
      case 3:
        result.notExpression = NotExpression.toJson(this._logicalExpressionTypeValue);
        break;
      case 4:
        result.comparisonExpression = ComparisonExpression.toJson(this._logicalExpressionTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get logicalExpressionTypeCase() {
    return this._logicalExpressionTypeCase;
  }
  deleteLogicalExpressionType(path) {
    switch (this._logicalExpressionTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['andExpression'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['orExpression'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['notExpression'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['comparisonExpression'])};
      }
    }
  }
  /**
   * @returns {AndExpression}
   */
  get andExpression() {
    return this._logicalExpressionTypeCase === 1 ? this._logicalExpressionTypeValue : AndExpression.default;
  }
  setAndExpression(path, value) {
    return {type: 'SET', path: path.concat(['andExpression']), value: value.toJson()};
  }
  deleteAndExpression(path) {
    return {type: 'DELETE', path: path.concat(['andExpression'])};
  }
  /**
   * @returns {OrExpression}
   */
  get orExpression() {
    return this._logicalExpressionTypeCase === 2 ? this._logicalExpressionTypeValue : OrExpression.default;
  }
  setOrExpression(path, value) {
    return {type: 'SET', path: path.concat(['orExpression']), value: value.toJson()};
  }
  deleteOrExpression(path) {
    return {type: 'DELETE', path: path.concat(['orExpression'])};
  }
  /**
   * @returns {NotExpression}
   */
  get notExpression() {
    return this._logicalExpressionTypeCase === 3 ? this._logicalExpressionTypeValue : NotExpression.default;
  }
  setNotExpression(path, value) {
    return {type: 'SET', path: path.concat(['notExpression']), value: value.toJson()};
  }
  deleteNotExpression(path) {
    return {type: 'DELETE', path: path.concat(['notExpression'])};
  }
  /**
   * @returns {ComparisonExpression}
   */
  get comparisonExpression() {
    return this._logicalExpressionTypeCase === 4 ? this._logicalExpressionTypeValue : ComparisonExpression.default;
  }
  setComparisonExpression(path, value) {
    return {type: 'SET', path: path.concat(['comparisonExpression']), value: value.toJson()};
  }
  deleteComparisonExpression(path) {
    return {type: 'DELETE', path: path.concat(['comparisonExpression'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "andExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LogicalExpression(this);
              copy._logicalExpressionTypeCase = 1;
              copy._logicalExpressionTypeValue = AndExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._logicalExpressionTypeCase !== 1) {
                return this;
              }
              const copy = new LogicalExpression(this);
              copy._logicalExpressionTypeCase = 0;
              copy._logicalExpressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._logicalExpressionTypeCase !== 1) {
            const copy = new LogicalExpression(this);
            copy._logicalExpressionTypeCase = 1;
            copy._logicalExpressionTypeValue = AndExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.andExpression.apply(type, path.slice(1), value);
          if (newValue === this.andExpression) {
            return this;
          }
          const copy = new LogicalExpression(this);
          copy._logicalExpressionTypeCase = 1;
          copy._logicalExpressionTypeValue = newValue;
          return copy;
        }
      }
      case "orExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LogicalExpression(this);
              copy._logicalExpressionTypeCase = 2;
              copy._logicalExpressionTypeValue = OrExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._logicalExpressionTypeCase !== 2) {
                return this;
              }
              const copy = new LogicalExpression(this);
              copy._logicalExpressionTypeCase = 0;
              copy._logicalExpressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._logicalExpressionTypeCase !== 2) {
            const copy = new LogicalExpression(this);
            copy._logicalExpressionTypeCase = 2;
            copy._logicalExpressionTypeValue = OrExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.orExpression.apply(type, path.slice(1), value);
          if (newValue === this.orExpression) {
            return this;
          }
          const copy = new LogicalExpression(this);
          copy._logicalExpressionTypeCase = 2;
          copy._logicalExpressionTypeValue = newValue;
          return copy;
        }
      }
      case "notExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LogicalExpression(this);
              copy._logicalExpressionTypeCase = 3;
              copy._logicalExpressionTypeValue = NotExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._logicalExpressionTypeCase !== 3) {
                return this;
              }
              const copy = new LogicalExpression(this);
              copy._logicalExpressionTypeCase = 0;
              copy._logicalExpressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._logicalExpressionTypeCase !== 3) {
            const copy = new LogicalExpression(this);
            copy._logicalExpressionTypeCase = 3;
            copy._logicalExpressionTypeValue = NotExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.notExpression.apply(type, path.slice(1), value);
          if (newValue === this.notExpression) {
            return this;
          }
          const copy = new LogicalExpression(this);
          copy._logicalExpressionTypeCase = 3;
          copy._logicalExpressionTypeValue = newValue;
          return copy;
        }
      }
      case "comparisonExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LogicalExpression(this);
              copy._logicalExpressionTypeCase = 4;
              copy._logicalExpressionTypeValue = ComparisonExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._logicalExpressionTypeCase !== 4) {
                return this;
              }
              const copy = new LogicalExpression(this);
              copy._logicalExpressionTypeCase = 0;
              copy._logicalExpressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._logicalExpressionTypeCase !== 4) {
            const copy = new LogicalExpression(this);
            copy._logicalExpressionTypeCase = 4;
            copy._logicalExpressionTypeValue = ComparisonExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.comparisonExpression.apply(type, path.slice(1), value);
          if (newValue === this.comparisonExpression) {
            return this;
          }
          const copy = new LogicalExpression(this);
          copy._logicalExpressionTypeCase = 4;
          copy._logicalExpressionTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {LogicalExpression} other
   * @returns {LogicalExpression}
   */
  merge(other) {
    const copy = new LogicalExpression(this);
    if (other._logicalExpressionTypeCase === 1) {
      if (this._logicalExpressionTypeCase === 1) {
        copy._logicalExpressionTypeValue = copy._logicalExpressionTypeValue.merge(other._logicalExpressionTypeValue);
      } else {
        copy._logicalExpressionTypeValue = other._logicalExpressionTypeValue;
      }
      copy._logicalExpressionTypeCase = 1;
    }
    if (other._logicalExpressionTypeCase === 1) {
      if (this._logicalExpressionTypeCase === 1) {
        copy._logicalExpressionTypeValue = copy._logicalExpressionTypeValue.merge(other._logicalExpressionTypeValue);
      } else {
        copy._logicalExpressionTypeValue = other._logicalExpressionTypeValue;
      }
      copy._logicalExpressionTypeCase = 1;
    }
    if (other._logicalExpressionTypeCase === 1) {
      if (this._logicalExpressionTypeCase === 1) {
        copy._logicalExpressionTypeValue = copy._logicalExpressionTypeValue.merge(other._logicalExpressionTypeValue);
      } else {
        copy._logicalExpressionTypeValue = other._logicalExpressionTypeValue;
      }
      copy._logicalExpressionTypeCase = 1;
    }
    if (other._logicalExpressionTypeCase === 1) {
      if (this._logicalExpressionTypeCase === 1) {
        copy._logicalExpressionTypeValue = copy._logicalExpressionTypeValue.merge(other._logicalExpressionTypeValue);
      } else {
        copy._logicalExpressionTypeValue = other._logicalExpressionTypeValue;
      }
      copy._logicalExpressionTypeCase = 1;
    }
    return copy;
  }
}
LogicalExpression.default = new LogicalExpression();
class LogicalExpression_Builder {
  constructor(value) {
    this._value = new LogicalExpression(value);
  }
  build() {
    return new LogicalExpression(this._value);
  }
  clearlogicalExpressionType() {
    this._value._logicalExpressionTypeCase = 0;
    this._value._logicalExpressionTypeValue = null;
    return this;
  }
  setAndExpression(value) {
    this._value._logicalExpressionTypeCase = 1;
    this._value._logicalExpressionTypeValue = value;
    return this;
  }
  setOrExpression(value) {
    this._value._logicalExpressionTypeCase = 2;
    this._value._logicalExpressionTypeValue = value;
    return this;
  }
  setNotExpression(value) {
    this._value._logicalExpressionTypeCase = 3;
    this._value._logicalExpressionTypeValue = value;
    return this;
  }
  setComparisonExpression(value) {
    this._value._logicalExpressionTypeCase = 4;
    this._value._logicalExpressionTypeValue = value;
    return this;
  }
}
LogicalExpression.Builder = LogicalExpression_Builder;
class LogicalExpression_WithParent {
  /**
   * @param {LogicalExpression} value
   * @param {LogicalExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return LogicalExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get logicalExpressionTypeCase() {
    if (this._cachedlogicalExpressionTypeCase === undefined) {
      if (this._value._logicalExpressionTypeCase === 0) {
        this._cachedlogicalExpressionTypeCase = this._parent ? this._parent.logicalExpressionTypeCase : 0;
      } else {
        this._cachedlogicalExpressionTypeCase = this._value._logicalExpressionTypeCase;
      }
    }
    return this._cachedlogicalExpressionTypeCase;
  }
  get andExpression() {
    if (!this._cachedAndExpression) {
      if (this._value._logicalExpressionTypeCase === 0) {
        this._cachedAndExpression = this._parent ? new AndExpression.WithParent(AndExpression.default, this._parent.andExpression) : this._value.andExpression;
      } else if (this._value._logicalExpressionTypeCase === 1) {
        this._cachedAndExpression = new AndExpression.WithParent(this._value.andExpression, this._parent && this._parent.logicalExpressionTypeCase === 1 ? this._parent.andExpression : null);
      } else {
        this._cachedAndExpression = AndExpression.WithParent.default;
      }
    }
    return this._cachedAndExpression;
  }
  get orExpression() {
    if (!this._cachedOrExpression) {
      if (this._value._logicalExpressionTypeCase === 0) {
        this._cachedOrExpression = this._parent ? new OrExpression.WithParent(OrExpression.default, this._parent.orExpression) : this._value.orExpression;
      } else if (this._value._logicalExpressionTypeCase === 2) {
        this._cachedOrExpression = new OrExpression.WithParent(this._value.orExpression, this._parent && this._parent.logicalExpressionTypeCase === 2 ? this._parent.orExpression : null);
      } else {
        this._cachedOrExpression = OrExpression.WithParent.default;
      }
    }
    return this._cachedOrExpression;
  }
  get notExpression() {
    if (!this._cachedNotExpression) {
      if (this._value._logicalExpressionTypeCase === 0) {
        this._cachedNotExpression = this._parent ? new NotExpression.WithParent(NotExpression.default, this._parent.notExpression) : this._value.notExpression;
      } else if (this._value._logicalExpressionTypeCase === 3) {
        this._cachedNotExpression = new NotExpression.WithParent(this._value.notExpression, this._parent && this._parent.logicalExpressionTypeCase === 3 ? this._parent.notExpression : null);
      } else {
        this._cachedNotExpression = NotExpression.WithParent.default;
      }
    }
    return this._cachedNotExpression;
  }
  get comparisonExpression() {
    if (!this._cachedComparisonExpression) {
      if (this._value._logicalExpressionTypeCase === 0) {
        this._cachedComparisonExpression = this._parent ? new ComparisonExpression.WithParent(ComparisonExpression.default, this._parent.comparisonExpression) : this._value.comparisonExpression;
      } else if (this._value._logicalExpressionTypeCase === 4) {
        this._cachedComparisonExpression = new ComparisonExpression.WithParent(this._value.comparisonExpression, this._parent && this._parent.logicalExpressionTypeCase === 4 ? this._parent.comparisonExpression : null);
      } else {
        this._cachedComparisonExpression = ComparisonExpression.WithParent.default;
      }
    }
    return this._cachedComparisonExpression;
  }
  update(current, parent) {
    const result = new LogicalExpression_WithParent(current, parent);
    if (this._cachedAndExpression && this._value._logicalExpressionTypeCase === 1 && current._logicalExpressionTypeCase === 1) {
      if (this._value.andExpression === current.andExpression && this._parent === parent) {
        result._cachedAndExpression = this._cachedAndExpression;
      } else {
        result._cachedAndExpression = this._cachedAndExpression.update(current.andExpression, parent && parent.logicalExpressionTypeCase === 1 ? parent.andExpression : null);
      }
    }
    if (this._cachedOrExpression && this._value._logicalExpressionTypeCase === 2 && current._logicalExpressionTypeCase === 2) {
      if (this._value.orExpression === current.orExpression && this._parent === parent) {
        result._cachedOrExpression = this._cachedOrExpression;
      } else {
        result._cachedOrExpression = this._cachedOrExpression.update(current.orExpression, parent && parent.logicalExpressionTypeCase === 2 ? parent.orExpression : null);
      }
    }
    if (this._cachedNotExpression && this._value._logicalExpressionTypeCase === 3 && current._logicalExpressionTypeCase === 3) {
      if (this._value.notExpression === current.notExpression && this._parent === parent) {
        result._cachedNotExpression = this._cachedNotExpression;
      } else {
        result._cachedNotExpression = this._cachedNotExpression.update(current.notExpression, parent && parent.logicalExpressionTypeCase === 3 ? parent.notExpression : null);
      }
    }
    if (this._cachedComparisonExpression && this._value._logicalExpressionTypeCase === 4 && current._logicalExpressionTypeCase === 4) {
      if (this._value.comparisonExpression === current.comparisonExpression && this._parent === parent) {
        result._cachedComparisonExpression = this._cachedComparisonExpression;
      } else {
        result._cachedComparisonExpression = this._cachedComparisonExpression.update(current.comparisonExpression, parent && parent.logicalExpressionTypeCase === 4 ? parent.comparisonExpression : null);
      }
    }
    return result;
  }
}
LogicalExpression_WithParent.default = new LogicalExpression_WithParent(LogicalExpression.default, null);
LogicalExpression.WithParent = LogicalExpression_WithParent;
class LogicalExpression_Descriptor {
  get andExpression() {
    if (!this._andExpression) {
      this._andExpression = {
        name: "andExpression",
        Name: "AndExpression",
        number: 1,
        protoType: 11,
        protoName: "and_expression",
        oneofIndex: 0,
        type: AndExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._andExpression;
  }
  get orExpression() {
    if (!this._orExpression) {
      this._orExpression = {
        name: "orExpression",
        Name: "OrExpression",
        number: 2,
        protoType: 11,
        protoName: "or_expression",
        oneofIndex: 0,
        type: OrExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._orExpression;
  }
  get notExpression() {
    if (!this._notExpression) {
      this._notExpression = {
        name: "notExpression",
        Name: "NotExpression",
        number: 3,
        protoType: 11,
        protoName: "not_expression",
        oneofIndex: 0,
        type: NotExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._notExpression;
  }
  get comparisonExpression() {
    if (!this._comparisonExpression) {
      this._comparisonExpression = {
        name: "comparisonExpression",
        Name: "ComparisonExpression",
        number: 4,
        protoType: 11,
        protoName: "comparison_expression",
        oneofIndex: 0,
        type: ComparisonExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comparisonExpression;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.andExpression,
        this.orExpression,
        this.notExpression,
        this.comparisonExpression,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "logicalExpressionType",
        Name: "LogicalExpressionType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
LogicalExpression.descriptor = new LogicalExpression_Descriptor();
class ArithmeticExpression_OperatorType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "ADD": return 1;
        case "SUBTRACT": return 2;
        case "MULTIPLY": return 3;
        case "DIVIDE": return 4;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ArithmeticExpression_OperatorType.fromJson(value);
  }
  static fromReact(e) {
    return ArithmeticExpression_OperatorType.fromJson(e);
  }
}
ArithmeticExpression_OperatorType.NONE = 0;
ArithmeticExpression_OperatorType.ADD = 1;
ArithmeticExpression_OperatorType.SUBTRACT = 2;
ArithmeticExpression_OperatorType.MULTIPLY = 3;
ArithmeticExpression_OperatorType.DIVIDE = 4;
ArithmeticExpression_OperatorType.default = 0;
ArithmeticExpression_OperatorType.values = {
  NONE: 0,
  ADD: 1,
  SUBTRACT: 2,
  MULTIPLY: 3,
  DIVIDE: 4,
};
ArithmeticExpression_OperatorType.names = {
  0: "NONE",
  1: "ADD",
  2: "SUBTRACT",
  3: "MULTIPLY",
  4: "DIVIDE",
};
export class ArithmeticExpression {
  get descriptor() {
    return ArithmeticExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasOperatorType = false;
    this._operatorType = null;
    this._hasLeftOperand = false;
    this._leftOperand = null;
    this._hasRightOperand = false;
    this._rightOperand = null;
  }
  isEmpty() {
    if (this._hasOperatorType) return false;
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) return false;
    if (this._hasRightOperand && !this._rightOperand.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArithmeticExpression) {
      return value;
    }
    return ArithmeticExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArithmeticExpression();
    if (json.operatorType != null) {
      result._hasOperatorType = true;
      result._operatorType = ArithmeticExpression_OperatorType.fromJson(json.operatorType);
    }
    if (json.leftOperand != null) {
      result._hasLeftOperand = true;
      result._leftOperand = Expression.fromJson(json.leftOperand);
    }
    if (json.rightOperand != null) {
      result._hasRightOperand = true;
      result._rightOperand = Expression.fromJson(json.rightOperand);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasOperatorType) {
      result.operatorType = ArithmeticExpression_OperatorType.toJson(this._operatorType);
    }
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) {
      result.leftOperand = Expression.toJson(this._leftOperand);
    }
    if (this._hasRightOperand && !this._rightOperand.isEmpty()) {
      result.rightOperand = Expression.toJson(this._rightOperand);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get operatorType() {
    return this._hasOperatorType ? this._operatorType : ArithmeticExpression_OperatorType.default;
  }
  get hasOperatorType() {
    return this._hasOperatorType;
  }
  setOperatorType(path, value) {
    return {type: 'SET', path: path.concat(['operatorType']), value};
  }
  deleteOperatorType(path) {
    return {type: 'DELETE', path: path.concat(['operatorType'])};
  }
  /**
   * @returns {Expression}
   */
  get leftOperand() {
    return this._hasLeftOperand ? this._leftOperand : Expression.default;
  }
  get hasLeftOperand() {
    return this._hasLeftOperand;
  }
  setLeftOperand(path, value) {
    return {type: 'SET', path: path.concat(['leftOperand']), value: value.toJson()};
  }
  deleteLeftOperand(path) {
    return {type: 'DELETE', path: path.concat(['leftOperand'])};
  }
  /**
   * @returns {Expression}
   */
  get rightOperand() {
    return this._hasRightOperand ? this._rightOperand : Expression.default;
  }
  get hasRightOperand() {
    return this._hasRightOperand;
  }
  setRightOperand(path, value) {
    return {type: 'SET', path: path.concat(['rightOperand']), value: value.toJson()};
  }
  deleteRightOperand(path) {
    return {type: 'DELETE', path: path.concat(['rightOperand'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "operatorType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArithmeticExpression(this);
              copy._hasOperatorType = true;
              copy._operatorType = ArithmeticExpression_OperatorType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOperatorType) {
                return this;
              }
              const copy = new ArithmeticExpression(this);
              copy._hasOperatorType = false;
              copy._operatorType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "leftOperand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArithmeticExpression(this);
              copy._hasLeftOperand = true;
              copy._leftOperand = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeftOperand) {
                return this;
              }
              const copy = new ArithmeticExpression(this);
              copy._hasLeftOperand = false;
              copy._leftOperand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeftOperand) {
            const copy = new ArithmeticExpression(this);
            copy._hasLeftOperand = true;
            copy._leftOperand = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._leftOperand.apply(type, path.slice(1), value);
          if (newValue === this._leftOperand) {
            return this;
          }
          const copy = new ArithmeticExpression(this);
          copy._leftOperand = copy._leftOperand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "rightOperand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArithmeticExpression(this);
              copy._hasRightOperand = true;
              copy._rightOperand = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRightOperand) {
                return this;
              }
              const copy = new ArithmeticExpression(this);
              copy._hasRightOperand = false;
              copy._rightOperand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRightOperand) {
            const copy = new ArithmeticExpression(this);
            copy._hasRightOperand = true;
            copy._rightOperand = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._rightOperand.apply(type, path.slice(1), value);
          if (newValue === this._rightOperand) {
            return this;
          }
          const copy = new ArithmeticExpression(this);
          copy._rightOperand = copy._rightOperand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArithmeticExpression} other
   * @returns {ArithmeticExpression}
   */
  merge(other) {
    const copy = new ArithmeticExpression(this);
    if (other._hasOperatorType) {
      copy._hasOperatorType = true;
      copy._operatorType = other._operatorType;
    }
    if (other._hasLeftOperand) {
      if (copy._hasLeftOperand) {
        copy._leftOperand = copy.leftOperand.merge(other.leftOperand);
      } else {
        copy._leftOperand = other._leftOperand;
      }
      copy._hasLeftOperand = true;
    }
    if (other._hasRightOperand) {
      if (copy._hasRightOperand) {
        copy._rightOperand = copy.rightOperand.merge(other.rightOperand);
      } else {
        copy._rightOperand = other._rightOperand;
      }
      copy._hasRightOperand = true;
    }
    return copy;
  }
}
ArithmeticExpression.default = new ArithmeticExpression();
ArithmeticExpression.OperatorType = ArithmeticExpression_OperatorType;
class ArithmeticExpression_Builder {
  constructor(value) {
    this._value = new ArithmeticExpression(value);
  }
  build() {
    return new ArithmeticExpression(this._value);
  }
  setOperatorType(value) {
    this._value._hasOperatorType = true;
    this._value._operatorType = value;
    return this;
  }
  deleteOperatorType() {
    this._value._hasOperatorType = false;
    this._value._operatorType = null;
    return this;
  }
  setLeftOperand(value) {
    this._value._hasLeftOperand = true;
    this._value._leftOperand = value;
    return this;
  }
  deleteLeftOperand() {
    this._value._hasLeftOperand = false;
    this._value._leftOperand = null;
    return this;
  }
  setRightOperand(value) {
    this._value._hasRightOperand = true;
    this._value._rightOperand = value;
    return this;
  }
  deleteRightOperand() {
    this._value._hasRightOperand = false;
    this._value._rightOperand = null;
    return this;
  }
}
ArithmeticExpression.Builder = ArithmeticExpression_Builder;
class ArithmeticExpression_WithParent {
  /**
   * @param {ArithmeticExpression} value
   * @param {ArithmeticExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArithmeticExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasOperatorType() {
    if (this._cachedHasOperatorType === undefined) {
      if (this._value.hasOperatorType) {
        this._cachedHasOperatorType = true;
      } else {
        this._cachedHasOperatorType = this._parent ? this._parent.hasOperatorType : false;
      }
    }
    return this._cachedHasOperatorType;
  }
  get operatorType() {
    if (this._cachedOperatorType === undefined) {
      if (this._value.hasOperatorType) {
        this._cachedOperatorType = this._value.operatorType;
      } else {
        this._cachedOperatorType = this._parent ? this._parent.operatorType : this._value.operatorType;
      }
    }
    return this._cachedOperatorType;
  }
  get hasLeftOperand() {
    if (this._cachedHasLeftOperand === undefined) {
      if (this._value.hasLeftOperand) {
        this._cachedHasLeftOperand = true;
      } else {
        this._cachedHasLeftOperand = this._parent ? this._parent.hasLeftOperand : false;
      }
    }
    return this._cachedHasLeftOperand;
  }
  get leftOperand() {
    if (!this._cachedLeftOperand) {
      if (this._value.hasLeftOperand) {
        this._cachedLeftOperand = new Expression.WithParent(this._value.leftOperand, this._parent && this._parent.hasLeftOperand ? this._parent.leftOperand : null);
      } else {
        this._cachedLeftOperand = this._parent ? new Expression.WithParent(Expression.default, this._parent.leftOperand) : Expression.WithParent.default;
      }
    }
    return this._cachedLeftOperand;
  }
  get hasRightOperand() {
    if (this._cachedHasRightOperand === undefined) {
      if (this._value.hasRightOperand) {
        this._cachedHasRightOperand = true;
      } else {
        this._cachedHasRightOperand = this._parent ? this._parent.hasRightOperand : false;
      }
    }
    return this._cachedHasRightOperand;
  }
  get rightOperand() {
    if (!this._cachedRightOperand) {
      if (this._value.hasRightOperand) {
        this._cachedRightOperand = new Expression.WithParent(this._value.rightOperand, this._parent && this._parent.hasRightOperand ? this._parent.rightOperand : null);
      } else {
        this._cachedRightOperand = this._parent ? new Expression.WithParent(Expression.default, this._parent.rightOperand) : Expression.WithParent.default;
      }
    }
    return this._cachedRightOperand;
  }
  update(current, parent) {
    const result = new ArithmeticExpression_WithParent(current, parent);
    if (this._cachedLeftOperand && this._value.hasLeftOperand && current.hasLeftOperand) {
      if (this._value.leftOperand === current.leftOperand && this._parent === parent) {
        result._cachedLeftOperand = this._cachedLeftOperand;
      } else {
        result._cachedLeftOperand = this._cachedLeftOperand.update(current.leftOperand, parent && parent.hasLeftOperand ? parent.leftOperand : null);
      }
    }
    if (this._cachedRightOperand && this._value.hasRightOperand && current.hasRightOperand) {
      if (this._value.rightOperand === current.rightOperand && this._parent === parent) {
        result._cachedRightOperand = this._cachedRightOperand;
      } else {
        result._cachedRightOperand = this._cachedRightOperand.update(current.rightOperand, parent && parent.hasRightOperand ? parent.rightOperand : null);
      }
    }
    return result;
  }
}
ArithmeticExpression_WithParent.default = new ArithmeticExpression_WithParent(ArithmeticExpression.default, null);
ArithmeticExpression.WithParent = ArithmeticExpression_WithParent;
class ArithmeticExpression_Descriptor {
  get operatorType() {
    if (!this._operatorType) {
      this._operatorType = {
        name: "operatorType",
        Name: "OperatorType",
        number: 1,
        protoType: 14,
        protoName: "operator_type",
        type: ArithmeticExpression_OperatorType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._operatorType;
  }
  get leftOperand() {
    if (!this._leftOperand) {
      this._leftOperand = {
        name: "leftOperand",
        Name: "LeftOperand",
        number: 2,
        protoType: 11,
        protoName: "left_operand",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leftOperand;
  }
  get rightOperand() {
    if (!this._rightOperand) {
      this._rightOperand = {
        name: "rightOperand",
        Name: "RightOperand",
        number: 3,
        protoType: 11,
        protoName: "right_operand",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rightOperand;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.operatorType,
        this.leftOperand,
        this.rightOperand,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOperatorType",
        Name: "DummyOneofForOperatorType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLeftOperand",
        Name: "DummyOneofForLeftOperand",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRightOperand",
        Name: "DummyOneofForRightOperand",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ArithmeticExpression.descriptor = new ArithmeticExpression_Descriptor();
export class ArrayGetElementExpression {
  get descriptor() {
    return ArrayGetElementExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasArray = false;
    this._array = null;
    this._hasIndex = false;
    this._index = null;
  }
  isEmpty() {
    if (this._hasArray && !this._array.isEmpty()) return false;
    if (this._hasIndex && !this._index.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArrayGetElementExpression) {
      return value;
    }
    return ArrayGetElementExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArrayGetElementExpression();
    if (json.array != null) {
      result._hasArray = true;
      result._array = Expression.fromJson(json.array);
    }
    if (json.index != null) {
      result._hasIndex = true;
      result._index = Expression.fromJson(json.index);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasArray && !this._array.isEmpty()) {
      result.array = Expression.toJson(this._array);
    }
    if (this._hasIndex && !this._index.isEmpty()) {
      result.index = Expression.toJson(this._index);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get array() {
    return this._hasArray ? this._array : Expression.default;
  }
  get hasArray() {
    return this._hasArray;
  }
  setArray(path, value) {
    return {type: 'SET', path: path.concat(['array']), value: value.toJson()};
  }
  deleteArray(path) {
    return {type: 'DELETE', path: path.concat(['array'])};
  }
  /**
   * @returns {Expression}
   */
  get index() {
    return this._hasIndex ? this._index : Expression.default;
  }
  get hasIndex() {
    return this._hasIndex;
  }
  setIndex(path, value) {
    return {type: 'SET', path: path.concat(['index']), value: value.toJson()};
  }
  deleteIndex(path) {
    return {type: 'DELETE', path: path.concat(['index'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "array": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayGetElementExpression(this);
              copy._hasArray = true;
              copy._array = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArray) {
                return this;
              }
              const copy = new ArrayGetElementExpression(this);
              copy._hasArray = false;
              copy._array = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasArray) {
            const copy = new ArrayGetElementExpression(this);
            copy._hasArray = true;
            copy._array = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._array.apply(type, path.slice(1), value);
          if (newValue === this._array) {
            return this;
          }
          const copy = new ArrayGetElementExpression(this);
          copy._array = copy._array.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "index": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayGetElementExpression(this);
              copy._hasIndex = true;
              copy._index = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIndex) {
                return this;
              }
              const copy = new ArrayGetElementExpression(this);
              copy._hasIndex = false;
              copy._index = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasIndex) {
            const copy = new ArrayGetElementExpression(this);
            copy._hasIndex = true;
            copy._index = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._index.apply(type, path.slice(1), value);
          if (newValue === this._index) {
            return this;
          }
          const copy = new ArrayGetElementExpression(this);
          copy._index = copy._index.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArrayGetElementExpression} other
   * @returns {ArrayGetElementExpression}
   */
  merge(other) {
    const copy = new ArrayGetElementExpression(this);
    if (other._hasArray) {
      if (copy._hasArray) {
        copy._array = copy.array.merge(other.array);
      } else {
        copy._array = other._array;
      }
      copy._hasArray = true;
    }
    if (other._hasIndex) {
      if (copy._hasIndex) {
        copy._index = copy.index.merge(other.index);
      } else {
        copy._index = other._index;
      }
      copy._hasIndex = true;
    }
    return copy;
  }
}
ArrayGetElementExpression.default = new ArrayGetElementExpression();
class ArrayGetElementExpression_Builder {
  constructor(value) {
    this._value = new ArrayGetElementExpression(value);
  }
  build() {
    return new ArrayGetElementExpression(this._value);
  }
  setArray(value) {
    this._value._hasArray = true;
    this._value._array = value;
    return this;
  }
  deleteArray() {
    this._value._hasArray = false;
    this._value._array = null;
    return this;
  }
  setIndex(value) {
    this._value._hasIndex = true;
    this._value._index = value;
    return this;
  }
  deleteIndex() {
    this._value._hasIndex = false;
    this._value._index = null;
    return this;
  }
}
ArrayGetElementExpression.Builder = ArrayGetElementExpression_Builder;
class ArrayGetElementExpression_WithParent {
  /**
   * @param {ArrayGetElementExpression} value
   * @param {ArrayGetElementExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArrayGetElementExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasArray() {
    if (this._cachedHasArray === undefined) {
      if (this._value.hasArray) {
        this._cachedHasArray = true;
      } else {
        this._cachedHasArray = this._parent ? this._parent.hasArray : false;
      }
    }
    return this._cachedHasArray;
  }
  get array() {
    if (!this._cachedArray) {
      if (this._value.hasArray) {
        this._cachedArray = new Expression.WithParent(this._value.array, this._parent && this._parent.hasArray ? this._parent.array : null);
      } else {
        this._cachedArray = this._parent ? new Expression.WithParent(Expression.default, this._parent.array) : Expression.WithParent.default;
      }
    }
    return this._cachedArray;
  }
  get hasIndex() {
    if (this._cachedHasIndex === undefined) {
      if (this._value.hasIndex) {
        this._cachedHasIndex = true;
      } else {
        this._cachedHasIndex = this._parent ? this._parent.hasIndex : false;
      }
    }
    return this._cachedHasIndex;
  }
  get index() {
    if (!this._cachedIndex) {
      if (this._value.hasIndex) {
        this._cachedIndex = new Expression.WithParent(this._value.index, this._parent && this._parent.hasIndex ? this._parent.index : null);
      } else {
        this._cachedIndex = this._parent ? new Expression.WithParent(Expression.default, this._parent.index) : Expression.WithParent.default;
      }
    }
    return this._cachedIndex;
  }
  update(current, parent) {
    const result = new ArrayGetElementExpression_WithParent(current, parent);
    if (this._cachedArray && this._value.hasArray && current.hasArray) {
      if (this._value.array === current.array && this._parent === parent) {
        result._cachedArray = this._cachedArray;
      } else {
        result._cachedArray = this._cachedArray.update(current.array, parent && parent.hasArray ? parent.array : null);
      }
    }
    if (this._cachedIndex && this._value.hasIndex && current.hasIndex) {
      if (this._value.index === current.index && this._parent === parent) {
        result._cachedIndex = this._cachedIndex;
      } else {
        result._cachedIndex = this._cachedIndex.update(current.index, parent && parent.hasIndex ? parent.index : null);
      }
    }
    return result;
  }
}
ArrayGetElementExpression_WithParent.default = new ArrayGetElementExpression_WithParent(ArrayGetElementExpression.default, null);
ArrayGetElementExpression.WithParent = ArrayGetElementExpression_WithParent;
class ArrayGetElementExpression_Descriptor {
  get array() {
    if (!this._array) {
      this._array = {
        name: "array",
        Name: "Array",
        number: 1,
        protoType: 11,
        protoName: "array",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._array;
  }
  get index() {
    if (!this._index) {
      this._index = {
        name: "index",
        Name: "Index",
        number: 2,
        protoType: 11,
        protoName: "index",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._index;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.array,
        this.index,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForArray",
        Name: "DummyOneofForArray",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIndex",
        Name: "DummyOneofForIndex",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ArrayGetElementExpression.descriptor = new ArrayGetElementExpression_Descriptor();
export class ArrayGetLengthExpression {
  get descriptor() {
    return ArrayGetLengthExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasArray = false;
    this._array = null;
  }
  isEmpty() {
    if (this._hasArray && !this._array.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArrayGetLengthExpression) {
      return value;
    }
    return ArrayGetLengthExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArrayGetLengthExpression();
    if (json.array != null) {
      result._hasArray = true;
      result._array = Expression.fromJson(json.array);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasArray && !this._array.isEmpty()) {
      result.array = Expression.toJson(this._array);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get array() {
    return this._hasArray ? this._array : Expression.default;
  }
  get hasArray() {
    return this._hasArray;
  }
  setArray(path, value) {
    return {type: 'SET', path: path.concat(['array']), value: value.toJson()};
  }
  deleteArray(path) {
    return {type: 'DELETE', path: path.concat(['array'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "array": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayGetLengthExpression(this);
              copy._hasArray = true;
              copy._array = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArray) {
                return this;
              }
              const copy = new ArrayGetLengthExpression(this);
              copy._hasArray = false;
              copy._array = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasArray) {
            const copy = new ArrayGetLengthExpression(this);
            copy._hasArray = true;
            copy._array = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._array.apply(type, path.slice(1), value);
          if (newValue === this._array) {
            return this;
          }
          const copy = new ArrayGetLengthExpression(this);
          copy._array = copy._array.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArrayGetLengthExpression} other
   * @returns {ArrayGetLengthExpression}
   */
  merge(other) {
    const copy = new ArrayGetLengthExpression(this);
    if (other._hasArray) {
      if (copy._hasArray) {
        copy._array = copy.array.merge(other.array);
      } else {
        copy._array = other._array;
      }
      copy._hasArray = true;
    }
    return copy;
  }
}
ArrayGetLengthExpression.default = new ArrayGetLengthExpression();
class ArrayGetLengthExpression_Builder {
  constructor(value) {
    this._value = new ArrayGetLengthExpression(value);
  }
  build() {
    return new ArrayGetLengthExpression(this._value);
  }
  setArray(value) {
    this._value._hasArray = true;
    this._value._array = value;
    return this;
  }
  deleteArray() {
    this._value._hasArray = false;
    this._value._array = null;
    return this;
  }
}
ArrayGetLengthExpression.Builder = ArrayGetLengthExpression_Builder;
class ArrayGetLengthExpression_WithParent {
  /**
   * @param {ArrayGetLengthExpression} value
   * @param {ArrayGetLengthExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArrayGetLengthExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasArray() {
    if (this._cachedHasArray === undefined) {
      if (this._value.hasArray) {
        this._cachedHasArray = true;
      } else {
        this._cachedHasArray = this._parent ? this._parent.hasArray : false;
      }
    }
    return this._cachedHasArray;
  }
  get array() {
    if (!this._cachedArray) {
      if (this._value.hasArray) {
        this._cachedArray = new Expression.WithParent(this._value.array, this._parent && this._parent.hasArray ? this._parent.array : null);
      } else {
        this._cachedArray = this._parent ? new Expression.WithParent(Expression.default, this._parent.array) : Expression.WithParent.default;
      }
    }
    return this._cachedArray;
  }
  update(current, parent) {
    const result = new ArrayGetLengthExpression_WithParent(current, parent);
    if (this._cachedArray && this._value.hasArray && current.hasArray) {
      if (this._value.array === current.array && this._parent === parent) {
        result._cachedArray = this._cachedArray;
      } else {
        result._cachedArray = this._cachedArray.update(current.array, parent && parent.hasArray ? parent.array : null);
      }
    }
    return result;
  }
}
ArrayGetLengthExpression_WithParent.default = new ArrayGetLengthExpression_WithParent(ArrayGetLengthExpression.default, null);
ArrayGetLengthExpression.WithParent = ArrayGetLengthExpression_WithParent;
class ArrayGetLengthExpression_Descriptor {
  get array() {
    if (!this._array) {
      this._array = {
        name: "array",
        Name: "Array",
        number: 1,
        protoType: 11,
        protoName: "array",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._array;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.array,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForArray",
        Name: "DummyOneofForArray",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ArrayGetLengthExpression.descriptor = new ArrayGetLengthExpression_Descriptor();
export class ArrayExpression {
  get descriptor() {
    return ArrayExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._arrayExpressionTypeCase = 0;
    this._arrayExpressionTypeValue = null;
  }
  isEmpty() {
    if (this._arrayExpressionTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArrayExpression) {
      return value;
    }
    return ArrayExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArrayExpression();
    if (json.getElement != null) {
      result._arrayExpressionTypeCase = 1;
      result._arrayExpressionTypeValue = ArrayGetElementExpression.fromJson(json.getElement);
    }
    if (json.getLength != null) {
      result._arrayExpressionTypeCase = 2;
      result._arrayExpressionTypeValue = ArrayGetLengthExpression.fromJson(json.getLength);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._arrayExpressionTypeCase) {
      case 1:
        result.getElement = ArrayGetElementExpression.toJson(this._arrayExpressionTypeValue);
        break;
      case 2:
        result.getLength = ArrayGetLengthExpression.toJson(this._arrayExpressionTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get arrayExpressionTypeCase() {
    return this._arrayExpressionTypeCase;
  }
  deleteArrayExpressionType(path) {
    switch (this._arrayExpressionTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['getElement'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['getLength'])};
      }
    }
  }
  /**
   * @returns {ArrayGetElementExpression}
   */
  get getElement() {
    return this._arrayExpressionTypeCase === 1 ? this._arrayExpressionTypeValue : ArrayGetElementExpression.default;
  }
  setGetElement(path, value) {
    return {type: 'SET', path: path.concat(['getElement']), value: value.toJson()};
  }
  deleteGetElement(path) {
    return {type: 'DELETE', path: path.concat(['getElement'])};
  }
  /**
   * @returns {ArrayGetLengthExpression}
   */
  get getLength() {
    return this._arrayExpressionTypeCase === 2 ? this._arrayExpressionTypeValue : ArrayGetLengthExpression.default;
  }
  setGetLength(path, value) {
    return {type: 'SET', path: path.concat(['getLength']), value: value.toJson()};
  }
  deleteGetLength(path) {
    return {type: 'DELETE', path: path.concat(['getLength'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "getElement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayExpression(this);
              copy._arrayExpressionTypeCase = 1;
              copy._arrayExpressionTypeValue = ArrayGetElementExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._arrayExpressionTypeCase !== 1) {
                return this;
              }
              const copy = new ArrayExpression(this);
              copy._arrayExpressionTypeCase = 0;
              copy._arrayExpressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._arrayExpressionTypeCase !== 1) {
            const copy = new ArrayExpression(this);
            copy._arrayExpressionTypeCase = 1;
            copy._arrayExpressionTypeValue = ArrayGetElementExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.getElement.apply(type, path.slice(1), value);
          if (newValue === this.getElement) {
            return this;
          }
          const copy = new ArrayExpression(this);
          copy._arrayExpressionTypeCase = 1;
          copy._arrayExpressionTypeValue = newValue;
          return copy;
        }
      }
      case "getLength": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayExpression(this);
              copy._arrayExpressionTypeCase = 2;
              copy._arrayExpressionTypeValue = ArrayGetLengthExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._arrayExpressionTypeCase !== 2) {
                return this;
              }
              const copy = new ArrayExpression(this);
              copy._arrayExpressionTypeCase = 0;
              copy._arrayExpressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._arrayExpressionTypeCase !== 2) {
            const copy = new ArrayExpression(this);
            copy._arrayExpressionTypeCase = 2;
            copy._arrayExpressionTypeValue = ArrayGetLengthExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.getLength.apply(type, path.slice(1), value);
          if (newValue === this.getLength) {
            return this;
          }
          const copy = new ArrayExpression(this);
          copy._arrayExpressionTypeCase = 2;
          copy._arrayExpressionTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArrayExpression} other
   * @returns {ArrayExpression}
   */
  merge(other) {
    const copy = new ArrayExpression(this);
    if (other._arrayExpressionTypeCase === 1) {
      if (this._arrayExpressionTypeCase === 1) {
        copy._arrayExpressionTypeValue = copy._arrayExpressionTypeValue.merge(other._arrayExpressionTypeValue);
      } else {
        copy._arrayExpressionTypeValue = other._arrayExpressionTypeValue;
      }
      copy._arrayExpressionTypeCase = 1;
    }
    if (other._arrayExpressionTypeCase === 1) {
      if (this._arrayExpressionTypeCase === 1) {
        copy._arrayExpressionTypeValue = copy._arrayExpressionTypeValue.merge(other._arrayExpressionTypeValue);
      } else {
        copy._arrayExpressionTypeValue = other._arrayExpressionTypeValue;
      }
      copy._arrayExpressionTypeCase = 1;
    }
    return copy;
  }
}
ArrayExpression.default = new ArrayExpression();
class ArrayExpression_Builder {
  constructor(value) {
    this._value = new ArrayExpression(value);
  }
  build() {
    return new ArrayExpression(this._value);
  }
  cleararrayExpressionType() {
    this._value._arrayExpressionTypeCase = 0;
    this._value._arrayExpressionTypeValue = null;
    return this;
  }
  setGetElement(value) {
    this._value._arrayExpressionTypeCase = 1;
    this._value._arrayExpressionTypeValue = value;
    return this;
  }
  setGetLength(value) {
    this._value._arrayExpressionTypeCase = 2;
    this._value._arrayExpressionTypeValue = value;
    return this;
  }
}
ArrayExpression.Builder = ArrayExpression_Builder;
class ArrayExpression_WithParent {
  /**
   * @param {ArrayExpression} value
   * @param {ArrayExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArrayExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get arrayExpressionTypeCase() {
    if (this._cachedarrayExpressionTypeCase === undefined) {
      if (this._value._arrayExpressionTypeCase === 0) {
        this._cachedarrayExpressionTypeCase = this._parent ? this._parent.arrayExpressionTypeCase : 0;
      } else {
        this._cachedarrayExpressionTypeCase = this._value._arrayExpressionTypeCase;
      }
    }
    return this._cachedarrayExpressionTypeCase;
  }
  get getElement() {
    if (!this._cachedGetElement) {
      if (this._value._arrayExpressionTypeCase === 0) {
        this._cachedGetElement = this._parent ? new ArrayGetElementExpression.WithParent(ArrayGetElementExpression.default, this._parent.getElement) : this._value.getElement;
      } else if (this._value._arrayExpressionTypeCase === 1) {
        this._cachedGetElement = new ArrayGetElementExpression.WithParent(this._value.getElement, this._parent && this._parent.arrayExpressionTypeCase === 1 ? this._parent.getElement : null);
      } else {
        this._cachedGetElement = ArrayGetElementExpression.WithParent.default;
      }
    }
    return this._cachedGetElement;
  }
  get getLength() {
    if (!this._cachedGetLength) {
      if (this._value._arrayExpressionTypeCase === 0) {
        this._cachedGetLength = this._parent ? new ArrayGetLengthExpression.WithParent(ArrayGetLengthExpression.default, this._parent.getLength) : this._value.getLength;
      } else if (this._value._arrayExpressionTypeCase === 2) {
        this._cachedGetLength = new ArrayGetLengthExpression.WithParent(this._value.getLength, this._parent && this._parent.arrayExpressionTypeCase === 2 ? this._parent.getLength : null);
      } else {
        this._cachedGetLength = ArrayGetLengthExpression.WithParent.default;
      }
    }
    return this._cachedGetLength;
  }
  update(current, parent) {
    const result = new ArrayExpression_WithParent(current, parent);
    if (this._cachedGetElement && this._value._arrayExpressionTypeCase === 1 && current._arrayExpressionTypeCase === 1) {
      if (this._value.getElement === current.getElement && this._parent === parent) {
        result._cachedGetElement = this._cachedGetElement;
      } else {
        result._cachedGetElement = this._cachedGetElement.update(current.getElement, parent && parent.arrayExpressionTypeCase === 1 ? parent.getElement : null);
      }
    }
    if (this._cachedGetLength && this._value._arrayExpressionTypeCase === 2 && current._arrayExpressionTypeCase === 2) {
      if (this._value.getLength === current.getLength && this._parent === parent) {
        result._cachedGetLength = this._cachedGetLength;
      } else {
        result._cachedGetLength = this._cachedGetLength.update(current.getLength, parent && parent.arrayExpressionTypeCase === 2 ? parent.getLength : null);
      }
    }
    return result;
  }
}
ArrayExpression_WithParent.default = new ArrayExpression_WithParent(ArrayExpression.default, null);
ArrayExpression.WithParent = ArrayExpression_WithParent;
class ArrayExpression_Descriptor {
  get getElement() {
    if (!this._getElement) {
      this._getElement = {
        name: "getElement",
        Name: "GetElement",
        number: 1,
        protoType: 11,
        protoName: "get_element",
        oneofIndex: 0,
        type: ArrayGetElementExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._getElement;
  }
  get getLength() {
    if (!this._getLength) {
      this._getLength = {
        name: "getLength",
        Name: "GetLength",
        number: 2,
        protoType: 11,
        protoName: "get_length",
        oneofIndex: 0,
        type: ArrayGetLengthExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._getLength;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.getElement,
        this.getLength,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "arrayExpressionType",
        Name: "ArrayExpressionType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ArrayExpression.descriptor = new ArrayExpression_Descriptor();
export class TableGetElementExpression {
  get descriptor() {
    return TableGetElementExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTable = false;
    this._table = null;
    this._hasKey = false;
    this._key = null;
  }
  isEmpty() {
    if (this._hasTable && !this._table.isEmpty()) return false;
    if (this._hasKey && !this._key.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TableGetElementExpression) {
      return value;
    }
    return TableGetElementExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new TableGetElementExpression();
    if (json.table != null) {
      result._hasTable = true;
      result._table = Expression.fromJson(json.table);
    }
    if (json.key != null) {
      result._hasKey = true;
      result._key = Expression.fromJson(json.key);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTable && !this._table.isEmpty()) {
      result.table = Expression.toJson(this._table);
    }
    if (this._hasKey && !this._key.isEmpty()) {
      result.key = Expression.toJson(this._key);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get table() {
    return this._hasTable ? this._table : Expression.default;
  }
  get hasTable() {
    return this._hasTable;
  }
  setTable(path, value) {
    return {type: 'SET', path: path.concat(['table']), value: value.toJson()};
  }
  deleteTable(path) {
    return {type: 'DELETE', path: path.concat(['table'])};
  }
  /**
   * @returns {Expression}
   */
  get key() {
    return this._hasKey ? this._key : Expression.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value: value.toJson()};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "table": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableGetElementExpression(this);
              copy._hasTable = true;
              copy._table = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTable) {
                return this;
              }
              const copy = new TableGetElementExpression(this);
              copy._hasTable = false;
              copy._table = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTable) {
            const copy = new TableGetElementExpression(this);
            copy._hasTable = true;
            copy._table = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._table.apply(type, path.slice(1), value);
          if (newValue === this._table) {
            return this;
          }
          const copy = new TableGetElementExpression(this);
          copy._table = copy._table.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableGetElementExpression(this);
              copy._hasKey = true;
              copy._key = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TableGetElementExpression(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasKey) {
            const copy = new TableGetElementExpression(this);
            copy._hasKey = true;
            copy._key = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._key.apply(type, path.slice(1), value);
          if (newValue === this._key) {
            return this;
          }
          const copy = new TableGetElementExpression(this);
          copy._key = copy._key.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TableGetElementExpression} other
   * @returns {TableGetElementExpression}
   */
  merge(other) {
    const copy = new TableGetElementExpression(this);
    if (other._hasTable) {
      if (copy._hasTable) {
        copy._table = copy.table.merge(other.table);
      } else {
        copy._table = other._table;
      }
      copy._hasTable = true;
    }
    if (other._hasKey) {
      if (copy._hasKey) {
        copy._key = copy.key.merge(other.key);
      } else {
        copy._key = other._key;
      }
      copy._hasKey = true;
    }
    return copy;
  }
}
TableGetElementExpression.default = new TableGetElementExpression();
class TableGetElementExpression_Builder {
  constructor(value) {
    this._value = new TableGetElementExpression(value);
  }
  build() {
    return new TableGetElementExpression(this._value);
  }
  setTable(value) {
    this._value._hasTable = true;
    this._value._table = value;
    return this;
  }
  deleteTable() {
    this._value._hasTable = false;
    this._value._table = null;
    return this;
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
}
TableGetElementExpression.Builder = TableGetElementExpression_Builder;
class TableGetElementExpression_WithParent {
  /**
   * @param {TableGetElementExpression} value
   * @param {TableGetElementExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TableGetElementExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTable() {
    if (this._cachedHasTable === undefined) {
      if (this._value.hasTable) {
        this._cachedHasTable = true;
      } else {
        this._cachedHasTable = this._parent ? this._parent.hasTable : false;
      }
    }
    return this._cachedHasTable;
  }
  get table() {
    if (!this._cachedTable) {
      if (this._value.hasTable) {
        this._cachedTable = new Expression.WithParent(this._value.table, this._parent && this._parent.hasTable ? this._parent.table : null);
      } else {
        this._cachedTable = this._parent ? new Expression.WithParent(Expression.default, this._parent.table) : Expression.WithParent.default;
      }
    }
    return this._cachedTable;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (!this._cachedKey) {
      if (this._value.hasKey) {
        this._cachedKey = new Expression.WithParent(this._value.key, this._parent && this._parent.hasKey ? this._parent.key : null);
      } else {
        this._cachedKey = this._parent ? new Expression.WithParent(Expression.default, this._parent.key) : Expression.WithParent.default;
      }
    }
    return this._cachedKey;
  }
  update(current, parent) {
    const result = new TableGetElementExpression_WithParent(current, parent);
    if (this._cachedTable && this._value.hasTable && current.hasTable) {
      if (this._value.table === current.table && this._parent === parent) {
        result._cachedTable = this._cachedTable;
      } else {
        result._cachedTable = this._cachedTable.update(current.table, parent && parent.hasTable ? parent.table : null);
      }
    }
    if (this._cachedKey && this._value.hasKey && current.hasKey) {
      if (this._value.key === current.key && this._parent === parent) {
        result._cachedKey = this._cachedKey;
      } else {
        result._cachedKey = this._cachedKey.update(current.key, parent && parent.hasKey ? parent.key : null);
      }
    }
    return result;
  }
}
TableGetElementExpression_WithParent.default = new TableGetElementExpression_WithParent(TableGetElementExpression.default, null);
TableGetElementExpression.WithParent = TableGetElementExpression_WithParent;
class TableGetElementExpression_Descriptor {
  get table() {
    if (!this._table) {
      this._table = {
        name: "table",
        Name: "Table",
        number: 1,
        protoType: 11,
        protoName: "table",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._table;
  }
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 2,
        protoType: 11,
        protoName: "key",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.table,
        this.key,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTable",
        Name: "DummyOneofForTable",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
TableGetElementExpression.descriptor = new TableGetElementExpression_Descriptor();
export class TableHasKeyExpression {
  get descriptor() {
    return TableHasKeyExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTable = false;
    this._table = null;
    this._hasKey = false;
    this._key = null;
  }
  isEmpty() {
    if (this._hasTable && !this._table.isEmpty()) return false;
    if (this._hasKey && !this._key.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TableHasKeyExpression) {
      return value;
    }
    return TableHasKeyExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new TableHasKeyExpression();
    if (json.table != null) {
      result._hasTable = true;
      result._table = Expression.fromJson(json.table);
    }
    if (json.key != null) {
      result._hasKey = true;
      result._key = Expression.fromJson(json.key);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTable && !this._table.isEmpty()) {
      result.table = Expression.toJson(this._table);
    }
    if (this._hasKey && !this._key.isEmpty()) {
      result.key = Expression.toJson(this._key);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get table() {
    return this._hasTable ? this._table : Expression.default;
  }
  get hasTable() {
    return this._hasTable;
  }
  setTable(path, value) {
    return {type: 'SET', path: path.concat(['table']), value: value.toJson()};
  }
  deleteTable(path) {
    return {type: 'DELETE', path: path.concat(['table'])};
  }
  /**
   * @returns {Expression}
   */
  get key() {
    return this._hasKey ? this._key : Expression.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value: value.toJson()};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "table": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableHasKeyExpression(this);
              copy._hasTable = true;
              copy._table = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTable) {
                return this;
              }
              const copy = new TableHasKeyExpression(this);
              copy._hasTable = false;
              copy._table = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTable) {
            const copy = new TableHasKeyExpression(this);
            copy._hasTable = true;
            copy._table = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._table.apply(type, path.slice(1), value);
          if (newValue === this._table) {
            return this;
          }
          const copy = new TableHasKeyExpression(this);
          copy._table = copy._table.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableHasKeyExpression(this);
              copy._hasKey = true;
              copy._key = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TableHasKeyExpression(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasKey) {
            const copy = new TableHasKeyExpression(this);
            copy._hasKey = true;
            copy._key = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._key.apply(type, path.slice(1), value);
          if (newValue === this._key) {
            return this;
          }
          const copy = new TableHasKeyExpression(this);
          copy._key = copy._key.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TableHasKeyExpression} other
   * @returns {TableHasKeyExpression}
   */
  merge(other) {
    const copy = new TableHasKeyExpression(this);
    if (other._hasTable) {
      if (copy._hasTable) {
        copy._table = copy.table.merge(other.table);
      } else {
        copy._table = other._table;
      }
      copy._hasTable = true;
    }
    if (other._hasKey) {
      if (copy._hasKey) {
        copy._key = copy.key.merge(other.key);
      } else {
        copy._key = other._key;
      }
      copy._hasKey = true;
    }
    return copy;
  }
}
TableHasKeyExpression.default = new TableHasKeyExpression();
class TableHasKeyExpression_Builder {
  constructor(value) {
    this._value = new TableHasKeyExpression(value);
  }
  build() {
    return new TableHasKeyExpression(this._value);
  }
  setTable(value) {
    this._value._hasTable = true;
    this._value._table = value;
    return this;
  }
  deleteTable() {
    this._value._hasTable = false;
    this._value._table = null;
    return this;
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
}
TableHasKeyExpression.Builder = TableHasKeyExpression_Builder;
class TableHasKeyExpression_WithParent {
  /**
   * @param {TableHasKeyExpression} value
   * @param {TableHasKeyExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TableHasKeyExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTable() {
    if (this._cachedHasTable === undefined) {
      if (this._value.hasTable) {
        this._cachedHasTable = true;
      } else {
        this._cachedHasTable = this._parent ? this._parent.hasTable : false;
      }
    }
    return this._cachedHasTable;
  }
  get table() {
    if (!this._cachedTable) {
      if (this._value.hasTable) {
        this._cachedTable = new Expression.WithParent(this._value.table, this._parent && this._parent.hasTable ? this._parent.table : null);
      } else {
        this._cachedTable = this._parent ? new Expression.WithParent(Expression.default, this._parent.table) : Expression.WithParent.default;
      }
    }
    return this._cachedTable;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (!this._cachedKey) {
      if (this._value.hasKey) {
        this._cachedKey = new Expression.WithParent(this._value.key, this._parent && this._parent.hasKey ? this._parent.key : null);
      } else {
        this._cachedKey = this._parent ? new Expression.WithParent(Expression.default, this._parent.key) : Expression.WithParent.default;
      }
    }
    return this._cachedKey;
  }
  update(current, parent) {
    const result = new TableHasKeyExpression_WithParent(current, parent);
    if (this._cachedTable && this._value.hasTable && current.hasTable) {
      if (this._value.table === current.table && this._parent === parent) {
        result._cachedTable = this._cachedTable;
      } else {
        result._cachedTable = this._cachedTable.update(current.table, parent && parent.hasTable ? parent.table : null);
      }
    }
    if (this._cachedKey && this._value.hasKey && current.hasKey) {
      if (this._value.key === current.key && this._parent === parent) {
        result._cachedKey = this._cachedKey;
      } else {
        result._cachedKey = this._cachedKey.update(current.key, parent && parent.hasKey ? parent.key : null);
      }
    }
    return result;
  }
}
TableHasKeyExpression_WithParent.default = new TableHasKeyExpression_WithParent(TableHasKeyExpression.default, null);
TableHasKeyExpression.WithParent = TableHasKeyExpression_WithParent;
class TableHasKeyExpression_Descriptor {
  get table() {
    if (!this._table) {
      this._table = {
        name: "table",
        Name: "Table",
        number: 1,
        protoType: 11,
        protoName: "table",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._table;
  }
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 2,
        protoType: 11,
        protoName: "key",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.table,
        this.key,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTable",
        Name: "DummyOneofForTable",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
TableHasKeyExpression.descriptor = new TableHasKeyExpression_Descriptor();
export class TableExpression {
  get descriptor() {
    return TableExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._tableExpressionTypeCase = 0;
    this._tableExpressionTypeValue = null;
  }
  isEmpty() {
    if (this._tableExpressionTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TableExpression) {
      return value;
    }
    return TableExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new TableExpression();
    if (json.getElement != null) {
      result._tableExpressionTypeCase = 1;
      result._tableExpressionTypeValue = TableGetElementExpression.fromJson(json.getElement);
    }
    if (json.hasKey != null) {
      result._tableExpressionTypeCase = 2;
      result._tableExpressionTypeValue = TableHasKeyExpression.fromJson(json.hasKey);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._tableExpressionTypeCase) {
      case 1:
        result.getElement = TableGetElementExpression.toJson(this._tableExpressionTypeValue);
        break;
      case 2:
        result.hasKey = TableHasKeyExpression.toJson(this._tableExpressionTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get tableExpressionTypeCase() {
    return this._tableExpressionTypeCase;
  }
  deleteTableExpressionType(path) {
    switch (this._tableExpressionTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['getElement'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['hasKey'])};
      }
    }
  }
  /**
   * @returns {TableGetElementExpression}
   */
  get getElement() {
    return this._tableExpressionTypeCase === 1 ? this._tableExpressionTypeValue : TableGetElementExpression.default;
  }
  setGetElement(path, value) {
    return {type: 'SET', path: path.concat(['getElement']), value: value.toJson()};
  }
  deleteGetElement(path) {
    return {type: 'DELETE', path: path.concat(['getElement'])};
  }
  /**
   * @returns {TableHasKeyExpression}
   */
  get hasKey() {
    return this._tableExpressionTypeCase === 2 ? this._tableExpressionTypeValue : TableHasKeyExpression.default;
  }
  setHasKey(path, value) {
    return {type: 'SET', path: path.concat(['hasKey']), value: value.toJson()};
  }
  deleteHasKey(path) {
    return {type: 'DELETE', path: path.concat(['hasKey'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "getElement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableExpression(this);
              copy._tableExpressionTypeCase = 1;
              copy._tableExpressionTypeValue = TableGetElementExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._tableExpressionTypeCase !== 1) {
                return this;
              }
              const copy = new TableExpression(this);
              copy._tableExpressionTypeCase = 0;
              copy._tableExpressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._tableExpressionTypeCase !== 1) {
            const copy = new TableExpression(this);
            copy._tableExpressionTypeCase = 1;
            copy._tableExpressionTypeValue = TableGetElementExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.getElement.apply(type, path.slice(1), value);
          if (newValue === this.getElement) {
            return this;
          }
          const copy = new TableExpression(this);
          copy._tableExpressionTypeCase = 1;
          copy._tableExpressionTypeValue = newValue;
          return copy;
        }
      }
      case "hasKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableExpression(this);
              copy._tableExpressionTypeCase = 2;
              copy._tableExpressionTypeValue = TableHasKeyExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._tableExpressionTypeCase !== 2) {
                return this;
              }
              const copy = new TableExpression(this);
              copy._tableExpressionTypeCase = 0;
              copy._tableExpressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._tableExpressionTypeCase !== 2) {
            const copy = new TableExpression(this);
            copy._tableExpressionTypeCase = 2;
            copy._tableExpressionTypeValue = TableHasKeyExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.hasKey.apply(type, path.slice(1), value);
          if (newValue === this.hasKey) {
            return this;
          }
          const copy = new TableExpression(this);
          copy._tableExpressionTypeCase = 2;
          copy._tableExpressionTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TableExpression} other
   * @returns {TableExpression}
   */
  merge(other) {
    const copy = new TableExpression(this);
    if (other._tableExpressionTypeCase === 1) {
      if (this._tableExpressionTypeCase === 1) {
        copy._tableExpressionTypeValue = copy._tableExpressionTypeValue.merge(other._tableExpressionTypeValue);
      } else {
        copy._tableExpressionTypeValue = other._tableExpressionTypeValue;
      }
      copy._tableExpressionTypeCase = 1;
    }
    if (other._tableExpressionTypeCase === 1) {
      if (this._tableExpressionTypeCase === 1) {
        copy._tableExpressionTypeValue = copy._tableExpressionTypeValue.merge(other._tableExpressionTypeValue);
      } else {
        copy._tableExpressionTypeValue = other._tableExpressionTypeValue;
      }
      copy._tableExpressionTypeCase = 1;
    }
    return copy;
  }
}
TableExpression.default = new TableExpression();
class TableExpression_Builder {
  constructor(value) {
    this._value = new TableExpression(value);
  }
  build() {
    return new TableExpression(this._value);
  }
  cleartableExpressionType() {
    this._value._tableExpressionTypeCase = 0;
    this._value._tableExpressionTypeValue = null;
    return this;
  }
  setGetElement(value) {
    this._value._tableExpressionTypeCase = 1;
    this._value._tableExpressionTypeValue = value;
    return this;
  }
  setHasKey(value) {
    this._value._tableExpressionTypeCase = 2;
    this._value._tableExpressionTypeValue = value;
    return this;
  }
}
TableExpression.Builder = TableExpression_Builder;
class TableExpression_WithParent {
  /**
   * @param {TableExpression} value
   * @param {TableExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TableExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get tableExpressionTypeCase() {
    if (this._cachedtableExpressionTypeCase === undefined) {
      if (this._value._tableExpressionTypeCase === 0) {
        this._cachedtableExpressionTypeCase = this._parent ? this._parent.tableExpressionTypeCase : 0;
      } else {
        this._cachedtableExpressionTypeCase = this._value._tableExpressionTypeCase;
      }
    }
    return this._cachedtableExpressionTypeCase;
  }
  get getElement() {
    if (!this._cachedGetElement) {
      if (this._value._tableExpressionTypeCase === 0) {
        this._cachedGetElement = this._parent ? new TableGetElementExpression.WithParent(TableGetElementExpression.default, this._parent.getElement) : this._value.getElement;
      } else if (this._value._tableExpressionTypeCase === 1) {
        this._cachedGetElement = new TableGetElementExpression.WithParent(this._value.getElement, this._parent && this._parent.tableExpressionTypeCase === 1 ? this._parent.getElement : null);
      } else {
        this._cachedGetElement = TableGetElementExpression.WithParent.default;
      }
    }
    return this._cachedGetElement;
  }
  get hasKey() {
    if (!this._cachedHasKey) {
      if (this._value._tableExpressionTypeCase === 0) {
        this._cachedHasKey = this._parent ? new TableHasKeyExpression.WithParent(TableHasKeyExpression.default, this._parent.hasKey) : this._value.hasKey;
      } else if (this._value._tableExpressionTypeCase === 2) {
        this._cachedHasKey = new TableHasKeyExpression.WithParent(this._value.hasKey, this._parent && this._parent.tableExpressionTypeCase === 2 ? this._parent.hasKey : null);
      } else {
        this._cachedHasKey = TableHasKeyExpression.WithParent.default;
      }
    }
    return this._cachedHasKey;
  }
  update(current, parent) {
    const result = new TableExpression_WithParent(current, parent);
    if (this._cachedGetElement && this._value._tableExpressionTypeCase === 1 && current._tableExpressionTypeCase === 1) {
      if (this._value.getElement === current.getElement && this._parent === parent) {
        result._cachedGetElement = this._cachedGetElement;
      } else {
        result._cachedGetElement = this._cachedGetElement.update(current.getElement, parent && parent.tableExpressionTypeCase === 1 ? parent.getElement : null);
      }
    }
    if (this._cachedHasKey && this._value._tableExpressionTypeCase === 2 && current._tableExpressionTypeCase === 2) {
      if (this._value.hasKey === current.hasKey && this._parent === parent) {
        result._cachedHasKey = this._cachedHasKey;
      } else {
        result._cachedHasKey = this._cachedHasKey.update(current.hasKey, parent && parent.tableExpressionTypeCase === 2 ? parent.hasKey : null);
      }
    }
    return result;
  }
}
TableExpression_WithParent.default = new TableExpression_WithParent(TableExpression.default, null);
TableExpression.WithParent = TableExpression_WithParent;
class TableExpression_Descriptor {
  get getElement() {
    if (!this._getElement) {
      this._getElement = {
        name: "getElement",
        Name: "GetElement",
        number: 1,
        protoType: 11,
        protoName: "get_element",
        oneofIndex: 0,
        type: TableGetElementExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._getElement;
  }
  get hasKey() {
    if (!this._hasKey) {
      this._hasKey = {
        name: "hasKey",
        Name: "HasKey",
        number: 2,
        protoType: 11,
        protoName: "has_key",
        oneofIndex: 0,
        type: TableHasKeyExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hasKey;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.getElement,
        this.hasKey,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "tableExpressionType",
        Name: "TableExpressionType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
TableExpression.descriptor = new TableExpression_Descriptor();
class CreateTableExpression_TableEntry {
  get descriptor() {
    return CreateTableExpression_TableEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CreateTableExpression_TableEntry) {
      return value;
    }
    return CreateTableExpression_TableEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new CreateTableExpression_TableEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = Expression.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = Expression.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {Expression}
   */
  get value() {
    return this._hasValue ? this._value : Expression.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CreateTableExpression_TableEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new CreateTableExpression_TableEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CreateTableExpression_TableEntry(this);
              copy._hasValue = true;
              copy._value = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new CreateTableExpression_TableEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new CreateTableExpression_TableEntry(this);
            copy._hasValue = true;
            copy._value = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new CreateTableExpression_TableEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CreateTableExpression_TableEntry} other
   * @returns {CreateTableExpression_TableEntry}
   */
  merge(other) {
    const copy = new CreateTableExpression_TableEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
CreateTableExpression_TableEntry.default = new CreateTableExpression_TableEntry();
class CreateTableExpression_TableEntry_Builder {
  constructor(value) {
    this._value = new CreateTableExpression_TableEntry(value);
  }
  build() {
    return new CreateTableExpression_TableEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
CreateTableExpression_TableEntry.Builder = CreateTableExpression_TableEntry_Builder;
class CreateTableExpression_TableEntry_WithParent {
  /**
   * @param {CreateTableExpression_TableEntry} value
   * @param {CreateTableExpression_TableEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CreateTableExpression_TableEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new Expression.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new Expression.WithParent(Expression.default, this._parent.value) : Expression.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new CreateTableExpression_TableEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
CreateTableExpression_TableEntry_WithParent.default = new CreateTableExpression_TableEntry_WithParent(CreateTableExpression_TableEntry.default, null);
CreateTableExpression_TableEntry.WithParent = CreateTableExpression_TableEntry_WithParent;
class CreateTableExpression_TableEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: Expression,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CreateTableExpression_TableEntry.descriptor = new CreateTableExpression_TableEntry_Descriptor();
export class CreateTableExpression {
  get descriptor() {
    return CreateTableExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetType = false;
    this._targetType = null;
    this._table = {};
  }
  isEmpty() {
    if (this._hasTargetType && !this._targetType.isEmpty()) return false;
    if (Object.keys(this._table).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CreateTableExpression) {
      return value;
    }
    return CreateTableExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new CreateTableExpression();
    if (json.targetType != null) {
      result._hasTargetType = true;
      result._targetType = TypeDeclaration.fromJson(json.targetType);
    }
    result._table = JsonToMap(json.table, JsonToString, Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetType && !this._targetType.isEmpty()) {
      result.targetType = TypeDeclaration.toJson(this._targetType);
    }
    if (Object.keys(this._table).length > 0) {
      result.table = MapToJson(this._table, JsonToString, Expression);
    }
    return result;
  }
  /**
   * @returns {TypeDeclaration}
   */
  get targetType() {
    return this._hasTargetType ? this._targetType : TypeDeclaration.default;
  }
  get hasTargetType() {
    return this._hasTargetType;
  }
  setTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value: value.toJson()};
  }
  deleteTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  /**
   * @returns {Object<string, Expression>}
   */
  get table() {
    return this._table;
  }
  setTable(path, value) {
    return {type: 'SET', path: path.concat(['table']), value: MapToJson(value, JsonToString, Expression)};
  }
  setTableByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['table', key]), value: value.toJson()};
  }
  deleteTable(path) {
    return {type: 'DELETE', path: path.concat(['table'])};
  }
  deleteTableByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['table', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CreateTableExpression(this);
              copy._hasTargetType = true;
              copy._targetType = TypeDeclaration.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetType) {
                return this;
              }
              const copy = new CreateTableExpression(this);
              copy._hasTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTargetType) {
            const copy = new CreateTableExpression(this);
            copy._hasTargetType = true;
            copy._targetType = TypeDeclaration.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._targetType.apply(type, path.slice(1), value);
          if (newValue === this._targetType) {
            return this;
          }
          const copy = new CreateTableExpression(this);
          copy._targetType = copy._targetType.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "table": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._table).length === 0) {
                return this;
              }
              const copy = new CreateTableExpression(this);
              copy._table = {};
              return copy;
            }
            case 'SET': {
              const copy = new CreateTableExpression(this);
              copy._table = {};
              for (let key in value) {
                copy._table[key] = Expression.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new CreateTableExpression(this);
              copy._table = {...copy._table};
              copy._table[path[1]] = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._table[path[1]]) {
                return this;
              }
              const copy = new CreateTableExpression(this);
              copy._table = {...copy._table};
              delete copy._table[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._table[key] === undefined) {
            const copy = new CreateTableExpression(this);
            copy._table = {...copy._table};
            copy._table[key] = Expression.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._table[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CreateTableExpression(this);
          copy._table = {...copy._table};
          copy._table[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CreateTableExpression} other
   * @returns {CreateTableExpression}
   */
  merge(other) {
    const copy = new CreateTableExpression(this);
    if (other._hasTargetType) {
      if (copy._hasTargetType) {
        copy._targetType = copy.targetType.merge(other.targetType);
      } else {
        copy._targetType = other._targetType;
      }
      copy._hasTargetType = true;
    }
    copy._table = {...this._table, ...other._table};
    return copy;
  }
}
CreateTableExpression.default = new CreateTableExpression();
CreateTableExpression.TableEntry = CreateTableExpression_TableEntry;
class CreateTableExpression_Builder {
  constructor(value) {
    this._value = new CreateTableExpression(value);
  }
  build() {
    return new CreateTableExpression(this._value);
  }
  setTargetType(value) {
    this._value._hasTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteTargetType() {
    this._value._hasTargetType = false;
    this._value._targetType = null;
    return this;
  }
  setTable(key, value) {
    this._value._table = {...this._value._table, [key]: value};
    return this;
  }
  addAllTable(values) {
    this._value._table = {...this._value._table, ...values};
    return this;
  }
  deleteTable(key) {
    this._value._table = {...this._value._table};
    delete this._value._table[key];
    return this;
  }
  clearTable() {
    this._value._table = {};
    return this;
  }
}
CreateTableExpression.Builder = CreateTableExpression_Builder;
class CreateTableExpression_WithParent {
  /**
   * @param {CreateTableExpression} value
   * @param {CreateTableExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CreateTableExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetType() {
    if (this._cachedHasTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedHasTargetType = true;
      } else {
        this._cachedHasTargetType = this._parent ? this._parent.hasTargetType : false;
      }
    }
    return this._cachedHasTargetType;
  }
  get targetType() {
    if (!this._cachedTargetType) {
      if (this._value.hasTargetType) {
        this._cachedTargetType = new TypeDeclaration.WithParent(this._value.targetType, this._parent && this._parent.hasTargetType ? this._parent.targetType : null);
      } else {
        this._cachedTargetType = this._parent ? new TypeDeclaration.WithParent(TypeDeclaration.default, this._parent.targetType) : TypeDeclaration.WithParent.default;
      }
    }
    return this._cachedTargetType;
  }
  get selfTable() {
    if (!this._selfTable) {
      this._selfTable = {};
      for (let i in this._value.table) {
        this._selfTable[i] = new Expression.WithParent(this._value.table[i], null);
      }
    }
    return this._selfTable;
  }
  get inherentTable() {
    if (!this._inherentTable) {
      this._inherentTable = this._parent ? this._parent.table : {};
    }
    return this._inherentTable;
  }
  get table() {
    if (!this._allTable) {
      this._allTable = this._parent ? {...this._parent.table, ...this.selfTable} : this.selfTable;
    }
    return this._allTable;
  }
  update(current, parent) {
    const result = new CreateTableExpression_WithParent(current, parent);
    if (this._cachedTargetType && this._value.hasTargetType && current.hasTargetType) {
      if (this._value.targetType === current.targetType && this._parent === parent) {
        result._cachedTargetType = this._cachedTargetType;
      } else {
        result._cachedTargetType = this._cachedTargetType.update(current.targetType, parent && parent.hasTargetType ? parent.targetType : null);
      }
    }
    if (this._selfTable) {
      if (this._value.table === current.table) {
        result._selfTable = this._selfTable;
      } else {
        result._selfTable = {};
        for (let i in current.table) {
          const oldValue = this._value.table[i];
          if (oldValue) {
            const oldCache = this._selfTable[i];
            if (oldValue === current.table[i]) {
              result._selfTable[i] = oldCache;
            } else {
              result._selfTable[i] = oldCache.update(current.table[i], null);
            }
          } else {
            result._selfTable[i] = new Expression.WithParent(current.table[i], null);
          }
        }
      }
    }
    return result;
  }
}
CreateTableExpression_WithParent.default = new CreateTableExpression_WithParent(CreateTableExpression.default, null);
CreateTableExpression.WithParent = CreateTableExpression_WithParent;
class CreateTableExpression_Descriptor {
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "TargetType",
        number: 2,
        protoType: 11,
        protoName: "target_type",
        type: TypeDeclaration,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get table() {
    if (!this._table) {
      this._table = {
        name: "table",
        Name: "Table",
        number: 1,
        protoType: 11,
        protoName: "table",
        isMap: true,
        keyType: JsonToString,
        valueType: Expression,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._table;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetType,
        this.table,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetType",
        Name: "DummyOneofForTargetType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CreateTableExpression.descriptor = new CreateTableExpression_Descriptor();
export class CreateArrayExpression {
  get descriptor() {
    return CreateArrayExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetType = false;
    this._targetType = null;
    this._array = [];
  }
  isEmpty() {
    if (this._hasTargetType && !this._targetType.isEmpty()) return false;
    if (this._array.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CreateArrayExpression) {
      return value;
    }
    return CreateArrayExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new CreateArrayExpression();
    if (json.targetType != null) {
      result._hasTargetType = true;
      result._targetType = TypeDeclaration.fromJson(json.targetType);
    }
    result._array = JsonToList(json.array, Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetType && !this._targetType.isEmpty()) {
      result.targetType = TypeDeclaration.toJson(this._targetType);
    }
    if (this._array.length > 0) {
      result.array = ArrayToJson(this._array, Expression);
    }
    return result;
  }
  /**
   * @returns {TypeDeclaration}
   */
  get targetType() {
    return this._hasTargetType ? this._targetType : TypeDeclaration.default;
  }
  get hasTargetType() {
    return this._hasTargetType;
  }
  setTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value: value.toJson()};
  }
  deleteTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  /**
   * @returns {Expression[]}
   */
  get array() {
    return this._array;
  }
  addArray(path, value) {
    return {type: 'ADD', path: path.concat(['array']), value: value.toJson()};
  }
  setArray(path, value) {
    return {type: 'SET', path: path.concat(['array']), value: ArrayToJson(value, Expression)};
  }
  setArrayByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['array', key]), value: value.toJson()};
  }
  deleteArray(path) {
    return {type: 'DELETE', path: path.concat(['array'])};
  }
  deleteArrayByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['array', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CreateArrayExpression(this);
              copy._hasTargetType = true;
              copy._targetType = TypeDeclaration.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetType) {
                return this;
              }
              const copy = new CreateArrayExpression(this);
              copy._hasTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTargetType) {
            const copy = new CreateArrayExpression(this);
            copy._hasTargetType = true;
            copy._targetType = TypeDeclaration.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._targetType.apply(type, path.slice(1), value);
          if (newValue === this._targetType) {
            return this;
          }
          const copy = new CreateArrayExpression(this);
          copy._targetType = copy._targetType.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "array": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CreateArrayExpression(this);
              copy._array = [];        for (let i of value) {
                copy._array.push(Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CreateArrayExpression(this);
              copy._array = copy._array.concat([Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._array.length === 0) {
                return this;
              }
              const copy = new CreateArrayExpression(this);
              copy._array = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._array.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CreateArrayExpression(this);
              copy._array = copy._array.slice();
              copy._array[path[1]] = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CreateArrayExpression(this);
              copy._array = copy._array.slice(0, path[1]).concat(copy._array.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._array.length) {
            return this;
          }
          const oldValue = this._array[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CreateArrayExpression(this);
          copy._array = copy._array.slice();
          copy._array[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CreateArrayExpression} other
   * @returns {CreateArrayExpression}
   */
  merge(other) {
    const copy = new CreateArrayExpression(this);
    if (other._hasTargetType) {
      if (copy._hasTargetType) {
        copy._targetType = copy.targetType.merge(other.targetType);
      } else {
        copy._targetType = other._targetType;
      }
      copy._hasTargetType = true;
    }
    copy._array = this._array.concat(other._array);
    return copy;
  }
}
CreateArrayExpression.default = new CreateArrayExpression();
class CreateArrayExpression_Builder {
  constructor(value) {
    this._value = new CreateArrayExpression(value);
  }
  build() {
    return new CreateArrayExpression(this._value);
  }
  setTargetType(value) {
    this._value._hasTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteTargetType() {
    this._value._hasTargetType = false;
    this._value._targetType = null;
    return this;
  }
  addAllArray(values) {
    this._value._array = this._value._array.concat(values);
    return this;
  }
  addArray(value) {
    this._value._array = this._value._array.concat([value]);
    return this;
  }
  setArray(index, value) {
    this._value._array = this._value._array.concat();
    this._value._array[index] = value;
    return this;
  }
  clearArray() {
    this._value._array = [];
    return this;
  }
}
CreateArrayExpression.Builder = CreateArrayExpression_Builder;
class CreateArrayExpression_WithParent {
  /**
   * @param {CreateArrayExpression} value
   * @param {CreateArrayExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CreateArrayExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetType() {
    if (this._cachedHasTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedHasTargetType = true;
      } else {
        this._cachedHasTargetType = this._parent ? this._parent.hasTargetType : false;
      }
    }
    return this._cachedHasTargetType;
  }
  get targetType() {
    if (!this._cachedTargetType) {
      if (this._value.hasTargetType) {
        this._cachedTargetType = new TypeDeclaration.WithParent(this._value.targetType, this._parent && this._parent.hasTargetType ? this._parent.targetType : null);
      } else {
        this._cachedTargetType = this._parent ? new TypeDeclaration.WithParent(TypeDeclaration.default, this._parent.targetType) : TypeDeclaration.WithParent.default;
      }
    }
    return this._cachedTargetType;
  }
  get selfArray() {
    if (!this._selfArray) {
      this._selfArray = [];
      for (let i of this._value.array) {
        this._selfArray.push(new Expression.WithParent(i, null));
      }
    }
    return this._selfArray;
  }
  get inherentArray() {
    if (!this._inherentArray) {
      this._inherentArray = this._parent ? this._parent.array : [];
    }
    return this._inherentArray;
  }
  get array() {
    if (!this._allArray) {
      this._allArray = this._parent ? this._parent.array.concat(this.selfArray) : this.selfArray;
    }
    return this._allArray;
  }
  update(current, parent) {
    const result = new CreateArrayExpression_WithParent(current, parent);
    if (this._cachedTargetType && this._value.hasTargetType && current.hasTargetType) {
      if (this._value.targetType === current.targetType && this._parent === parent) {
        result._cachedTargetType = this._cachedTargetType;
      } else {
        result._cachedTargetType = this._cachedTargetType.update(current.targetType, parent && parent.hasTargetType ? parent.targetType : null);
      }
    }
    if (this._selfArray) {
      if (this._value.array === current.array) {
        result._selfArray = this._selfArray;
      } else {
        result._selfArray = [];
        for (let i = 0; i < current.array.length; i++) {
          const oldValue = this._value.array[i];
          if (oldValue) {
            const oldCache = this._selfArray[i];
            if (oldValue === current.array[i]) {
              result._selfArray[i] = oldCache;
            } else {
              result._selfArray[i] = oldCache.update(current.array[i], null);
            }
          } else {
            result._selfArray[i] = new Expression.WithParent(current.array[i], null);
          }
        }
      }
    }
    return result;
  }
}
CreateArrayExpression_WithParent.default = new CreateArrayExpression_WithParent(CreateArrayExpression.default, null);
CreateArrayExpression.WithParent = CreateArrayExpression_WithParent;
class CreateArrayExpression_Descriptor {
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "TargetType",
        number: 2,
        protoType: 11,
        protoName: "target_type",
        type: TypeDeclaration,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get array() {
    if (!this._array) {
      this._array = {
        name: "array",
        Name: "Array",
        number: 1,
        protoType: 11,
        protoName: "array",
        type: Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._array;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetType,
        this.array,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetType",
        Name: "DummyOneofForTargetType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CreateArrayExpression.descriptor = new CreateArrayExpression_Descriptor();
class CreateCompositeTypeInstanceExpression_MembersEntry {
  get descriptor() {
    return CreateCompositeTypeInstanceExpression_MembersEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CreateCompositeTypeInstanceExpression_MembersEntry) {
      return value;
    }
    return CreateCompositeTypeInstanceExpression_MembersEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new CreateCompositeTypeInstanceExpression_MembersEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = Expression.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = Expression.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {Expression}
   */
  get value() {
    return this._hasValue ? this._value : Expression.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CreateCompositeTypeInstanceExpression_MembersEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new CreateCompositeTypeInstanceExpression_MembersEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CreateCompositeTypeInstanceExpression_MembersEntry(this);
              copy._hasValue = true;
              copy._value = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new CreateCompositeTypeInstanceExpression_MembersEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new CreateCompositeTypeInstanceExpression_MembersEntry(this);
            copy._hasValue = true;
            copy._value = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new CreateCompositeTypeInstanceExpression_MembersEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CreateCompositeTypeInstanceExpression_MembersEntry} other
   * @returns {CreateCompositeTypeInstanceExpression_MembersEntry}
   */
  merge(other) {
    const copy = new CreateCompositeTypeInstanceExpression_MembersEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
CreateCompositeTypeInstanceExpression_MembersEntry.default = new CreateCompositeTypeInstanceExpression_MembersEntry();
class CreateCompositeTypeInstanceExpression_MembersEntry_Builder {
  constructor(value) {
    this._value = new CreateCompositeTypeInstanceExpression_MembersEntry(value);
  }
  build() {
    return new CreateCompositeTypeInstanceExpression_MembersEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
CreateCompositeTypeInstanceExpression_MembersEntry.Builder = CreateCompositeTypeInstanceExpression_MembersEntry_Builder;
class CreateCompositeTypeInstanceExpression_MembersEntry_WithParent {
  /**
   * @param {CreateCompositeTypeInstanceExpression_MembersEntry} value
   * @param {CreateCompositeTypeInstanceExpression_MembersEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CreateCompositeTypeInstanceExpression_MembersEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new Expression.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new Expression.WithParent(Expression.default, this._parent.value) : Expression.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new CreateCompositeTypeInstanceExpression_MembersEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
CreateCompositeTypeInstanceExpression_MembersEntry_WithParent.default = new CreateCompositeTypeInstanceExpression_MembersEntry_WithParent(CreateCompositeTypeInstanceExpression_MembersEntry.default, null);
CreateCompositeTypeInstanceExpression_MembersEntry.WithParent = CreateCompositeTypeInstanceExpression_MembersEntry_WithParent;
class CreateCompositeTypeInstanceExpression_MembersEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: Expression,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CreateCompositeTypeInstanceExpression_MembersEntry.descriptor = new CreateCompositeTypeInstanceExpression_MembersEntry_Descriptor();
export class CreateCompositeTypeInstanceExpression {
  get descriptor() {
    return CreateCompositeTypeInstanceExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetType = false;
    this._targetType = null;
    this._members = {};
  }
  isEmpty() {
    if (this._hasTargetType && !this._targetType.isEmpty()) return false;
    if (Object.keys(this._members).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CreateCompositeTypeInstanceExpression) {
      return value;
    }
    return CreateCompositeTypeInstanceExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new CreateCompositeTypeInstanceExpression();
    if (json.targetType != null) {
      result._hasTargetType = true;
      result._targetType = TypeDeclaration.fromJson(json.targetType);
    }
    result._members = JsonToMap(json.members, JsonToString, Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetType && !this._targetType.isEmpty()) {
      result.targetType = TypeDeclaration.toJson(this._targetType);
    }
    if (Object.keys(this._members).length > 0) {
      result.members = MapToJson(this._members, JsonToString, Expression);
    }
    return result;
  }
  /**
   * @returns {TypeDeclaration}
   */
  get targetType() {
    return this._hasTargetType ? this._targetType : TypeDeclaration.default;
  }
  get hasTargetType() {
    return this._hasTargetType;
  }
  setTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value: value.toJson()};
  }
  deleteTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  /**
   * @returns {Object<string, Expression>}
   */
  get members() {
    return this._members;
  }
  setMembers(path, value) {
    return {type: 'SET', path: path.concat(['members']), value: MapToJson(value, JsonToString, Expression)};
  }
  setMembersByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['members', key]), value: value.toJson()};
  }
  deleteMembers(path) {
    return {type: 'DELETE', path: path.concat(['members'])};
  }
  deleteMembersByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['members', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CreateCompositeTypeInstanceExpression(this);
              copy._hasTargetType = true;
              copy._targetType = TypeDeclaration.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetType) {
                return this;
              }
              const copy = new CreateCompositeTypeInstanceExpression(this);
              copy._hasTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTargetType) {
            const copy = new CreateCompositeTypeInstanceExpression(this);
            copy._hasTargetType = true;
            copy._targetType = TypeDeclaration.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._targetType.apply(type, path.slice(1), value);
          if (newValue === this._targetType) {
            return this;
          }
          const copy = new CreateCompositeTypeInstanceExpression(this);
          copy._targetType = copy._targetType.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "members": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._members).length === 0) {
                return this;
              }
              const copy = new CreateCompositeTypeInstanceExpression(this);
              copy._members = {};
              return copy;
            }
            case 'SET': {
              const copy = new CreateCompositeTypeInstanceExpression(this);
              copy._members = {};
              for (let key in value) {
                copy._members[key] = Expression.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new CreateCompositeTypeInstanceExpression(this);
              copy._members = {...copy._members};
              copy._members[path[1]] = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._members[path[1]]) {
                return this;
              }
              const copy = new CreateCompositeTypeInstanceExpression(this);
              copy._members = {...copy._members};
              delete copy._members[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._members[key] === undefined) {
            const copy = new CreateCompositeTypeInstanceExpression(this);
            copy._members = {...copy._members};
            copy._members[key] = Expression.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._members[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CreateCompositeTypeInstanceExpression(this);
          copy._members = {...copy._members};
          copy._members[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CreateCompositeTypeInstanceExpression} other
   * @returns {CreateCompositeTypeInstanceExpression}
   */
  merge(other) {
    const copy = new CreateCompositeTypeInstanceExpression(this);
    if (other._hasTargetType) {
      if (copy._hasTargetType) {
        copy._targetType = copy.targetType.merge(other.targetType);
      } else {
        copy._targetType = other._targetType;
      }
      copy._hasTargetType = true;
    }
    copy._members = {...this._members, ...other._members};
    return copy;
  }
}
CreateCompositeTypeInstanceExpression.default = new CreateCompositeTypeInstanceExpression();
CreateCompositeTypeInstanceExpression.MembersEntry = CreateCompositeTypeInstanceExpression_MembersEntry;
class CreateCompositeTypeInstanceExpression_Builder {
  constructor(value) {
    this._value = new CreateCompositeTypeInstanceExpression(value);
  }
  build() {
    return new CreateCompositeTypeInstanceExpression(this._value);
  }
  setTargetType(value) {
    this._value._hasTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteTargetType() {
    this._value._hasTargetType = false;
    this._value._targetType = null;
    return this;
  }
  setMembers(key, value) {
    this._value._members = {...this._value._members, [key]: value};
    return this;
  }
  addAllMembers(values) {
    this._value._members = {...this._value._members, ...values};
    return this;
  }
  deleteMembers(key) {
    this._value._members = {...this._value._members};
    delete this._value._members[key];
    return this;
  }
  clearMembers() {
    this._value._members = {};
    return this;
  }
}
CreateCompositeTypeInstanceExpression.Builder = CreateCompositeTypeInstanceExpression_Builder;
class CreateCompositeTypeInstanceExpression_WithParent {
  /**
   * @param {CreateCompositeTypeInstanceExpression} value
   * @param {CreateCompositeTypeInstanceExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CreateCompositeTypeInstanceExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetType() {
    if (this._cachedHasTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedHasTargetType = true;
      } else {
        this._cachedHasTargetType = this._parent ? this._parent.hasTargetType : false;
      }
    }
    return this._cachedHasTargetType;
  }
  get targetType() {
    if (!this._cachedTargetType) {
      if (this._value.hasTargetType) {
        this._cachedTargetType = new TypeDeclaration.WithParent(this._value.targetType, this._parent && this._parent.hasTargetType ? this._parent.targetType : null);
      } else {
        this._cachedTargetType = this._parent ? new TypeDeclaration.WithParent(TypeDeclaration.default, this._parent.targetType) : TypeDeclaration.WithParent.default;
      }
    }
    return this._cachedTargetType;
  }
  get selfMembers() {
    if (!this._selfMembers) {
      this._selfMembers = {};
      for (let i in this._value.members) {
        this._selfMembers[i] = new Expression.WithParent(this._value.members[i], null);
      }
    }
    return this._selfMembers;
  }
  get inherentMembers() {
    if (!this._inherentMembers) {
      this._inherentMembers = this._parent ? this._parent.members : {};
    }
    return this._inherentMembers;
  }
  get members() {
    if (!this._allMembers) {
      this._allMembers = this._parent ? {...this._parent.members, ...this.selfMembers} : this.selfMembers;
    }
    return this._allMembers;
  }
  update(current, parent) {
    const result = new CreateCompositeTypeInstanceExpression_WithParent(current, parent);
    if (this._cachedTargetType && this._value.hasTargetType && current.hasTargetType) {
      if (this._value.targetType === current.targetType && this._parent === parent) {
        result._cachedTargetType = this._cachedTargetType;
      } else {
        result._cachedTargetType = this._cachedTargetType.update(current.targetType, parent && parent.hasTargetType ? parent.targetType : null);
      }
    }
    if (this._selfMembers) {
      if (this._value.members === current.members) {
        result._selfMembers = this._selfMembers;
      } else {
        result._selfMembers = {};
        for (let i in current.members) {
          const oldValue = this._value.members[i];
          if (oldValue) {
            const oldCache = this._selfMembers[i];
            if (oldValue === current.members[i]) {
              result._selfMembers[i] = oldCache;
            } else {
              result._selfMembers[i] = oldCache.update(current.members[i], null);
            }
          } else {
            result._selfMembers[i] = new Expression.WithParent(current.members[i], null);
          }
        }
      }
    }
    return result;
  }
}
CreateCompositeTypeInstanceExpression_WithParent.default = new CreateCompositeTypeInstanceExpression_WithParent(CreateCompositeTypeInstanceExpression.default, null);
CreateCompositeTypeInstanceExpression.WithParent = CreateCompositeTypeInstanceExpression_WithParent;
class CreateCompositeTypeInstanceExpression_Descriptor {
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "TargetType",
        number: 2,
        protoType: 11,
        protoName: "target_type",
        type: TypeDeclaration,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get members() {
    if (!this._members) {
      this._members = {
        name: "members",
        Name: "Members",
        number: 1,
        protoType: 11,
        protoName: "members",
        isMap: true,
        keyType: JsonToString,
        valueType: Expression,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._members;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetType,
        this.members,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetType",
        Name: "DummyOneofForTargetType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CreateCompositeTypeInstanceExpression.descriptor = new CreateCompositeTypeInstanceExpression_Descriptor();
export class AccessCompositeTypeInstanceExpression {
  get descriptor() {
    return AccessCompositeTypeInstanceExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTarget = false;
    this._target = null;
    this._accessPath = [];
  }
  isEmpty() {
    if (this._hasTarget && !this._target.isEmpty()) return false;
    if (this._accessPath.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AccessCompositeTypeInstanceExpression) {
      return value;
    }
    return AccessCompositeTypeInstanceExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new AccessCompositeTypeInstanceExpression();
    if (json.target != null) {
      result._hasTarget = true;
      result._target = Expression.fromJson(json.target);
    }
    result._accessPath = JsonToList(json.accessPath, Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTarget && !this._target.isEmpty()) {
      result.target = Expression.toJson(this._target);
    }
    if (this._accessPath.length > 0) {
      result.accessPath = ArrayToJson(this._accessPath, Expression);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get target() {
    return this._hasTarget ? this._target : Expression.default;
  }
  get hasTarget() {
    return this._hasTarget;
  }
  setTarget(path, value) {
    return {type: 'SET', path: path.concat(['target']), value: value.toJson()};
  }
  deleteTarget(path) {
    return {type: 'DELETE', path: path.concat(['target'])};
  }
  /**
   * @returns {Expression[]}
   */
  get accessPath() {
    return this._accessPath;
  }
  addAccessPath(path, value) {
    return {type: 'ADD', path: path.concat(['accessPath']), value: value.toJson()};
  }
  setAccessPath(path, value) {
    return {type: 'SET', path: path.concat(['accessPath']), value: ArrayToJson(value, Expression)};
  }
  setAccessPathByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['accessPath', key]), value: value.toJson()};
  }
  deleteAccessPath(path) {
    return {type: 'DELETE', path: path.concat(['accessPath'])};
  }
  deleteAccessPathByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['accessPath', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "target": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AccessCompositeTypeInstanceExpression(this);
              copy._hasTarget = true;
              copy._target = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTarget) {
                return this;
              }
              const copy = new AccessCompositeTypeInstanceExpression(this);
              copy._hasTarget = false;
              copy._target = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTarget) {
            const copy = new AccessCompositeTypeInstanceExpression(this);
            copy._hasTarget = true;
            copy._target = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._target.apply(type, path.slice(1), value);
          if (newValue === this._target) {
            return this;
          }
          const copy = new AccessCompositeTypeInstanceExpression(this);
          copy._target = copy._target.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "accessPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AccessCompositeTypeInstanceExpression(this);
              copy._accessPath = [];        for (let i of value) {
                copy._accessPath.push(Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AccessCompositeTypeInstanceExpression(this);
              copy._accessPath = copy._accessPath.concat([Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._accessPath.length === 0) {
                return this;
              }
              const copy = new AccessCompositeTypeInstanceExpression(this);
              copy._accessPath = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._accessPath.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AccessCompositeTypeInstanceExpression(this);
              copy._accessPath = copy._accessPath.slice();
              copy._accessPath[path[1]] = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AccessCompositeTypeInstanceExpression(this);
              copy._accessPath = copy._accessPath.slice(0, path[1]).concat(copy._accessPath.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._accessPath.length) {
            return this;
          }
          const oldValue = this._accessPath[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AccessCompositeTypeInstanceExpression(this);
          copy._accessPath = copy._accessPath.slice();
          copy._accessPath[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AccessCompositeTypeInstanceExpression} other
   * @returns {AccessCompositeTypeInstanceExpression}
   */
  merge(other) {
    const copy = new AccessCompositeTypeInstanceExpression(this);
    if (other._hasTarget) {
      if (copy._hasTarget) {
        copy._target = copy.target.merge(other.target);
      } else {
        copy._target = other._target;
      }
      copy._hasTarget = true;
    }
    copy._accessPath = this._accessPath.concat(other._accessPath);
    return copy;
  }
}
AccessCompositeTypeInstanceExpression.default = new AccessCompositeTypeInstanceExpression();
class AccessCompositeTypeInstanceExpression_Builder {
  constructor(value) {
    this._value = new AccessCompositeTypeInstanceExpression(value);
  }
  build() {
    return new AccessCompositeTypeInstanceExpression(this._value);
  }
  setTarget(value) {
    this._value._hasTarget = true;
    this._value._target = value;
    return this;
  }
  deleteTarget() {
    this._value._hasTarget = false;
    this._value._target = null;
    return this;
  }
  addAllAccessPath(values) {
    this._value._accessPath = this._value._accessPath.concat(values);
    return this;
  }
  addAccessPath(value) {
    this._value._accessPath = this._value._accessPath.concat([value]);
    return this;
  }
  setAccessPath(index, value) {
    this._value._accessPath = this._value._accessPath.concat();
    this._value._accessPath[index] = value;
    return this;
  }
  clearAccessPath() {
    this._value._accessPath = [];
    return this;
  }
}
AccessCompositeTypeInstanceExpression.Builder = AccessCompositeTypeInstanceExpression_Builder;
class AccessCompositeTypeInstanceExpression_WithParent {
  /**
   * @param {AccessCompositeTypeInstanceExpression} value
   * @param {AccessCompositeTypeInstanceExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AccessCompositeTypeInstanceExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTarget() {
    if (this._cachedHasTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedHasTarget = true;
      } else {
        this._cachedHasTarget = this._parent ? this._parent.hasTarget : false;
      }
    }
    return this._cachedHasTarget;
  }
  get target() {
    if (!this._cachedTarget) {
      if (this._value.hasTarget) {
        this._cachedTarget = new Expression.WithParent(this._value.target, this._parent && this._parent.hasTarget ? this._parent.target : null);
      } else {
        this._cachedTarget = this._parent ? new Expression.WithParent(Expression.default, this._parent.target) : Expression.WithParent.default;
      }
    }
    return this._cachedTarget;
  }
  get selfAccessPath() {
    if (!this._selfAccessPath) {
      this._selfAccessPath = [];
      for (let i of this._value.accessPath) {
        this._selfAccessPath.push(new Expression.WithParent(i, null));
      }
    }
    return this._selfAccessPath;
  }
  get inherentAccessPath() {
    if (!this._inherentAccessPath) {
      this._inherentAccessPath = this._parent ? this._parent.accessPath : [];
    }
    return this._inherentAccessPath;
  }
  get accessPath() {
    if (!this._allAccessPath) {
      this._allAccessPath = this._parent ? this._parent.accessPath.concat(this.selfAccessPath) : this.selfAccessPath;
    }
    return this._allAccessPath;
  }
  update(current, parent) {
    const result = new AccessCompositeTypeInstanceExpression_WithParent(current, parent);
    if (this._cachedTarget && this._value.hasTarget && current.hasTarget) {
      if (this._value.target === current.target && this._parent === parent) {
        result._cachedTarget = this._cachedTarget;
      } else {
        result._cachedTarget = this._cachedTarget.update(current.target, parent && parent.hasTarget ? parent.target : null);
      }
    }
    if (this._selfAccessPath) {
      if (this._value.accessPath === current.accessPath) {
        result._selfAccessPath = this._selfAccessPath;
      } else {
        result._selfAccessPath = [];
        for (let i = 0; i < current.accessPath.length; i++) {
          const oldValue = this._value.accessPath[i];
          if (oldValue) {
            const oldCache = this._selfAccessPath[i];
            if (oldValue === current.accessPath[i]) {
              result._selfAccessPath[i] = oldCache;
            } else {
              result._selfAccessPath[i] = oldCache.update(current.accessPath[i], null);
            }
          } else {
            result._selfAccessPath[i] = new Expression.WithParent(current.accessPath[i], null);
          }
        }
      }
    }
    return result;
  }
}
AccessCompositeTypeInstanceExpression_WithParent.default = new AccessCompositeTypeInstanceExpression_WithParent(AccessCompositeTypeInstanceExpression.default, null);
AccessCompositeTypeInstanceExpression.WithParent = AccessCompositeTypeInstanceExpression_WithParent;
class AccessCompositeTypeInstanceExpression_Descriptor {
  get target() {
    if (!this._target) {
      this._target = {
        name: "target",
        Name: "Target",
        number: 1,
        protoType: 11,
        protoName: "target",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._target;
  }
  get accessPath() {
    if (!this._accessPath) {
      this._accessPath = {
        name: "accessPath",
        Name: "AccessPath",
        number: 2,
        protoType: 11,
        protoName: "access_path",
        type: Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._accessPath;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.target,
        this.accessPath,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTarget",
        Name: "DummyOneofForTarget",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
AccessCompositeTypeInstanceExpression.descriptor = new AccessCompositeTypeInstanceExpression_Descriptor();
export class Expression {
  get descriptor() {
    return Expression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._expressionTypeCase = 0;
    this._expressionTypeValue = null;
  }
  isEmpty() {
    if (this._expressionTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Expression) {
      return value;
    }
    return Expression.fromJson(value);
  }
  static fromJson(json) {
    const result = new Expression();
    if (json.literal != null) {
      result._expressionTypeCase = 1;
      result._expressionTypeValue = Literal.fromJson(json.literal);
    }
    if (json.variableRef != null) {
      result._expressionTypeCase = 2;
      result._expressionTypeValue = VariableRef.fromJson(json.variableRef);
    }
    if (json.functionCall != null) {
      result._expressionTypeCase = 3;
      result._expressionTypeValue = FunctionCall.fromJson(json.functionCall);
    }
    if (json.arithmeticExpression != null) {
      result._expressionTypeCase = 4;
      result._expressionTypeValue = ArithmeticExpression.fromJson(json.arithmeticExpression);
    }
    if (json.logicalExpression != null) {
      result._expressionTypeCase = 5;
      result._expressionTypeValue = LogicalExpression.fromJson(json.logicalExpression);
    }
    if (json.arrayExpression != null) {
      result._expressionTypeCase = 6;
      result._expressionTypeValue = ArrayExpression.fromJson(json.arrayExpression);
    }
    if (json.tableExpression != null) {
      result._expressionTypeCase = 7;
      result._expressionTypeValue = TableExpression.fromJson(json.tableExpression);
    }
    if (json.createTableExpression != null) {
      result._expressionTypeCase = 8;
      result._expressionTypeValue = CreateTableExpression.fromJson(json.createTableExpression);
    }
    if (json.createArrayExpression != null) {
      result._expressionTypeCase = 9;
      result._expressionTypeValue = CreateArrayExpression.fromJson(json.createArrayExpression);
    }
    if (json.createCompositeTypeInstanceExpression != null) {
      result._expressionTypeCase = 10;
      result._expressionTypeValue = CreateCompositeTypeInstanceExpression.fromJson(json.createCompositeTypeInstanceExpression);
    }
    if (json.accessCompositeTypeInstanceExpression != null) {
      result._expressionTypeCase = 11;
      result._expressionTypeValue = AccessCompositeTypeInstanceExpression.fromJson(json.accessCompositeTypeInstanceExpression);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._expressionTypeCase) {
      case 1:
        result.literal = Literal.toJson(this._expressionTypeValue);
        break;
      case 2:
        result.variableRef = VariableRef.toJson(this._expressionTypeValue);
        break;
      case 3:
        result.functionCall = FunctionCall.toJson(this._expressionTypeValue);
        break;
      case 4:
        result.arithmeticExpression = ArithmeticExpression.toJson(this._expressionTypeValue);
        break;
      case 5:
        result.logicalExpression = LogicalExpression.toJson(this._expressionTypeValue);
        break;
      case 6:
        result.arrayExpression = ArrayExpression.toJson(this._expressionTypeValue);
        break;
      case 7:
        result.tableExpression = TableExpression.toJson(this._expressionTypeValue);
        break;
      case 8:
        result.createTableExpression = CreateTableExpression.toJson(this._expressionTypeValue);
        break;
      case 9:
        result.createArrayExpression = CreateArrayExpression.toJson(this._expressionTypeValue);
        break;
      case 10:
        result.createCompositeTypeInstanceExpression = CreateCompositeTypeInstanceExpression.toJson(this._expressionTypeValue);
        break;
      case 11:
        result.accessCompositeTypeInstanceExpression = AccessCompositeTypeInstanceExpression.toJson(this._expressionTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get expressionTypeCase() {
    return this._expressionTypeCase;
  }
  deleteExpressionType(path) {
    switch (this._expressionTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['literal'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['variableRef'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['functionCall'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['arithmeticExpression'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['logicalExpression'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['arrayExpression'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['tableExpression'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['createTableExpression'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['createArrayExpression'])};
      }
      case 10: {
        return {type: 'DELETE', path: path.concat(['createCompositeTypeInstanceExpression'])};
      }
      case 11: {
        return {type: 'DELETE', path: path.concat(['accessCompositeTypeInstanceExpression'])};
      }
    }
  }
  /**
   * @returns {Literal}
   */
  get literal() {
    return this._expressionTypeCase === 1 ? this._expressionTypeValue : Literal.default;
  }
  setLiteral(path, value) {
    return {type: 'SET', path: path.concat(['literal']), value: value.toJson()};
  }
  deleteLiteral(path) {
    return {type: 'DELETE', path: path.concat(['literal'])};
  }
  /**
   * @returns {VariableRef}
   */
  get variableRef() {
    return this._expressionTypeCase === 2 ? this._expressionTypeValue : VariableRef.default;
  }
  setVariableRef(path, value) {
    return {type: 'SET', path: path.concat(['variableRef']), value: value.toJson()};
  }
  deleteVariableRef(path) {
    return {type: 'DELETE', path: path.concat(['variableRef'])};
  }
  /**
   * @returns {FunctionCall}
   */
  get functionCall() {
    return this._expressionTypeCase === 3 ? this._expressionTypeValue : FunctionCall.default;
  }
  setFunctionCall(path, value) {
    return {type: 'SET', path: path.concat(['functionCall']), value: value.toJson()};
  }
  deleteFunctionCall(path) {
    return {type: 'DELETE', path: path.concat(['functionCall'])};
  }
  /**
   * @returns {ArithmeticExpression}
   */
  get arithmeticExpression() {
    return this._expressionTypeCase === 4 ? this._expressionTypeValue : ArithmeticExpression.default;
  }
  setArithmeticExpression(path, value) {
    return {type: 'SET', path: path.concat(['arithmeticExpression']), value: value.toJson()};
  }
  deleteArithmeticExpression(path) {
    return {type: 'DELETE', path: path.concat(['arithmeticExpression'])};
  }
  /**
   * @returns {LogicalExpression}
   */
  get logicalExpression() {
    return this._expressionTypeCase === 5 ? this._expressionTypeValue : LogicalExpression.default;
  }
  setLogicalExpression(path, value) {
    return {type: 'SET', path: path.concat(['logicalExpression']), value: value.toJson()};
  }
  deleteLogicalExpression(path) {
    return {type: 'DELETE', path: path.concat(['logicalExpression'])};
  }
  /**
   * @returns {ArrayExpression}
   */
  get arrayExpression() {
    return this._expressionTypeCase === 6 ? this._expressionTypeValue : ArrayExpression.default;
  }
  setArrayExpression(path, value) {
    return {type: 'SET', path: path.concat(['arrayExpression']), value: value.toJson()};
  }
  deleteArrayExpression(path) {
    return {type: 'DELETE', path: path.concat(['arrayExpression'])};
  }
  /**
   * @returns {TableExpression}
   */
  get tableExpression() {
    return this._expressionTypeCase === 7 ? this._expressionTypeValue : TableExpression.default;
  }
  setTableExpression(path, value) {
    return {type: 'SET', path: path.concat(['tableExpression']), value: value.toJson()};
  }
  deleteTableExpression(path) {
    return {type: 'DELETE', path: path.concat(['tableExpression'])};
  }
  /**
   * @returns {CreateTableExpression}
   */
  get createTableExpression() {
    return this._expressionTypeCase === 8 ? this._expressionTypeValue : CreateTableExpression.default;
  }
  setCreateTableExpression(path, value) {
    return {type: 'SET', path: path.concat(['createTableExpression']), value: value.toJson()};
  }
  deleteCreateTableExpression(path) {
    return {type: 'DELETE', path: path.concat(['createTableExpression'])};
  }
  /**
   * @returns {CreateArrayExpression}
   */
  get createArrayExpression() {
    return this._expressionTypeCase === 9 ? this._expressionTypeValue : CreateArrayExpression.default;
  }
  setCreateArrayExpression(path, value) {
    return {type: 'SET', path: path.concat(['createArrayExpression']), value: value.toJson()};
  }
  deleteCreateArrayExpression(path) {
    return {type: 'DELETE', path: path.concat(['createArrayExpression'])};
  }
  /**
   * @returns {CreateCompositeTypeInstanceExpression}
   */
  get createCompositeTypeInstanceExpression() {
    return this._expressionTypeCase === 10 ? this._expressionTypeValue : CreateCompositeTypeInstanceExpression.default;
  }
  setCreateCompositeTypeInstanceExpression(path, value) {
    return {type: 'SET', path: path.concat(['createCompositeTypeInstanceExpression']), value: value.toJson()};
  }
  deleteCreateCompositeTypeInstanceExpression(path) {
    return {type: 'DELETE', path: path.concat(['createCompositeTypeInstanceExpression'])};
  }
  /**
   * @returns {AccessCompositeTypeInstanceExpression}
   */
  get accessCompositeTypeInstanceExpression() {
    return this._expressionTypeCase === 11 ? this._expressionTypeValue : AccessCompositeTypeInstanceExpression.default;
  }
  setAccessCompositeTypeInstanceExpression(path, value) {
    return {type: 'SET', path: path.concat(['accessCompositeTypeInstanceExpression']), value: value.toJson()};
  }
  deleteAccessCompositeTypeInstanceExpression(path) {
    return {type: 'DELETE', path: path.concat(['accessCompositeTypeInstanceExpression'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "literal": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 1;
              copy._expressionTypeValue = Literal.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 1) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 1) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 1;
            copy._expressionTypeValue = Literal.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.literal.apply(type, path.slice(1), value);
          if (newValue === this.literal) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 1;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "variableRef": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 2;
              copy._expressionTypeValue = VariableRef.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 2) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 2) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 2;
            copy._expressionTypeValue = VariableRef.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.variableRef.apply(type, path.slice(1), value);
          if (newValue === this.variableRef) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 2;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "functionCall": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 3;
              copy._expressionTypeValue = FunctionCall.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 3) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 3) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 3;
            copy._expressionTypeValue = FunctionCall.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.functionCall.apply(type, path.slice(1), value);
          if (newValue === this.functionCall) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 3;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "arithmeticExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 4;
              copy._expressionTypeValue = ArithmeticExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 4) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 4) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 4;
            copy._expressionTypeValue = ArithmeticExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.arithmeticExpression.apply(type, path.slice(1), value);
          if (newValue === this.arithmeticExpression) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 4;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "logicalExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 5;
              copy._expressionTypeValue = LogicalExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 5) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 5) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 5;
            copy._expressionTypeValue = LogicalExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.logicalExpression.apply(type, path.slice(1), value);
          if (newValue === this.logicalExpression) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 5;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "arrayExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 6;
              copy._expressionTypeValue = ArrayExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 6) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 6) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 6;
            copy._expressionTypeValue = ArrayExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.arrayExpression.apply(type, path.slice(1), value);
          if (newValue === this.arrayExpression) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 6;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "tableExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 7;
              copy._expressionTypeValue = TableExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 7) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 7) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 7;
            copy._expressionTypeValue = TableExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.tableExpression.apply(type, path.slice(1), value);
          if (newValue === this.tableExpression) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 7;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "createTableExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 8;
              copy._expressionTypeValue = CreateTableExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 8) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 8) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 8;
            copy._expressionTypeValue = CreateTableExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.createTableExpression.apply(type, path.slice(1), value);
          if (newValue === this.createTableExpression) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 8;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "createArrayExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 9;
              copy._expressionTypeValue = CreateArrayExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 9) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 9) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 9;
            copy._expressionTypeValue = CreateArrayExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.createArrayExpression.apply(type, path.slice(1), value);
          if (newValue === this.createArrayExpression) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 9;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "createCompositeTypeInstanceExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 10;
              copy._expressionTypeValue = CreateCompositeTypeInstanceExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 10) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 10) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 10;
            copy._expressionTypeValue = CreateCompositeTypeInstanceExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.createCompositeTypeInstanceExpression.apply(type, path.slice(1), value);
          if (newValue === this.createCompositeTypeInstanceExpression) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 10;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      case "accessCompositeTypeInstanceExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Expression(this);
              copy._expressionTypeCase = 11;
              copy._expressionTypeValue = AccessCompositeTypeInstanceExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionTypeCase !== 11) {
                return this;
              }
              const copy = new Expression(this);
              copy._expressionTypeCase = 0;
              copy._expressionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._expressionTypeCase !== 11) {
            const copy = new Expression(this);
            copy._expressionTypeCase = 11;
            copy._expressionTypeValue = AccessCompositeTypeInstanceExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.accessCompositeTypeInstanceExpression.apply(type, path.slice(1), value);
          if (newValue === this.accessCompositeTypeInstanceExpression) {
            return this;
          }
          const copy = new Expression(this);
          copy._expressionTypeCase = 11;
          copy._expressionTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Expression} other
   * @returns {Expression}
   */
  merge(other) {
    const copy = new Expression(this);
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    if (other._expressionTypeCase === 1) {
      if (this._expressionTypeCase === 1) {
        copy._expressionTypeValue = copy._expressionTypeValue.merge(other._expressionTypeValue);
      } else {
        copy._expressionTypeValue = other._expressionTypeValue;
      }
      copy._expressionTypeCase = 1;
    }
    return copy;
  }
}
Expression.default = new Expression();
class Expression_Builder {
  constructor(value) {
    this._value = new Expression(value);
  }
  build() {
    return new Expression(this._value);
  }
  clearexpressionType() {
    this._value._expressionTypeCase = 0;
    this._value._expressionTypeValue = null;
    return this;
  }
  setLiteral(value) {
    this._value._expressionTypeCase = 1;
    this._value._expressionTypeValue = value;
    return this;
  }
  setVariableRef(value) {
    this._value._expressionTypeCase = 2;
    this._value._expressionTypeValue = value;
    return this;
  }
  setFunctionCall(value) {
    this._value._expressionTypeCase = 3;
    this._value._expressionTypeValue = value;
    return this;
  }
  setArithmeticExpression(value) {
    this._value._expressionTypeCase = 4;
    this._value._expressionTypeValue = value;
    return this;
  }
  setLogicalExpression(value) {
    this._value._expressionTypeCase = 5;
    this._value._expressionTypeValue = value;
    return this;
  }
  setArrayExpression(value) {
    this._value._expressionTypeCase = 6;
    this._value._expressionTypeValue = value;
    return this;
  }
  setTableExpression(value) {
    this._value._expressionTypeCase = 7;
    this._value._expressionTypeValue = value;
    return this;
  }
  setCreateTableExpression(value) {
    this._value._expressionTypeCase = 8;
    this._value._expressionTypeValue = value;
    return this;
  }
  setCreateArrayExpression(value) {
    this._value._expressionTypeCase = 9;
    this._value._expressionTypeValue = value;
    return this;
  }
  setCreateCompositeTypeInstanceExpression(value) {
    this._value._expressionTypeCase = 10;
    this._value._expressionTypeValue = value;
    return this;
  }
  setAccessCompositeTypeInstanceExpression(value) {
    this._value._expressionTypeCase = 11;
    this._value._expressionTypeValue = value;
    return this;
  }
}
Expression.Builder = Expression_Builder;
class Expression_WithParent {
  /**
   * @param {Expression} value
   * @param {Expression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Expression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get expressionTypeCase() {
    if (this._cachedexpressionTypeCase === undefined) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedexpressionTypeCase = this._parent ? this._parent.expressionTypeCase : 0;
      } else {
        this._cachedexpressionTypeCase = this._value._expressionTypeCase;
      }
    }
    return this._cachedexpressionTypeCase;
  }
  get literal() {
    if (!this._cachedLiteral) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedLiteral = this._parent ? new Literal.WithParent(Literal.default, this._parent.literal) : this._value.literal;
      } else if (this._value._expressionTypeCase === 1) {
        this._cachedLiteral = new Literal.WithParent(this._value.literal, this._parent && this._parent.expressionTypeCase === 1 ? this._parent.literal : null);
      } else {
        this._cachedLiteral = Literal.WithParent.default;
      }
    }
    return this._cachedLiteral;
  }
  get variableRef() {
    if (!this._cachedVariableRef) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedVariableRef = this._parent ? new VariableRef.WithParent(VariableRef.default, this._parent.variableRef) : this._value.variableRef;
      } else if (this._value._expressionTypeCase === 2) {
        this._cachedVariableRef = new VariableRef.WithParent(this._value.variableRef, this._parent && this._parent.expressionTypeCase === 2 ? this._parent.variableRef : null);
      } else {
        this._cachedVariableRef = VariableRef.WithParent.default;
      }
    }
    return this._cachedVariableRef;
  }
  get functionCall() {
    if (!this._cachedFunctionCall) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedFunctionCall = this._parent ? new FunctionCall.WithParent(FunctionCall.default, this._parent.functionCall) : this._value.functionCall;
      } else if (this._value._expressionTypeCase === 3) {
        this._cachedFunctionCall = new FunctionCall.WithParent(this._value.functionCall, this._parent && this._parent.expressionTypeCase === 3 ? this._parent.functionCall : null);
      } else {
        this._cachedFunctionCall = FunctionCall.WithParent.default;
      }
    }
    return this._cachedFunctionCall;
  }
  get arithmeticExpression() {
    if (!this._cachedArithmeticExpression) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedArithmeticExpression = this._parent ? new ArithmeticExpression.WithParent(ArithmeticExpression.default, this._parent.arithmeticExpression) : this._value.arithmeticExpression;
      } else if (this._value._expressionTypeCase === 4) {
        this._cachedArithmeticExpression = new ArithmeticExpression.WithParent(this._value.arithmeticExpression, this._parent && this._parent.expressionTypeCase === 4 ? this._parent.arithmeticExpression : null);
      } else {
        this._cachedArithmeticExpression = ArithmeticExpression.WithParent.default;
      }
    }
    return this._cachedArithmeticExpression;
  }
  get logicalExpression() {
    if (!this._cachedLogicalExpression) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedLogicalExpression = this._parent ? new LogicalExpression.WithParent(LogicalExpression.default, this._parent.logicalExpression) : this._value.logicalExpression;
      } else if (this._value._expressionTypeCase === 5) {
        this._cachedLogicalExpression = new LogicalExpression.WithParent(this._value.logicalExpression, this._parent && this._parent.expressionTypeCase === 5 ? this._parent.logicalExpression : null);
      } else {
        this._cachedLogicalExpression = LogicalExpression.WithParent.default;
      }
    }
    return this._cachedLogicalExpression;
  }
  get arrayExpression() {
    if (!this._cachedArrayExpression) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedArrayExpression = this._parent ? new ArrayExpression.WithParent(ArrayExpression.default, this._parent.arrayExpression) : this._value.arrayExpression;
      } else if (this._value._expressionTypeCase === 6) {
        this._cachedArrayExpression = new ArrayExpression.WithParent(this._value.arrayExpression, this._parent && this._parent.expressionTypeCase === 6 ? this._parent.arrayExpression : null);
      } else {
        this._cachedArrayExpression = ArrayExpression.WithParent.default;
      }
    }
    return this._cachedArrayExpression;
  }
  get tableExpression() {
    if (!this._cachedTableExpression) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedTableExpression = this._parent ? new TableExpression.WithParent(TableExpression.default, this._parent.tableExpression) : this._value.tableExpression;
      } else if (this._value._expressionTypeCase === 7) {
        this._cachedTableExpression = new TableExpression.WithParent(this._value.tableExpression, this._parent && this._parent.expressionTypeCase === 7 ? this._parent.tableExpression : null);
      } else {
        this._cachedTableExpression = TableExpression.WithParent.default;
      }
    }
    return this._cachedTableExpression;
  }
  get createTableExpression() {
    if (!this._cachedCreateTableExpression) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedCreateTableExpression = this._parent ? new CreateTableExpression.WithParent(CreateTableExpression.default, this._parent.createTableExpression) : this._value.createTableExpression;
      } else if (this._value._expressionTypeCase === 8) {
        this._cachedCreateTableExpression = new CreateTableExpression.WithParent(this._value.createTableExpression, this._parent && this._parent.expressionTypeCase === 8 ? this._parent.createTableExpression : null);
      } else {
        this._cachedCreateTableExpression = CreateTableExpression.WithParent.default;
      }
    }
    return this._cachedCreateTableExpression;
  }
  get createArrayExpression() {
    if (!this._cachedCreateArrayExpression) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedCreateArrayExpression = this._parent ? new CreateArrayExpression.WithParent(CreateArrayExpression.default, this._parent.createArrayExpression) : this._value.createArrayExpression;
      } else if (this._value._expressionTypeCase === 9) {
        this._cachedCreateArrayExpression = new CreateArrayExpression.WithParent(this._value.createArrayExpression, this._parent && this._parent.expressionTypeCase === 9 ? this._parent.createArrayExpression : null);
      } else {
        this._cachedCreateArrayExpression = CreateArrayExpression.WithParent.default;
      }
    }
    return this._cachedCreateArrayExpression;
  }
  get createCompositeTypeInstanceExpression() {
    if (!this._cachedCreateCompositeTypeInstanceExpression) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedCreateCompositeTypeInstanceExpression = this._parent ? new CreateCompositeTypeInstanceExpression.WithParent(CreateCompositeTypeInstanceExpression.default, this._parent.createCompositeTypeInstanceExpression) : this._value.createCompositeTypeInstanceExpression;
      } else if (this._value._expressionTypeCase === 10) {
        this._cachedCreateCompositeTypeInstanceExpression = new CreateCompositeTypeInstanceExpression.WithParent(this._value.createCompositeTypeInstanceExpression, this._parent && this._parent.expressionTypeCase === 10 ? this._parent.createCompositeTypeInstanceExpression : null);
      } else {
        this._cachedCreateCompositeTypeInstanceExpression = CreateCompositeTypeInstanceExpression.WithParent.default;
      }
    }
    return this._cachedCreateCompositeTypeInstanceExpression;
  }
  get accessCompositeTypeInstanceExpression() {
    if (!this._cachedAccessCompositeTypeInstanceExpression) {
      if (this._value._expressionTypeCase === 0) {
        this._cachedAccessCompositeTypeInstanceExpression = this._parent ? new AccessCompositeTypeInstanceExpression.WithParent(AccessCompositeTypeInstanceExpression.default, this._parent.accessCompositeTypeInstanceExpression) : this._value.accessCompositeTypeInstanceExpression;
      } else if (this._value._expressionTypeCase === 11) {
        this._cachedAccessCompositeTypeInstanceExpression = new AccessCompositeTypeInstanceExpression.WithParent(this._value.accessCompositeTypeInstanceExpression, this._parent && this._parent.expressionTypeCase === 11 ? this._parent.accessCompositeTypeInstanceExpression : null);
      } else {
        this._cachedAccessCompositeTypeInstanceExpression = AccessCompositeTypeInstanceExpression.WithParent.default;
      }
    }
    return this._cachedAccessCompositeTypeInstanceExpression;
  }
  update(current, parent) {
    const result = new Expression_WithParent(current, parent);
    if (this._cachedLiteral && this._value._expressionTypeCase === 1 && current._expressionTypeCase === 1) {
      if (this._value.literal === current.literal && this._parent === parent) {
        result._cachedLiteral = this._cachedLiteral;
      } else {
        result._cachedLiteral = this._cachedLiteral.update(current.literal, parent && parent.expressionTypeCase === 1 ? parent.literal : null);
      }
    }
    if (this._cachedVariableRef && this._value._expressionTypeCase === 2 && current._expressionTypeCase === 2) {
      if (this._value.variableRef === current.variableRef && this._parent === parent) {
        result._cachedVariableRef = this._cachedVariableRef;
      } else {
        result._cachedVariableRef = this._cachedVariableRef.update(current.variableRef, parent && parent.expressionTypeCase === 2 ? parent.variableRef : null);
      }
    }
    if (this._cachedFunctionCall && this._value._expressionTypeCase === 3 && current._expressionTypeCase === 3) {
      if (this._value.functionCall === current.functionCall && this._parent === parent) {
        result._cachedFunctionCall = this._cachedFunctionCall;
      } else {
        result._cachedFunctionCall = this._cachedFunctionCall.update(current.functionCall, parent && parent.expressionTypeCase === 3 ? parent.functionCall : null);
      }
    }
    if (this._cachedArithmeticExpression && this._value._expressionTypeCase === 4 && current._expressionTypeCase === 4) {
      if (this._value.arithmeticExpression === current.arithmeticExpression && this._parent === parent) {
        result._cachedArithmeticExpression = this._cachedArithmeticExpression;
      } else {
        result._cachedArithmeticExpression = this._cachedArithmeticExpression.update(current.arithmeticExpression, parent && parent.expressionTypeCase === 4 ? parent.arithmeticExpression : null);
      }
    }
    if (this._cachedLogicalExpression && this._value._expressionTypeCase === 5 && current._expressionTypeCase === 5) {
      if (this._value.logicalExpression === current.logicalExpression && this._parent === parent) {
        result._cachedLogicalExpression = this._cachedLogicalExpression;
      } else {
        result._cachedLogicalExpression = this._cachedLogicalExpression.update(current.logicalExpression, parent && parent.expressionTypeCase === 5 ? parent.logicalExpression : null);
      }
    }
    if (this._cachedArrayExpression && this._value._expressionTypeCase === 6 && current._expressionTypeCase === 6) {
      if (this._value.arrayExpression === current.arrayExpression && this._parent === parent) {
        result._cachedArrayExpression = this._cachedArrayExpression;
      } else {
        result._cachedArrayExpression = this._cachedArrayExpression.update(current.arrayExpression, parent && parent.expressionTypeCase === 6 ? parent.arrayExpression : null);
      }
    }
    if (this._cachedTableExpression && this._value._expressionTypeCase === 7 && current._expressionTypeCase === 7) {
      if (this._value.tableExpression === current.tableExpression && this._parent === parent) {
        result._cachedTableExpression = this._cachedTableExpression;
      } else {
        result._cachedTableExpression = this._cachedTableExpression.update(current.tableExpression, parent && parent.expressionTypeCase === 7 ? parent.tableExpression : null);
      }
    }
    if (this._cachedCreateTableExpression && this._value._expressionTypeCase === 8 && current._expressionTypeCase === 8) {
      if (this._value.createTableExpression === current.createTableExpression && this._parent === parent) {
        result._cachedCreateTableExpression = this._cachedCreateTableExpression;
      } else {
        result._cachedCreateTableExpression = this._cachedCreateTableExpression.update(current.createTableExpression, parent && parent.expressionTypeCase === 8 ? parent.createTableExpression : null);
      }
    }
    if (this._cachedCreateArrayExpression && this._value._expressionTypeCase === 9 && current._expressionTypeCase === 9) {
      if (this._value.createArrayExpression === current.createArrayExpression && this._parent === parent) {
        result._cachedCreateArrayExpression = this._cachedCreateArrayExpression;
      } else {
        result._cachedCreateArrayExpression = this._cachedCreateArrayExpression.update(current.createArrayExpression, parent && parent.expressionTypeCase === 9 ? parent.createArrayExpression : null);
      }
    }
    if (this._cachedCreateCompositeTypeInstanceExpression && this._value._expressionTypeCase === 10 && current._expressionTypeCase === 10) {
      if (this._value.createCompositeTypeInstanceExpression === current.createCompositeTypeInstanceExpression && this._parent === parent) {
        result._cachedCreateCompositeTypeInstanceExpression = this._cachedCreateCompositeTypeInstanceExpression;
      } else {
        result._cachedCreateCompositeTypeInstanceExpression = this._cachedCreateCompositeTypeInstanceExpression.update(current.createCompositeTypeInstanceExpression, parent && parent.expressionTypeCase === 10 ? parent.createCompositeTypeInstanceExpression : null);
      }
    }
    if (this._cachedAccessCompositeTypeInstanceExpression && this._value._expressionTypeCase === 11 && current._expressionTypeCase === 11) {
      if (this._value.accessCompositeTypeInstanceExpression === current.accessCompositeTypeInstanceExpression && this._parent === parent) {
        result._cachedAccessCompositeTypeInstanceExpression = this._cachedAccessCompositeTypeInstanceExpression;
      } else {
        result._cachedAccessCompositeTypeInstanceExpression = this._cachedAccessCompositeTypeInstanceExpression.update(current.accessCompositeTypeInstanceExpression, parent && parent.expressionTypeCase === 11 ? parent.accessCompositeTypeInstanceExpression : null);
      }
    }
    return result;
  }
}
Expression_WithParent.default = new Expression_WithParent(Expression.default, null);
Expression.WithParent = Expression_WithParent;
class Expression_Descriptor {
  get literal() {
    if (!this._literal) {
      this._literal = {
        name: "literal",
        Name: "Literal",
        number: 1,
        protoType: 11,
        protoName: "literal",
        oneofIndex: 0,
        type: Literal,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._literal;
  }
  get variableRef() {
    if (!this._variableRef) {
      this._variableRef = {
        name: "variableRef",
        Name: "VariableRef",
        number: 2,
        protoType: 11,
        protoName: "variable_ref",
        oneofIndex: 0,
        type: VariableRef,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._variableRef;
  }
  get functionCall() {
    if (!this._functionCall) {
      this._functionCall = {
        name: "functionCall",
        Name: "FunctionCall",
        number: 3,
        protoType: 11,
        protoName: "function_call",
        oneofIndex: 0,
        type: FunctionCall,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._functionCall;
  }
  get arithmeticExpression() {
    if (!this._arithmeticExpression) {
      this._arithmeticExpression = {
        name: "arithmeticExpression",
        Name: "ArithmeticExpression",
        number: 4,
        protoType: 11,
        protoName: "arithmetic_expression",
        oneofIndex: 0,
        type: ArithmeticExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._arithmeticExpression;
  }
  get logicalExpression() {
    if (!this._logicalExpression) {
      this._logicalExpression = {
        name: "logicalExpression",
        Name: "LogicalExpression",
        number: 5,
        protoType: 11,
        protoName: "logical_expression",
        oneofIndex: 0,
        type: LogicalExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._logicalExpression;
  }
  get arrayExpression() {
    if (!this._arrayExpression) {
      this._arrayExpression = {
        name: "arrayExpression",
        Name: "ArrayExpression",
        number: 6,
        protoType: 11,
        protoName: "array_expression",
        oneofIndex: 0,
        type: ArrayExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._arrayExpression;
  }
  get tableExpression() {
    if (!this._tableExpression) {
      this._tableExpression = {
        name: "tableExpression",
        Name: "TableExpression",
        number: 7,
        protoType: 11,
        protoName: "table_expression",
        oneofIndex: 0,
        type: TableExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tableExpression;
  }
  get createTableExpression() {
    if (!this._createTableExpression) {
      this._createTableExpression = {
        name: "createTableExpression",
        Name: "CreateTableExpression",
        number: 8,
        protoType: 11,
        protoName: "create_table_expression",
        oneofIndex: 0,
        type: CreateTableExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._createTableExpression;
  }
  get createArrayExpression() {
    if (!this._createArrayExpression) {
      this._createArrayExpression = {
        name: "createArrayExpression",
        Name: "CreateArrayExpression",
        number: 9,
        protoType: 11,
        protoName: "create_array_expression",
        oneofIndex: 0,
        type: CreateArrayExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._createArrayExpression;
  }
  get createCompositeTypeInstanceExpression() {
    if (!this._createCompositeTypeInstanceExpression) {
      this._createCompositeTypeInstanceExpression = {
        name: "createCompositeTypeInstanceExpression",
        Name: "CreateCompositeTypeInstanceExpression",
        number: 10,
        protoType: 11,
        protoName: "create_composite_type_instance_expression",
        oneofIndex: 0,
        type: CreateCompositeTypeInstanceExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._createCompositeTypeInstanceExpression;
  }
  get accessCompositeTypeInstanceExpression() {
    if (!this._accessCompositeTypeInstanceExpression) {
      this._accessCompositeTypeInstanceExpression = {
        name: "accessCompositeTypeInstanceExpression",
        Name: "AccessCompositeTypeInstanceExpression",
        number: 11,
        protoType: 11,
        protoName: "access_composite_type_instance_expression",
        oneofIndex: 0,
        type: AccessCompositeTypeInstanceExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._accessCompositeTypeInstanceExpression;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.literal,
        this.variableRef,
        this.functionCall,
        this.arithmeticExpression,
        this.logicalExpression,
        this.arrayExpression,
        this.tableExpression,
        this.createTableExpression,
        this.createArrayExpression,
        this.createCompositeTypeInstanceExpression,
        this.accessCompositeTypeInstanceExpression,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "expressionType",
        Name: "ExpressionType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
          this.fields[9],
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
Expression.descriptor = new Expression_Descriptor();
export class StatementFunctionCall {
  get descriptor() {
    return StatementFunctionCall.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFunctionName = false;
    this._functionName = null;
    this._parameters = [];
    this._hasAsync = false;
    this._async = null;
    this._hasDelay = false;
    this._delay = null;
  }
  isEmpty() {
    if (this._hasFunctionName) return false;
    if (this._parameters.length > 0) return false;
    if (this._hasAsync) return false;
    if (this._hasDelay && !this._delay.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StatementFunctionCall) {
      return value;
    }
    return StatementFunctionCall.fromJson(value);
  }
  static fromJson(json) {
    const result = new StatementFunctionCall();
    if (json.functionName != null) {
      result._hasFunctionName = true;
      result._functionName = JsonToString.fromJson(json.functionName);
    }
    result._parameters = JsonToList(json.parameters, Expression);
    if (json.async != null) {
      result._hasAsync = true;
      result._async = JsonToBoolean.fromJson(json.async);
    }
    if (json.delay != null) {
      result._hasDelay = true;
      result._delay = Expression.fromJson(json.delay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFunctionName) {
      result.functionName = JsonToString.toJson(this._functionName);
    }
    if (this._parameters.length > 0) {
      result.parameters = ArrayToJson(this._parameters, Expression);
    }
    if (this._hasAsync) {
      result.async = JsonToBoolean.toJson(this._async);
    }
    if (this._hasDelay && !this._delay.isEmpty()) {
      result.delay = Expression.toJson(this._delay);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get functionName() {
    return this._hasFunctionName ? this._functionName : JsonToString.default;
  }
  get hasFunctionName() {
    return this._hasFunctionName;
  }
  setFunctionName(path, value) {
    return {type: 'SET', path: path.concat(['functionName']), value};
  }
  deleteFunctionName(path) {
    return {type: 'DELETE', path: path.concat(['functionName'])};
  }
  /**
   * @returns {Expression[]}
   */
  get parameters() {
    return this._parameters;
  }
  addParameters(path, value) {
    return {type: 'ADD', path: path.concat(['parameters']), value: value.toJson()};
  }
  setParameters(path, value) {
    return {type: 'SET', path: path.concat(['parameters']), value: ArrayToJson(value, Expression)};
  }
  setParametersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['parameters', key]), value: value.toJson()};
  }
  deleteParameters(path) {
    return {type: 'DELETE', path: path.concat(['parameters'])};
  }
  deleteParametersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['parameters', key])};
  }
  /**
   * @returns {boolean}
   */
  get async() {
    return this._hasAsync ? this._async : JsonToBoolean.default;
  }
  get hasAsync() {
    return this._hasAsync;
  }
  setAsync(path, value) {
    return {type: 'SET', path: path.concat(['async']), value};
  }
  deleteAsync(path) {
    return {type: 'DELETE', path: path.concat(['async'])};
  }
  /**
   * @returns {Expression}
   */
  get delay() {
    return this._hasDelay ? this._delay : Expression.default;
  }
  get hasDelay() {
    return this._hasDelay;
  }
  setDelay(path, value) {
    return {type: 'SET', path: path.concat(['delay']), value: value.toJson()};
  }
  deleteDelay(path) {
    return {type: 'DELETE', path: path.concat(['delay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "functionName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StatementFunctionCall(this);
              copy._hasFunctionName = true;
              copy._functionName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFunctionName) {
                return this;
              }
              const copy = new StatementFunctionCall(this);
              copy._hasFunctionName = false;
              copy._functionName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parameters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StatementFunctionCall(this);
              copy._parameters = [];        for (let i of value) {
                copy._parameters.push(Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StatementFunctionCall(this);
              copy._parameters = copy._parameters.concat([Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._parameters.length === 0) {
                return this;
              }
              const copy = new StatementFunctionCall(this);
              copy._parameters = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StatementFunctionCall(this);
              copy._parameters = copy._parameters.slice();
              copy._parameters[path[1]] = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StatementFunctionCall(this);
              copy._parameters = copy._parameters.slice(0, path[1]).concat(copy._parameters.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          const oldValue = this._parameters[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StatementFunctionCall(this);
          copy._parameters = copy._parameters.slice();
          copy._parameters[key] = newValue;
          return copy;
        }
      }
      case "async": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StatementFunctionCall(this);
              copy._hasAsync = true;
              copy._async = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAsync) {
                return this;
              }
              const copy = new StatementFunctionCall(this);
              copy._hasAsync = false;
              copy._async = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "delay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StatementFunctionCall(this);
              copy._hasDelay = true;
              copy._delay = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDelay) {
                return this;
              }
              const copy = new StatementFunctionCall(this);
              copy._hasDelay = false;
              copy._delay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDelay) {
            const copy = new StatementFunctionCall(this);
            copy._hasDelay = true;
            copy._delay = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._delay.apply(type, path.slice(1), value);
          if (newValue === this._delay) {
            return this;
          }
          const copy = new StatementFunctionCall(this);
          copy._delay = copy._delay.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StatementFunctionCall} other
   * @returns {StatementFunctionCall}
   */
  merge(other) {
    const copy = new StatementFunctionCall(this);
    if (other._hasFunctionName) {
      copy._hasFunctionName = true;
      copy._functionName = other._functionName;
    }
    copy._parameters = this._parameters.concat(other._parameters);
    if (other._hasAsync) {
      copy._hasAsync = true;
      copy._async = other._async;
    }
    if (other._hasDelay) {
      if (copy._hasDelay) {
        copy._delay = copy.delay.merge(other.delay);
      } else {
        copy._delay = other._delay;
      }
      copy._hasDelay = true;
    }
    return copy;
  }
}
StatementFunctionCall.default = new StatementFunctionCall();
class StatementFunctionCall_Builder {
  constructor(value) {
    this._value = new StatementFunctionCall(value);
  }
  build() {
    return new StatementFunctionCall(this._value);
  }
  setFunctionName(value) {
    this._value._hasFunctionName = true;
    this._value._functionName = value;
    return this;
  }
  deleteFunctionName() {
    this._value._hasFunctionName = false;
    this._value._functionName = null;
    return this;
  }
  addAllParameters(values) {
    this._value._parameters = this._value._parameters.concat(values);
    return this;
  }
  addParameters(value) {
    this._value._parameters = this._value._parameters.concat([value]);
    return this;
  }
  setParameters(index, value) {
    this._value._parameters = this._value._parameters.concat();
    this._value._parameters[index] = value;
    return this;
  }
  clearParameters() {
    this._value._parameters = [];
    return this;
  }
  setAsync(value) {
    this._value._hasAsync = true;
    this._value._async = value;
    return this;
  }
  deleteAsync() {
    this._value._hasAsync = false;
    this._value._async = null;
    return this;
  }
  setDelay(value) {
    this._value._hasDelay = true;
    this._value._delay = value;
    return this;
  }
  deleteDelay() {
    this._value._hasDelay = false;
    this._value._delay = null;
    return this;
  }
}
StatementFunctionCall.Builder = StatementFunctionCall_Builder;
class StatementFunctionCall_WithParent {
  /**
   * @param {StatementFunctionCall} value
   * @param {StatementFunctionCall_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StatementFunctionCall.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFunctionName() {
    if (this._cachedHasFunctionName === undefined) {
      if (this._value.hasFunctionName) {
        this._cachedHasFunctionName = true;
      } else {
        this._cachedHasFunctionName = this._parent ? this._parent.hasFunctionName : false;
      }
    }
    return this._cachedHasFunctionName;
  }
  get functionName() {
    if (this._cachedFunctionName === undefined) {
      if (this._value.hasFunctionName) {
        this._cachedFunctionName = this._value.functionName;
      } else {
        this._cachedFunctionName = this._parent ? this._parent.functionName : this._value.functionName;
      }
    }
    return this._cachedFunctionName;
  }
  get selfParameters() {
    if (!this._selfParameters) {
      this._selfParameters = [];
      for (let i of this._value.parameters) {
        this._selfParameters.push(new Expression.WithParent(i, null));
      }
    }
    return this._selfParameters;
  }
  get inherentParameters() {
    if (!this._inherentParameters) {
      this._inherentParameters = this._parent ? this._parent.parameters : [];
    }
    return this._inherentParameters;
  }
  get parameters() {
    if (!this._allParameters) {
      this._allParameters = this._parent ? this._parent.parameters.concat(this.selfParameters) : this.selfParameters;
    }
    return this._allParameters;
  }
  get hasAsync() {
    if (this._cachedHasAsync === undefined) {
      if (this._value.hasAsync) {
        this._cachedHasAsync = true;
      } else {
        this._cachedHasAsync = this._parent ? this._parent.hasAsync : false;
      }
    }
    return this._cachedHasAsync;
  }
  get async() {
    if (this._cachedAsync === undefined) {
      if (this._value.hasAsync) {
        this._cachedAsync = this._value.async;
      } else {
        this._cachedAsync = this._parent ? this._parent.async : this._value.async;
      }
    }
    return this._cachedAsync;
  }
  get hasDelay() {
    if (this._cachedHasDelay === undefined) {
      if (this._value.hasDelay) {
        this._cachedHasDelay = true;
      } else {
        this._cachedHasDelay = this._parent ? this._parent.hasDelay : false;
      }
    }
    return this._cachedHasDelay;
  }
  get delay() {
    if (!this._cachedDelay) {
      if (this._value.hasDelay) {
        this._cachedDelay = new Expression.WithParent(this._value.delay, this._parent && this._parent.hasDelay ? this._parent.delay : null);
      } else {
        this._cachedDelay = this._parent ? new Expression.WithParent(Expression.default, this._parent.delay) : Expression.WithParent.default;
      }
    }
    return this._cachedDelay;
  }
  update(current, parent) {
    const result = new StatementFunctionCall_WithParent(current, parent);
    if (this._selfParameters) {
      if (this._value.parameters === current.parameters) {
        result._selfParameters = this._selfParameters;
      } else {
        result._selfParameters = [];
        for (let i = 0; i < current.parameters.length; i++) {
          const oldValue = this._value.parameters[i];
          if (oldValue) {
            const oldCache = this._selfParameters[i];
            if (oldValue === current.parameters[i]) {
              result._selfParameters[i] = oldCache;
            } else {
              result._selfParameters[i] = oldCache.update(current.parameters[i], null);
            }
          } else {
            result._selfParameters[i] = new Expression.WithParent(current.parameters[i], null);
          }
        }
      }
    }
    if (this._cachedDelay && this._value.hasDelay && current.hasDelay) {
      if (this._value.delay === current.delay && this._parent === parent) {
        result._cachedDelay = this._cachedDelay;
      } else {
        result._cachedDelay = this._cachedDelay.update(current.delay, parent && parent.hasDelay ? parent.delay : null);
      }
    }
    return result;
  }
}
StatementFunctionCall_WithParent.default = new StatementFunctionCall_WithParent(StatementFunctionCall.default, null);
StatementFunctionCall.WithParent = StatementFunctionCall_WithParent;
class StatementFunctionCall_Descriptor {
  get functionName() {
    if (!this._functionName) {
      this._functionName = {
        name: "functionName",
        Name: "FunctionName",
        number: 1,
        protoType: 9,
        protoName: "function_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._functionName;
  }
  get parameters() {
    if (!this._parameters) {
      this._parameters = {
        name: "parameters",
        Name: "Parameters",
        number: 2,
        protoType: 11,
        protoName: "parameters",
        type: Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parameters;
  }
  get async() {
    if (!this._async) {
      this._async = {
        name: "async",
        Name: "Async",
        number: 3,
        protoType: 8,
        protoName: "async",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._async;
  }
  get delay() {
    if (!this._delay) {
      this._delay = {
        name: "delay",
        Name: "Delay",
        number: 4,
        protoType: 11,
        protoName: "delay",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._delay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.functionName,
        this.parameters,
        this.async,
        this.delay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFunctionName",
        Name: "DummyOneofForFunctionName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAsync",
        Name: "DummyOneofForAsync",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDelay",
        Name: "DummyOneofForDelay",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
StatementFunctionCall.descriptor = new StatementFunctionCall_Descriptor();
export class Statement {
  get descriptor() {
    return Statement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._statementTypeCase = 0;
    this._statementTypeValue = null;
  }
  isEmpty() {
    if (this._statementTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Statement) {
      return value;
    }
    return Statement.fromJson(value);
  }
  static fromJson(json) {
    const result = new Statement();
    if (json.functionCall != null) {
      result._statementTypeCase = 1;
      result._statementTypeValue = StatementFunctionCall.fromJson(json.functionCall);
    }
    if (json.ifElseStatement != null) {
      result._statementTypeCase = 2;
      result._statementTypeValue = IfElseStatement.fromJson(json.ifElseStatement);
    }
    if (json.whileStatement != null) {
      result._statementTypeCase = 3;
      result._statementTypeValue = WhileStatement.fromJson(json.whileStatement);
    }
    if (json.forEachStatement != null) {
      result._statementTypeCase = 4;
      result._statementTypeValue = ForEachNumberStatement.fromJson(json.forEachStatement);
    }
    if (json.assignmentStatement != null) {
      result._statementTypeCase = 5;
      result._statementTypeValue = AssignmentStatement.fromJson(json.assignmentStatement);
    }
    if (json.breakStatement != null) {
      result._statementTypeCase = 6;
      result._statementTypeValue = BreakStatement.fromJson(json.breakStatement);
    }
    if (json.continueStatement != null) {
      result._statementTypeCase = 7;
      result._statementTypeValue = ContinueStatement.fromJson(json.continueStatement);
    }
    if (json.returnStatement != null) {
      result._statementTypeCase = 8;
      result._statementTypeValue = ReturnStatement.fromJson(json.returnStatement);
    }
    if (json.arrayStatement != null) {
      result._statementTypeCase = 9;
      result._statementTypeValue = ArrayStatement.fromJson(json.arrayStatement);
    }
    if (json.tableStatement != null) {
      result._statementTypeCase = 10;
      result._statementTypeValue = TableStatement.fromJson(json.tableStatement);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._statementTypeCase) {
      case 1:
        result.functionCall = StatementFunctionCall.toJson(this._statementTypeValue);
        break;
      case 2:
        result.ifElseStatement = IfElseStatement.toJson(this._statementTypeValue);
        break;
      case 3:
        result.whileStatement = WhileStatement.toJson(this._statementTypeValue);
        break;
      case 4:
        result.forEachStatement = ForEachNumberStatement.toJson(this._statementTypeValue);
        break;
      case 5:
        result.assignmentStatement = AssignmentStatement.toJson(this._statementTypeValue);
        break;
      case 6:
        result.breakStatement = BreakStatement.toJson(this._statementTypeValue);
        break;
      case 7:
        result.continueStatement = ContinueStatement.toJson(this._statementTypeValue);
        break;
      case 8:
        result.returnStatement = ReturnStatement.toJson(this._statementTypeValue);
        break;
      case 9:
        result.arrayStatement = ArrayStatement.toJson(this._statementTypeValue);
        break;
      case 10:
        result.tableStatement = TableStatement.toJson(this._statementTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get statementTypeCase() {
    return this._statementTypeCase;
  }
  deleteStatementType(path) {
    switch (this._statementTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['functionCall'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['ifElseStatement'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['whileStatement'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['forEachStatement'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['assignmentStatement'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['breakStatement'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['continueStatement'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['returnStatement'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['arrayStatement'])};
      }
      case 10: {
        return {type: 'DELETE', path: path.concat(['tableStatement'])};
      }
    }
  }
  /**
   * @returns {StatementFunctionCall}
   */
  get functionCall() {
    return this._statementTypeCase === 1 ? this._statementTypeValue : StatementFunctionCall.default;
  }
  setFunctionCall(path, value) {
    return {type: 'SET', path: path.concat(['functionCall']), value: value.toJson()};
  }
  deleteFunctionCall(path) {
    return {type: 'DELETE', path: path.concat(['functionCall'])};
  }
  /**
   * @returns {IfElseStatement}
   */
  get ifElseStatement() {
    return this._statementTypeCase === 2 ? this._statementTypeValue : IfElseStatement.default;
  }
  setIfElseStatement(path, value) {
    return {type: 'SET', path: path.concat(['ifElseStatement']), value: value.toJson()};
  }
  deleteIfElseStatement(path) {
    return {type: 'DELETE', path: path.concat(['ifElseStatement'])};
  }
  /**
   * @returns {WhileStatement}
   */
  get whileStatement() {
    return this._statementTypeCase === 3 ? this._statementTypeValue : WhileStatement.default;
  }
  setWhileStatement(path, value) {
    return {type: 'SET', path: path.concat(['whileStatement']), value: value.toJson()};
  }
  deleteWhileStatement(path) {
    return {type: 'DELETE', path: path.concat(['whileStatement'])};
  }
  /**
   * @returns {ForEachNumberStatement}
   */
  get forEachStatement() {
    return this._statementTypeCase === 4 ? this._statementTypeValue : ForEachNumberStatement.default;
  }
  setForEachStatement(path, value) {
    return {type: 'SET', path: path.concat(['forEachStatement']), value: value.toJson()};
  }
  deleteForEachStatement(path) {
    return {type: 'DELETE', path: path.concat(['forEachStatement'])};
  }
  /**
   * @returns {AssignmentStatement}
   */
  get assignmentStatement() {
    return this._statementTypeCase === 5 ? this._statementTypeValue : AssignmentStatement.default;
  }
  setAssignmentStatement(path, value) {
    return {type: 'SET', path: path.concat(['assignmentStatement']), value: value.toJson()};
  }
  deleteAssignmentStatement(path) {
    return {type: 'DELETE', path: path.concat(['assignmentStatement'])};
  }
  /**
   * @returns {BreakStatement}
   */
  get breakStatement() {
    return this._statementTypeCase === 6 ? this._statementTypeValue : BreakStatement.default;
  }
  setBreakStatement(path, value) {
    return {type: 'SET', path: path.concat(['breakStatement']), value: value.toJson()};
  }
  deleteBreakStatement(path) {
    return {type: 'DELETE', path: path.concat(['breakStatement'])};
  }
  /**
   * @returns {ContinueStatement}
   */
  get continueStatement() {
    return this._statementTypeCase === 7 ? this._statementTypeValue : ContinueStatement.default;
  }
  setContinueStatement(path, value) {
    return {type: 'SET', path: path.concat(['continueStatement']), value: value.toJson()};
  }
  deleteContinueStatement(path) {
    return {type: 'DELETE', path: path.concat(['continueStatement'])};
  }
  /**
   * @returns {ReturnStatement}
   */
  get returnStatement() {
    return this._statementTypeCase === 8 ? this._statementTypeValue : ReturnStatement.default;
  }
  setReturnStatement(path, value) {
    return {type: 'SET', path: path.concat(['returnStatement']), value: value.toJson()};
  }
  deleteReturnStatement(path) {
    return {type: 'DELETE', path: path.concat(['returnStatement'])};
  }
  /**
   * @returns {ArrayStatement}
   */
  get arrayStatement() {
    return this._statementTypeCase === 9 ? this._statementTypeValue : ArrayStatement.default;
  }
  setArrayStatement(path, value) {
    return {type: 'SET', path: path.concat(['arrayStatement']), value: value.toJson()};
  }
  deleteArrayStatement(path) {
    return {type: 'DELETE', path: path.concat(['arrayStatement'])};
  }
  /**
   * @returns {TableStatement}
   */
  get tableStatement() {
    return this._statementTypeCase === 10 ? this._statementTypeValue : TableStatement.default;
  }
  setTableStatement(path, value) {
    return {type: 'SET', path: path.concat(['tableStatement']), value: value.toJson()};
  }
  deleteTableStatement(path) {
    return {type: 'DELETE', path: path.concat(['tableStatement'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "functionCall": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 1;
              copy._statementTypeValue = StatementFunctionCall.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 1) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 1) {
            const copy = new Statement(this);
            copy._statementTypeCase = 1;
            copy._statementTypeValue = StatementFunctionCall.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.functionCall.apply(type, path.slice(1), value);
          if (newValue === this.functionCall) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 1;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      case "ifElseStatement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 2;
              copy._statementTypeValue = IfElseStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 2) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 2) {
            const copy = new Statement(this);
            copy._statementTypeCase = 2;
            copy._statementTypeValue = IfElseStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.ifElseStatement.apply(type, path.slice(1), value);
          if (newValue === this.ifElseStatement) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 2;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      case "whileStatement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 3;
              copy._statementTypeValue = WhileStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 3) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 3) {
            const copy = new Statement(this);
            copy._statementTypeCase = 3;
            copy._statementTypeValue = WhileStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.whileStatement.apply(type, path.slice(1), value);
          if (newValue === this.whileStatement) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 3;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      case "forEachStatement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 4;
              copy._statementTypeValue = ForEachNumberStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 4) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 4) {
            const copy = new Statement(this);
            copy._statementTypeCase = 4;
            copy._statementTypeValue = ForEachNumberStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.forEachStatement.apply(type, path.slice(1), value);
          if (newValue === this.forEachStatement) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 4;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      case "assignmentStatement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 5;
              copy._statementTypeValue = AssignmentStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 5) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 5) {
            const copy = new Statement(this);
            copy._statementTypeCase = 5;
            copy._statementTypeValue = AssignmentStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.assignmentStatement.apply(type, path.slice(1), value);
          if (newValue === this.assignmentStatement) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 5;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      case "breakStatement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 6;
              copy._statementTypeValue = BreakStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 6) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 6) {
            const copy = new Statement(this);
            copy._statementTypeCase = 6;
            copy._statementTypeValue = BreakStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.breakStatement.apply(type, path.slice(1), value);
          if (newValue === this.breakStatement) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 6;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      case "continueStatement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 7;
              copy._statementTypeValue = ContinueStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 7) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 7) {
            const copy = new Statement(this);
            copy._statementTypeCase = 7;
            copy._statementTypeValue = ContinueStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.continueStatement.apply(type, path.slice(1), value);
          if (newValue === this.continueStatement) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 7;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      case "returnStatement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 8;
              copy._statementTypeValue = ReturnStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 8) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 8) {
            const copy = new Statement(this);
            copy._statementTypeCase = 8;
            copy._statementTypeValue = ReturnStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.returnStatement.apply(type, path.slice(1), value);
          if (newValue === this.returnStatement) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 8;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      case "arrayStatement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 9;
              copy._statementTypeValue = ArrayStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 9) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 9) {
            const copy = new Statement(this);
            copy._statementTypeCase = 9;
            copy._statementTypeValue = ArrayStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.arrayStatement.apply(type, path.slice(1), value);
          if (newValue === this.arrayStatement) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 9;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      case "tableStatement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Statement(this);
              copy._statementTypeCase = 10;
              copy._statementTypeValue = TableStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._statementTypeCase !== 10) {
                return this;
              }
              const copy = new Statement(this);
              copy._statementTypeCase = 0;
              copy._statementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._statementTypeCase !== 10) {
            const copy = new Statement(this);
            copy._statementTypeCase = 10;
            copy._statementTypeValue = TableStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.tableStatement.apply(type, path.slice(1), value);
          if (newValue === this.tableStatement) {
            return this;
          }
          const copy = new Statement(this);
          copy._statementTypeCase = 10;
          copy._statementTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Statement} other
   * @returns {Statement}
   */
  merge(other) {
    const copy = new Statement(this);
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    if (other._statementTypeCase === 1) {
      if (this._statementTypeCase === 1) {
        copy._statementTypeValue = copy._statementTypeValue.merge(other._statementTypeValue);
      } else {
        copy._statementTypeValue = other._statementTypeValue;
      }
      copy._statementTypeCase = 1;
    }
    return copy;
  }
}
Statement.default = new Statement();
class Statement_Builder {
  constructor(value) {
    this._value = new Statement(value);
  }
  build() {
    return new Statement(this._value);
  }
  clearstatementType() {
    this._value._statementTypeCase = 0;
    this._value._statementTypeValue = null;
    return this;
  }
  setFunctionCall(value) {
    this._value._statementTypeCase = 1;
    this._value._statementTypeValue = value;
    return this;
  }
  setIfElseStatement(value) {
    this._value._statementTypeCase = 2;
    this._value._statementTypeValue = value;
    return this;
  }
  setWhileStatement(value) {
    this._value._statementTypeCase = 3;
    this._value._statementTypeValue = value;
    return this;
  }
  setForEachStatement(value) {
    this._value._statementTypeCase = 4;
    this._value._statementTypeValue = value;
    return this;
  }
  setAssignmentStatement(value) {
    this._value._statementTypeCase = 5;
    this._value._statementTypeValue = value;
    return this;
  }
  setBreakStatement(value) {
    this._value._statementTypeCase = 6;
    this._value._statementTypeValue = value;
    return this;
  }
  setContinueStatement(value) {
    this._value._statementTypeCase = 7;
    this._value._statementTypeValue = value;
    return this;
  }
  setReturnStatement(value) {
    this._value._statementTypeCase = 8;
    this._value._statementTypeValue = value;
    return this;
  }
  setArrayStatement(value) {
    this._value._statementTypeCase = 9;
    this._value._statementTypeValue = value;
    return this;
  }
  setTableStatement(value) {
    this._value._statementTypeCase = 10;
    this._value._statementTypeValue = value;
    return this;
  }
}
Statement.Builder = Statement_Builder;
class Statement_WithParent {
  /**
   * @param {Statement} value
   * @param {Statement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Statement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get statementTypeCase() {
    if (this._cachedstatementTypeCase === undefined) {
      if (this._value._statementTypeCase === 0) {
        this._cachedstatementTypeCase = this._parent ? this._parent.statementTypeCase : 0;
      } else {
        this._cachedstatementTypeCase = this._value._statementTypeCase;
      }
    }
    return this._cachedstatementTypeCase;
  }
  get functionCall() {
    if (!this._cachedFunctionCall) {
      if (this._value._statementTypeCase === 0) {
        this._cachedFunctionCall = this._parent ? new StatementFunctionCall.WithParent(StatementFunctionCall.default, this._parent.functionCall) : this._value.functionCall;
      } else if (this._value._statementTypeCase === 1) {
        this._cachedFunctionCall = new StatementFunctionCall.WithParent(this._value.functionCall, this._parent && this._parent.statementTypeCase === 1 ? this._parent.functionCall : null);
      } else {
        this._cachedFunctionCall = StatementFunctionCall.WithParent.default;
      }
    }
    return this._cachedFunctionCall;
  }
  get ifElseStatement() {
    if (!this._cachedIfElseStatement) {
      if (this._value._statementTypeCase === 0) {
        this._cachedIfElseStatement = this._parent ? new IfElseStatement.WithParent(IfElseStatement.default, this._parent.ifElseStatement) : this._value.ifElseStatement;
      } else if (this._value._statementTypeCase === 2) {
        this._cachedIfElseStatement = new IfElseStatement.WithParent(this._value.ifElseStatement, this._parent && this._parent.statementTypeCase === 2 ? this._parent.ifElseStatement : null);
      } else {
        this._cachedIfElseStatement = IfElseStatement.WithParent.default;
      }
    }
    return this._cachedIfElseStatement;
  }
  get whileStatement() {
    if (!this._cachedWhileStatement) {
      if (this._value._statementTypeCase === 0) {
        this._cachedWhileStatement = this._parent ? new WhileStatement.WithParent(WhileStatement.default, this._parent.whileStatement) : this._value.whileStatement;
      } else if (this._value._statementTypeCase === 3) {
        this._cachedWhileStatement = new WhileStatement.WithParent(this._value.whileStatement, this._parent && this._parent.statementTypeCase === 3 ? this._parent.whileStatement : null);
      } else {
        this._cachedWhileStatement = WhileStatement.WithParent.default;
      }
    }
    return this._cachedWhileStatement;
  }
  get forEachStatement() {
    if (!this._cachedForEachStatement) {
      if (this._value._statementTypeCase === 0) {
        this._cachedForEachStatement = this._parent ? new ForEachNumberStatement.WithParent(ForEachNumberStatement.default, this._parent.forEachStatement) : this._value.forEachStatement;
      } else if (this._value._statementTypeCase === 4) {
        this._cachedForEachStatement = new ForEachNumberStatement.WithParent(this._value.forEachStatement, this._parent && this._parent.statementTypeCase === 4 ? this._parent.forEachStatement : null);
      } else {
        this._cachedForEachStatement = ForEachNumberStatement.WithParent.default;
      }
    }
    return this._cachedForEachStatement;
  }
  get assignmentStatement() {
    if (!this._cachedAssignmentStatement) {
      if (this._value._statementTypeCase === 0) {
        this._cachedAssignmentStatement = this._parent ? new AssignmentStatement.WithParent(AssignmentStatement.default, this._parent.assignmentStatement) : this._value.assignmentStatement;
      } else if (this._value._statementTypeCase === 5) {
        this._cachedAssignmentStatement = new AssignmentStatement.WithParent(this._value.assignmentStatement, this._parent && this._parent.statementTypeCase === 5 ? this._parent.assignmentStatement : null);
      } else {
        this._cachedAssignmentStatement = AssignmentStatement.WithParent.default;
      }
    }
    return this._cachedAssignmentStatement;
  }
  get breakStatement() {
    if (!this._cachedBreakStatement) {
      if (this._value._statementTypeCase === 0) {
        this._cachedBreakStatement = this._parent ? new BreakStatement.WithParent(BreakStatement.default, this._parent.breakStatement) : this._value.breakStatement;
      } else if (this._value._statementTypeCase === 6) {
        this._cachedBreakStatement = new BreakStatement.WithParent(this._value.breakStatement, this._parent && this._parent.statementTypeCase === 6 ? this._parent.breakStatement : null);
      } else {
        this._cachedBreakStatement = BreakStatement.WithParent.default;
      }
    }
    return this._cachedBreakStatement;
  }
  get continueStatement() {
    if (!this._cachedContinueStatement) {
      if (this._value._statementTypeCase === 0) {
        this._cachedContinueStatement = this._parent ? new ContinueStatement.WithParent(ContinueStatement.default, this._parent.continueStatement) : this._value.continueStatement;
      } else if (this._value._statementTypeCase === 7) {
        this._cachedContinueStatement = new ContinueStatement.WithParent(this._value.continueStatement, this._parent && this._parent.statementTypeCase === 7 ? this._parent.continueStatement : null);
      } else {
        this._cachedContinueStatement = ContinueStatement.WithParent.default;
      }
    }
    return this._cachedContinueStatement;
  }
  get returnStatement() {
    if (!this._cachedReturnStatement) {
      if (this._value._statementTypeCase === 0) {
        this._cachedReturnStatement = this._parent ? new ReturnStatement.WithParent(ReturnStatement.default, this._parent.returnStatement) : this._value.returnStatement;
      } else if (this._value._statementTypeCase === 8) {
        this._cachedReturnStatement = new ReturnStatement.WithParent(this._value.returnStatement, this._parent && this._parent.statementTypeCase === 8 ? this._parent.returnStatement : null);
      } else {
        this._cachedReturnStatement = ReturnStatement.WithParent.default;
      }
    }
    return this._cachedReturnStatement;
  }
  get arrayStatement() {
    if (!this._cachedArrayStatement) {
      if (this._value._statementTypeCase === 0) {
        this._cachedArrayStatement = this._parent ? new ArrayStatement.WithParent(ArrayStatement.default, this._parent.arrayStatement) : this._value.arrayStatement;
      } else if (this._value._statementTypeCase === 9) {
        this._cachedArrayStatement = new ArrayStatement.WithParent(this._value.arrayStatement, this._parent && this._parent.statementTypeCase === 9 ? this._parent.arrayStatement : null);
      } else {
        this._cachedArrayStatement = ArrayStatement.WithParent.default;
      }
    }
    return this._cachedArrayStatement;
  }
  get tableStatement() {
    if (!this._cachedTableStatement) {
      if (this._value._statementTypeCase === 0) {
        this._cachedTableStatement = this._parent ? new TableStatement.WithParent(TableStatement.default, this._parent.tableStatement) : this._value.tableStatement;
      } else if (this._value._statementTypeCase === 10) {
        this._cachedTableStatement = new TableStatement.WithParent(this._value.tableStatement, this._parent && this._parent.statementTypeCase === 10 ? this._parent.tableStatement : null);
      } else {
        this._cachedTableStatement = TableStatement.WithParent.default;
      }
    }
    return this._cachedTableStatement;
  }
  update(current, parent) {
    const result = new Statement_WithParent(current, parent);
    if (this._cachedFunctionCall && this._value._statementTypeCase === 1 && current._statementTypeCase === 1) {
      if (this._value.functionCall === current.functionCall && this._parent === parent) {
        result._cachedFunctionCall = this._cachedFunctionCall;
      } else {
        result._cachedFunctionCall = this._cachedFunctionCall.update(current.functionCall, parent && parent.statementTypeCase === 1 ? parent.functionCall : null);
      }
    }
    if (this._cachedIfElseStatement && this._value._statementTypeCase === 2 && current._statementTypeCase === 2) {
      if (this._value.ifElseStatement === current.ifElseStatement && this._parent === parent) {
        result._cachedIfElseStatement = this._cachedIfElseStatement;
      } else {
        result._cachedIfElseStatement = this._cachedIfElseStatement.update(current.ifElseStatement, parent && parent.statementTypeCase === 2 ? parent.ifElseStatement : null);
      }
    }
    if (this._cachedWhileStatement && this._value._statementTypeCase === 3 && current._statementTypeCase === 3) {
      if (this._value.whileStatement === current.whileStatement && this._parent === parent) {
        result._cachedWhileStatement = this._cachedWhileStatement;
      } else {
        result._cachedWhileStatement = this._cachedWhileStatement.update(current.whileStatement, parent && parent.statementTypeCase === 3 ? parent.whileStatement : null);
      }
    }
    if (this._cachedForEachStatement && this._value._statementTypeCase === 4 && current._statementTypeCase === 4) {
      if (this._value.forEachStatement === current.forEachStatement && this._parent === parent) {
        result._cachedForEachStatement = this._cachedForEachStatement;
      } else {
        result._cachedForEachStatement = this._cachedForEachStatement.update(current.forEachStatement, parent && parent.statementTypeCase === 4 ? parent.forEachStatement : null);
      }
    }
    if (this._cachedAssignmentStatement && this._value._statementTypeCase === 5 && current._statementTypeCase === 5) {
      if (this._value.assignmentStatement === current.assignmentStatement && this._parent === parent) {
        result._cachedAssignmentStatement = this._cachedAssignmentStatement;
      } else {
        result._cachedAssignmentStatement = this._cachedAssignmentStatement.update(current.assignmentStatement, parent && parent.statementTypeCase === 5 ? parent.assignmentStatement : null);
      }
    }
    if (this._cachedBreakStatement && this._value._statementTypeCase === 6 && current._statementTypeCase === 6) {
      if (this._value.breakStatement === current.breakStatement && this._parent === parent) {
        result._cachedBreakStatement = this._cachedBreakStatement;
      } else {
        result._cachedBreakStatement = this._cachedBreakStatement.update(current.breakStatement, parent && parent.statementTypeCase === 6 ? parent.breakStatement : null);
      }
    }
    if (this._cachedContinueStatement && this._value._statementTypeCase === 7 && current._statementTypeCase === 7) {
      if (this._value.continueStatement === current.continueStatement && this._parent === parent) {
        result._cachedContinueStatement = this._cachedContinueStatement;
      } else {
        result._cachedContinueStatement = this._cachedContinueStatement.update(current.continueStatement, parent && parent.statementTypeCase === 7 ? parent.continueStatement : null);
      }
    }
    if (this._cachedReturnStatement && this._value._statementTypeCase === 8 && current._statementTypeCase === 8) {
      if (this._value.returnStatement === current.returnStatement && this._parent === parent) {
        result._cachedReturnStatement = this._cachedReturnStatement;
      } else {
        result._cachedReturnStatement = this._cachedReturnStatement.update(current.returnStatement, parent && parent.statementTypeCase === 8 ? parent.returnStatement : null);
      }
    }
    if (this._cachedArrayStatement && this._value._statementTypeCase === 9 && current._statementTypeCase === 9) {
      if (this._value.arrayStatement === current.arrayStatement && this._parent === parent) {
        result._cachedArrayStatement = this._cachedArrayStatement;
      } else {
        result._cachedArrayStatement = this._cachedArrayStatement.update(current.arrayStatement, parent && parent.statementTypeCase === 9 ? parent.arrayStatement : null);
      }
    }
    if (this._cachedTableStatement && this._value._statementTypeCase === 10 && current._statementTypeCase === 10) {
      if (this._value.tableStatement === current.tableStatement && this._parent === parent) {
        result._cachedTableStatement = this._cachedTableStatement;
      } else {
        result._cachedTableStatement = this._cachedTableStatement.update(current.tableStatement, parent && parent.statementTypeCase === 10 ? parent.tableStatement : null);
      }
    }
    return result;
  }
}
Statement_WithParent.default = new Statement_WithParent(Statement.default, null);
Statement.WithParent = Statement_WithParent;
class Statement_Descriptor {
  get functionCall() {
    if (!this._functionCall) {
      this._functionCall = {
        name: "functionCall",
        Name: "FunctionCall",
        number: 1,
        protoType: 11,
        protoName: "function_call",
        oneofIndex: 0,
        type: StatementFunctionCall,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._functionCall;
  }
  get ifElseStatement() {
    if (!this._ifElseStatement) {
      this._ifElseStatement = {
        name: "ifElseStatement",
        Name: "IfElseStatement",
        number: 2,
        protoType: 11,
        protoName: "if_else_statement",
        oneofIndex: 0,
        type: IfElseStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ifElseStatement;
  }
  get whileStatement() {
    if (!this._whileStatement) {
      this._whileStatement = {
        name: "whileStatement",
        Name: "WhileStatement",
        number: 3,
        protoType: 11,
        protoName: "while_statement",
        oneofIndex: 0,
        type: WhileStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whileStatement;
  }
  get forEachStatement() {
    if (!this._forEachStatement) {
      this._forEachStatement = {
        name: "forEachStatement",
        Name: "ForEachStatement",
        number: 4,
        protoType: 11,
        protoName: "for_each_statement",
        oneofIndex: 0,
        type: ForEachNumberStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forEachStatement;
  }
  get assignmentStatement() {
    if (!this._assignmentStatement) {
      this._assignmentStatement = {
        name: "assignmentStatement",
        Name: "AssignmentStatement",
        number: 5,
        protoType: 11,
        protoName: "assignment_statement",
        oneofIndex: 0,
        type: AssignmentStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._assignmentStatement;
  }
  get breakStatement() {
    if (!this._breakStatement) {
      this._breakStatement = {
        name: "breakStatement",
        Name: "BreakStatement",
        number: 6,
        protoType: 11,
        protoName: "break_statement",
        oneofIndex: 0,
        type: BreakStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._breakStatement;
  }
  get continueStatement() {
    if (!this._continueStatement) {
      this._continueStatement = {
        name: "continueStatement",
        Name: "ContinueStatement",
        number: 7,
        protoType: 11,
        protoName: "continue_statement",
        oneofIndex: 0,
        type: ContinueStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._continueStatement;
  }
  get returnStatement() {
    if (!this._returnStatement) {
      this._returnStatement = {
        name: "returnStatement",
        Name: "ReturnStatement",
        number: 8,
        protoType: 11,
        protoName: "return_statement",
        oneofIndex: 0,
        type: ReturnStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._returnStatement;
  }
  get arrayStatement() {
    if (!this._arrayStatement) {
      this._arrayStatement = {
        name: "arrayStatement",
        Name: "ArrayStatement",
        number: 9,
        protoType: 11,
        protoName: "array_statement",
        oneofIndex: 0,
        type: ArrayStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._arrayStatement;
  }
  get tableStatement() {
    if (!this._tableStatement) {
      this._tableStatement = {
        name: "tableStatement",
        Name: "TableStatement",
        number: 10,
        protoType: 11,
        protoName: "table_statement",
        oneofIndex: 0,
        type: TableStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tableStatement;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.functionCall,
        this.ifElseStatement,
        this.whileStatement,
        this.forEachStatement,
        this.assignmentStatement,
        this.breakStatement,
        this.continueStatement,
        this.returnStatement,
        this.arrayStatement,
        this.tableStatement,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "statementType",
        Name: "StatementType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
          this.fields[9],
        ],
      });
    }
    return this._oneofs;
  }
}
Statement.descriptor = new Statement_Descriptor();
export class IfElseStatement {
  get descriptor() {
    return IfElseStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCondition = false;
    this._condition = null;
    this._ifBody = [];
    this._elseBody = [];
  }
  isEmpty() {
    if (this._hasCondition && !this._condition.isEmpty()) return false;
    if (this._ifBody.length > 0) return false;
    if (this._elseBody.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof IfElseStatement) {
      return value;
    }
    return IfElseStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new IfElseStatement();
    if (json.condition != null) {
      result._hasCondition = true;
      result._condition = Expression.fromJson(json.condition);
    }
    result._ifBody = JsonToList(json.ifBody, Statement);
    result._elseBody = JsonToList(json.elseBody, Statement);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCondition && !this._condition.isEmpty()) {
      result.condition = Expression.toJson(this._condition);
    }
    if (this._ifBody.length > 0) {
      result.ifBody = ArrayToJson(this._ifBody, Statement);
    }
    if (this._elseBody.length > 0) {
      result.elseBody = ArrayToJson(this._elseBody, Statement);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get condition() {
    return this._hasCondition ? this._condition : Expression.default;
  }
  get hasCondition() {
    return this._hasCondition;
  }
  setCondition(path, value) {
    return {type: 'SET', path: path.concat(['condition']), value: value.toJson()};
  }
  deleteCondition(path) {
    return {type: 'DELETE', path: path.concat(['condition'])};
  }
  /**
   * @returns {Statement[]}
   */
  get ifBody() {
    return this._ifBody;
  }
  addIfBody(path, value) {
    return {type: 'ADD', path: path.concat(['ifBody']), value: value.toJson()};
  }
  setIfBody(path, value) {
    return {type: 'SET', path: path.concat(['ifBody']), value: ArrayToJson(value, Statement)};
  }
  setIfBodyByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['ifBody', key]), value: value.toJson()};
  }
  deleteIfBody(path) {
    return {type: 'DELETE', path: path.concat(['ifBody'])};
  }
  deleteIfBodyByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['ifBody', key])};
  }
  /**
   * @returns {Statement[]}
   */
  get elseBody() {
    return this._elseBody;
  }
  addElseBody(path, value) {
    return {type: 'ADD', path: path.concat(['elseBody']), value: value.toJson()};
  }
  setElseBody(path, value) {
    return {type: 'SET', path: path.concat(['elseBody']), value: ArrayToJson(value, Statement)};
  }
  setElseBodyByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['elseBody', key]), value: value.toJson()};
  }
  deleteElseBody(path) {
    return {type: 'DELETE', path: path.concat(['elseBody'])};
  }
  deleteElseBodyByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['elseBody', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "condition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new IfElseStatement(this);
              copy._hasCondition = true;
              copy._condition = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCondition) {
                return this;
              }
              const copy = new IfElseStatement(this);
              copy._hasCondition = false;
              copy._condition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCondition) {
            const copy = new IfElseStatement(this);
            copy._hasCondition = true;
            copy._condition = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._condition.apply(type, path.slice(1), value);
          if (newValue === this._condition) {
            return this;
          }
          const copy = new IfElseStatement(this);
          copy._condition = copy._condition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "ifBody": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new IfElseStatement(this);
              copy._ifBody = [];        for (let i of value) {
                copy._ifBody.push(Statement.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new IfElseStatement(this);
              copy._ifBody = copy._ifBody.concat([Statement.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._ifBody.length === 0) {
                return this;
              }
              const copy = new IfElseStatement(this);
              copy._ifBody = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._ifBody.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new IfElseStatement(this);
              copy._ifBody = copy._ifBody.slice();
              copy._ifBody[path[1]] = Statement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new IfElseStatement(this);
              copy._ifBody = copy._ifBody.slice(0, path[1]).concat(copy._ifBody.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._ifBody.length) {
            return this;
          }
          const oldValue = this._ifBody[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new IfElseStatement(this);
          copy._ifBody = copy._ifBody.slice();
          copy._ifBody[key] = newValue;
          return copy;
        }
      }
      case "elseBody": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new IfElseStatement(this);
              copy._elseBody = [];        for (let i of value) {
                copy._elseBody.push(Statement.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new IfElseStatement(this);
              copy._elseBody = copy._elseBody.concat([Statement.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._elseBody.length === 0) {
                return this;
              }
              const copy = new IfElseStatement(this);
              copy._elseBody = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._elseBody.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new IfElseStatement(this);
              copy._elseBody = copy._elseBody.slice();
              copy._elseBody[path[1]] = Statement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new IfElseStatement(this);
              copy._elseBody = copy._elseBody.slice(0, path[1]).concat(copy._elseBody.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._elseBody.length) {
            return this;
          }
          const oldValue = this._elseBody[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new IfElseStatement(this);
          copy._elseBody = copy._elseBody.slice();
          copy._elseBody[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {IfElseStatement} other
   * @returns {IfElseStatement}
   */
  merge(other) {
    const copy = new IfElseStatement(this);
    if (other._hasCondition) {
      if (copy._hasCondition) {
        copy._condition = copy.condition.merge(other.condition);
      } else {
        copy._condition = other._condition;
      }
      copy._hasCondition = true;
    }
    copy._ifBody = this._ifBody.concat(other._ifBody);
    copy._elseBody = this._elseBody.concat(other._elseBody);
    return copy;
  }
}
IfElseStatement.default = new IfElseStatement();
class IfElseStatement_Builder {
  constructor(value) {
    this._value = new IfElseStatement(value);
  }
  build() {
    return new IfElseStatement(this._value);
  }
  setCondition(value) {
    this._value._hasCondition = true;
    this._value._condition = value;
    return this;
  }
  deleteCondition() {
    this._value._hasCondition = false;
    this._value._condition = null;
    return this;
  }
  addAllIfBody(values) {
    this._value._ifBody = this._value._ifBody.concat(values);
    return this;
  }
  addIfBody(value) {
    this._value._ifBody = this._value._ifBody.concat([value]);
    return this;
  }
  setIfBody(index, value) {
    this._value._ifBody = this._value._ifBody.concat();
    this._value._ifBody[index] = value;
    return this;
  }
  clearIfBody() {
    this._value._ifBody = [];
    return this;
  }
  addAllElseBody(values) {
    this._value._elseBody = this._value._elseBody.concat(values);
    return this;
  }
  addElseBody(value) {
    this._value._elseBody = this._value._elseBody.concat([value]);
    return this;
  }
  setElseBody(index, value) {
    this._value._elseBody = this._value._elseBody.concat();
    this._value._elseBody[index] = value;
    return this;
  }
  clearElseBody() {
    this._value._elseBody = [];
    return this;
  }
}
IfElseStatement.Builder = IfElseStatement_Builder;
class IfElseStatement_WithParent {
  /**
   * @param {IfElseStatement} value
   * @param {IfElseStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return IfElseStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCondition() {
    if (this._cachedHasCondition === undefined) {
      if (this._value.hasCondition) {
        this._cachedHasCondition = true;
      } else {
        this._cachedHasCondition = this._parent ? this._parent.hasCondition : false;
      }
    }
    return this._cachedHasCondition;
  }
  get condition() {
    if (!this._cachedCondition) {
      if (this._value.hasCondition) {
        this._cachedCondition = new Expression.WithParent(this._value.condition, this._parent && this._parent.hasCondition ? this._parent.condition : null);
      } else {
        this._cachedCondition = this._parent ? new Expression.WithParent(Expression.default, this._parent.condition) : Expression.WithParent.default;
      }
    }
    return this._cachedCondition;
  }
  get selfIfBody() {
    if (!this._selfIfBody) {
      this._selfIfBody = [];
      for (let i of this._value.ifBody) {
        this._selfIfBody.push(new Statement.WithParent(i, null));
      }
    }
    return this._selfIfBody;
  }
  get inherentIfBody() {
    if (!this._inherentIfBody) {
      this._inherentIfBody = this._parent ? this._parent.ifBody : [];
    }
    return this._inherentIfBody;
  }
  get ifBody() {
    if (!this._allIfBody) {
      this._allIfBody = this._parent ? this._parent.ifBody.concat(this.selfIfBody) : this.selfIfBody;
    }
    return this._allIfBody;
  }
  get selfElseBody() {
    if (!this._selfElseBody) {
      this._selfElseBody = [];
      for (let i of this._value.elseBody) {
        this._selfElseBody.push(new Statement.WithParent(i, null));
      }
    }
    return this._selfElseBody;
  }
  get inherentElseBody() {
    if (!this._inherentElseBody) {
      this._inherentElseBody = this._parent ? this._parent.elseBody : [];
    }
    return this._inherentElseBody;
  }
  get elseBody() {
    if (!this._allElseBody) {
      this._allElseBody = this._parent ? this._parent.elseBody.concat(this.selfElseBody) : this.selfElseBody;
    }
    return this._allElseBody;
  }
  update(current, parent) {
    const result = new IfElseStatement_WithParent(current, parent);
    if (this._cachedCondition && this._value.hasCondition && current.hasCondition) {
      if (this._value.condition === current.condition && this._parent === parent) {
        result._cachedCondition = this._cachedCondition;
      } else {
        result._cachedCondition = this._cachedCondition.update(current.condition, parent && parent.hasCondition ? parent.condition : null);
      }
    }
    if (this._selfIfBody) {
      if (this._value.ifBody === current.ifBody) {
        result._selfIfBody = this._selfIfBody;
      } else {
        result._selfIfBody = [];
        for (let i = 0; i < current.ifBody.length; i++) {
          const oldValue = this._value.ifBody[i];
          if (oldValue) {
            const oldCache = this._selfIfBody[i];
            if (oldValue === current.ifBody[i]) {
              result._selfIfBody[i] = oldCache;
            } else {
              result._selfIfBody[i] = oldCache.update(current.ifBody[i], null);
            }
          } else {
            result._selfIfBody[i] = new Statement.WithParent(current.ifBody[i], null);
          }
        }
      }
    }
    if (this._selfElseBody) {
      if (this._value.elseBody === current.elseBody) {
        result._selfElseBody = this._selfElseBody;
      } else {
        result._selfElseBody = [];
        for (let i = 0; i < current.elseBody.length; i++) {
          const oldValue = this._value.elseBody[i];
          if (oldValue) {
            const oldCache = this._selfElseBody[i];
            if (oldValue === current.elseBody[i]) {
              result._selfElseBody[i] = oldCache;
            } else {
              result._selfElseBody[i] = oldCache.update(current.elseBody[i], null);
            }
          } else {
            result._selfElseBody[i] = new Statement.WithParent(current.elseBody[i], null);
          }
        }
      }
    }
    return result;
  }
}
IfElseStatement_WithParent.default = new IfElseStatement_WithParent(IfElseStatement.default, null);
IfElseStatement.WithParent = IfElseStatement_WithParent;
class IfElseStatement_Descriptor {
  get condition() {
    if (!this._condition) {
      this._condition = {
        name: "condition",
        Name: "Condition",
        number: 1,
        protoType: 11,
        protoName: "condition",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._condition;
  }
  get ifBody() {
    if (!this._ifBody) {
      this._ifBody = {
        name: "ifBody",
        Name: "IfBody",
        number: 2,
        protoType: 11,
        protoName: "if_body",
        type: Statement,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ifBody;
  }
  get elseBody() {
    if (!this._elseBody) {
      this._elseBody = {
        name: "elseBody",
        Name: "ElseBody",
        number: 3,
        protoType: 11,
        protoName: "else_body",
        type: Statement,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._elseBody;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.condition,
        this.ifBody,
        this.elseBody,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCondition",
        Name: "DummyOneofForCondition",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
IfElseStatement.descriptor = new IfElseStatement_Descriptor();
export class WhileStatement {
  get descriptor() {
    return WhileStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCondition = false;
    this._condition = null;
    this._body = [];
  }
  isEmpty() {
    if (this._hasCondition && !this._condition.isEmpty()) return false;
    if (this._body.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof WhileStatement) {
      return value;
    }
    return WhileStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new WhileStatement();
    if (json.condition != null) {
      result._hasCondition = true;
      result._condition = Expression.fromJson(json.condition);
    }
    result._body = JsonToList(json.body, Statement);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCondition && !this._condition.isEmpty()) {
      result.condition = Expression.toJson(this._condition);
    }
    if (this._body.length > 0) {
      result.body = ArrayToJson(this._body, Statement);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get condition() {
    return this._hasCondition ? this._condition : Expression.default;
  }
  get hasCondition() {
    return this._hasCondition;
  }
  setCondition(path, value) {
    return {type: 'SET', path: path.concat(['condition']), value: value.toJson()};
  }
  deleteCondition(path) {
    return {type: 'DELETE', path: path.concat(['condition'])};
  }
  /**
   * @returns {Statement[]}
   */
  get body() {
    return this._body;
  }
  addBody(path, value) {
    return {type: 'ADD', path: path.concat(['body']), value: value.toJson()};
  }
  setBody(path, value) {
    return {type: 'SET', path: path.concat(['body']), value: ArrayToJson(value, Statement)};
  }
  setBodyByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['body', key]), value: value.toJson()};
  }
  deleteBody(path) {
    return {type: 'DELETE', path: path.concat(['body'])};
  }
  deleteBodyByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['body', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "condition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WhileStatement(this);
              copy._hasCondition = true;
              copy._condition = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCondition) {
                return this;
              }
              const copy = new WhileStatement(this);
              copy._hasCondition = false;
              copy._condition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCondition) {
            const copy = new WhileStatement(this);
            copy._hasCondition = true;
            copy._condition = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._condition.apply(type, path.slice(1), value);
          if (newValue === this._condition) {
            return this;
          }
          const copy = new WhileStatement(this);
          copy._condition = copy._condition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "body": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WhileStatement(this);
              copy._body = [];        for (let i of value) {
                copy._body.push(Statement.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new WhileStatement(this);
              copy._body = copy._body.concat([Statement.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._body.length === 0) {
                return this;
              }
              const copy = new WhileStatement(this);
              copy._body = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._body.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new WhileStatement(this);
              copy._body = copy._body.slice();
              copy._body[path[1]] = Statement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new WhileStatement(this);
              copy._body = copy._body.slice(0, path[1]).concat(copy._body.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._body.length) {
            return this;
          }
          const oldValue = this._body[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new WhileStatement(this);
          copy._body = copy._body.slice();
          copy._body[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {WhileStatement} other
   * @returns {WhileStatement}
   */
  merge(other) {
    const copy = new WhileStatement(this);
    if (other._hasCondition) {
      if (copy._hasCondition) {
        copy._condition = copy.condition.merge(other.condition);
      } else {
        copy._condition = other._condition;
      }
      copy._hasCondition = true;
    }
    copy._body = this._body.concat(other._body);
    return copy;
  }
}
WhileStatement.default = new WhileStatement();
class WhileStatement_Builder {
  constructor(value) {
    this._value = new WhileStatement(value);
  }
  build() {
    return new WhileStatement(this._value);
  }
  setCondition(value) {
    this._value._hasCondition = true;
    this._value._condition = value;
    return this;
  }
  deleteCondition() {
    this._value._hasCondition = false;
    this._value._condition = null;
    return this;
  }
  addAllBody(values) {
    this._value._body = this._value._body.concat(values);
    return this;
  }
  addBody(value) {
    this._value._body = this._value._body.concat([value]);
    return this;
  }
  setBody(index, value) {
    this._value._body = this._value._body.concat();
    this._value._body[index] = value;
    return this;
  }
  clearBody() {
    this._value._body = [];
    return this;
  }
}
WhileStatement.Builder = WhileStatement_Builder;
class WhileStatement_WithParent {
  /**
   * @param {WhileStatement} value
   * @param {WhileStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return WhileStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCondition() {
    if (this._cachedHasCondition === undefined) {
      if (this._value.hasCondition) {
        this._cachedHasCondition = true;
      } else {
        this._cachedHasCondition = this._parent ? this._parent.hasCondition : false;
      }
    }
    return this._cachedHasCondition;
  }
  get condition() {
    if (!this._cachedCondition) {
      if (this._value.hasCondition) {
        this._cachedCondition = new Expression.WithParent(this._value.condition, this._parent && this._parent.hasCondition ? this._parent.condition : null);
      } else {
        this._cachedCondition = this._parent ? new Expression.WithParent(Expression.default, this._parent.condition) : Expression.WithParent.default;
      }
    }
    return this._cachedCondition;
  }
  get selfBody() {
    if (!this._selfBody) {
      this._selfBody = [];
      for (let i of this._value.body) {
        this._selfBody.push(new Statement.WithParent(i, null));
      }
    }
    return this._selfBody;
  }
  get inherentBody() {
    if (!this._inherentBody) {
      this._inherentBody = this._parent ? this._parent.body : [];
    }
    return this._inherentBody;
  }
  get body() {
    if (!this._allBody) {
      this._allBody = this._parent ? this._parent.body.concat(this.selfBody) : this.selfBody;
    }
    return this._allBody;
  }
  update(current, parent) {
    const result = new WhileStatement_WithParent(current, parent);
    if (this._cachedCondition && this._value.hasCondition && current.hasCondition) {
      if (this._value.condition === current.condition && this._parent === parent) {
        result._cachedCondition = this._cachedCondition;
      } else {
        result._cachedCondition = this._cachedCondition.update(current.condition, parent && parent.hasCondition ? parent.condition : null);
      }
    }
    if (this._selfBody) {
      if (this._value.body === current.body) {
        result._selfBody = this._selfBody;
      } else {
        result._selfBody = [];
        for (let i = 0; i < current.body.length; i++) {
          const oldValue = this._value.body[i];
          if (oldValue) {
            const oldCache = this._selfBody[i];
            if (oldValue === current.body[i]) {
              result._selfBody[i] = oldCache;
            } else {
              result._selfBody[i] = oldCache.update(current.body[i], null);
            }
          } else {
            result._selfBody[i] = new Statement.WithParent(current.body[i], null);
          }
        }
      }
    }
    return result;
  }
}
WhileStatement_WithParent.default = new WhileStatement_WithParent(WhileStatement.default, null);
WhileStatement.WithParent = WhileStatement_WithParent;
class WhileStatement_Descriptor {
  get condition() {
    if (!this._condition) {
      this._condition = {
        name: "condition",
        Name: "Condition",
        number: 1,
        protoType: 11,
        protoName: "condition",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._condition;
  }
  get body() {
    if (!this._body) {
      this._body = {
        name: "body",
        Name: "Body",
        number: 2,
        protoType: 11,
        protoName: "body",
        type: Statement,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._body;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.condition,
        this.body,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCondition",
        Name: "DummyOneofForCondition",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
WhileStatement.descriptor = new WhileStatement_Descriptor();
export class ForEachNumberStatement {
  get descriptor() {
    return ForEachNumberStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetVariableRef = false;
    this._targetVariableRef = null;
    this._hasFrom = false;
    this._from = null;
    this._hasTo = false;
    this._to = null;
    this._hasIncrement = false;
    this._increment = null;
    this._body = [];
  }
  isEmpty() {
    if (this._hasTargetVariableRef && !this._targetVariableRef.isEmpty()) return false;
    if (this._hasFrom && !this._from.isEmpty()) return false;
    if (this._hasTo && !this._to.isEmpty()) return false;
    if (this._hasIncrement && !this._increment.isEmpty()) return false;
    if (this._body.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ForEachNumberStatement) {
      return value;
    }
    return ForEachNumberStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ForEachNumberStatement();
    if (json.targetVariableRef != null) {
      result._hasTargetVariableRef = true;
      result._targetVariableRef = VariableRef.fromJson(json.targetVariableRef);
    }
    if (json.from != null) {
      result._hasFrom = true;
      result._from = Expression.fromJson(json.from);
    }
    if (json.to != null) {
      result._hasTo = true;
      result._to = Expression.fromJson(json.to);
    }
    if (json.increment != null) {
      result._hasIncrement = true;
      result._increment = Expression.fromJson(json.increment);
    }
    result._body = JsonToList(json.body, Statement);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetVariableRef && !this._targetVariableRef.isEmpty()) {
      result.targetVariableRef = VariableRef.toJson(this._targetVariableRef);
    }
    if (this._hasFrom && !this._from.isEmpty()) {
      result.from = Expression.toJson(this._from);
    }
    if (this._hasTo && !this._to.isEmpty()) {
      result.to = Expression.toJson(this._to);
    }
    if (this._hasIncrement && !this._increment.isEmpty()) {
      result.increment = Expression.toJson(this._increment);
    }
    if (this._body.length > 0) {
      result.body = ArrayToJson(this._body, Statement);
    }
    return result;
  }
  /**
   * @returns {VariableRef}
   */
  get targetVariableRef() {
    return this._hasTargetVariableRef ? this._targetVariableRef : VariableRef.default;
  }
  get hasTargetVariableRef() {
    return this._hasTargetVariableRef;
  }
  setTargetVariableRef(path, value) {
    return {type: 'SET', path: path.concat(['targetVariableRef']), value: value.toJson()};
  }
  deleteTargetVariableRef(path) {
    return {type: 'DELETE', path: path.concat(['targetVariableRef'])};
  }
  /**
   * @returns {Expression}
   */
  get from() {
    return this._hasFrom ? this._from : Expression.default;
  }
  get hasFrom() {
    return this._hasFrom;
  }
  setFrom(path, value) {
    return {type: 'SET', path: path.concat(['from']), value: value.toJson()};
  }
  deleteFrom(path) {
    return {type: 'DELETE', path: path.concat(['from'])};
  }
  /**
   * @returns {Expression}
   */
  get to() {
    return this._hasTo ? this._to : Expression.default;
  }
  get hasTo() {
    return this._hasTo;
  }
  setTo(path, value) {
    return {type: 'SET', path: path.concat(['to']), value: value.toJson()};
  }
  deleteTo(path) {
    return {type: 'DELETE', path: path.concat(['to'])};
  }
  /**
   * @returns {Expression}
   */
  get increment() {
    return this._hasIncrement ? this._increment : Expression.default;
  }
  get hasIncrement() {
    return this._hasIncrement;
  }
  setIncrement(path, value) {
    return {type: 'SET', path: path.concat(['increment']), value: value.toJson()};
  }
  deleteIncrement(path) {
    return {type: 'DELETE', path: path.concat(['increment'])};
  }
  /**
   * @returns {Statement[]}
   */
  get body() {
    return this._body;
  }
  addBody(path, value) {
    return {type: 'ADD', path: path.concat(['body']), value: value.toJson()};
  }
  setBody(path, value) {
    return {type: 'SET', path: path.concat(['body']), value: ArrayToJson(value, Statement)};
  }
  setBodyByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['body', key]), value: value.toJson()};
  }
  deleteBody(path) {
    return {type: 'DELETE', path: path.concat(['body'])};
  }
  deleteBodyByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['body', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetVariableRef": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ForEachNumberStatement(this);
              copy._hasTargetVariableRef = true;
              copy._targetVariableRef = VariableRef.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetVariableRef) {
                return this;
              }
              const copy = new ForEachNumberStatement(this);
              copy._hasTargetVariableRef = false;
              copy._targetVariableRef = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTargetVariableRef) {
            const copy = new ForEachNumberStatement(this);
            copy._hasTargetVariableRef = true;
            copy._targetVariableRef = VariableRef.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._targetVariableRef.apply(type, path.slice(1), value);
          if (newValue === this._targetVariableRef) {
            return this;
          }
          const copy = new ForEachNumberStatement(this);
          copy._targetVariableRef = copy._targetVariableRef.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "from": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ForEachNumberStatement(this);
              copy._hasFrom = true;
              copy._from = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFrom) {
                return this;
              }
              const copy = new ForEachNumberStatement(this);
              copy._hasFrom = false;
              copy._from = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFrom) {
            const copy = new ForEachNumberStatement(this);
            copy._hasFrom = true;
            copy._from = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._from.apply(type, path.slice(1), value);
          if (newValue === this._from) {
            return this;
          }
          const copy = new ForEachNumberStatement(this);
          copy._from = copy._from.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "to": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ForEachNumberStatement(this);
              copy._hasTo = true;
              copy._to = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTo) {
                return this;
              }
              const copy = new ForEachNumberStatement(this);
              copy._hasTo = false;
              copy._to = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTo) {
            const copy = new ForEachNumberStatement(this);
            copy._hasTo = true;
            copy._to = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._to.apply(type, path.slice(1), value);
          if (newValue === this._to) {
            return this;
          }
          const copy = new ForEachNumberStatement(this);
          copy._to = copy._to.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "increment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ForEachNumberStatement(this);
              copy._hasIncrement = true;
              copy._increment = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIncrement) {
                return this;
              }
              const copy = new ForEachNumberStatement(this);
              copy._hasIncrement = false;
              copy._increment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasIncrement) {
            const copy = new ForEachNumberStatement(this);
            copy._hasIncrement = true;
            copy._increment = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._increment.apply(type, path.slice(1), value);
          if (newValue === this._increment) {
            return this;
          }
          const copy = new ForEachNumberStatement(this);
          copy._increment = copy._increment.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "body": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ForEachNumberStatement(this);
              copy._body = [];        for (let i of value) {
                copy._body.push(Statement.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ForEachNumberStatement(this);
              copy._body = copy._body.concat([Statement.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._body.length === 0) {
                return this;
              }
              const copy = new ForEachNumberStatement(this);
              copy._body = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._body.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ForEachNumberStatement(this);
              copy._body = copy._body.slice();
              copy._body[path[1]] = Statement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ForEachNumberStatement(this);
              copy._body = copy._body.slice(0, path[1]).concat(copy._body.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._body.length) {
            return this;
          }
          const oldValue = this._body[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ForEachNumberStatement(this);
          copy._body = copy._body.slice();
          copy._body[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ForEachNumberStatement} other
   * @returns {ForEachNumberStatement}
   */
  merge(other) {
    const copy = new ForEachNumberStatement(this);
    if (other._hasTargetVariableRef) {
      if (copy._hasTargetVariableRef) {
        copy._targetVariableRef = copy.targetVariableRef.merge(other.targetVariableRef);
      } else {
        copy._targetVariableRef = other._targetVariableRef;
      }
      copy._hasTargetVariableRef = true;
    }
    if (other._hasFrom) {
      if (copy._hasFrom) {
        copy._from = copy.from.merge(other.from);
      } else {
        copy._from = other._from;
      }
      copy._hasFrom = true;
    }
    if (other._hasTo) {
      if (copy._hasTo) {
        copy._to = copy.to.merge(other.to);
      } else {
        copy._to = other._to;
      }
      copy._hasTo = true;
    }
    if (other._hasIncrement) {
      if (copy._hasIncrement) {
        copy._increment = copy.increment.merge(other.increment);
      } else {
        copy._increment = other._increment;
      }
      copy._hasIncrement = true;
    }
    copy._body = this._body.concat(other._body);
    return copy;
  }
}
ForEachNumberStatement.default = new ForEachNumberStatement();
class ForEachNumberStatement_Builder {
  constructor(value) {
    this._value = new ForEachNumberStatement(value);
  }
  build() {
    return new ForEachNumberStatement(this._value);
  }
  setTargetVariableRef(value) {
    this._value._hasTargetVariableRef = true;
    this._value._targetVariableRef = value;
    return this;
  }
  deleteTargetVariableRef() {
    this._value._hasTargetVariableRef = false;
    this._value._targetVariableRef = null;
    return this;
  }
  setFrom(value) {
    this._value._hasFrom = true;
    this._value._from = value;
    return this;
  }
  deleteFrom() {
    this._value._hasFrom = false;
    this._value._from = null;
    return this;
  }
  setTo(value) {
    this._value._hasTo = true;
    this._value._to = value;
    return this;
  }
  deleteTo() {
    this._value._hasTo = false;
    this._value._to = null;
    return this;
  }
  setIncrement(value) {
    this._value._hasIncrement = true;
    this._value._increment = value;
    return this;
  }
  deleteIncrement() {
    this._value._hasIncrement = false;
    this._value._increment = null;
    return this;
  }
  addAllBody(values) {
    this._value._body = this._value._body.concat(values);
    return this;
  }
  addBody(value) {
    this._value._body = this._value._body.concat([value]);
    return this;
  }
  setBody(index, value) {
    this._value._body = this._value._body.concat();
    this._value._body[index] = value;
    return this;
  }
  clearBody() {
    this._value._body = [];
    return this;
  }
}
ForEachNumberStatement.Builder = ForEachNumberStatement_Builder;
class ForEachNumberStatement_WithParent {
  /**
   * @param {ForEachNumberStatement} value
   * @param {ForEachNumberStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ForEachNumberStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetVariableRef() {
    if (this._cachedHasTargetVariableRef === undefined) {
      if (this._value.hasTargetVariableRef) {
        this._cachedHasTargetVariableRef = true;
      } else {
        this._cachedHasTargetVariableRef = this._parent ? this._parent.hasTargetVariableRef : false;
      }
    }
    return this._cachedHasTargetVariableRef;
  }
  get targetVariableRef() {
    if (!this._cachedTargetVariableRef) {
      if (this._value.hasTargetVariableRef) {
        this._cachedTargetVariableRef = new VariableRef.WithParent(this._value.targetVariableRef, this._parent && this._parent.hasTargetVariableRef ? this._parent.targetVariableRef : null);
      } else {
        this._cachedTargetVariableRef = this._parent ? new VariableRef.WithParent(VariableRef.default, this._parent.targetVariableRef) : VariableRef.WithParent.default;
      }
    }
    return this._cachedTargetVariableRef;
  }
  get hasFrom() {
    if (this._cachedHasFrom === undefined) {
      if (this._value.hasFrom) {
        this._cachedHasFrom = true;
      } else {
        this._cachedHasFrom = this._parent ? this._parent.hasFrom : false;
      }
    }
    return this._cachedHasFrom;
  }
  get from() {
    if (!this._cachedFrom) {
      if (this._value.hasFrom) {
        this._cachedFrom = new Expression.WithParent(this._value.from, this._parent && this._parent.hasFrom ? this._parent.from : null);
      } else {
        this._cachedFrom = this._parent ? new Expression.WithParent(Expression.default, this._parent.from) : Expression.WithParent.default;
      }
    }
    return this._cachedFrom;
  }
  get hasTo() {
    if (this._cachedHasTo === undefined) {
      if (this._value.hasTo) {
        this._cachedHasTo = true;
      } else {
        this._cachedHasTo = this._parent ? this._parent.hasTo : false;
      }
    }
    return this._cachedHasTo;
  }
  get to() {
    if (!this._cachedTo) {
      if (this._value.hasTo) {
        this._cachedTo = new Expression.WithParent(this._value.to, this._parent && this._parent.hasTo ? this._parent.to : null);
      } else {
        this._cachedTo = this._parent ? new Expression.WithParent(Expression.default, this._parent.to) : Expression.WithParent.default;
      }
    }
    return this._cachedTo;
  }
  get hasIncrement() {
    if (this._cachedHasIncrement === undefined) {
      if (this._value.hasIncrement) {
        this._cachedHasIncrement = true;
      } else {
        this._cachedHasIncrement = this._parent ? this._parent.hasIncrement : false;
      }
    }
    return this._cachedHasIncrement;
  }
  get increment() {
    if (!this._cachedIncrement) {
      if (this._value.hasIncrement) {
        this._cachedIncrement = new Expression.WithParent(this._value.increment, this._parent && this._parent.hasIncrement ? this._parent.increment : null);
      } else {
        this._cachedIncrement = this._parent ? new Expression.WithParent(Expression.default, this._parent.increment) : Expression.WithParent.default;
      }
    }
    return this._cachedIncrement;
  }
  get selfBody() {
    if (!this._selfBody) {
      this._selfBody = [];
      for (let i of this._value.body) {
        this._selfBody.push(new Statement.WithParent(i, null));
      }
    }
    return this._selfBody;
  }
  get inherentBody() {
    if (!this._inherentBody) {
      this._inherentBody = this._parent ? this._parent.body : [];
    }
    return this._inherentBody;
  }
  get body() {
    if (!this._allBody) {
      this._allBody = this._parent ? this._parent.body.concat(this.selfBody) : this.selfBody;
    }
    return this._allBody;
  }
  update(current, parent) {
    const result = new ForEachNumberStatement_WithParent(current, parent);
    if (this._cachedTargetVariableRef && this._value.hasTargetVariableRef && current.hasTargetVariableRef) {
      if (this._value.targetVariableRef === current.targetVariableRef && this._parent === parent) {
        result._cachedTargetVariableRef = this._cachedTargetVariableRef;
      } else {
        result._cachedTargetVariableRef = this._cachedTargetVariableRef.update(current.targetVariableRef, parent && parent.hasTargetVariableRef ? parent.targetVariableRef : null);
      }
    }
    if (this._cachedFrom && this._value.hasFrom && current.hasFrom) {
      if (this._value.from === current.from && this._parent === parent) {
        result._cachedFrom = this._cachedFrom;
      } else {
        result._cachedFrom = this._cachedFrom.update(current.from, parent && parent.hasFrom ? parent.from : null);
      }
    }
    if (this._cachedTo && this._value.hasTo && current.hasTo) {
      if (this._value.to === current.to && this._parent === parent) {
        result._cachedTo = this._cachedTo;
      } else {
        result._cachedTo = this._cachedTo.update(current.to, parent && parent.hasTo ? parent.to : null);
      }
    }
    if (this._cachedIncrement && this._value.hasIncrement && current.hasIncrement) {
      if (this._value.increment === current.increment && this._parent === parent) {
        result._cachedIncrement = this._cachedIncrement;
      } else {
        result._cachedIncrement = this._cachedIncrement.update(current.increment, parent && parent.hasIncrement ? parent.increment : null);
      }
    }
    if (this._selfBody) {
      if (this._value.body === current.body) {
        result._selfBody = this._selfBody;
      } else {
        result._selfBody = [];
        for (let i = 0; i < current.body.length; i++) {
          const oldValue = this._value.body[i];
          if (oldValue) {
            const oldCache = this._selfBody[i];
            if (oldValue === current.body[i]) {
              result._selfBody[i] = oldCache;
            } else {
              result._selfBody[i] = oldCache.update(current.body[i], null);
            }
          } else {
            result._selfBody[i] = new Statement.WithParent(current.body[i], null);
          }
        }
      }
    }
    return result;
  }
}
ForEachNumberStatement_WithParent.default = new ForEachNumberStatement_WithParent(ForEachNumberStatement.default, null);
ForEachNumberStatement.WithParent = ForEachNumberStatement_WithParent;
class ForEachNumberStatement_Descriptor {
  get targetVariableRef() {
    if (!this._targetVariableRef) {
      this._targetVariableRef = {
        name: "targetVariableRef",
        Name: "TargetVariableRef",
        number: 1,
        protoType: 11,
        protoName: "target_variable_ref",
        type: VariableRef,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetVariableRef;
  }
  get from() {
    if (!this._from) {
      this._from = {
        name: "from",
        Name: "From",
        number: 2,
        protoType: 11,
        protoName: "from",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._from;
  }
  get to() {
    if (!this._to) {
      this._to = {
        name: "to",
        Name: "To",
        number: 3,
        protoType: 11,
        protoName: "to",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._to;
  }
  get increment() {
    if (!this._increment) {
      this._increment = {
        name: "increment",
        Name: "Increment",
        number: 5,
        protoType: 11,
        protoName: "increment",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._increment;
  }
  get body() {
    if (!this._body) {
      this._body = {
        name: "body",
        Name: "Body",
        number: 4,
        protoType: 11,
        protoName: "body",
        type: Statement,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._body;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetVariableRef,
        this.from,
        this.to,
        this.increment,
        this.body,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetVariableRef",
        Name: "DummyOneofForTargetVariableRef",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFrom",
        Name: "DummyOneofForFrom",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTo",
        Name: "DummyOneofForTo",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIncrement",
        Name: "DummyOneofForIncrement",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ForEachNumberStatement.descriptor = new ForEachNumberStatement_Descriptor();
export class AssignmentStatement {
  get descriptor() {
    return AssignmentStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeftOperand = false;
    this._leftOperand = null;
    this._hasRightOperad = false;
    this._rightOperad = null;
  }
  isEmpty() {
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) return false;
    if (this._hasRightOperad && !this._rightOperad.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AssignmentStatement) {
      return value;
    }
    return AssignmentStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new AssignmentStatement();
    if (json.leftOperand != null) {
      result._hasLeftOperand = true;
      result._leftOperand = VariableRef.fromJson(json.leftOperand);
    }
    if (json.rightOperad != null) {
      result._hasRightOperad = true;
      result._rightOperad = Expression.fromJson(json.rightOperad);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeftOperand && !this._leftOperand.isEmpty()) {
      result.leftOperand = VariableRef.toJson(this._leftOperand);
    }
    if (this._hasRightOperad && !this._rightOperad.isEmpty()) {
      result.rightOperad = Expression.toJson(this._rightOperad);
    }
    return result;
  }
  /**
   * @returns {VariableRef}
   */
  get leftOperand() {
    return this._hasLeftOperand ? this._leftOperand : VariableRef.default;
  }
  get hasLeftOperand() {
    return this._hasLeftOperand;
  }
  setLeftOperand(path, value) {
    return {type: 'SET', path: path.concat(['leftOperand']), value: value.toJson()};
  }
  deleteLeftOperand(path) {
    return {type: 'DELETE', path: path.concat(['leftOperand'])};
  }
  /**
   * @returns {Expression}
   */
  get rightOperad() {
    return this._hasRightOperad ? this._rightOperad : Expression.default;
  }
  get hasRightOperad() {
    return this._hasRightOperad;
  }
  setRightOperad(path, value) {
    return {type: 'SET', path: path.concat(['rightOperad']), value: value.toJson()};
  }
  deleteRightOperad(path) {
    return {type: 'DELETE', path: path.concat(['rightOperad'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "leftOperand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssignmentStatement(this);
              copy._hasLeftOperand = true;
              copy._leftOperand = VariableRef.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeftOperand) {
                return this;
              }
              const copy = new AssignmentStatement(this);
              copy._hasLeftOperand = false;
              copy._leftOperand = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeftOperand) {
            const copy = new AssignmentStatement(this);
            copy._hasLeftOperand = true;
            copy._leftOperand = VariableRef.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._leftOperand.apply(type, path.slice(1), value);
          if (newValue === this._leftOperand) {
            return this;
          }
          const copy = new AssignmentStatement(this);
          copy._leftOperand = copy._leftOperand.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "rightOperad": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AssignmentStatement(this);
              copy._hasRightOperad = true;
              copy._rightOperad = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRightOperad) {
                return this;
              }
              const copy = new AssignmentStatement(this);
              copy._hasRightOperad = false;
              copy._rightOperad = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRightOperad) {
            const copy = new AssignmentStatement(this);
            copy._hasRightOperad = true;
            copy._rightOperad = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._rightOperad.apply(type, path.slice(1), value);
          if (newValue === this._rightOperad) {
            return this;
          }
          const copy = new AssignmentStatement(this);
          copy._rightOperad = copy._rightOperad.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AssignmentStatement} other
   * @returns {AssignmentStatement}
   */
  merge(other) {
    const copy = new AssignmentStatement(this);
    if (other._hasLeftOperand) {
      if (copy._hasLeftOperand) {
        copy._leftOperand = copy.leftOperand.merge(other.leftOperand);
      } else {
        copy._leftOperand = other._leftOperand;
      }
      copy._hasLeftOperand = true;
    }
    if (other._hasRightOperad) {
      if (copy._hasRightOperad) {
        copy._rightOperad = copy.rightOperad.merge(other.rightOperad);
      } else {
        copy._rightOperad = other._rightOperad;
      }
      copy._hasRightOperad = true;
    }
    return copy;
  }
}
AssignmentStatement.default = new AssignmentStatement();
class AssignmentStatement_Builder {
  constructor(value) {
    this._value = new AssignmentStatement(value);
  }
  build() {
    return new AssignmentStatement(this._value);
  }
  setLeftOperand(value) {
    this._value._hasLeftOperand = true;
    this._value._leftOperand = value;
    return this;
  }
  deleteLeftOperand() {
    this._value._hasLeftOperand = false;
    this._value._leftOperand = null;
    return this;
  }
  setRightOperad(value) {
    this._value._hasRightOperad = true;
    this._value._rightOperad = value;
    return this;
  }
  deleteRightOperad() {
    this._value._hasRightOperad = false;
    this._value._rightOperad = null;
    return this;
  }
}
AssignmentStatement.Builder = AssignmentStatement_Builder;
class AssignmentStatement_WithParent {
  /**
   * @param {AssignmentStatement} value
   * @param {AssignmentStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AssignmentStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeftOperand() {
    if (this._cachedHasLeftOperand === undefined) {
      if (this._value.hasLeftOperand) {
        this._cachedHasLeftOperand = true;
      } else {
        this._cachedHasLeftOperand = this._parent ? this._parent.hasLeftOperand : false;
      }
    }
    return this._cachedHasLeftOperand;
  }
  get leftOperand() {
    if (!this._cachedLeftOperand) {
      if (this._value.hasLeftOperand) {
        this._cachedLeftOperand = new VariableRef.WithParent(this._value.leftOperand, this._parent && this._parent.hasLeftOperand ? this._parent.leftOperand : null);
      } else {
        this._cachedLeftOperand = this._parent ? new VariableRef.WithParent(VariableRef.default, this._parent.leftOperand) : VariableRef.WithParent.default;
      }
    }
    return this._cachedLeftOperand;
  }
  get hasRightOperad() {
    if (this._cachedHasRightOperad === undefined) {
      if (this._value.hasRightOperad) {
        this._cachedHasRightOperad = true;
      } else {
        this._cachedHasRightOperad = this._parent ? this._parent.hasRightOperad : false;
      }
    }
    return this._cachedHasRightOperad;
  }
  get rightOperad() {
    if (!this._cachedRightOperad) {
      if (this._value.hasRightOperad) {
        this._cachedRightOperad = new Expression.WithParent(this._value.rightOperad, this._parent && this._parent.hasRightOperad ? this._parent.rightOperad : null);
      } else {
        this._cachedRightOperad = this._parent ? new Expression.WithParent(Expression.default, this._parent.rightOperad) : Expression.WithParent.default;
      }
    }
    return this._cachedRightOperad;
  }
  update(current, parent) {
    const result = new AssignmentStatement_WithParent(current, parent);
    if (this._cachedLeftOperand && this._value.hasLeftOperand && current.hasLeftOperand) {
      if (this._value.leftOperand === current.leftOperand && this._parent === parent) {
        result._cachedLeftOperand = this._cachedLeftOperand;
      } else {
        result._cachedLeftOperand = this._cachedLeftOperand.update(current.leftOperand, parent && parent.hasLeftOperand ? parent.leftOperand : null);
      }
    }
    if (this._cachedRightOperad && this._value.hasRightOperad && current.hasRightOperad) {
      if (this._value.rightOperad === current.rightOperad && this._parent === parent) {
        result._cachedRightOperad = this._cachedRightOperad;
      } else {
        result._cachedRightOperad = this._cachedRightOperad.update(current.rightOperad, parent && parent.hasRightOperad ? parent.rightOperad : null);
      }
    }
    return result;
  }
}
AssignmentStatement_WithParent.default = new AssignmentStatement_WithParent(AssignmentStatement.default, null);
AssignmentStatement.WithParent = AssignmentStatement_WithParent;
class AssignmentStatement_Descriptor {
  get leftOperand() {
    if (!this._leftOperand) {
      this._leftOperand = {
        name: "leftOperand",
        Name: "LeftOperand",
        number: 1,
        protoType: 11,
        protoName: "left_operand",
        type: VariableRef,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leftOperand;
  }
  get rightOperad() {
    if (!this._rightOperad) {
      this._rightOperad = {
        name: "rightOperad",
        Name: "RightOperad",
        number: 2,
        protoType: 11,
        protoName: "right_operad",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rightOperad;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.leftOperand,
        this.rightOperad,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeftOperand",
        Name: "DummyOneofForLeftOperand",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRightOperad",
        Name: "DummyOneofForRightOperad",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
AssignmentStatement.descriptor = new AssignmentStatement_Descriptor();
export class BreakStatement {
  get descriptor() {
    return BreakStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof BreakStatement) {
      return value;
    }
    return BreakStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new BreakStatement();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {BreakStatement} other
   * @returns {BreakStatement}
   */
  merge(other) {
    const copy = new BreakStatement(this);
    return copy;
  }
}
BreakStatement.default = new BreakStatement();
class BreakStatement_Builder {
  constructor(value) {
    this._value = new BreakStatement(value);
  }
  build() {
    return new BreakStatement(this._value);
  }
}
BreakStatement.Builder = BreakStatement_Builder;
class BreakStatement_WithParent {
  /**
   * @param {BreakStatement} value
   * @param {BreakStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BreakStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new BreakStatement_WithParent(current, parent);
    return result;
  }
}
BreakStatement_WithParent.default = new BreakStatement_WithParent(BreakStatement.default, null);
BreakStatement.WithParent = BreakStatement_WithParent;
class BreakStatement_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
BreakStatement.descriptor = new BreakStatement_Descriptor();
export class ContinueStatement {
  get descriptor() {
    return ContinueStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof ContinueStatement) {
      return value;
    }
    return ContinueStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ContinueStatement();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {ContinueStatement} other
   * @returns {ContinueStatement}
   */
  merge(other) {
    const copy = new ContinueStatement(this);
    return copy;
  }
}
ContinueStatement.default = new ContinueStatement();
class ContinueStatement_Builder {
  constructor(value) {
    this._value = new ContinueStatement(value);
  }
  build() {
    return new ContinueStatement(this._value);
  }
}
ContinueStatement.Builder = ContinueStatement_Builder;
class ContinueStatement_WithParent {
  /**
   * @param {ContinueStatement} value
   * @param {ContinueStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ContinueStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new ContinueStatement_WithParent(current, parent);
    return result;
  }
}
ContinueStatement_WithParent.default = new ContinueStatement_WithParent(ContinueStatement.default, null);
ContinueStatement.WithParent = ContinueStatement_WithParent;
class ContinueStatement_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ContinueStatement.descriptor = new ContinueStatement_Descriptor();
export class ReturnStatement {
  get descriptor() {
    return ReturnStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasReturnValue = false;
    this._returnValue = null;
  }
  isEmpty() {
    if (this._hasReturnValue && !this._returnValue.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ReturnStatement) {
      return value;
    }
    return ReturnStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ReturnStatement();
    if (json.returnValue != null) {
      result._hasReturnValue = true;
      result._returnValue = Expression.fromJson(json.returnValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasReturnValue && !this._returnValue.isEmpty()) {
      result.returnValue = Expression.toJson(this._returnValue);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get returnValue() {
    return this._hasReturnValue ? this._returnValue : Expression.default;
  }
  get hasReturnValue() {
    return this._hasReturnValue;
  }
  setReturnValue(path, value) {
    return {type: 'SET', path: path.concat(['returnValue']), value: value.toJson()};
  }
  deleteReturnValue(path) {
    return {type: 'DELETE', path: path.concat(['returnValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "returnValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ReturnStatement(this);
              copy._hasReturnValue = true;
              copy._returnValue = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReturnValue) {
                return this;
              }
              const copy = new ReturnStatement(this);
              copy._hasReturnValue = false;
              copy._returnValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasReturnValue) {
            const copy = new ReturnStatement(this);
            copy._hasReturnValue = true;
            copy._returnValue = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._returnValue.apply(type, path.slice(1), value);
          if (newValue === this._returnValue) {
            return this;
          }
          const copy = new ReturnStatement(this);
          copy._returnValue = copy._returnValue.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ReturnStatement} other
   * @returns {ReturnStatement}
   */
  merge(other) {
    const copy = new ReturnStatement(this);
    if (other._hasReturnValue) {
      if (copy._hasReturnValue) {
        copy._returnValue = copy.returnValue.merge(other.returnValue);
      } else {
        copy._returnValue = other._returnValue;
      }
      copy._hasReturnValue = true;
    }
    return copy;
  }
}
ReturnStatement.default = new ReturnStatement();
class ReturnStatement_Builder {
  constructor(value) {
    this._value = new ReturnStatement(value);
  }
  build() {
    return new ReturnStatement(this._value);
  }
  setReturnValue(value) {
    this._value._hasReturnValue = true;
    this._value._returnValue = value;
    return this;
  }
  deleteReturnValue() {
    this._value._hasReturnValue = false;
    this._value._returnValue = null;
    return this;
  }
}
ReturnStatement.Builder = ReturnStatement_Builder;
class ReturnStatement_WithParent {
  /**
   * @param {ReturnStatement} value
   * @param {ReturnStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ReturnStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasReturnValue() {
    if (this._cachedHasReturnValue === undefined) {
      if (this._value.hasReturnValue) {
        this._cachedHasReturnValue = true;
      } else {
        this._cachedHasReturnValue = this._parent ? this._parent.hasReturnValue : false;
      }
    }
    return this._cachedHasReturnValue;
  }
  get returnValue() {
    if (!this._cachedReturnValue) {
      if (this._value.hasReturnValue) {
        this._cachedReturnValue = new Expression.WithParent(this._value.returnValue, this._parent && this._parent.hasReturnValue ? this._parent.returnValue : null);
      } else {
        this._cachedReturnValue = this._parent ? new Expression.WithParent(Expression.default, this._parent.returnValue) : Expression.WithParent.default;
      }
    }
    return this._cachedReturnValue;
  }
  update(current, parent) {
    const result = new ReturnStatement_WithParent(current, parent);
    if (this._cachedReturnValue && this._value.hasReturnValue && current.hasReturnValue) {
      if (this._value.returnValue === current.returnValue && this._parent === parent) {
        result._cachedReturnValue = this._cachedReturnValue;
      } else {
        result._cachedReturnValue = this._cachedReturnValue.update(current.returnValue, parent && parent.hasReturnValue ? parent.returnValue : null);
      }
    }
    return result;
  }
}
ReturnStatement_WithParent.default = new ReturnStatement_WithParent(ReturnStatement.default, null);
ReturnStatement.WithParent = ReturnStatement_WithParent;
class ReturnStatement_Descriptor {
  get returnValue() {
    if (!this._returnValue) {
      this._returnValue = {
        name: "returnValue",
        Name: "ReturnValue",
        number: 1,
        protoType: 11,
        protoName: "return_value",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._returnValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.returnValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForReturnValue",
        Name: "DummyOneofForReturnValue",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ReturnStatement.descriptor = new ReturnStatement_Descriptor();
export class ArrayRemoveStatement {
  get descriptor() {
    return ArrayRemoveStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasArray = false;
    this._array = null;
    this._hasIndex = false;
    this._index = null;
  }
  isEmpty() {
    if (this._hasArray && !this._array.isEmpty()) return false;
    if (this._hasIndex && !this._index.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArrayRemoveStatement) {
      return value;
    }
    return ArrayRemoveStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArrayRemoveStatement();
    if (json.array != null) {
      result._hasArray = true;
      result._array = Expression.fromJson(json.array);
    }
    if (json.index != null) {
      result._hasIndex = true;
      result._index = Expression.fromJson(json.index);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasArray && !this._array.isEmpty()) {
      result.array = Expression.toJson(this._array);
    }
    if (this._hasIndex && !this._index.isEmpty()) {
      result.index = Expression.toJson(this._index);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get array() {
    return this._hasArray ? this._array : Expression.default;
  }
  get hasArray() {
    return this._hasArray;
  }
  setArray(path, value) {
    return {type: 'SET', path: path.concat(['array']), value: value.toJson()};
  }
  deleteArray(path) {
    return {type: 'DELETE', path: path.concat(['array'])};
  }
  /**
   * @returns {Expression}
   */
  get index() {
    return this._hasIndex ? this._index : Expression.default;
  }
  get hasIndex() {
    return this._hasIndex;
  }
  setIndex(path, value) {
    return {type: 'SET', path: path.concat(['index']), value: value.toJson()};
  }
  deleteIndex(path) {
    return {type: 'DELETE', path: path.concat(['index'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "array": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayRemoveStatement(this);
              copy._hasArray = true;
              copy._array = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArray) {
                return this;
              }
              const copy = new ArrayRemoveStatement(this);
              copy._hasArray = false;
              copy._array = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasArray) {
            const copy = new ArrayRemoveStatement(this);
            copy._hasArray = true;
            copy._array = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._array.apply(type, path.slice(1), value);
          if (newValue === this._array) {
            return this;
          }
          const copy = new ArrayRemoveStatement(this);
          copy._array = copy._array.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "index": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayRemoveStatement(this);
              copy._hasIndex = true;
              copy._index = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIndex) {
                return this;
              }
              const copy = new ArrayRemoveStatement(this);
              copy._hasIndex = false;
              copy._index = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasIndex) {
            const copy = new ArrayRemoveStatement(this);
            copy._hasIndex = true;
            copy._index = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._index.apply(type, path.slice(1), value);
          if (newValue === this._index) {
            return this;
          }
          const copy = new ArrayRemoveStatement(this);
          copy._index = copy._index.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArrayRemoveStatement} other
   * @returns {ArrayRemoveStatement}
   */
  merge(other) {
    const copy = new ArrayRemoveStatement(this);
    if (other._hasArray) {
      if (copy._hasArray) {
        copy._array = copy.array.merge(other.array);
      } else {
        copy._array = other._array;
      }
      copy._hasArray = true;
    }
    if (other._hasIndex) {
      if (copy._hasIndex) {
        copy._index = copy.index.merge(other.index);
      } else {
        copy._index = other._index;
      }
      copy._hasIndex = true;
    }
    return copy;
  }
}
ArrayRemoveStatement.default = new ArrayRemoveStatement();
class ArrayRemoveStatement_Builder {
  constructor(value) {
    this._value = new ArrayRemoveStatement(value);
  }
  build() {
    return new ArrayRemoveStatement(this._value);
  }
  setArray(value) {
    this._value._hasArray = true;
    this._value._array = value;
    return this;
  }
  deleteArray() {
    this._value._hasArray = false;
    this._value._array = null;
    return this;
  }
  setIndex(value) {
    this._value._hasIndex = true;
    this._value._index = value;
    return this;
  }
  deleteIndex() {
    this._value._hasIndex = false;
    this._value._index = null;
    return this;
  }
}
ArrayRemoveStatement.Builder = ArrayRemoveStatement_Builder;
class ArrayRemoveStatement_WithParent {
  /**
   * @param {ArrayRemoveStatement} value
   * @param {ArrayRemoveStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArrayRemoveStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasArray() {
    if (this._cachedHasArray === undefined) {
      if (this._value.hasArray) {
        this._cachedHasArray = true;
      } else {
        this._cachedHasArray = this._parent ? this._parent.hasArray : false;
      }
    }
    return this._cachedHasArray;
  }
  get array() {
    if (!this._cachedArray) {
      if (this._value.hasArray) {
        this._cachedArray = new Expression.WithParent(this._value.array, this._parent && this._parent.hasArray ? this._parent.array : null);
      } else {
        this._cachedArray = this._parent ? new Expression.WithParent(Expression.default, this._parent.array) : Expression.WithParent.default;
      }
    }
    return this._cachedArray;
  }
  get hasIndex() {
    if (this._cachedHasIndex === undefined) {
      if (this._value.hasIndex) {
        this._cachedHasIndex = true;
      } else {
        this._cachedHasIndex = this._parent ? this._parent.hasIndex : false;
      }
    }
    return this._cachedHasIndex;
  }
  get index() {
    if (!this._cachedIndex) {
      if (this._value.hasIndex) {
        this._cachedIndex = new Expression.WithParent(this._value.index, this._parent && this._parent.hasIndex ? this._parent.index : null);
      } else {
        this._cachedIndex = this._parent ? new Expression.WithParent(Expression.default, this._parent.index) : Expression.WithParent.default;
      }
    }
    return this._cachedIndex;
  }
  update(current, parent) {
    const result = new ArrayRemoveStatement_WithParent(current, parent);
    if (this._cachedArray && this._value.hasArray && current.hasArray) {
      if (this._value.array === current.array && this._parent === parent) {
        result._cachedArray = this._cachedArray;
      } else {
        result._cachedArray = this._cachedArray.update(current.array, parent && parent.hasArray ? parent.array : null);
      }
    }
    if (this._cachedIndex && this._value.hasIndex && current.hasIndex) {
      if (this._value.index === current.index && this._parent === parent) {
        result._cachedIndex = this._cachedIndex;
      } else {
        result._cachedIndex = this._cachedIndex.update(current.index, parent && parent.hasIndex ? parent.index : null);
      }
    }
    return result;
  }
}
ArrayRemoveStatement_WithParent.default = new ArrayRemoveStatement_WithParent(ArrayRemoveStatement.default, null);
ArrayRemoveStatement.WithParent = ArrayRemoveStatement_WithParent;
class ArrayRemoveStatement_Descriptor {
  get array() {
    if (!this._array) {
      this._array = {
        name: "array",
        Name: "Array",
        number: 1,
        protoType: 11,
        protoName: "array",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._array;
  }
  get index() {
    if (!this._index) {
      this._index = {
        name: "index",
        Name: "Index",
        number: 2,
        protoType: 11,
        protoName: "index",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._index;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.array,
        this.index,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForArray",
        Name: "DummyOneofForArray",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIndex",
        Name: "DummyOneofForIndex",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ArrayRemoveStatement.descriptor = new ArrayRemoveStatement_Descriptor();
export class ArrayAddStatement {
  get descriptor() {
    return ArrayAddStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasArray = false;
    this._array = null;
    this._hasElement = false;
    this._element = null;
  }
  isEmpty() {
    if (this._hasArray && !this._array.isEmpty()) return false;
    if (this._hasElement && !this._element.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArrayAddStatement) {
      return value;
    }
    return ArrayAddStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArrayAddStatement();
    if (json.array != null) {
      result._hasArray = true;
      result._array = Expression.fromJson(json.array);
    }
    if (json.element != null) {
      result._hasElement = true;
      result._element = Expression.fromJson(json.element);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasArray && !this._array.isEmpty()) {
      result.array = Expression.toJson(this._array);
    }
    if (this._hasElement && !this._element.isEmpty()) {
      result.element = Expression.toJson(this._element);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get array() {
    return this._hasArray ? this._array : Expression.default;
  }
  get hasArray() {
    return this._hasArray;
  }
  setArray(path, value) {
    return {type: 'SET', path: path.concat(['array']), value: value.toJson()};
  }
  deleteArray(path) {
    return {type: 'DELETE', path: path.concat(['array'])};
  }
  /**
   * @returns {Expression}
   */
  get element() {
    return this._hasElement ? this._element : Expression.default;
  }
  get hasElement() {
    return this._hasElement;
  }
  setElement(path, value) {
    return {type: 'SET', path: path.concat(['element']), value: value.toJson()};
  }
  deleteElement(path) {
    return {type: 'DELETE', path: path.concat(['element'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "array": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayAddStatement(this);
              copy._hasArray = true;
              copy._array = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArray) {
                return this;
              }
              const copy = new ArrayAddStatement(this);
              copy._hasArray = false;
              copy._array = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasArray) {
            const copy = new ArrayAddStatement(this);
            copy._hasArray = true;
            copy._array = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._array.apply(type, path.slice(1), value);
          if (newValue === this._array) {
            return this;
          }
          const copy = new ArrayAddStatement(this);
          copy._array = copy._array.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "element": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayAddStatement(this);
              copy._hasElement = true;
              copy._element = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElement) {
                return this;
              }
              const copy = new ArrayAddStatement(this);
              copy._hasElement = false;
              copy._element = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasElement) {
            const copy = new ArrayAddStatement(this);
            copy._hasElement = true;
            copy._element = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._element.apply(type, path.slice(1), value);
          if (newValue === this._element) {
            return this;
          }
          const copy = new ArrayAddStatement(this);
          copy._element = copy._element.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArrayAddStatement} other
   * @returns {ArrayAddStatement}
   */
  merge(other) {
    const copy = new ArrayAddStatement(this);
    if (other._hasArray) {
      if (copy._hasArray) {
        copy._array = copy.array.merge(other.array);
      } else {
        copy._array = other._array;
      }
      copy._hasArray = true;
    }
    if (other._hasElement) {
      if (copy._hasElement) {
        copy._element = copy.element.merge(other.element);
      } else {
        copy._element = other._element;
      }
      copy._hasElement = true;
    }
    return copy;
  }
}
ArrayAddStatement.default = new ArrayAddStatement();
class ArrayAddStatement_Builder {
  constructor(value) {
    this._value = new ArrayAddStatement(value);
  }
  build() {
    return new ArrayAddStatement(this._value);
  }
  setArray(value) {
    this._value._hasArray = true;
    this._value._array = value;
    return this;
  }
  deleteArray() {
    this._value._hasArray = false;
    this._value._array = null;
    return this;
  }
  setElement(value) {
    this._value._hasElement = true;
    this._value._element = value;
    return this;
  }
  deleteElement() {
    this._value._hasElement = false;
    this._value._element = null;
    return this;
  }
}
ArrayAddStatement.Builder = ArrayAddStatement_Builder;
class ArrayAddStatement_WithParent {
  /**
   * @param {ArrayAddStatement} value
   * @param {ArrayAddStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArrayAddStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasArray() {
    if (this._cachedHasArray === undefined) {
      if (this._value.hasArray) {
        this._cachedHasArray = true;
      } else {
        this._cachedHasArray = this._parent ? this._parent.hasArray : false;
      }
    }
    return this._cachedHasArray;
  }
  get array() {
    if (!this._cachedArray) {
      if (this._value.hasArray) {
        this._cachedArray = new Expression.WithParent(this._value.array, this._parent && this._parent.hasArray ? this._parent.array : null);
      } else {
        this._cachedArray = this._parent ? new Expression.WithParent(Expression.default, this._parent.array) : Expression.WithParent.default;
      }
    }
    return this._cachedArray;
  }
  get hasElement() {
    if (this._cachedHasElement === undefined) {
      if (this._value.hasElement) {
        this._cachedHasElement = true;
      } else {
        this._cachedHasElement = this._parent ? this._parent.hasElement : false;
      }
    }
    return this._cachedHasElement;
  }
  get element() {
    if (!this._cachedElement) {
      if (this._value.hasElement) {
        this._cachedElement = new Expression.WithParent(this._value.element, this._parent && this._parent.hasElement ? this._parent.element : null);
      } else {
        this._cachedElement = this._parent ? new Expression.WithParent(Expression.default, this._parent.element) : Expression.WithParent.default;
      }
    }
    return this._cachedElement;
  }
  update(current, parent) {
    const result = new ArrayAddStatement_WithParent(current, parent);
    if (this._cachedArray && this._value.hasArray && current.hasArray) {
      if (this._value.array === current.array && this._parent === parent) {
        result._cachedArray = this._cachedArray;
      } else {
        result._cachedArray = this._cachedArray.update(current.array, parent && parent.hasArray ? parent.array : null);
      }
    }
    if (this._cachedElement && this._value.hasElement && current.hasElement) {
      if (this._value.element === current.element && this._parent === parent) {
        result._cachedElement = this._cachedElement;
      } else {
        result._cachedElement = this._cachedElement.update(current.element, parent && parent.hasElement ? parent.element : null);
      }
    }
    return result;
  }
}
ArrayAddStatement_WithParent.default = new ArrayAddStatement_WithParent(ArrayAddStatement.default, null);
ArrayAddStatement.WithParent = ArrayAddStatement_WithParent;
class ArrayAddStatement_Descriptor {
  get array() {
    if (!this._array) {
      this._array = {
        name: "array",
        Name: "Array",
        number: 1,
        protoType: 11,
        protoName: "array",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._array;
  }
  get element() {
    if (!this._element) {
      this._element = {
        name: "element",
        Name: "Element",
        number: 2,
        protoType: 11,
        protoName: "element",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._element;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.array,
        this.element,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForArray",
        Name: "DummyOneofForArray",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForElement",
        Name: "DummyOneofForElement",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ArrayAddStatement.descriptor = new ArrayAddStatement_Descriptor();
export class ArraySetStatement {
  get descriptor() {
    return ArraySetStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasArray = false;
    this._array = null;
    this._hasIndex = false;
    this._index = null;
    this._hasElement = false;
    this._element = null;
  }
  isEmpty() {
    if (this._hasArray && !this._array.isEmpty()) return false;
    if (this._hasIndex && !this._index.isEmpty()) return false;
    if (this._hasElement && !this._element.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArraySetStatement) {
      return value;
    }
    return ArraySetStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArraySetStatement();
    if (json.array != null) {
      result._hasArray = true;
      result._array = Expression.fromJson(json.array);
    }
    if (json.index != null) {
      result._hasIndex = true;
      result._index = Expression.fromJson(json.index);
    }
    if (json.element != null) {
      result._hasElement = true;
      result._element = Expression.fromJson(json.element);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasArray && !this._array.isEmpty()) {
      result.array = Expression.toJson(this._array);
    }
    if (this._hasIndex && !this._index.isEmpty()) {
      result.index = Expression.toJson(this._index);
    }
    if (this._hasElement && !this._element.isEmpty()) {
      result.element = Expression.toJson(this._element);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get array() {
    return this._hasArray ? this._array : Expression.default;
  }
  get hasArray() {
    return this._hasArray;
  }
  setArray(path, value) {
    return {type: 'SET', path: path.concat(['array']), value: value.toJson()};
  }
  deleteArray(path) {
    return {type: 'DELETE', path: path.concat(['array'])};
  }
  /**
   * @returns {Expression}
   */
  get index() {
    return this._hasIndex ? this._index : Expression.default;
  }
  get hasIndex() {
    return this._hasIndex;
  }
  setIndex(path, value) {
    return {type: 'SET', path: path.concat(['index']), value: value.toJson()};
  }
  deleteIndex(path) {
    return {type: 'DELETE', path: path.concat(['index'])};
  }
  /**
   * @returns {Expression}
   */
  get element() {
    return this._hasElement ? this._element : Expression.default;
  }
  get hasElement() {
    return this._hasElement;
  }
  setElement(path, value) {
    return {type: 'SET', path: path.concat(['element']), value: value.toJson()};
  }
  deleteElement(path) {
    return {type: 'DELETE', path: path.concat(['element'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "array": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArraySetStatement(this);
              copy._hasArray = true;
              copy._array = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArray) {
                return this;
              }
              const copy = new ArraySetStatement(this);
              copy._hasArray = false;
              copy._array = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasArray) {
            const copy = new ArraySetStatement(this);
            copy._hasArray = true;
            copy._array = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._array.apply(type, path.slice(1), value);
          if (newValue === this._array) {
            return this;
          }
          const copy = new ArraySetStatement(this);
          copy._array = copy._array.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "index": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArraySetStatement(this);
              copy._hasIndex = true;
              copy._index = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIndex) {
                return this;
              }
              const copy = new ArraySetStatement(this);
              copy._hasIndex = false;
              copy._index = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasIndex) {
            const copy = new ArraySetStatement(this);
            copy._hasIndex = true;
            copy._index = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._index.apply(type, path.slice(1), value);
          if (newValue === this._index) {
            return this;
          }
          const copy = new ArraySetStatement(this);
          copy._index = copy._index.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "element": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArraySetStatement(this);
              copy._hasElement = true;
              copy._element = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElement) {
                return this;
              }
              const copy = new ArraySetStatement(this);
              copy._hasElement = false;
              copy._element = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasElement) {
            const copy = new ArraySetStatement(this);
            copy._hasElement = true;
            copy._element = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._element.apply(type, path.slice(1), value);
          if (newValue === this._element) {
            return this;
          }
          const copy = new ArraySetStatement(this);
          copy._element = copy._element.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArraySetStatement} other
   * @returns {ArraySetStatement}
   */
  merge(other) {
    const copy = new ArraySetStatement(this);
    if (other._hasArray) {
      if (copy._hasArray) {
        copy._array = copy.array.merge(other.array);
      } else {
        copy._array = other._array;
      }
      copy._hasArray = true;
    }
    if (other._hasIndex) {
      if (copy._hasIndex) {
        copy._index = copy.index.merge(other.index);
      } else {
        copy._index = other._index;
      }
      copy._hasIndex = true;
    }
    if (other._hasElement) {
      if (copy._hasElement) {
        copy._element = copy.element.merge(other.element);
      } else {
        copy._element = other._element;
      }
      copy._hasElement = true;
    }
    return copy;
  }
}
ArraySetStatement.default = new ArraySetStatement();
class ArraySetStatement_Builder {
  constructor(value) {
    this._value = new ArraySetStatement(value);
  }
  build() {
    return new ArraySetStatement(this._value);
  }
  setArray(value) {
    this._value._hasArray = true;
    this._value._array = value;
    return this;
  }
  deleteArray() {
    this._value._hasArray = false;
    this._value._array = null;
    return this;
  }
  setIndex(value) {
    this._value._hasIndex = true;
    this._value._index = value;
    return this;
  }
  deleteIndex() {
    this._value._hasIndex = false;
    this._value._index = null;
    return this;
  }
  setElement(value) {
    this._value._hasElement = true;
    this._value._element = value;
    return this;
  }
  deleteElement() {
    this._value._hasElement = false;
    this._value._element = null;
    return this;
  }
}
ArraySetStatement.Builder = ArraySetStatement_Builder;
class ArraySetStatement_WithParent {
  /**
   * @param {ArraySetStatement} value
   * @param {ArraySetStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArraySetStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasArray() {
    if (this._cachedHasArray === undefined) {
      if (this._value.hasArray) {
        this._cachedHasArray = true;
      } else {
        this._cachedHasArray = this._parent ? this._parent.hasArray : false;
      }
    }
    return this._cachedHasArray;
  }
  get array() {
    if (!this._cachedArray) {
      if (this._value.hasArray) {
        this._cachedArray = new Expression.WithParent(this._value.array, this._parent && this._parent.hasArray ? this._parent.array : null);
      } else {
        this._cachedArray = this._parent ? new Expression.WithParent(Expression.default, this._parent.array) : Expression.WithParent.default;
      }
    }
    return this._cachedArray;
  }
  get hasIndex() {
    if (this._cachedHasIndex === undefined) {
      if (this._value.hasIndex) {
        this._cachedHasIndex = true;
      } else {
        this._cachedHasIndex = this._parent ? this._parent.hasIndex : false;
      }
    }
    return this._cachedHasIndex;
  }
  get index() {
    if (!this._cachedIndex) {
      if (this._value.hasIndex) {
        this._cachedIndex = new Expression.WithParent(this._value.index, this._parent && this._parent.hasIndex ? this._parent.index : null);
      } else {
        this._cachedIndex = this._parent ? new Expression.WithParent(Expression.default, this._parent.index) : Expression.WithParent.default;
      }
    }
    return this._cachedIndex;
  }
  get hasElement() {
    if (this._cachedHasElement === undefined) {
      if (this._value.hasElement) {
        this._cachedHasElement = true;
      } else {
        this._cachedHasElement = this._parent ? this._parent.hasElement : false;
      }
    }
    return this._cachedHasElement;
  }
  get element() {
    if (!this._cachedElement) {
      if (this._value.hasElement) {
        this._cachedElement = new Expression.WithParent(this._value.element, this._parent && this._parent.hasElement ? this._parent.element : null);
      } else {
        this._cachedElement = this._parent ? new Expression.WithParent(Expression.default, this._parent.element) : Expression.WithParent.default;
      }
    }
    return this._cachedElement;
  }
  update(current, parent) {
    const result = new ArraySetStatement_WithParent(current, parent);
    if (this._cachedArray && this._value.hasArray && current.hasArray) {
      if (this._value.array === current.array && this._parent === parent) {
        result._cachedArray = this._cachedArray;
      } else {
        result._cachedArray = this._cachedArray.update(current.array, parent && parent.hasArray ? parent.array : null);
      }
    }
    if (this._cachedIndex && this._value.hasIndex && current.hasIndex) {
      if (this._value.index === current.index && this._parent === parent) {
        result._cachedIndex = this._cachedIndex;
      } else {
        result._cachedIndex = this._cachedIndex.update(current.index, parent && parent.hasIndex ? parent.index : null);
      }
    }
    if (this._cachedElement && this._value.hasElement && current.hasElement) {
      if (this._value.element === current.element && this._parent === parent) {
        result._cachedElement = this._cachedElement;
      } else {
        result._cachedElement = this._cachedElement.update(current.element, parent && parent.hasElement ? parent.element : null);
      }
    }
    return result;
  }
}
ArraySetStatement_WithParent.default = new ArraySetStatement_WithParent(ArraySetStatement.default, null);
ArraySetStatement.WithParent = ArraySetStatement_WithParent;
class ArraySetStatement_Descriptor {
  get array() {
    if (!this._array) {
      this._array = {
        name: "array",
        Name: "Array",
        number: 1,
        protoType: 11,
        protoName: "array",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._array;
  }
  get index() {
    if (!this._index) {
      this._index = {
        name: "index",
        Name: "Index",
        number: 2,
        protoType: 11,
        protoName: "index",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._index;
  }
  get element() {
    if (!this._element) {
      this._element = {
        name: "element",
        Name: "Element",
        number: 3,
        protoType: 11,
        protoName: "element",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._element;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.array,
        this.index,
        this.element,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForArray",
        Name: "DummyOneofForArray",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIndex",
        Name: "DummyOneofForIndex",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForElement",
        Name: "DummyOneofForElement",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ArraySetStatement.descriptor = new ArraySetStatement_Descriptor();
export class ArrayInsertStatement {
  get descriptor() {
    return ArrayInsertStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasArray = false;
    this._array = null;
    this._hasIndex = false;
    this._index = null;
    this._hasElement = false;
    this._element = null;
  }
  isEmpty() {
    if (this._hasArray && !this._array.isEmpty()) return false;
    if (this._hasIndex && !this._index.isEmpty()) return false;
    if (this._hasElement && !this._element.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArrayInsertStatement) {
      return value;
    }
    return ArrayInsertStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArrayInsertStatement();
    if (json.array != null) {
      result._hasArray = true;
      result._array = Expression.fromJson(json.array);
    }
    if (json.index != null) {
      result._hasIndex = true;
      result._index = Expression.fromJson(json.index);
    }
    if (json.element != null) {
      result._hasElement = true;
      result._element = Expression.fromJson(json.element);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasArray && !this._array.isEmpty()) {
      result.array = Expression.toJson(this._array);
    }
    if (this._hasIndex && !this._index.isEmpty()) {
      result.index = Expression.toJson(this._index);
    }
    if (this._hasElement && !this._element.isEmpty()) {
      result.element = Expression.toJson(this._element);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get array() {
    return this._hasArray ? this._array : Expression.default;
  }
  get hasArray() {
    return this._hasArray;
  }
  setArray(path, value) {
    return {type: 'SET', path: path.concat(['array']), value: value.toJson()};
  }
  deleteArray(path) {
    return {type: 'DELETE', path: path.concat(['array'])};
  }
  /**
   * @returns {Expression}
   */
  get index() {
    return this._hasIndex ? this._index : Expression.default;
  }
  get hasIndex() {
    return this._hasIndex;
  }
  setIndex(path, value) {
    return {type: 'SET', path: path.concat(['index']), value: value.toJson()};
  }
  deleteIndex(path) {
    return {type: 'DELETE', path: path.concat(['index'])};
  }
  /**
   * @returns {Expression}
   */
  get element() {
    return this._hasElement ? this._element : Expression.default;
  }
  get hasElement() {
    return this._hasElement;
  }
  setElement(path, value) {
    return {type: 'SET', path: path.concat(['element']), value: value.toJson()};
  }
  deleteElement(path) {
    return {type: 'DELETE', path: path.concat(['element'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "array": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayInsertStatement(this);
              copy._hasArray = true;
              copy._array = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArray) {
                return this;
              }
              const copy = new ArrayInsertStatement(this);
              copy._hasArray = false;
              copy._array = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasArray) {
            const copy = new ArrayInsertStatement(this);
            copy._hasArray = true;
            copy._array = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._array.apply(type, path.slice(1), value);
          if (newValue === this._array) {
            return this;
          }
          const copy = new ArrayInsertStatement(this);
          copy._array = copy._array.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "index": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayInsertStatement(this);
              copy._hasIndex = true;
              copy._index = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIndex) {
                return this;
              }
              const copy = new ArrayInsertStatement(this);
              copy._hasIndex = false;
              copy._index = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasIndex) {
            const copy = new ArrayInsertStatement(this);
            copy._hasIndex = true;
            copy._index = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._index.apply(type, path.slice(1), value);
          if (newValue === this._index) {
            return this;
          }
          const copy = new ArrayInsertStatement(this);
          copy._index = copy._index.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "element": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayInsertStatement(this);
              copy._hasElement = true;
              copy._element = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElement) {
                return this;
              }
              const copy = new ArrayInsertStatement(this);
              copy._hasElement = false;
              copy._element = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasElement) {
            const copy = new ArrayInsertStatement(this);
            copy._hasElement = true;
            copy._element = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._element.apply(type, path.slice(1), value);
          if (newValue === this._element) {
            return this;
          }
          const copy = new ArrayInsertStatement(this);
          copy._element = copy._element.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArrayInsertStatement} other
   * @returns {ArrayInsertStatement}
   */
  merge(other) {
    const copy = new ArrayInsertStatement(this);
    if (other._hasArray) {
      if (copy._hasArray) {
        copy._array = copy.array.merge(other.array);
      } else {
        copy._array = other._array;
      }
      copy._hasArray = true;
    }
    if (other._hasIndex) {
      if (copy._hasIndex) {
        copy._index = copy.index.merge(other.index);
      } else {
        copy._index = other._index;
      }
      copy._hasIndex = true;
    }
    if (other._hasElement) {
      if (copy._hasElement) {
        copy._element = copy.element.merge(other.element);
      } else {
        copy._element = other._element;
      }
      copy._hasElement = true;
    }
    return copy;
  }
}
ArrayInsertStatement.default = new ArrayInsertStatement();
class ArrayInsertStatement_Builder {
  constructor(value) {
    this._value = new ArrayInsertStatement(value);
  }
  build() {
    return new ArrayInsertStatement(this._value);
  }
  setArray(value) {
    this._value._hasArray = true;
    this._value._array = value;
    return this;
  }
  deleteArray() {
    this._value._hasArray = false;
    this._value._array = null;
    return this;
  }
  setIndex(value) {
    this._value._hasIndex = true;
    this._value._index = value;
    return this;
  }
  deleteIndex() {
    this._value._hasIndex = false;
    this._value._index = null;
    return this;
  }
  setElement(value) {
    this._value._hasElement = true;
    this._value._element = value;
    return this;
  }
  deleteElement() {
    this._value._hasElement = false;
    this._value._element = null;
    return this;
  }
}
ArrayInsertStatement.Builder = ArrayInsertStatement_Builder;
class ArrayInsertStatement_WithParent {
  /**
   * @param {ArrayInsertStatement} value
   * @param {ArrayInsertStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArrayInsertStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasArray() {
    if (this._cachedHasArray === undefined) {
      if (this._value.hasArray) {
        this._cachedHasArray = true;
      } else {
        this._cachedHasArray = this._parent ? this._parent.hasArray : false;
      }
    }
    return this._cachedHasArray;
  }
  get array() {
    if (!this._cachedArray) {
      if (this._value.hasArray) {
        this._cachedArray = new Expression.WithParent(this._value.array, this._parent && this._parent.hasArray ? this._parent.array : null);
      } else {
        this._cachedArray = this._parent ? new Expression.WithParent(Expression.default, this._parent.array) : Expression.WithParent.default;
      }
    }
    return this._cachedArray;
  }
  get hasIndex() {
    if (this._cachedHasIndex === undefined) {
      if (this._value.hasIndex) {
        this._cachedHasIndex = true;
      } else {
        this._cachedHasIndex = this._parent ? this._parent.hasIndex : false;
      }
    }
    return this._cachedHasIndex;
  }
  get index() {
    if (!this._cachedIndex) {
      if (this._value.hasIndex) {
        this._cachedIndex = new Expression.WithParent(this._value.index, this._parent && this._parent.hasIndex ? this._parent.index : null);
      } else {
        this._cachedIndex = this._parent ? new Expression.WithParent(Expression.default, this._parent.index) : Expression.WithParent.default;
      }
    }
    return this._cachedIndex;
  }
  get hasElement() {
    if (this._cachedHasElement === undefined) {
      if (this._value.hasElement) {
        this._cachedHasElement = true;
      } else {
        this._cachedHasElement = this._parent ? this._parent.hasElement : false;
      }
    }
    return this._cachedHasElement;
  }
  get element() {
    if (!this._cachedElement) {
      if (this._value.hasElement) {
        this._cachedElement = new Expression.WithParent(this._value.element, this._parent && this._parent.hasElement ? this._parent.element : null);
      } else {
        this._cachedElement = this._parent ? new Expression.WithParent(Expression.default, this._parent.element) : Expression.WithParent.default;
      }
    }
    return this._cachedElement;
  }
  update(current, parent) {
    const result = new ArrayInsertStatement_WithParent(current, parent);
    if (this._cachedArray && this._value.hasArray && current.hasArray) {
      if (this._value.array === current.array && this._parent === parent) {
        result._cachedArray = this._cachedArray;
      } else {
        result._cachedArray = this._cachedArray.update(current.array, parent && parent.hasArray ? parent.array : null);
      }
    }
    if (this._cachedIndex && this._value.hasIndex && current.hasIndex) {
      if (this._value.index === current.index && this._parent === parent) {
        result._cachedIndex = this._cachedIndex;
      } else {
        result._cachedIndex = this._cachedIndex.update(current.index, parent && parent.hasIndex ? parent.index : null);
      }
    }
    if (this._cachedElement && this._value.hasElement && current.hasElement) {
      if (this._value.element === current.element && this._parent === parent) {
        result._cachedElement = this._cachedElement;
      } else {
        result._cachedElement = this._cachedElement.update(current.element, parent && parent.hasElement ? parent.element : null);
      }
    }
    return result;
  }
}
ArrayInsertStatement_WithParent.default = new ArrayInsertStatement_WithParent(ArrayInsertStatement.default, null);
ArrayInsertStatement.WithParent = ArrayInsertStatement_WithParent;
class ArrayInsertStatement_Descriptor {
  get array() {
    if (!this._array) {
      this._array = {
        name: "array",
        Name: "Array",
        number: 1,
        protoType: 11,
        protoName: "array",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._array;
  }
  get index() {
    if (!this._index) {
      this._index = {
        name: "index",
        Name: "Index",
        number: 2,
        protoType: 11,
        protoName: "index",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._index;
  }
  get element() {
    if (!this._element) {
      this._element = {
        name: "element",
        Name: "Element",
        number: 3,
        protoType: 11,
        protoName: "element",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._element;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.array,
        this.index,
        this.element,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForArray",
        Name: "DummyOneofForArray",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIndex",
        Name: "DummyOneofForIndex",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForElement",
        Name: "DummyOneofForElement",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ArrayInsertStatement.descriptor = new ArrayInsertStatement_Descriptor();
export class ArrayForEachStatement {
  get descriptor() {
    return ArrayForEachStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasArray = false;
    this._array = null;
    this._hasIndex = false;
    this._index = null;
    this._hasElement = false;
    this._element = null;
    this._body = [];
  }
  isEmpty() {
    if (this._hasArray && !this._array.isEmpty()) return false;
    if (this._hasIndex && !this._index.isEmpty()) return false;
    if (this._hasElement && !this._element.isEmpty()) return false;
    if (this._body.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArrayForEachStatement) {
      return value;
    }
    return ArrayForEachStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArrayForEachStatement();
    if (json.array != null) {
      result._hasArray = true;
      result._array = Expression.fromJson(json.array);
    }
    if (json.index != null) {
      result._hasIndex = true;
      result._index = VariableRef.fromJson(json.index);
    }
    if (json.element != null) {
      result._hasElement = true;
      result._element = VariableRef.fromJson(json.element);
    }
    result._body = JsonToList(json.body, Statement);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasArray && !this._array.isEmpty()) {
      result.array = Expression.toJson(this._array);
    }
    if (this._hasIndex && !this._index.isEmpty()) {
      result.index = VariableRef.toJson(this._index);
    }
    if (this._hasElement && !this._element.isEmpty()) {
      result.element = VariableRef.toJson(this._element);
    }
    if (this._body.length > 0) {
      result.body = ArrayToJson(this._body, Statement);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get array() {
    return this._hasArray ? this._array : Expression.default;
  }
  get hasArray() {
    return this._hasArray;
  }
  setArray(path, value) {
    return {type: 'SET', path: path.concat(['array']), value: value.toJson()};
  }
  deleteArray(path) {
    return {type: 'DELETE', path: path.concat(['array'])};
  }
  /**
   * @returns {VariableRef}
   */
  get index() {
    return this._hasIndex ? this._index : VariableRef.default;
  }
  get hasIndex() {
    return this._hasIndex;
  }
  setIndex(path, value) {
    return {type: 'SET', path: path.concat(['index']), value: value.toJson()};
  }
  deleteIndex(path) {
    return {type: 'DELETE', path: path.concat(['index'])};
  }
  /**
   * @returns {VariableRef}
   */
  get element() {
    return this._hasElement ? this._element : VariableRef.default;
  }
  get hasElement() {
    return this._hasElement;
  }
  setElement(path, value) {
    return {type: 'SET', path: path.concat(['element']), value: value.toJson()};
  }
  deleteElement(path) {
    return {type: 'DELETE', path: path.concat(['element'])};
  }
  /**
   * @returns {Statement[]}
   */
  get body() {
    return this._body;
  }
  addBody(path, value) {
    return {type: 'ADD', path: path.concat(['body']), value: value.toJson()};
  }
  setBody(path, value) {
    return {type: 'SET', path: path.concat(['body']), value: ArrayToJson(value, Statement)};
  }
  setBodyByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['body', key]), value: value.toJson()};
  }
  deleteBody(path) {
    return {type: 'DELETE', path: path.concat(['body'])};
  }
  deleteBodyByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['body', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "array": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayForEachStatement(this);
              copy._hasArray = true;
              copy._array = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArray) {
                return this;
              }
              const copy = new ArrayForEachStatement(this);
              copy._hasArray = false;
              copy._array = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasArray) {
            const copy = new ArrayForEachStatement(this);
            copy._hasArray = true;
            copy._array = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._array.apply(type, path.slice(1), value);
          if (newValue === this._array) {
            return this;
          }
          const copy = new ArrayForEachStatement(this);
          copy._array = copy._array.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "index": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayForEachStatement(this);
              copy._hasIndex = true;
              copy._index = VariableRef.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIndex) {
                return this;
              }
              const copy = new ArrayForEachStatement(this);
              copy._hasIndex = false;
              copy._index = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasIndex) {
            const copy = new ArrayForEachStatement(this);
            copy._hasIndex = true;
            copy._index = VariableRef.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._index.apply(type, path.slice(1), value);
          if (newValue === this._index) {
            return this;
          }
          const copy = new ArrayForEachStatement(this);
          copy._index = copy._index.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "element": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayForEachStatement(this);
              copy._hasElement = true;
              copy._element = VariableRef.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElement) {
                return this;
              }
              const copy = new ArrayForEachStatement(this);
              copy._hasElement = false;
              copy._element = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasElement) {
            const copy = new ArrayForEachStatement(this);
            copy._hasElement = true;
            copy._element = VariableRef.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._element.apply(type, path.slice(1), value);
          if (newValue === this._element) {
            return this;
          }
          const copy = new ArrayForEachStatement(this);
          copy._element = copy._element.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "body": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayForEachStatement(this);
              copy._body = [];        for (let i of value) {
                copy._body.push(Statement.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ArrayForEachStatement(this);
              copy._body = copy._body.concat([Statement.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._body.length === 0) {
                return this;
              }
              const copy = new ArrayForEachStatement(this);
              copy._body = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._body.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ArrayForEachStatement(this);
              copy._body = copy._body.slice();
              copy._body[path[1]] = Statement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ArrayForEachStatement(this);
              copy._body = copy._body.slice(0, path[1]).concat(copy._body.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._body.length) {
            return this;
          }
          const oldValue = this._body[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ArrayForEachStatement(this);
          copy._body = copy._body.slice();
          copy._body[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArrayForEachStatement} other
   * @returns {ArrayForEachStatement}
   */
  merge(other) {
    const copy = new ArrayForEachStatement(this);
    if (other._hasArray) {
      if (copy._hasArray) {
        copy._array = copy.array.merge(other.array);
      } else {
        copy._array = other._array;
      }
      copy._hasArray = true;
    }
    if (other._hasIndex) {
      if (copy._hasIndex) {
        copy._index = copy.index.merge(other.index);
      } else {
        copy._index = other._index;
      }
      copy._hasIndex = true;
    }
    if (other._hasElement) {
      if (copy._hasElement) {
        copy._element = copy.element.merge(other.element);
      } else {
        copy._element = other._element;
      }
      copy._hasElement = true;
    }
    copy._body = this._body.concat(other._body);
    return copy;
  }
}
ArrayForEachStatement.default = new ArrayForEachStatement();
class ArrayForEachStatement_Builder {
  constructor(value) {
    this._value = new ArrayForEachStatement(value);
  }
  build() {
    return new ArrayForEachStatement(this._value);
  }
  setArray(value) {
    this._value._hasArray = true;
    this._value._array = value;
    return this;
  }
  deleteArray() {
    this._value._hasArray = false;
    this._value._array = null;
    return this;
  }
  setIndex(value) {
    this._value._hasIndex = true;
    this._value._index = value;
    return this;
  }
  deleteIndex() {
    this._value._hasIndex = false;
    this._value._index = null;
    return this;
  }
  setElement(value) {
    this._value._hasElement = true;
    this._value._element = value;
    return this;
  }
  deleteElement() {
    this._value._hasElement = false;
    this._value._element = null;
    return this;
  }
  addAllBody(values) {
    this._value._body = this._value._body.concat(values);
    return this;
  }
  addBody(value) {
    this._value._body = this._value._body.concat([value]);
    return this;
  }
  setBody(index, value) {
    this._value._body = this._value._body.concat();
    this._value._body[index] = value;
    return this;
  }
  clearBody() {
    this._value._body = [];
    return this;
  }
}
ArrayForEachStatement.Builder = ArrayForEachStatement_Builder;
class ArrayForEachStatement_WithParent {
  /**
   * @param {ArrayForEachStatement} value
   * @param {ArrayForEachStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArrayForEachStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasArray() {
    if (this._cachedHasArray === undefined) {
      if (this._value.hasArray) {
        this._cachedHasArray = true;
      } else {
        this._cachedHasArray = this._parent ? this._parent.hasArray : false;
      }
    }
    return this._cachedHasArray;
  }
  get array() {
    if (!this._cachedArray) {
      if (this._value.hasArray) {
        this._cachedArray = new Expression.WithParent(this._value.array, this._parent && this._parent.hasArray ? this._parent.array : null);
      } else {
        this._cachedArray = this._parent ? new Expression.WithParent(Expression.default, this._parent.array) : Expression.WithParent.default;
      }
    }
    return this._cachedArray;
  }
  get hasIndex() {
    if (this._cachedHasIndex === undefined) {
      if (this._value.hasIndex) {
        this._cachedHasIndex = true;
      } else {
        this._cachedHasIndex = this._parent ? this._parent.hasIndex : false;
      }
    }
    return this._cachedHasIndex;
  }
  get index() {
    if (!this._cachedIndex) {
      if (this._value.hasIndex) {
        this._cachedIndex = new VariableRef.WithParent(this._value.index, this._parent && this._parent.hasIndex ? this._parent.index : null);
      } else {
        this._cachedIndex = this._parent ? new VariableRef.WithParent(VariableRef.default, this._parent.index) : VariableRef.WithParent.default;
      }
    }
    return this._cachedIndex;
  }
  get hasElement() {
    if (this._cachedHasElement === undefined) {
      if (this._value.hasElement) {
        this._cachedHasElement = true;
      } else {
        this._cachedHasElement = this._parent ? this._parent.hasElement : false;
      }
    }
    return this._cachedHasElement;
  }
  get element() {
    if (!this._cachedElement) {
      if (this._value.hasElement) {
        this._cachedElement = new VariableRef.WithParent(this._value.element, this._parent && this._parent.hasElement ? this._parent.element : null);
      } else {
        this._cachedElement = this._parent ? new VariableRef.WithParent(VariableRef.default, this._parent.element) : VariableRef.WithParent.default;
      }
    }
    return this._cachedElement;
  }
  get selfBody() {
    if (!this._selfBody) {
      this._selfBody = [];
      for (let i of this._value.body) {
        this._selfBody.push(new Statement.WithParent(i, null));
      }
    }
    return this._selfBody;
  }
  get inherentBody() {
    if (!this._inherentBody) {
      this._inherentBody = this._parent ? this._parent.body : [];
    }
    return this._inherentBody;
  }
  get body() {
    if (!this._allBody) {
      this._allBody = this._parent ? this._parent.body.concat(this.selfBody) : this.selfBody;
    }
    return this._allBody;
  }
  update(current, parent) {
    const result = new ArrayForEachStatement_WithParent(current, parent);
    if (this._cachedArray && this._value.hasArray && current.hasArray) {
      if (this._value.array === current.array && this._parent === parent) {
        result._cachedArray = this._cachedArray;
      } else {
        result._cachedArray = this._cachedArray.update(current.array, parent && parent.hasArray ? parent.array : null);
      }
    }
    if (this._cachedIndex && this._value.hasIndex && current.hasIndex) {
      if (this._value.index === current.index && this._parent === parent) {
        result._cachedIndex = this._cachedIndex;
      } else {
        result._cachedIndex = this._cachedIndex.update(current.index, parent && parent.hasIndex ? parent.index : null);
      }
    }
    if (this._cachedElement && this._value.hasElement && current.hasElement) {
      if (this._value.element === current.element && this._parent === parent) {
        result._cachedElement = this._cachedElement;
      } else {
        result._cachedElement = this._cachedElement.update(current.element, parent && parent.hasElement ? parent.element : null);
      }
    }
    if (this._selfBody) {
      if (this._value.body === current.body) {
        result._selfBody = this._selfBody;
      } else {
        result._selfBody = [];
        for (let i = 0; i < current.body.length; i++) {
          const oldValue = this._value.body[i];
          if (oldValue) {
            const oldCache = this._selfBody[i];
            if (oldValue === current.body[i]) {
              result._selfBody[i] = oldCache;
            } else {
              result._selfBody[i] = oldCache.update(current.body[i], null);
            }
          } else {
            result._selfBody[i] = new Statement.WithParent(current.body[i], null);
          }
        }
      }
    }
    return result;
  }
}
ArrayForEachStatement_WithParent.default = new ArrayForEachStatement_WithParent(ArrayForEachStatement.default, null);
ArrayForEachStatement.WithParent = ArrayForEachStatement_WithParent;
class ArrayForEachStatement_Descriptor {
  get array() {
    if (!this._array) {
      this._array = {
        name: "array",
        Name: "Array",
        number: 1,
        protoType: 11,
        protoName: "array",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._array;
  }
  get index() {
    if (!this._index) {
      this._index = {
        name: "index",
        Name: "Index",
        number: 2,
        protoType: 11,
        protoName: "index",
        type: VariableRef,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._index;
  }
  get element() {
    if (!this._element) {
      this._element = {
        name: "element",
        Name: "Element",
        number: 3,
        protoType: 11,
        protoName: "element",
        type: VariableRef,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._element;
  }
  get body() {
    if (!this._body) {
      this._body = {
        name: "body",
        Name: "Body",
        number: 4,
        protoType: 11,
        protoName: "body",
        type: Statement,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._body;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.array,
        this.index,
        this.element,
        this.body,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForArray",
        Name: "DummyOneofForArray",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIndex",
        Name: "DummyOneofForIndex",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForElement",
        Name: "DummyOneofForElement",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ArrayForEachStatement.descriptor = new ArrayForEachStatement_Descriptor();
export class ArrayClearStatement {
  get descriptor() {
    return ArrayClearStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasArray = false;
    this._array = null;
  }
  isEmpty() {
    if (this._hasArray && !this._array.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArrayClearStatement) {
      return value;
    }
    return ArrayClearStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArrayClearStatement();
    if (json.array != null) {
      result._hasArray = true;
      result._array = VariableRef.fromJson(json.array);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasArray && !this._array.isEmpty()) {
      result.array = VariableRef.toJson(this._array);
    }
    return result;
  }
  /**
   * @returns {VariableRef}
   */
  get array() {
    return this._hasArray ? this._array : VariableRef.default;
  }
  get hasArray() {
    return this._hasArray;
  }
  setArray(path, value) {
    return {type: 'SET', path: path.concat(['array']), value: value.toJson()};
  }
  deleteArray(path) {
    return {type: 'DELETE', path: path.concat(['array'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "array": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayClearStatement(this);
              copy._hasArray = true;
              copy._array = VariableRef.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArray) {
                return this;
              }
              const copy = new ArrayClearStatement(this);
              copy._hasArray = false;
              copy._array = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasArray) {
            const copy = new ArrayClearStatement(this);
            copy._hasArray = true;
            copy._array = VariableRef.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._array.apply(type, path.slice(1), value);
          if (newValue === this._array) {
            return this;
          }
          const copy = new ArrayClearStatement(this);
          copy._array = copy._array.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArrayClearStatement} other
   * @returns {ArrayClearStatement}
   */
  merge(other) {
    const copy = new ArrayClearStatement(this);
    if (other._hasArray) {
      if (copy._hasArray) {
        copy._array = copy.array.merge(other.array);
      } else {
        copy._array = other._array;
      }
      copy._hasArray = true;
    }
    return copy;
  }
}
ArrayClearStatement.default = new ArrayClearStatement();
class ArrayClearStatement_Builder {
  constructor(value) {
    this._value = new ArrayClearStatement(value);
  }
  build() {
    return new ArrayClearStatement(this._value);
  }
  setArray(value) {
    this._value._hasArray = true;
    this._value._array = value;
    return this;
  }
  deleteArray() {
    this._value._hasArray = false;
    this._value._array = null;
    return this;
  }
}
ArrayClearStatement.Builder = ArrayClearStatement_Builder;
class ArrayClearStatement_WithParent {
  /**
   * @param {ArrayClearStatement} value
   * @param {ArrayClearStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArrayClearStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasArray() {
    if (this._cachedHasArray === undefined) {
      if (this._value.hasArray) {
        this._cachedHasArray = true;
      } else {
        this._cachedHasArray = this._parent ? this._parent.hasArray : false;
      }
    }
    return this._cachedHasArray;
  }
  get array() {
    if (!this._cachedArray) {
      if (this._value.hasArray) {
        this._cachedArray = new VariableRef.WithParent(this._value.array, this._parent && this._parent.hasArray ? this._parent.array : null);
      } else {
        this._cachedArray = this._parent ? new VariableRef.WithParent(VariableRef.default, this._parent.array) : VariableRef.WithParent.default;
      }
    }
    return this._cachedArray;
  }
  update(current, parent) {
    const result = new ArrayClearStatement_WithParent(current, parent);
    if (this._cachedArray && this._value.hasArray && current.hasArray) {
      if (this._value.array === current.array && this._parent === parent) {
        result._cachedArray = this._cachedArray;
      } else {
        result._cachedArray = this._cachedArray.update(current.array, parent && parent.hasArray ? parent.array : null);
      }
    }
    return result;
  }
}
ArrayClearStatement_WithParent.default = new ArrayClearStatement_WithParent(ArrayClearStatement.default, null);
ArrayClearStatement.WithParent = ArrayClearStatement_WithParent;
class ArrayClearStatement_Descriptor {
  get array() {
    if (!this._array) {
      this._array = {
        name: "array",
        Name: "Array",
        number: 1,
        protoType: 11,
        protoName: "array",
        type: VariableRef,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._array;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.array,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForArray",
        Name: "DummyOneofForArray",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ArrayClearStatement.descriptor = new ArrayClearStatement_Descriptor();
export class ArrayStatement {
  get descriptor() {
    return ArrayStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._arrayStatementTypeCase = 0;
    this._arrayStatementTypeValue = null;
  }
  isEmpty() {
    if (this._arrayStatementTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ArrayStatement) {
      return value;
    }
    return ArrayStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ArrayStatement();
    if (json.add != null) {
      result._arrayStatementTypeCase = 1;
      result._arrayStatementTypeValue = ArrayAddStatement.fromJson(json.add);
    }
    if (json.set != null) {
      result._arrayStatementTypeCase = 2;
      result._arrayStatementTypeValue = ArraySetStatement.fromJson(json.set);
    }
    if (json.remove != null) {
      result._arrayStatementTypeCase = 3;
      result._arrayStatementTypeValue = ArrayRemoveStatement.fromJson(json.remove);
    }
    if (json.insert != null) {
      result._arrayStatementTypeCase = 4;
      result._arrayStatementTypeValue = ArrayInsertStatement.fromJson(json.insert);
    }
    if (json.forEach != null) {
      result._arrayStatementTypeCase = 5;
      result._arrayStatementTypeValue = ArrayForEachStatement.fromJson(json.forEach);
    }
    if (json.clear != null) {
      result._arrayStatementTypeCase = 6;
      result._arrayStatementTypeValue = ArrayClearStatement.fromJson(json.clear);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._arrayStatementTypeCase) {
      case 1:
        result.add = ArrayAddStatement.toJson(this._arrayStatementTypeValue);
        break;
      case 2:
        result.set = ArraySetStatement.toJson(this._arrayStatementTypeValue);
        break;
      case 3:
        result.remove = ArrayRemoveStatement.toJson(this._arrayStatementTypeValue);
        break;
      case 4:
        result.insert = ArrayInsertStatement.toJson(this._arrayStatementTypeValue);
        break;
      case 5:
        result.forEach = ArrayForEachStatement.toJson(this._arrayStatementTypeValue);
        break;
      case 6:
        result.clear = ArrayClearStatement.toJson(this._arrayStatementTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get arrayStatementTypeCase() {
    return this._arrayStatementTypeCase;
  }
  deleteArrayStatementType(path) {
    switch (this._arrayStatementTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['add'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['set'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['remove'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['insert'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['forEach'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['clear'])};
      }
    }
  }
  /**
   * @returns {ArrayAddStatement}
   */
  get add() {
    return this._arrayStatementTypeCase === 1 ? this._arrayStatementTypeValue : ArrayAddStatement.default;
  }
  setAdd(path, value) {
    return {type: 'SET', path: path.concat(['add']), value: value.toJson()};
  }
  deleteAdd(path) {
    return {type: 'DELETE', path: path.concat(['add'])};
  }
  /**
   * @returns {ArraySetStatement}
   */
  get set() {
    return this._arrayStatementTypeCase === 2 ? this._arrayStatementTypeValue : ArraySetStatement.default;
  }
  setSet(path, value) {
    return {type: 'SET', path: path.concat(['set']), value: value.toJson()};
  }
  deleteSet(path) {
    return {type: 'DELETE', path: path.concat(['set'])};
  }
  /**
   * @returns {ArrayRemoveStatement}
   */
  get remove() {
    return this._arrayStatementTypeCase === 3 ? this._arrayStatementTypeValue : ArrayRemoveStatement.default;
  }
  setRemove(path, value) {
    return {type: 'SET', path: path.concat(['remove']), value: value.toJson()};
  }
  deleteRemove(path) {
    return {type: 'DELETE', path: path.concat(['remove'])};
  }
  /**
   * @returns {ArrayInsertStatement}
   */
  get insert() {
    return this._arrayStatementTypeCase === 4 ? this._arrayStatementTypeValue : ArrayInsertStatement.default;
  }
  setInsert(path, value) {
    return {type: 'SET', path: path.concat(['insert']), value: value.toJson()};
  }
  deleteInsert(path) {
    return {type: 'DELETE', path: path.concat(['insert'])};
  }
  /**
   * @returns {ArrayForEachStatement}
   */
  get forEach() {
    return this._arrayStatementTypeCase === 5 ? this._arrayStatementTypeValue : ArrayForEachStatement.default;
  }
  setForEach(path, value) {
    return {type: 'SET', path: path.concat(['forEach']), value: value.toJson()};
  }
  deleteForEach(path) {
    return {type: 'DELETE', path: path.concat(['forEach'])};
  }
  /**
   * @returns {ArrayClearStatement}
   */
  get clear() {
    return this._arrayStatementTypeCase === 6 ? this._arrayStatementTypeValue : ArrayClearStatement.default;
  }
  setClear(path, value) {
    return {type: 'SET', path: path.concat(['clear']), value: value.toJson()};
  }
  deleteClear(path) {
    return {type: 'DELETE', path: path.concat(['clear'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "add": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 1;
              copy._arrayStatementTypeValue = ArrayAddStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._arrayStatementTypeCase !== 1) {
                return this;
              }
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 0;
              copy._arrayStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._arrayStatementTypeCase !== 1) {
            const copy = new ArrayStatement(this);
            copy._arrayStatementTypeCase = 1;
            copy._arrayStatementTypeValue = ArrayAddStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.add.apply(type, path.slice(1), value);
          if (newValue === this.add) {
            return this;
          }
          const copy = new ArrayStatement(this);
          copy._arrayStatementTypeCase = 1;
          copy._arrayStatementTypeValue = newValue;
          return copy;
        }
      }
      case "set": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 2;
              copy._arrayStatementTypeValue = ArraySetStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._arrayStatementTypeCase !== 2) {
                return this;
              }
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 0;
              copy._arrayStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._arrayStatementTypeCase !== 2) {
            const copy = new ArrayStatement(this);
            copy._arrayStatementTypeCase = 2;
            copy._arrayStatementTypeValue = ArraySetStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.set.apply(type, path.slice(1), value);
          if (newValue === this.set) {
            return this;
          }
          const copy = new ArrayStatement(this);
          copy._arrayStatementTypeCase = 2;
          copy._arrayStatementTypeValue = newValue;
          return copy;
        }
      }
      case "remove": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 3;
              copy._arrayStatementTypeValue = ArrayRemoveStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._arrayStatementTypeCase !== 3) {
                return this;
              }
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 0;
              copy._arrayStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._arrayStatementTypeCase !== 3) {
            const copy = new ArrayStatement(this);
            copy._arrayStatementTypeCase = 3;
            copy._arrayStatementTypeValue = ArrayRemoveStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.remove.apply(type, path.slice(1), value);
          if (newValue === this.remove) {
            return this;
          }
          const copy = new ArrayStatement(this);
          copy._arrayStatementTypeCase = 3;
          copy._arrayStatementTypeValue = newValue;
          return copy;
        }
      }
      case "insert": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 4;
              copy._arrayStatementTypeValue = ArrayInsertStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._arrayStatementTypeCase !== 4) {
                return this;
              }
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 0;
              copy._arrayStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._arrayStatementTypeCase !== 4) {
            const copy = new ArrayStatement(this);
            copy._arrayStatementTypeCase = 4;
            copy._arrayStatementTypeValue = ArrayInsertStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.insert.apply(type, path.slice(1), value);
          if (newValue === this.insert) {
            return this;
          }
          const copy = new ArrayStatement(this);
          copy._arrayStatementTypeCase = 4;
          copy._arrayStatementTypeValue = newValue;
          return copy;
        }
      }
      case "forEach": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 5;
              copy._arrayStatementTypeValue = ArrayForEachStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._arrayStatementTypeCase !== 5) {
                return this;
              }
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 0;
              copy._arrayStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._arrayStatementTypeCase !== 5) {
            const copy = new ArrayStatement(this);
            copy._arrayStatementTypeCase = 5;
            copy._arrayStatementTypeValue = ArrayForEachStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.forEach.apply(type, path.slice(1), value);
          if (newValue === this.forEach) {
            return this;
          }
          const copy = new ArrayStatement(this);
          copy._arrayStatementTypeCase = 5;
          copy._arrayStatementTypeValue = newValue;
          return copy;
        }
      }
      case "clear": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 6;
              copy._arrayStatementTypeValue = ArrayClearStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._arrayStatementTypeCase !== 6) {
                return this;
              }
              const copy = new ArrayStatement(this);
              copy._arrayStatementTypeCase = 0;
              copy._arrayStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._arrayStatementTypeCase !== 6) {
            const copy = new ArrayStatement(this);
            copy._arrayStatementTypeCase = 6;
            copy._arrayStatementTypeValue = ArrayClearStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.clear.apply(type, path.slice(1), value);
          if (newValue === this.clear) {
            return this;
          }
          const copy = new ArrayStatement(this);
          copy._arrayStatementTypeCase = 6;
          copy._arrayStatementTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ArrayStatement} other
   * @returns {ArrayStatement}
   */
  merge(other) {
    const copy = new ArrayStatement(this);
    if (other._arrayStatementTypeCase === 1) {
      if (this._arrayStatementTypeCase === 1) {
        copy._arrayStatementTypeValue = copy._arrayStatementTypeValue.merge(other._arrayStatementTypeValue);
      } else {
        copy._arrayStatementTypeValue = other._arrayStatementTypeValue;
      }
      copy._arrayStatementTypeCase = 1;
    }
    if (other._arrayStatementTypeCase === 1) {
      if (this._arrayStatementTypeCase === 1) {
        copy._arrayStatementTypeValue = copy._arrayStatementTypeValue.merge(other._arrayStatementTypeValue);
      } else {
        copy._arrayStatementTypeValue = other._arrayStatementTypeValue;
      }
      copy._arrayStatementTypeCase = 1;
    }
    if (other._arrayStatementTypeCase === 1) {
      if (this._arrayStatementTypeCase === 1) {
        copy._arrayStatementTypeValue = copy._arrayStatementTypeValue.merge(other._arrayStatementTypeValue);
      } else {
        copy._arrayStatementTypeValue = other._arrayStatementTypeValue;
      }
      copy._arrayStatementTypeCase = 1;
    }
    if (other._arrayStatementTypeCase === 1) {
      if (this._arrayStatementTypeCase === 1) {
        copy._arrayStatementTypeValue = copy._arrayStatementTypeValue.merge(other._arrayStatementTypeValue);
      } else {
        copy._arrayStatementTypeValue = other._arrayStatementTypeValue;
      }
      copy._arrayStatementTypeCase = 1;
    }
    if (other._arrayStatementTypeCase === 1) {
      if (this._arrayStatementTypeCase === 1) {
        copy._arrayStatementTypeValue = copy._arrayStatementTypeValue.merge(other._arrayStatementTypeValue);
      } else {
        copy._arrayStatementTypeValue = other._arrayStatementTypeValue;
      }
      copy._arrayStatementTypeCase = 1;
    }
    if (other._arrayStatementTypeCase === 1) {
      if (this._arrayStatementTypeCase === 1) {
        copy._arrayStatementTypeValue = copy._arrayStatementTypeValue.merge(other._arrayStatementTypeValue);
      } else {
        copy._arrayStatementTypeValue = other._arrayStatementTypeValue;
      }
      copy._arrayStatementTypeCase = 1;
    }
    return copy;
  }
}
ArrayStatement.default = new ArrayStatement();
class ArrayStatement_Builder {
  constructor(value) {
    this._value = new ArrayStatement(value);
  }
  build() {
    return new ArrayStatement(this._value);
  }
  cleararrayStatementType() {
    this._value._arrayStatementTypeCase = 0;
    this._value._arrayStatementTypeValue = null;
    return this;
  }
  setAdd(value) {
    this._value._arrayStatementTypeCase = 1;
    this._value._arrayStatementTypeValue = value;
    return this;
  }
  setSet(value) {
    this._value._arrayStatementTypeCase = 2;
    this._value._arrayStatementTypeValue = value;
    return this;
  }
  setRemove(value) {
    this._value._arrayStatementTypeCase = 3;
    this._value._arrayStatementTypeValue = value;
    return this;
  }
  setInsert(value) {
    this._value._arrayStatementTypeCase = 4;
    this._value._arrayStatementTypeValue = value;
    return this;
  }
  setForEach(value) {
    this._value._arrayStatementTypeCase = 5;
    this._value._arrayStatementTypeValue = value;
    return this;
  }
  setClear(value) {
    this._value._arrayStatementTypeCase = 6;
    this._value._arrayStatementTypeValue = value;
    return this;
  }
}
ArrayStatement.Builder = ArrayStatement_Builder;
class ArrayStatement_WithParent {
  /**
   * @param {ArrayStatement} value
   * @param {ArrayStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ArrayStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get arrayStatementTypeCase() {
    if (this._cachedarrayStatementTypeCase === undefined) {
      if (this._value._arrayStatementTypeCase === 0) {
        this._cachedarrayStatementTypeCase = this._parent ? this._parent.arrayStatementTypeCase : 0;
      } else {
        this._cachedarrayStatementTypeCase = this._value._arrayStatementTypeCase;
      }
    }
    return this._cachedarrayStatementTypeCase;
  }
  get add() {
    if (!this._cachedAdd) {
      if (this._value._arrayStatementTypeCase === 0) {
        this._cachedAdd = this._parent ? new ArrayAddStatement.WithParent(ArrayAddStatement.default, this._parent.add) : this._value.add;
      } else if (this._value._arrayStatementTypeCase === 1) {
        this._cachedAdd = new ArrayAddStatement.WithParent(this._value.add, this._parent && this._parent.arrayStatementTypeCase === 1 ? this._parent.add : null);
      } else {
        this._cachedAdd = ArrayAddStatement.WithParent.default;
      }
    }
    return this._cachedAdd;
  }
  get set() {
    if (!this._cachedSet) {
      if (this._value._arrayStatementTypeCase === 0) {
        this._cachedSet = this._parent ? new ArraySetStatement.WithParent(ArraySetStatement.default, this._parent.set) : this._value.set;
      } else if (this._value._arrayStatementTypeCase === 2) {
        this._cachedSet = new ArraySetStatement.WithParent(this._value.set, this._parent && this._parent.arrayStatementTypeCase === 2 ? this._parent.set : null);
      } else {
        this._cachedSet = ArraySetStatement.WithParent.default;
      }
    }
    return this._cachedSet;
  }
  get remove() {
    if (!this._cachedRemove) {
      if (this._value._arrayStatementTypeCase === 0) {
        this._cachedRemove = this._parent ? new ArrayRemoveStatement.WithParent(ArrayRemoveStatement.default, this._parent.remove) : this._value.remove;
      } else if (this._value._arrayStatementTypeCase === 3) {
        this._cachedRemove = new ArrayRemoveStatement.WithParent(this._value.remove, this._parent && this._parent.arrayStatementTypeCase === 3 ? this._parent.remove : null);
      } else {
        this._cachedRemove = ArrayRemoveStatement.WithParent.default;
      }
    }
    return this._cachedRemove;
  }
  get insert() {
    if (!this._cachedInsert) {
      if (this._value._arrayStatementTypeCase === 0) {
        this._cachedInsert = this._parent ? new ArrayInsertStatement.WithParent(ArrayInsertStatement.default, this._parent.insert) : this._value.insert;
      } else if (this._value._arrayStatementTypeCase === 4) {
        this._cachedInsert = new ArrayInsertStatement.WithParent(this._value.insert, this._parent && this._parent.arrayStatementTypeCase === 4 ? this._parent.insert : null);
      } else {
        this._cachedInsert = ArrayInsertStatement.WithParent.default;
      }
    }
    return this._cachedInsert;
  }
  get forEach() {
    if (!this._cachedForEach) {
      if (this._value._arrayStatementTypeCase === 0) {
        this._cachedForEach = this._parent ? new ArrayForEachStatement.WithParent(ArrayForEachStatement.default, this._parent.forEach) : this._value.forEach;
      } else if (this._value._arrayStatementTypeCase === 5) {
        this._cachedForEach = new ArrayForEachStatement.WithParent(this._value.forEach, this._parent && this._parent.arrayStatementTypeCase === 5 ? this._parent.forEach : null);
      } else {
        this._cachedForEach = ArrayForEachStatement.WithParent.default;
      }
    }
    return this._cachedForEach;
  }
  get clear() {
    if (!this._cachedClear) {
      if (this._value._arrayStatementTypeCase === 0) {
        this._cachedClear = this._parent ? new ArrayClearStatement.WithParent(ArrayClearStatement.default, this._parent.clear) : this._value.clear;
      } else if (this._value._arrayStatementTypeCase === 6) {
        this._cachedClear = new ArrayClearStatement.WithParent(this._value.clear, this._parent && this._parent.arrayStatementTypeCase === 6 ? this._parent.clear : null);
      } else {
        this._cachedClear = ArrayClearStatement.WithParent.default;
      }
    }
    return this._cachedClear;
  }
  update(current, parent) {
    const result = new ArrayStatement_WithParent(current, parent);
    if (this._cachedAdd && this._value._arrayStatementTypeCase === 1 && current._arrayStatementTypeCase === 1) {
      if (this._value.add === current.add && this._parent === parent) {
        result._cachedAdd = this._cachedAdd;
      } else {
        result._cachedAdd = this._cachedAdd.update(current.add, parent && parent.arrayStatementTypeCase === 1 ? parent.add : null);
      }
    }
    if (this._cachedSet && this._value._arrayStatementTypeCase === 2 && current._arrayStatementTypeCase === 2) {
      if (this._value.set === current.set && this._parent === parent) {
        result._cachedSet = this._cachedSet;
      } else {
        result._cachedSet = this._cachedSet.update(current.set, parent && parent.arrayStatementTypeCase === 2 ? parent.set : null);
      }
    }
    if (this._cachedRemove && this._value._arrayStatementTypeCase === 3 && current._arrayStatementTypeCase === 3) {
      if (this._value.remove === current.remove && this._parent === parent) {
        result._cachedRemove = this._cachedRemove;
      } else {
        result._cachedRemove = this._cachedRemove.update(current.remove, parent && parent.arrayStatementTypeCase === 3 ? parent.remove : null);
      }
    }
    if (this._cachedInsert && this._value._arrayStatementTypeCase === 4 && current._arrayStatementTypeCase === 4) {
      if (this._value.insert === current.insert && this._parent === parent) {
        result._cachedInsert = this._cachedInsert;
      } else {
        result._cachedInsert = this._cachedInsert.update(current.insert, parent && parent.arrayStatementTypeCase === 4 ? parent.insert : null);
      }
    }
    if (this._cachedForEach && this._value._arrayStatementTypeCase === 5 && current._arrayStatementTypeCase === 5) {
      if (this._value.forEach === current.forEach && this._parent === parent) {
        result._cachedForEach = this._cachedForEach;
      } else {
        result._cachedForEach = this._cachedForEach.update(current.forEach, parent && parent.arrayStatementTypeCase === 5 ? parent.forEach : null);
      }
    }
    if (this._cachedClear && this._value._arrayStatementTypeCase === 6 && current._arrayStatementTypeCase === 6) {
      if (this._value.clear === current.clear && this._parent === parent) {
        result._cachedClear = this._cachedClear;
      } else {
        result._cachedClear = this._cachedClear.update(current.clear, parent && parent.arrayStatementTypeCase === 6 ? parent.clear : null);
      }
    }
    return result;
  }
}
ArrayStatement_WithParent.default = new ArrayStatement_WithParent(ArrayStatement.default, null);
ArrayStatement.WithParent = ArrayStatement_WithParent;
class ArrayStatement_Descriptor {
  get add() {
    if (!this._add) {
      this._add = {
        name: "add",
        Name: "Add",
        number: 1,
        protoType: 11,
        protoName: "add",
        oneofIndex: 0,
        type: ArrayAddStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._add;
  }
  get set() {
    if (!this._set) {
      this._set = {
        name: "set",
        Name: "Set",
        number: 2,
        protoType: 11,
        protoName: "set",
        oneofIndex: 0,
        type: ArraySetStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._set;
  }
  get remove() {
    if (!this._remove) {
      this._remove = {
        name: "remove",
        Name: "Remove",
        number: 3,
        protoType: 11,
        protoName: "remove",
        oneofIndex: 0,
        type: ArrayRemoveStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._remove;
  }
  get insert() {
    if (!this._insert) {
      this._insert = {
        name: "insert",
        Name: "Insert",
        number: 4,
        protoType: 11,
        protoName: "insert",
        oneofIndex: 0,
        type: ArrayInsertStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._insert;
  }
  get forEach() {
    if (!this._forEach) {
      this._forEach = {
        name: "forEach",
        Name: "ForEach",
        number: 5,
        protoType: 11,
        protoName: "for_each",
        oneofIndex: 0,
        type: ArrayForEachStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forEach;
  }
  get clear() {
    if (!this._clear) {
      this._clear = {
        name: "clear",
        Name: "Clear",
        number: 6,
        protoType: 11,
        protoName: "clear",
        oneofIndex: 0,
        type: ArrayClearStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clear;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.add,
        this.set,
        this.remove,
        this.insert,
        this.forEach,
        this.clear,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "arrayStatementType",
        Name: "ArrayStatementType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
ArrayStatement.descriptor = new ArrayStatement_Descriptor();
export class TableSetStatement {
  get descriptor() {
    return TableSetStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTable = false;
    this._table = null;
    this._hasKey = false;
    this._key = null;
    this._hasElement = false;
    this._element = null;
  }
  isEmpty() {
    if (this._hasTable && !this._table.isEmpty()) return false;
    if (this._hasKey && !this._key.isEmpty()) return false;
    if (this._hasElement && !this._element.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TableSetStatement) {
      return value;
    }
    return TableSetStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new TableSetStatement();
    if (json.table != null) {
      result._hasTable = true;
      result._table = Expression.fromJson(json.table);
    }
    if (json.key != null) {
      result._hasKey = true;
      result._key = Expression.fromJson(json.key);
    }
    if (json.element != null) {
      result._hasElement = true;
      result._element = Expression.fromJson(json.element);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTable && !this._table.isEmpty()) {
      result.table = Expression.toJson(this._table);
    }
    if (this._hasKey && !this._key.isEmpty()) {
      result.key = Expression.toJson(this._key);
    }
    if (this._hasElement && !this._element.isEmpty()) {
      result.element = Expression.toJson(this._element);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get table() {
    return this._hasTable ? this._table : Expression.default;
  }
  get hasTable() {
    return this._hasTable;
  }
  setTable(path, value) {
    return {type: 'SET', path: path.concat(['table']), value: value.toJson()};
  }
  deleteTable(path) {
    return {type: 'DELETE', path: path.concat(['table'])};
  }
  /**
   * @returns {Expression}
   */
  get key() {
    return this._hasKey ? this._key : Expression.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value: value.toJson()};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {Expression}
   */
  get element() {
    return this._hasElement ? this._element : Expression.default;
  }
  get hasElement() {
    return this._hasElement;
  }
  setElement(path, value) {
    return {type: 'SET', path: path.concat(['element']), value: value.toJson()};
  }
  deleteElement(path) {
    return {type: 'DELETE', path: path.concat(['element'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "table": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableSetStatement(this);
              copy._hasTable = true;
              copy._table = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTable) {
                return this;
              }
              const copy = new TableSetStatement(this);
              copy._hasTable = false;
              copy._table = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTable) {
            const copy = new TableSetStatement(this);
            copy._hasTable = true;
            copy._table = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._table.apply(type, path.slice(1), value);
          if (newValue === this._table) {
            return this;
          }
          const copy = new TableSetStatement(this);
          copy._table = copy._table.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableSetStatement(this);
              copy._hasKey = true;
              copy._key = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TableSetStatement(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasKey) {
            const copy = new TableSetStatement(this);
            copy._hasKey = true;
            copy._key = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._key.apply(type, path.slice(1), value);
          if (newValue === this._key) {
            return this;
          }
          const copy = new TableSetStatement(this);
          copy._key = copy._key.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "element": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableSetStatement(this);
              copy._hasElement = true;
              copy._element = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElement) {
                return this;
              }
              const copy = new TableSetStatement(this);
              copy._hasElement = false;
              copy._element = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasElement) {
            const copy = new TableSetStatement(this);
            copy._hasElement = true;
            copy._element = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._element.apply(type, path.slice(1), value);
          if (newValue === this._element) {
            return this;
          }
          const copy = new TableSetStatement(this);
          copy._element = copy._element.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TableSetStatement} other
   * @returns {TableSetStatement}
   */
  merge(other) {
    const copy = new TableSetStatement(this);
    if (other._hasTable) {
      if (copy._hasTable) {
        copy._table = copy.table.merge(other.table);
      } else {
        copy._table = other._table;
      }
      copy._hasTable = true;
    }
    if (other._hasKey) {
      if (copy._hasKey) {
        copy._key = copy.key.merge(other.key);
      } else {
        copy._key = other._key;
      }
      copy._hasKey = true;
    }
    if (other._hasElement) {
      if (copy._hasElement) {
        copy._element = copy.element.merge(other.element);
      } else {
        copy._element = other._element;
      }
      copy._hasElement = true;
    }
    return copy;
  }
}
TableSetStatement.default = new TableSetStatement();
class TableSetStatement_Builder {
  constructor(value) {
    this._value = new TableSetStatement(value);
  }
  build() {
    return new TableSetStatement(this._value);
  }
  setTable(value) {
    this._value._hasTable = true;
    this._value._table = value;
    return this;
  }
  deleteTable() {
    this._value._hasTable = false;
    this._value._table = null;
    return this;
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setElement(value) {
    this._value._hasElement = true;
    this._value._element = value;
    return this;
  }
  deleteElement() {
    this._value._hasElement = false;
    this._value._element = null;
    return this;
  }
}
TableSetStatement.Builder = TableSetStatement_Builder;
class TableSetStatement_WithParent {
  /**
   * @param {TableSetStatement} value
   * @param {TableSetStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TableSetStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTable() {
    if (this._cachedHasTable === undefined) {
      if (this._value.hasTable) {
        this._cachedHasTable = true;
      } else {
        this._cachedHasTable = this._parent ? this._parent.hasTable : false;
      }
    }
    return this._cachedHasTable;
  }
  get table() {
    if (!this._cachedTable) {
      if (this._value.hasTable) {
        this._cachedTable = new Expression.WithParent(this._value.table, this._parent && this._parent.hasTable ? this._parent.table : null);
      } else {
        this._cachedTable = this._parent ? new Expression.WithParent(Expression.default, this._parent.table) : Expression.WithParent.default;
      }
    }
    return this._cachedTable;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (!this._cachedKey) {
      if (this._value.hasKey) {
        this._cachedKey = new Expression.WithParent(this._value.key, this._parent && this._parent.hasKey ? this._parent.key : null);
      } else {
        this._cachedKey = this._parent ? new Expression.WithParent(Expression.default, this._parent.key) : Expression.WithParent.default;
      }
    }
    return this._cachedKey;
  }
  get hasElement() {
    if (this._cachedHasElement === undefined) {
      if (this._value.hasElement) {
        this._cachedHasElement = true;
      } else {
        this._cachedHasElement = this._parent ? this._parent.hasElement : false;
      }
    }
    return this._cachedHasElement;
  }
  get element() {
    if (!this._cachedElement) {
      if (this._value.hasElement) {
        this._cachedElement = new Expression.WithParent(this._value.element, this._parent && this._parent.hasElement ? this._parent.element : null);
      } else {
        this._cachedElement = this._parent ? new Expression.WithParent(Expression.default, this._parent.element) : Expression.WithParent.default;
      }
    }
    return this._cachedElement;
  }
  update(current, parent) {
    const result = new TableSetStatement_WithParent(current, parent);
    if (this._cachedTable && this._value.hasTable && current.hasTable) {
      if (this._value.table === current.table && this._parent === parent) {
        result._cachedTable = this._cachedTable;
      } else {
        result._cachedTable = this._cachedTable.update(current.table, parent && parent.hasTable ? parent.table : null);
      }
    }
    if (this._cachedKey && this._value.hasKey && current.hasKey) {
      if (this._value.key === current.key && this._parent === parent) {
        result._cachedKey = this._cachedKey;
      } else {
        result._cachedKey = this._cachedKey.update(current.key, parent && parent.hasKey ? parent.key : null);
      }
    }
    if (this._cachedElement && this._value.hasElement && current.hasElement) {
      if (this._value.element === current.element && this._parent === parent) {
        result._cachedElement = this._cachedElement;
      } else {
        result._cachedElement = this._cachedElement.update(current.element, parent && parent.hasElement ? parent.element : null);
      }
    }
    return result;
  }
}
TableSetStatement_WithParent.default = new TableSetStatement_WithParent(TableSetStatement.default, null);
TableSetStatement.WithParent = TableSetStatement_WithParent;
class TableSetStatement_Descriptor {
  get table() {
    if (!this._table) {
      this._table = {
        name: "table",
        Name: "Table",
        number: 1,
        protoType: 11,
        protoName: "table",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._table;
  }
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 2,
        protoType: 11,
        protoName: "key",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get element() {
    if (!this._element) {
      this._element = {
        name: "element",
        Name: "Element",
        number: 3,
        protoType: 11,
        protoName: "element",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._element;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.table,
        this.key,
        this.element,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTable",
        Name: "DummyOneofForTable",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForElement",
        Name: "DummyOneofForElement",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
TableSetStatement.descriptor = new TableSetStatement_Descriptor();
export class TableRemoveStatement {
  get descriptor() {
    return TableRemoveStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTable = false;
    this._table = null;
    this._hasKey = false;
    this._key = null;
  }
  isEmpty() {
    if (this._hasTable && !this._table.isEmpty()) return false;
    if (this._hasKey && !this._key.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TableRemoveStatement) {
      return value;
    }
    return TableRemoveStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new TableRemoveStatement();
    if (json.table != null) {
      result._hasTable = true;
      result._table = Expression.fromJson(json.table);
    }
    if (json.key != null) {
      result._hasKey = true;
      result._key = Expression.fromJson(json.key);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTable && !this._table.isEmpty()) {
      result.table = Expression.toJson(this._table);
    }
    if (this._hasKey && !this._key.isEmpty()) {
      result.key = Expression.toJson(this._key);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get table() {
    return this._hasTable ? this._table : Expression.default;
  }
  get hasTable() {
    return this._hasTable;
  }
  setTable(path, value) {
    return {type: 'SET', path: path.concat(['table']), value: value.toJson()};
  }
  deleteTable(path) {
    return {type: 'DELETE', path: path.concat(['table'])};
  }
  /**
   * @returns {Expression}
   */
  get key() {
    return this._hasKey ? this._key : Expression.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value: value.toJson()};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "table": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableRemoveStatement(this);
              copy._hasTable = true;
              copy._table = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTable) {
                return this;
              }
              const copy = new TableRemoveStatement(this);
              copy._hasTable = false;
              copy._table = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTable) {
            const copy = new TableRemoveStatement(this);
            copy._hasTable = true;
            copy._table = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._table.apply(type, path.slice(1), value);
          if (newValue === this._table) {
            return this;
          }
          const copy = new TableRemoveStatement(this);
          copy._table = copy._table.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableRemoveStatement(this);
              copy._hasKey = true;
              copy._key = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TableRemoveStatement(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasKey) {
            const copy = new TableRemoveStatement(this);
            copy._hasKey = true;
            copy._key = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._key.apply(type, path.slice(1), value);
          if (newValue === this._key) {
            return this;
          }
          const copy = new TableRemoveStatement(this);
          copy._key = copy._key.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TableRemoveStatement} other
   * @returns {TableRemoveStatement}
   */
  merge(other) {
    const copy = new TableRemoveStatement(this);
    if (other._hasTable) {
      if (copy._hasTable) {
        copy._table = copy.table.merge(other.table);
      } else {
        copy._table = other._table;
      }
      copy._hasTable = true;
    }
    if (other._hasKey) {
      if (copy._hasKey) {
        copy._key = copy.key.merge(other.key);
      } else {
        copy._key = other._key;
      }
      copy._hasKey = true;
    }
    return copy;
  }
}
TableRemoveStatement.default = new TableRemoveStatement();
class TableRemoveStatement_Builder {
  constructor(value) {
    this._value = new TableRemoveStatement(value);
  }
  build() {
    return new TableRemoveStatement(this._value);
  }
  setTable(value) {
    this._value._hasTable = true;
    this._value._table = value;
    return this;
  }
  deleteTable() {
    this._value._hasTable = false;
    this._value._table = null;
    return this;
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
}
TableRemoveStatement.Builder = TableRemoveStatement_Builder;
class TableRemoveStatement_WithParent {
  /**
   * @param {TableRemoveStatement} value
   * @param {TableRemoveStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TableRemoveStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTable() {
    if (this._cachedHasTable === undefined) {
      if (this._value.hasTable) {
        this._cachedHasTable = true;
      } else {
        this._cachedHasTable = this._parent ? this._parent.hasTable : false;
      }
    }
    return this._cachedHasTable;
  }
  get table() {
    if (!this._cachedTable) {
      if (this._value.hasTable) {
        this._cachedTable = new Expression.WithParent(this._value.table, this._parent && this._parent.hasTable ? this._parent.table : null);
      } else {
        this._cachedTable = this._parent ? new Expression.WithParent(Expression.default, this._parent.table) : Expression.WithParent.default;
      }
    }
    return this._cachedTable;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (!this._cachedKey) {
      if (this._value.hasKey) {
        this._cachedKey = new Expression.WithParent(this._value.key, this._parent && this._parent.hasKey ? this._parent.key : null);
      } else {
        this._cachedKey = this._parent ? new Expression.WithParent(Expression.default, this._parent.key) : Expression.WithParent.default;
      }
    }
    return this._cachedKey;
  }
  update(current, parent) {
    const result = new TableRemoveStatement_WithParent(current, parent);
    if (this._cachedTable && this._value.hasTable && current.hasTable) {
      if (this._value.table === current.table && this._parent === parent) {
        result._cachedTable = this._cachedTable;
      } else {
        result._cachedTable = this._cachedTable.update(current.table, parent && parent.hasTable ? parent.table : null);
      }
    }
    if (this._cachedKey && this._value.hasKey && current.hasKey) {
      if (this._value.key === current.key && this._parent === parent) {
        result._cachedKey = this._cachedKey;
      } else {
        result._cachedKey = this._cachedKey.update(current.key, parent && parent.hasKey ? parent.key : null);
      }
    }
    return result;
  }
}
TableRemoveStatement_WithParent.default = new TableRemoveStatement_WithParent(TableRemoveStatement.default, null);
TableRemoveStatement.WithParent = TableRemoveStatement_WithParent;
class TableRemoveStatement_Descriptor {
  get table() {
    if (!this._table) {
      this._table = {
        name: "table",
        Name: "Table",
        number: 1,
        protoType: 11,
        protoName: "table",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._table;
  }
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 2,
        protoType: 11,
        protoName: "key",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.table,
        this.key,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTable",
        Name: "DummyOneofForTable",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
TableRemoveStatement.descriptor = new TableRemoveStatement_Descriptor();
export class TableForEachStatement {
  get descriptor() {
    return TableForEachStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTable = false;
    this._table = null;
    this._hasKey = false;
    this._key = null;
    this._hasElement = false;
    this._element = null;
    this._body = [];
  }
  isEmpty() {
    if (this._hasTable && !this._table.isEmpty()) return false;
    if (this._hasKey && !this._key.isEmpty()) return false;
    if (this._hasElement && !this._element.isEmpty()) return false;
    if (this._body.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TableForEachStatement) {
      return value;
    }
    return TableForEachStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new TableForEachStatement();
    if (json.table != null) {
      result._hasTable = true;
      result._table = Expression.fromJson(json.table);
    }
    if (json.key != null) {
      result._hasKey = true;
      result._key = VariableRef.fromJson(json.key);
    }
    if (json.element != null) {
      result._hasElement = true;
      result._element = VariableRef.fromJson(json.element);
    }
    result._body = JsonToList(json.body, Statement);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTable && !this._table.isEmpty()) {
      result.table = Expression.toJson(this._table);
    }
    if (this._hasKey && !this._key.isEmpty()) {
      result.key = VariableRef.toJson(this._key);
    }
    if (this._hasElement && !this._element.isEmpty()) {
      result.element = VariableRef.toJson(this._element);
    }
    if (this._body.length > 0) {
      result.body = ArrayToJson(this._body, Statement);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get table() {
    return this._hasTable ? this._table : Expression.default;
  }
  get hasTable() {
    return this._hasTable;
  }
  setTable(path, value) {
    return {type: 'SET', path: path.concat(['table']), value: value.toJson()};
  }
  deleteTable(path) {
    return {type: 'DELETE', path: path.concat(['table'])};
  }
  /**
   * @returns {VariableRef}
   */
  get key() {
    return this._hasKey ? this._key : VariableRef.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value: value.toJson()};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {VariableRef}
   */
  get element() {
    return this._hasElement ? this._element : VariableRef.default;
  }
  get hasElement() {
    return this._hasElement;
  }
  setElement(path, value) {
    return {type: 'SET', path: path.concat(['element']), value: value.toJson()};
  }
  deleteElement(path) {
    return {type: 'DELETE', path: path.concat(['element'])};
  }
  /**
   * @returns {Statement[]}
   */
  get body() {
    return this._body;
  }
  addBody(path, value) {
    return {type: 'ADD', path: path.concat(['body']), value: value.toJson()};
  }
  setBody(path, value) {
    return {type: 'SET', path: path.concat(['body']), value: ArrayToJson(value, Statement)};
  }
  setBodyByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['body', key]), value: value.toJson()};
  }
  deleteBody(path) {
    return {type: 'DELETE', path: path.concat(['body'])};
  }
  deleteBodyByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['body', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "table": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableForEachStatement(this);
              copy._hasTable = true;
              copy._table = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTable) {
                return this;
              }
              const copy = new TableForEachStatement(this);
              copy._hasTable = false;
              copy._table = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTable) {
            const copy = new TableForEachStatement(this);
            copy._hasTable = true;
            copy._table = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._table.apply(type, path.slice(1), value);
          if (newValue === this._table) {
            return this;
          }
          const copy = new TableForEachStatement(this);
          copy._table = copy._table.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableForEachStatement(this);
              copy._hasKey = true;
              copy._key = VariableRef.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TableForEachStatement(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasKey) {
            const copy = new TableForEachStatement(this);
            copy._hasKey = true;
            copy._key = VariableRef.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._key.apply(type, path.slice(1), value);
          if (newValue === this._key) {
            return this;
          }
          const copy = new TableForEachStatement(this);
          copy._key = copy._key.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "element": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableForEachStatement(this);
              copy._hasElement = true;
              copy._element = VariableRef.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElement) {
                return this;
              }
              const copy = new TableForEachStatement(this);
              copy._hasElement = false;
              copy._element = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasElement) {
            const copy = new TableForEachStatement(this);
            copy._hasElement = true;
            copy._element = VariableRef.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._element.apply(type, path.slice(1), value);
          if (newValue === this._element) {
            return this;
          }
          const copy = new TableForEachStatement(this);
          copy._element = copy._element.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "body": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableForEachStatement(this);
              copy._body = [];        for (let i of value) {
                copy._body.push(Statement.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TableForEachStatement(this);
              copy._body = copy._body.concat([Statement.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._body.length === 0) {
                return this;
              }
              const copy = new TableForEachStatement(this);
              copy._body = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._body.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TableForEachStatement(this);
              copy._body = copy._body.slice();
              copy._body[path[1]] = Statement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TableForEachStatement(this);
              copy._body = copy._body.slice(0, path[1]).concat(copy._body.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._body.length) {
            return this;
          }
          const oldValue = this._body[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TableForEachStatement(this);
          copy._body = copy._body.slice();
          copy._body[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TableForEachStatement} other
   * @returns {TableForEachStatement}
   */
  merge(other) {
    const copy = new TableForEachStatement(this);
    if (other._hasTable) {
      if (copy._hasTable) {
        copy._table = copy.table.merge(other.table);
      } else {
        copy._table = other._table;
      }
      copy._hasTable = true;
    }
    if (other._hasKey) {
      if (copy._hasKey) {
        copy._key = copy.key.merge(other.key);
      } else {
        copy._key = other._key;
      }
      copy._hasKey = true;
    }
    if (other._hasElement) {
      if (copy._hasElement) {
        copy._element = copy.element.merge(other.element);
      } else {
        copy._element = other._element;
      }
      copy._hasElement = true;
    }
    copy._body = this._body.concat(other._body);
    return copy;
  }
}
TableForEachStatement.default = new TableForEachStatement();
class TableForEachStatement_Builder {
  constructor(value) {
    this._value = new TableForEachStatement(value);
  }
  build() {
    return new TableForEachStatement(this._value);
  }
  setTable(value) {
    this._value._hasTable = true;
    this._value._table = value;
    return this;
  }
  deleteTable() {
    this._value._hasTable = false;
    this._value._table = null;
    return this;
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setElement(value) {
    this._value._hasElement = true;
    this._value._element = value;
    return this;
  }
  deleteElement() {
    this._value._hasElement = false;
    this._value._element = null;
    return this;
  }
  addAllBody(values) {
    this._value._body = this._value._body.concat(values);
    return this;
  }
  addBody(value) {
    this._value._body = this._value._body.concat([value]);
    return this;
  }
  setBody(index, value) {
    this._value._body = this._value._body.concat();
    this._value._body[index] = value;
    return this;
  }
  clearBody() {
    this._value._body = [];
    return this;
  }
}
TableForEachStatement.Builder = TableForEachStatement_Builder;
class TableForEachStatement_WithParent {
  /**
   * @param {TableForEachStatement} value
   * @param {TableForEachStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TableForEachStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTable() {
    if (this._cachedHasTable === undefined) {
      if (this._value.hasTable) {
        this._cachedHasTable = true;
      } else {
        this._cachedHasTable = this._parent ? this._parent.hasTable : false;
      }
    }
    return this._cachedHasTable;
  }
  get table() {
    if (!this._cachedTable) {
      if (this._value.hasTable) {
        this._cachedTable = new Expression.WithParent(this._value.table, this._parent && this._parent.hasTable ? this._parent.table : null);
      } else {
        this._cachedTable = this._parent ? new Expression.WithParent(Expression.default, this._parent.table) : Expression.WithParent.default;
      }
    }
    return this._cachedTable;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (!this._cachedKey) {
      if (this._value.hasKey) {
        this._cachedKey = new VariableRef.WithParent(this._value.key, this._parent && this._parent.hasKey ? this._parent.key : null);
      } else {
        this._cachedKey = this._parent ? new VariableRef.WithParent(VariableRef.default, this._parent.key) : VariableRef.WithParent.default;
      }
    }
    return this._cachedKey;
  }
  get hasElement() {
    if (this._cachedHasElement === undefined) {
      if (this._value.hasElement) {
        this._cachedHasElement = true;
      } else {
        this._cachedHasElement = this._parent ? this._parent.hasElement : false;
      }
    }
    return this._cachedHasElement;
  }
  get element() {
    if (!this._cachedElement) {
      if (this._value.hasElement) {
        this._cachedElement = new VariableRef.WithParent(this._value.element, this._parent && this._parent.hasElement ? this._parent.element : null);
      } else {
        this._cachedElement = this._parent ? new VariableRef.WithParent(VariableRef.default, this._parent.element) : VariableRef.WithParent.default;
      }
    }
    return this._cachedElement;
  }
  get selfBody() {
    if (!this._selfBody) {
      this._selfBody = [];
      for (let i of this._value.body) {
        this._selfBody.push(new Statement.WithParent(i, null));
      }
    }
    return this._selfBody;
  }
  get inherentBody() {
    if (!this._inherentBody) {
      this._inherentBody = this._parent ? this._parent.body : [];
    }
    return this._inherentBody;
  }
  get body() {
    if (!this._allBody) {
      this._allBody = this._parent ? this._parent.body.concat(this.selfBody) : this.selfBody;
    }
    return this._allBody;
  }
  update(current, parent) {
    const result = new TableForEachStatement_WithParent(current, parent);
    if (this._cachedTable && this._value.hasTable && current.hasTable) {
      if (this._value.table === current.table && this._parent === parent) {
        result._cachedTable = this._cachedTable;
      } else {
        result._cachedTable = this._cachedTable.update(current.table, parent && parent.hasTable ? parent.table : null);
      }
    }
    if (this._cachedKey && this._value.hasKey && current.hasKey) {
      if (this._value.key === current.key && this._parent === parent) {
        result._cachedKey = this._cachedKey;
      } else {
        result._cachedKey = this._cachedKey.update(current.key, parent && parent.hasKey ? parent.key : null);
      }
    }
    if (this._cachedElement && this._value.hasElement && current.hasElement) {
      if (this._value.element === current.element && this._parent === parent) {
        result._cachedElement = this._cachedElement;
      } else {
        result._cachedElement = this._cachedElement.update(current.element, parent && parent.hasElement ? parent.element : null);
      }
    }
    if (this._selfBody) {
      if (this._value.body === current.body) {
        result._selfBody = this._selfBody;
      } else {
        result._selfBody = [];
        for (let i = 0; i < current.body.length; i++) {
          const oldValue = this._value.body[i];
          if (oldValue) {
            const oldCache = this._selfBody[i];
            if (oldValue === current.body[i]) {
              result._selfBody[i] = oldCache;
            } else {
              result._selfBody[i] = oldCache.update(current.body[i], null);
            }
          } else {
            result._selfBody[i] = new Statement.WithParent(current.body[i], null);
          }
        }
      }
    }
    return result;
  }
}
TableForEachStatement_WithParent.default = new TableForEachStatement_WithParent(TableForEachStatement.default, null);
TableForEachStatement.WithParent = TableForEachStatement_WithParent;
class TableForEachStatement_Descriptor {
  get table() {
    if (!this._table) {
      this._table = {
        name: "table",
        Name: "Table",
        number: 1,
        protoType: 11,
        protoName: "table",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._table;
  }
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 2,
        protoType: 11,
        protoName: "key",
        type: VariableRef,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get element() {
    if (!this._element) {
      this._element = {
        name: "element",
        Name: "Element",
        number: 3,
        protoType: 11,
        protoName: "element",
        type: VariableRef,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._element;
  }
  get body() {
    if (!this._body) {
      this._body = {
        name: "body",
        Name: "Body",
        number: 4,
        protoType: 11,
        protoName: "body",
        type: Statement,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._body;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.table,
        this.key,
        this.element,
        this.body,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTable",
        Name: "DummyOneofForTable",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForElement",
        Name: "DummyOneofForElement",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
TableForEachStatement.descriptor = new TableForEachStatement_Descriptor();
export class TableClearStatement {
  get descriptor() {
    return TableClearStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTable = false;
    this._table = null;
  }
  isEmpty() {
    if (this._hasTable && !this._table.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TableClearStatement) {
      return value;
    }
    return TableClearStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new TableClearStatement();
    if (json.table != null) {
      result._hasTable = true;
      result._table = VariableRef.fromJson(json.table);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTable && !this._table.isEmpty()) {
      result.table = VariableRef.toJson(this._table);
    }
    return result;
  }
  /**
   * @returns {VariableRef}
   */
  get table() {
    return this._hasTable ? this._table : VariableRef.default;
  }
  get hasTable() {
    return this._hasTable;
  }
  setTable(path, value) {
    return {type: 'SET', path: path.concat(['table']), value: value.toJson()};
  }
  deleteTable(path) {
    return {type: 'DELETE', path: path.concat(['table'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "table": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableClearStatement(this);
              copy._hasTable = true;
              copy._table = VariableRef.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTable) {
                return this;
              }
              const copy = new TableClearStatement(this);
              copy._hasTable = false;
              copy._table = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTable) {
            const copy = new TableClearStatement(this);
            copy._hasTable = true;
            copy._table = VariableRef.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._table.apply(type, path.slice(1), value);
          if (newValue === this._table) {
            return this;
          }
          const copy = new TableClearStatement(this);
          copy._table = copy._table.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TableClearStatement} other
   * @returns {TableClearStatement}
   */
  merge(other) {
    const copy = new TableClearStatement(this);
    if (other._hasTable) {
      if (copy._hasTable) {
        copy._table = copy.table.merge(other.table);
      } else {
        copy._table = other._table;
      }
      copy._hasTable = true;
    }
    return copy;
  }
}
TableClearStatement.default = new TableClearStatement();
class TableClearStatement_Builder {
  constructor(value) {
    this._value = new TableClearStatement(value);
  }
  build() {
    return new TableClearStatement(this._value);
  }
  setTable(value) {
    this._value._hasTable = true;
    this._value._table = value;
    return this;
  }
  deleteTable() {
    this._value._hasTable = false;
    this._value._table = null;
    return this;
  }
}
TableClearStatement.Builder = TableClearStatement_Builder;
class TableClearStatement_WithParent {
  /**
   * @param {TableClearStatement} value
   * @param {TableClearStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TableClearStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTable() {
    if (this._cachedHasTable === undefined) {
      if (this._value.hasTable) {
        this._cachedHasTable = true;
      } else {
        this._cachedHasTable = this._parent ? this._parent.hasTable : false;
      }
    }
    return this._cachedHasTable;
  }
  get table() {
    if (!this._cachedTable) {
      if (this._value.hasTable) {
        this._cachedTable = new VariableRef.WithParent(this._value.table, this._parent && this._parent.hasTable ? this._parent.table : null);
      } else {
        this._cachedTable = this._parent ? new VariableRef.WithParent(VariableRef.default, this._parent.table) : VariableRef.WithParent.default;
      }
    }
    return this._cachedTable;
  }
  update(current, parent) {
    const result = new TableClearStatement_WithParent(current, parent);
    if (this._cachedTable && this._value.hasTable && current.hasTable) {
      if (this._value.table === current.table && this._parent === parent) {
        result._cachedTable = this._cachedTable;
      } else {
        result._cachedTable = this._cachedTable.update(current.table, parent && parent.hasTable ? parent.table : null);
      }
    }
    return result;
  }
}
TableClearStatement_WithParent.default = new TableClearStatement_WithParent(TableClearStatement.default, null);
TableClearStatement.WithParent = TableClearStatement_WithParent;
class TableClearStatement_Descriptor {
  get table() {
    if (!this._table) {
      this._table = {
        name: "table",
        Name: "Table",
        number: 1,
        protoType: 11,
        protoName: "table",
        type: VariableRef,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._table;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.table,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTable",
        Name: "DummyOneofForTable",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
TableClearStatement.descriptor = new TableClearStatement_Descriptor();
export class TableStatement {
  get descriptor() {
    return TableStatement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._tableStatementTypeCase = 0;
    this._tableStatementTypeValue = null;
  }
  isEmpty() {
    if (this._tableStatementTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TableStatement) {
      return value;
    }
    return TableStatement.fromJson(value);
  }
  static fromJson(json) {
    const result = new TableStatement();
    if (json.set != null) {
      result._tableStatementTypeCase = 1;
      result._tableStatementTypeValue = TableSetStatement.fromJson(json.set);
    }
    if (json.remove != null) {
      result._tableStatementTypeCase = 2;
      result._tableStatementTypeValue = TableRemoveStatement.fromJson(json.remove);
    }
    if (json.forEach != null) {
      result._tableStatementTypeCase = 3;
      result._tableStatementTypeValue = TableForEachStatement.fromJson(json.forEach);
    }
    if (json.clear != null) {
      result._tableStatementTypeCase = 4;
      result._tableStatementTypeValue = TableClearStatement.fromJson(json.clear);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._tableStatementTypeCase) {
      case 1:
        result.set = TableSetStatement.toJson(this._tableStatementTypeValue);
        break;
      case 2:
        result.remove = TableRemoveStatement.toJson(this._tableStatementTypeValue);
        break;
      case 3:
        result.forEach = TableForEachStatement.toJson(this._tableStatementTypeValue);
        break;
      case 4:
        result.clear = TableClearStatement.toJson(this._tableStatementTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get tableStatementTypeCase() {
    return this._tableStatementTypeCase;
  }
  deleteTableStatementType(path) {
    switch (this._tableStatementTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['set'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['remove'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['forEach'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['clear'])};
      }
    }
  }
  /**
   * @returns {TableSetStatement}
   */
  get set() {
    return this._tableStatementTypeCase === 1 ? this._tableStatementTypeValue : TableSetStatement.default;
  }
  setSet(path, value) {
    return {type: 'SET', path: path.concat(['set']), value: value.toJson()};
  }
  deleteSet(path) {
    return {type: 'DELETE', path: path.concat(['set'])};
  }
  /**
   * @returns {TableRemoveStatement}
   */
  get remove() {
    return this._tableStatementTypeCase === 2 ? this._tableStatementTypeValue : TableRemoveStatement.default;
  }
  setRemove(path, value) {
    return {type: 'SET', path: path.concat(['remove']), value: value.toJson()};
  }
  deleteRemove(path) {
    return {type: 'DELETE', path: path.concat(['remove'])};
  }
  /**
   * @returns {TableForEachStatement}
   */
  get forEach() {
    return this._tableStatementTypeCase === 3 ? this._tableStatementTypeValue : TableForEachStatement.default;
  }
  setForEach(path, value) {
    return {type: 'SET', path: path.concat(['forEach']), value: value.toJson()};
  }
  deleteForEach(path) {
    return {type: 'DELETE', path: path.concat(['forEach'])};
  }
  /**
   * @returns {TableClearStatement}
   */
  get clear() {
    return this._tableStatementTypeCase === 4 ? this._tableStatementTypeValue : TableClearStatement.default;
  }
  setClear(path, value) {
    return {type: 'SET', path: path.concat(['clear']), value: value.toJson()};
  }
  deleteClear(path) {
    return {type: 'DELETE', path: path.concat(['clear'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "set": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableStatement(this);
              copy._tableStatementTypeCase = 1;
              copy._tableStatementTypeValue = TableSetStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._tableStatementTypeCase !== 1) {
                return this;
              }
              const copy = new TableStatement(this);
              copy._tableStatementTypeCase = 0;
              copy._tableStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._tableStatementTypeCase !== 1) {
            const copy = new TableStatement(this);
            copy._tableStatementTypeCase = 1;
            copy._tableStatementTypeValue = TableSetStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.set.apply(type, path.slice(1), value);
          if (newValue === this.set) {
            return this;
          }
          const copy = new TableStatement(this);
          copy._tableStatementTypeCase = 1;
          copy._tableStatementTypeValue = newValue;
          return copy;
        }
      }
      case "remove": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableStatement(this);
              copy._tableStatementTypeCase = 2;
              copy._tableStatementTypeValue = TableRemoveStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._tableStatementTypeCase !== 2) {
                return this;
              }
              const copy = new TableStatement(this);
              copy._tableStatementTypeCase = 0;
              copy._tableStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._tableStatementTypeCase !== 2) {
            const copy = new TableStatement(this);
            copy._tableStatementTypeCase = 2;
            copy._tableStatementTypeValue = TableRemoveStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.remove.apply(type, path.slice(1), value);
          if (newValue === this.remove) {
            return this;
          }
          const copy = new TableStatement(this);
          copy._tableStatementTypeCase = 2;
          copy._tableStatementTypeValue = newValue;
          return copy;
        }
      }
      case "forEach": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableStatement(this);
              copy._tableStatementTypeCase = 3;
              copy._tableStatementTypeValue = TableForEachStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._tableStatementTypeCase !== 3) {
                return this;
              }
              const copy = new TableStatement(this);
              copy._tableStatementTypeCase = 0;
              copy._tableStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._tableStatementTypeCase !== 3) {
            const copy = new TableStatement(this);
            copy._tableStatementTypeCase = 3;
            copy._tableStatementTypeValue = TableForEachStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.forEach.apply(type, path.slice(1), value);
          if (newValue === this.forEach) {
            return this;
          }
          const copy = new TableStatement(this);
          copy._tableStatementTypeCase = 3;
          copy._tableStatementTypeValue = newValue;
          return copy;
        }
      }
      case "clear": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TableStatement(this);
              copy._tableStatementTypeCase = 4;
              copy._tableStatementTypeValue = TableClearStatement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._tableStatementTypeCase !== 4) {
                return this;
              }
              const copy = new TableStatement(this);
              copy._tableStatementTypeCase = 0;
              copy._tableStatementTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._tableStatementTypeCase !== 4) {
            const copy = new TableStatement(this);
            copy._tableStatementTypeCase = 4;
            copy._tableStatementTypeValue = TableClearStatement.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.clear.apply(type, path.slice(1), value);
          if (newValue === this.clear) {
            return this;
          }
          const copy = new TableStatement(this);
          copy._tableStatementTypeCase = 4;
          copy._tableStatementTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TableStatement} other
   * @returns {TableStatement}
   */
  merge(other) {
    const copy = new TableStatement(this);
    if (other._tableStatementTypeCase === 1) {
      if (this._tableStatementTypeCase === 1) {
        copy._tableStatementTypeValue = copy._tableStatementTypeValue.merge(other._tableStatementTypeValue);
      } else {
        copy._tableStatementTypeValue = other._tableStatementTypeValue;
      }
      copy._tableStatementTypeCase = 1;
    }
    if (other._tableStatementTypeCase === 1) {
      if (this._tableStatementTypeCase === 1) {
        copy._tableStatementTypeValue = copy._tableStatementTypeValue.merge(other._tableStatementTypeValue);
      } else {
        copy._tableStatementTypeValue = other._tableStatementTypeValue;
      }
      copy._tableStatementTypeCase = 1;
    }
    if (other._tableStatementTypeCase === 1) {
      if (this._tableStatementTypeCase === 1) {
        copy._tableStatementTypeValue = copy._tableStatementTypeValue.merge(other._tableStatementTypeValue);
      } else {
        copy._tableStatementTypeValue = other._tableStatementTypeValue;
      }
      copy._tableStatementTypeCase = 1;
    }
    if (other._tableStatementTypeCase === 1) {
      if (this._tableStatementTypeCase === 1) {
        copy._tableStatementTypeValue = copy._tableStatementTypeValue.merge(other._tableStatementTypeValue);
      } else {
        copy._tableStatementTypeValue = other._tableStatementTypeValue;
      }
      copy._tableStatementTypeCase = 1;
    }
    return copy;
  }
}
TableStatement.default = new TableStatement();
class TableStatement_Builder {
  constructor(value) {
    this._value = new TableStatement(value);
  }
  build() {
    return new TableStatement(this._value);
  }
  cleartableStatementType() {
    this._value._tableStatementTypeCase = 0;
    this._value._tableStatementTypeValue = null;
    return this;
  }
  setSet(value) {
    this._value._tableStatementTypeCase = 1;
    this._value._tableStatementTypeValue = value;
    return this;
  }
  setRemove(value) {
    this._value._tableStatementTypeCase = 2;
    this._value._tableStatementTypeValue = value;
    return this;
  }
  setForEach(value) {
    this._value._tableStatementTypeCase = 3;
    this._value._tableStatementTypeValue = value;
    return this;
  }
  setClear(value) {
    this._value._tableStatementTypeCase = 4;
    this._value._tableStatementTypeValue = value;
    return this;
  }
}
TableStatement.Builder = TableStatement_Builder;
class TableStatement_WithParent {
  /**
   * @param {TableStatement} value
   * @param {TableStatement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TableStatement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get tableStatementTypeCase() {
    if (this._cachedtableStatementTypeCase === undefined) {
      if (this._value._tableStatementTypeCase === 0) {
        this._cachedtableStatementTypeCase = this._parent ? this._parent.tableStatementTypeCase : 0;
      } else {
        this._cachedtableStatementTypeCase = this._value._tableStatementTypeCase;
      }
    }
    return this._cachedtableStatementTypeCase;
  }
  get set() {
    if (!this._cachedSet) {
      if (this._value._tableStatementTypeCase === 0) {
        this._cachedSet = this._parent ? new TableSetStatement.WithParent(TableSetStatement.default, this._parent.set) : this._value.set;
      } else if (this._value._tableStatementTypeCase === 1) {
        this._cachedSet = new TableSetStatement.WithParent(this._value.set, this._parent && this._parent.tableStatementTypeCase === 1 ? this._parent.set : null);
      } else {
        this._cachedSet = TableSetStatement.WithParent.default;
      }
    }
    return this._cachedSet;
  }
  get remove() {
    if (!this._cachedRemove) {
      if (this._value._tableStatementTypeCase === 0) {
        this._cachedRemove = this._parent ? new TableRemoveStatement.WithParent(TableRemoveStatement.default, this._parent.remove) : this._value.remove;
      } else if (this._value._tableStatementTypeCase === 2) {
        this._cachedRemove = new TableRemoveStatement.WithParent(this._value.remove, this._parent && this._parent.tableStatementTypeCase === 2 ? this._parent.remove : null);
      } else {
        this._cachedRemove = TableRemoveStatement.WithParent.default;
      }
    }
    return this._cachedRemove;
  }
  get forEach() {
    if (!this._cachedForEach) {
      if (this._value._tableStatementTypeCase === 0) {
        this._cachedForEach = this._parent ? new TableForEachStatement.WithParent(TableForEachStatement.default, this._parent.forEach) : this._value.forEach;
      } else if (this._value._tableStatementTypeCase === 3) {
        this._cachedForEach = new TableForEachStatement.WithParent(this._value.forEach, this._parent && this._parent.tableStatementTypeCase === 3 ? this._parent.forEach : null);
      } else {
        this._cachedForEach = TableForEachStatement.WithParent.default;
      }
    }
    return this._cachedForEach;
  }
  get clear() {
    if (!this._cachedClear) {
      if (this._value._tableStatementTypeCase === 0) {
        this._cachedClear = this._parent ? new TableClearStatement.WithParent(TableClearStatement.default, this._parent.clear) : this._value.clear;
      } else if (this._value._tableStatementTypeCase === 4) {
        this._cachedClear = new TableClearStatement.WithParent(this._value.clear, this._parent && this._parent.tableStatementTypeCase === 4 ? this._parent.clear : null);
      } else {
        this._cachedClear = TableClearStatement.WithParent.default;
      }
    }
    return this._cachedClear;
  }
  update(current, parent) {
    const result = new TableStatement_WithParent(current, parent);
    if (this._cachedSet && this._value._tableStatementTypeCase === 1 && current._tableStatementTypeCase === 1) {
      if (this._value.set === current.set && this._parent === parent) {
        result._cachedSet = this._cachedSet;
      } else {
        result._cachedSet = this._cachedSet.update(current.set, parent && parent.tableStatementTypeCase === 1 ? parent.set : null);
      }
    }
    if (this._cachedRemove && this._value._tableStatementTypeCase === 2 && current._tableStatementTypeCase === 2) {
      if (this._value.remove === current.remove && this._parent === parent) {
        result._cachedRemove = this._cachedRemove;
      } else {
        result._cachedRemove = this._cachedRemove.update(current.remove, parent && parent.tableStatementTypeCase === 2 ? parent.remove : null);
      }
    }
    if (this._cachedForEach && this._value._tableStatementTypeCase === 3 && current._tableStatementTypeCase === 3) {
      if (this._value.forEach === current.forEach && this._parent === parent) {
        result._cachedForEach = this._cachedForEach;
      } else {
        result._cachedForEach = this._cachedForEach.update(current.forEach, parent && parent.tableStatementTypeCase === 3 ? parent.forEach : null);
      }
    }
    if (this._cachedClear && this._value._tableStatementTypeCase === 4 && current._tableStatementTypeCase === 4) {
      if (this._value.clear === current.clear && this._parent === parent) {
        result._cachedClear = this._cachedClear;
      } else {
        result._cachedClear = this._cachedClear.update(current.clear, parent && parent.tableStatementTypeCase === 4 ? parent.clear : null);
      }
    }
    return result;
  }
}
TableStatement_WithParent.default = new TableStatement_WithParent(TableStatement.default, null);
TableStatement.WithParent = TableStatement_WithParent;
class TableStatement_Descriptor {
  get set() {
    if (!this._set) {
      this._set = {
        name: "set",
        Name: "Set",
        number: 1,
        protoType: 11,
        protoName: "set",
        oneofIndex: 0,
        type: TableSetStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._set;
  }
  get remove() {
    if (!this._remove) {
      this._remove = {
        name: "remove",
        Name: "Remove",
        number: 2,
        protoType: 11,
        protoName: "remove",
        oneofIndex: 0,
        type: TableRemoveStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._remove;
  }
  get forEach() {
    if (!this._forEach) {
      this._forEach = {
        name: "forEach",
        Name: "ForEach",
        number: 3,
        protoType: 11,
        protoName: "for_each",
        oneofIndex: 0,
        type: TableForEachStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forEach;
  }
  get clear() {
    if (!this._clear) {
      this._clear = {
        name: "clear",
        Name: "Clear",
        number: 4,
        protoType: 11,
        protoName: "clear",
        oneofIndex: 0,
        type: TableClearStatement,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clear;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.set,
        this.remove,
        this.forEach,
        this.clear,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "tableStatementType",
        Name: "TableStatementType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
TableStatement.descriptor = new TableStatement_Descriptor();
export class ListenedEvent {
  get descriptor() {
    return ListenedEvent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEventName = false;
    this._eventName = null;
    this._parameters = [];
  }
  isEmpty() {
    if (this._hasEventName) return false;
    if (this._parameters.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ListenedEvent) {
      return value;
    }
    return ListenedEvent.fromJson(value);
  }
  static fromJson(json) {
    const result = new ListenedEvent();
    if (json.eventName != null) {
      result._hasEventName = true;
      result._eventName = JsonToString.fromJson(json.eventName);
    }
    result._parameters = JsonToList(json.parameters, VariableDefinition);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEventName) {
      result.eventName = JsonToString.toJson(this._eventName);
    }
    if (this._parameters.length > 0) {
      result.parameters = ArrayToJson(this._parameters, VariableDefinition);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get eventName() {
    return this._hasEventName ? this._eventName : JsonToString.default;
  }
  get hasEventName() {
    return this._hasEventName;
  }
  setEventName(path, value) {
    return {type: 'SET', path: path.concat(['eventName']), value};
  }
  deleteEventName(path) {
    return {type: 'DELETE', path: path.concat(['eventName'])};
  }
  /**
   * @returns {VariableDefinition[]}
   */
  get parameters() {
    return this._parameters;
  }
  addParameters(path, value) {
    return {type: 'ADD', path: path.concat(['parameters']), value: value.toJson()};
  }
  setParameters(path, value) {
    return {type: 'SET', path: path.concat(['parameters']), value: ArrayToJson(value, VariableDefinition)};
  }
  setParametersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['parameters', key]), value: value.toJson()};
  }
  deleteParameters(path) {
    return {type: 'DELETE', path: path.concat(['parameters'])};
  }
  deleteParametersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['parameters', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "eventName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ListenedEvent(this);
              copy._hasEventName = true;
              copy._eventName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventName) {
                return this;
              }
              const copy = new ListenedEvent(this);
              copy._hasEventName = false;
              copy._eventName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parameters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ListenedEvent(this);
              copy._parameters = [];        for (let i of value) {
                copy._parameters.push(VariableDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ListenedEvent(this);
              copy._parameters = copy._parameters.concat([VariableDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._parameters.length === 0) {
                return this;
              }
              const copy = new ListenedEvent(this);
              copy._parameters = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ListenedEvent(this);
              copy._parameters = copy._parameters.slice();
              copy._parameters[path[1]] = VariableDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ListenedEvent(this);
              copy._parameters = copy._parameters.slice(0, path[1]).concat(copy._parameters.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          const oldValue = this._parameters[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ListenedEvent(this);
          copy._parameters = copy._parameters.slice();
          copy._parameters[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ListenedEvent} other
   * @returns {ListenedEvent}
   */
  merge(other) {
    const copy = new ListenedEvent(this);
    if (other._hasEventName) {
      copy._hasEventName = true;
      copy._eventName = other._eventName;
    }
    copy._parameters = this._parameters.concat(other._parameters);
    return copy;
  }
}
ListenedEvent.default = new ListenedEvent();
class ListenedEvent_Builder {
  constructor(value) {
    this._value = new ListenedEvent(value);
  }
  build() {
    return new ListenedEvent(this._value);
  }
  setEventName(value) {
    this._value._hasEventName = true;
    this._value._eventName = value;
    return this;
  }
  deleteEventName() {
    this._value._hasEventName = false;
    this._value._eventName = null;
    return this;
  }
  addAllParameters(values) {
    this._value._parameters = this._value._parameters.concat(values);
    return this;
  }
  addParameters(value) {
    this._value._parameters = this._value._parameters.concat([value]);
    return this;
  }
  setParameters(index, value) {
    this._value._parameters = this._value._parameters.concat();
    this._value._parameters[index] = value;
    return this;
  }
  clearParameters() {
    this._value._parameters = [];
    return this;
  }
}
ListenedEvent.Builder = ListenedEvent_Builder;
class ListenedEvent_WithParent {
  /**
   * @param {ListenedEvent} value
   * @param {ListenedEvent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ListenedEvent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEventName() {
    if (this._cachedHasEventName === undefined) {
      if (this._value.hasEventName) {
        this._cachedHasEventName = true;
      } else {
        this._cachedHasEventName = this._parent ? this._parent.hasEventName : false;
      }
    }
    return this._cachedHasEventName;
  }
  get eventName() {
    if (this._cachedEventName === undefined) {
      if (this._value.hasEventName) {
        this._cachedEventName = this._value.eventName;
      } else {
        this._cachedEventName = this._parent ? this._parent.eventName : this._value.eventName;
      }
    }
    return this._cachedEventName;
  }
  get selfParameters() {
    if (!this._selfParameters) {
      this._selfParameters = [];
      for (let i of this._value.parameters) {
        this._selfParameters.push(new VariableDefinition.WithParent(i, null));
      }
    }
    return this._selfParameters;
  }
  get inherentParameters() {
    if (!this._inherentParameters) {
      this._inherentParameters = this._parent ? this._parent.parameters : [];
    }
    return this._inherentParameters;
  }
  get parameters() {
    if (!this._allParameters) {
      this._allParameters = this._parent ? this._parent.parameters.concat(this.selfParameters) : this.selfParameters;
    }
    return this._allParameters;
  }
  update(current, parent) {
    const result = new ListenedEvent_WithParent(current, parent);
    if (this._selfParameters) {
      if (this._value.parameters === current.parameters) {
        result._selfParameters = this._selfParameters;
      } else {
        result._selfParameters = [];
        for (let i = 0; i < current.parameters.length; i++) {
          const oldValue = this._value.parameters[i];
          if (oldValue) {
            const oldCache = this._selfParameters[i];
            if (oldValue === current.parameters[i]) {
              result._selfParameters[i] = oldCache;
            } else {
              result._selfParameters[i] = oldCache.update(current.parameters[i], null);
            }
          } else {
            result._selfParameters[i] = new VariableDefinition.WithParent(current.parameters[i], null);
          }
        }
      }
    }
    return result;
  }
}
ListenedEvent_WithParent.default = new ListenedEvent_WithParent(ListenedEvent.default, null);
ListenedEvent.WithParent = ListenedEvent_WithParent;
class ListenedEvent_Descriptor {
  get eventName() {
    if (!this._eventName) {
      this._eventName = {
        name: "eventName",
        Name: "EventName",
        number: 1,
        protoType: 9,
        protoName: "event_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventName;
  }
  get parameters() {
    if (!this._parameters) {
      this._parameters = {
        name: "parameters",
        Name: "Parameters",
        number: 2,
        protoType: 11,
        protoName: "parameters",
        type: VariableDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parameters;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.eventName,
        this.parameters,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEventName",
        Name: "DummyOneofForEventName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ListenedEvent.descriptor = new ListenedEvent_Descriptor();
export class TriggerParameter {
  get descriptor() {
    return TriggerParameter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TriggerParameter) {
      return value;
    }
    return TriggerParameter.fromJson(value);
  }
  static fromJson(json) {
    const result = new TriggerParameter();
    if (json.value != null) {
      result._hasValue = true;
      result._value = Expression.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = Expression.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {Expression}
   */
  get value() {
    return this._hasValue ? this._value : Expression.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerParameter(this);
              copy._hasValue = true;
              copy._value = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new TriggerParameter(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new TriggerParameter(this);
            copy._hasValue = true;
            copy._value = Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new TriggerParameter(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TriggerParameter} other
   * @returns {TriggerParameter}
   */
  merge(other) {
    const copy = new TriggerParameter(this);
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
TriggerParameter.default = new TriggerParameter();
class TriggerParameter_Builder {
  constructor(value) {
    this._value = new TriggerParameter(value);
  }
  build() {
    return new TriggerParameter(this._value);
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
TriggerParameter.Builder = TriggerParameter_Builder;
class TriggerParameter_WithParent {
  /**
   * @param {TriggerParameter} value
   * @param {TriggerParameter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TriggerParameter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new Expression.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new Expression.WithParent(Expression.default, this._parent.value) : Expression.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new TriggerParameter_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
TriggerParameter_WithParent.default = new TriggerParameter_WithParent(TriggerParameter.default, null);
TriggerParameter.WithParent = TriggerParameter_WithParent;
class TriggerParameter_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 11,
        protoName: "value",
        type: Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
TriggerParameter.descriptor = new TriggerParameter_Descriptor();
export class Trigger {
  get descriptor() {
    return Trigger.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEvent = false;
    this._event = null;
    this._parameters = [];
    this._localVariables = [];
    this._conditions = [];
    this._statements = [];
  }
  isEmpty() {
    if (this._hasEvent && !this._event.isEmpty()) return false;
    if (this._parameters.length > 0) return false;
    if (this._localVariables.length > 0) return false;
    if (this._conditions.length > 0) return false;
    if (this._statements.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Trigger) {
      return value;
    }
    return Trigger.fromJson(value);
  }
  static fromJson(json) {
    const result = new Trigger();
    if (json.event != null) {
      result._hasEvent = true;
      result._event = ListenedEvent.fromJson(json.event);
    }
    result._parameters = JsonToList(json.parameters, TriggerParameter);
    result._localVariables = JsonToList(json.localVariables, VariableDefinition);
    result._conditions = JsonToList(json.conditions, Expression);
    result._statements = JsonToList(json.statements, Statement);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEvent && !this._event.isEmpty()) {
      result.event = ListenedEvent.toJson(this._event);
    }
    if (this._parameters.length > 0) {
      result.parameters = ArrayToJson(this._parameters, TriggerParameter);
    }
    if (this._localVariables.length > 0) {
      result.localVariables = ArrayToJson(this._localVariables, VariableDefinition);
    }
    if (this._conditions.length > 0) {
      result.conditions = ArrayToJson(this._conditions, Expression);
    }
    if (this._statements.length > 0) {
      result.statements = ArrayToJson(this._statements, Statement);
    }
    return result;
  }
  /**
   * @returns {ListenedEvent}
   */
  get event() {
    return this._hasEvent ? this._event : ListenedEvent.default;
  }
  get hasEvent() {
    return this._hasEvent;
  }
  setEvent(path, value) {
    return {type: 'SET', path: path.concat(['event']), value: value.toJson()};
  }
  deleteEvent(path) {
    return {type: 'DELETE', path: path.concat(['event'])};
  }
  /**
   * @returns {TriggerParameter[]}
   */
  get parameters() {
    return this._parameters;
  }
  addParameters(path, value) {
    return {type: 'ADD', path: path.concat(['parameters']), value: value.toJson()};
  }
  setParameters(path, value) {
    return {type: 'SET', path: path.concat(['parameters']), value: ArrayToJson(value, TriggerParameter)};
  }
  setParametersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['parameters', key]), value: value.toJson()};
  }
  deleteParameters(path) {
    return {type: 'DELETE', path: path.concat(['parameters'])};
  }
  deleteParametersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['parameters', key])};
  }
  /**
   * @returns {VariableDefinition[]}
   */
  get localVariables() {
    return this._localVariables;
  }
  addLocalVariables(path, value) {
    return {type: 'ADD', path: path.concat(['localVariables']), value: value.toJson()};
  }
  setLocalVariables(path, value) {
    return {type: 'SET', path: path.concat(['localVariables']), value: ArrayToJson(value, VariableDefinition)};
  }
  setLocalVariablesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['localVariables', key]), value: value.toJson()};
  }
  deleteLocalVariables(path) {
    return {type: 'DELETE', path: path.concat(['localVariables'])};
  }
  deleteLocalVariablesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['localVariables', key])};
  }
  /**
   * @returns {Expression[]}
   */
  get conditions() {
    return this._conditions;
  }
  addConditions(path, value) {
    return {type: 'ADD', path: path.concat(['conditions']), value: value.toJson()};
  }
  setConditions(path, value) {
    return {type: 'SET', path: path.concat(['conditions']), value: ArrayToJson(value, Expression)};
  }
  setConditionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['conditions', key]), value: value.toJson()};
  }
  deleteConditions(path) {
    return {type: 'DELETE', path: path.concat(['conditions'])};
  }
  deleteConditionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['conditions', key])};
  }
  /**
   * @returns {Statement[]}
   */
  get statements() {
    return this._statements;
  }
  addStatements(path, value) {
    return {type: 'ADD', path: path.concat(['statements']), value: value.toJson()};
  }
  setStatements(path, value) {
    return {type: 'SET', path: path.concat(['statements']), value: ArrayToJson(value, Statement)};
  }
  setStatementsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['statements', key]), value: value.toJson()};
  }
  deleteStatements(path) {
    return {type: 'DELETE', path: path.concat(['statements'])};
  }
  deleteStatementsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['statements', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "event": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Trigger(this);
              copy._hasEvent = true;
              copy._event = ListenedEvent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEvent) {
                return this;
              }
              const copy = new Trigger(this);
              copy._hasEvent = false;
              copy._event = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEvent) {
            const copy = new Trigger(this);
            copy._hasEvent = true;
            copy._event = ListenedEvent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._event.apply(type, path.slice(1), value);
          if (newValue === this._event) {
            return this;
          }
          const copy = new Trigger(this);
          copy._event = copy._event.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "parameters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Trigger(this);
              copy._parameters = [];        for (let i of value) {
                copy._parameters.push(TriggerParameter.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Trigger(this);
              copy._parameters = copy._parameters.concat([TriggerParameter.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._parameters.length === 0) {
                return this;
              }
              const copy = new Trigger(this);
              copy._parameters = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Trigger(this);
              copy._parameters = copy._parameters.slice();
              copy._parameters[path[1]] = TriggerParameter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Trigger(this);
              copy._parameters = copy._parameters.slice(0, path[1]).concat(copy._parameters.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          const oldValue = this._parameters[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Trigger(this);
          copy._parameters = copy._parameters.slice();
          copy._parameters[key] = newValue;
          return copy;
        }
      }
      case "localVariables": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Trigger(this);
              copy._localVariables = [];        for (let i of value) {
                copy._localVariables.push(VariableDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Trigger(this);
              copy._localVariables = copy._localVariables.concat([VariableDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._localVariables.length === 0) {
                return this;
              }
              const copy = new Trigger(this);
              copy._localVariables = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._localVariables.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Trigger(this);
              copy._localVariables = copy._localVariables.slice();
              copy._localVariables[path[1]] = VariableDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Trigger(this);
              copy._localVariables = copy._localVariables.slice(0, path[1]).concat(copy._localVariables.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._localVariables.length) {
            return this;
          }
          const oldValue = this._localVariables[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Trigger(this);
          copy._localVariables = copy._localVariables.slice();
          copy._localVariables[key] = newValue;
          return copy;
        }
      }
      case "conditions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Trigger(this);
              copy._conditions = [];        for (let i of value) {
                copy._conditions.push(Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Trigger(this);
              copy._conditions = copy._conditions.concat([Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._conditions.length === 0) {
                return this;
              }
              const copy = new Trigger(this);
              copy._conditions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._conditions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Trigger(this);
              copy._conditions = copy._conditions.slice();
              copy._conditions[path[1]] = Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Trigger(this);
              copy._conditions = copy._conditions.slice(0, path[1]).concat(copy._conditions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._conditions.length) {
            return this;
          }
          const oldValue = this._conditions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Trigger(this);
          copy._conditions = copy._conditions.slice();
          copy._conditions[key] = newValue;
          return copy;
        }
      }
      case "statements": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Trigger(this);
              copy._statements = [];        for (let i of value) {
                copy._statements.push(Statement.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Trigger(this);
              copy._statements = copy._statements.concat([Statement.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._statements.length === 0) {
                return this;
              }
              const copy = new Trigger(this);
              copy._statements = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._statements.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Trigger(this);
              copy._statements = copy._statements.slice();
              copy._statements[path[1]] = Statement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Trigger(this);
              copy._statements = copy._statements.slice(0, path[1]).concat(copy._statements.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._statements.length) {
            return this;
          }
          const oldValue = this._statements[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Trigger(this);
          copy._statements = copy._statements.slice();
          copy._statements[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Trigger} other
   * @returns {Trigger}
   */
  merge(other) {
    const copy = new Trigger(this);
    if (other._hasEvent) {
      if (copy._hasEvent) {
        copy._event = copy.event.merge(other.event);
      } else {
        copy._event = other._event;
      }
      copy._hasEvent = true;
    }
    copy._parameters = this._parameters.concat(other._parameters);
    copy._localVariables = this._localVariables.concat(other._localVariables);
    copy._conditions = this._conditions.concat(other._conditions);
    copy._statements = this._statements.concat(other._statements);
    return copy;
  }
}
Trigger.default = new Trigger();
class Trigger_Builder {
  constructor(value) {
    this._value = new Trigger(value);
  }
  build() {
    return new Trigger(this._value);
  }
  setEvent(value) {
    this._value._hasEvent = true;
    this._value._event = value;
    return this;
  }
  deleteEvent() {
    this._value._hasEvent = false;
    this._value._event = null;
    return this;
  }
  addAllParameters(values) {
    this._value._parameters = this._value._parameters.concat(values);
    return this;
  }
  addParameters(value) {
    this._value._parameters = this._value._parameters.concat([value]);
    return this;
  }
  setParameters(index, value) {
    this._value._parameters = this._value._parameters.concat();
    this._value._parameters[index] = value;
    return this;
  }
  clearParameters() {
    this._value._parameters = [];
    return this;
  }
  addAllLocalVariables(values) {
    this._value._localVariables = this._value._localVariables.concat(values);
    return this;
  }
  addLocalVariables(value) {
    this._value._localVariables = this._value._localVariables.concat([value]);
    return this;
  }
  setLocalVariables(index, value) {
    this._value._localVariables = this._value._localVariables.concat();
    this._value._localVariables[index] = value;
    return this;
  }
  clearLocalVariables() {
    this._value._localVariables = [];
    return this;
  }
  addAllConditions(values) {
    this._value._conditions = this._value._conditions.concat(values);
    return this;
  }
  addConditions(value) {
    this._value._conditions = this._value._conditions.concat([value]);
    return this;
  }
  setConditions(index, value) {
    this._value._conditions = this._value._conditions.concat();
    this._value._conditions[index] = value;
    return this;
  }
  clearConditions() {
    this._value._conditions = [];
    return this;
  }
  addAllStatements(values) {
    this._value._statements = this._value._statements.concat(values);
    return this;
  }
  addStatements(value) {
    this._value._statements = this._value._statements.concat([value]);
    return this;
  }
  setStatements(index, value) {
    this._value._statements = this._value._statements.concat();
    this._value._statements[index] = value;
    return this;
  }
  clearStatements() {
    this._value._statements = [];
    return this;
  }
}
Trigger.Builder = Trigger_Builder;
class Trigger_WithParent {
  /**
   * @param {Trigger} value
   * @param {Trigger_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Trigger.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEvent() {
    if (this._cachedHasEvent === undefined) {
      if (this._value.hasEvent) {
        this._cachedHasEvent = true;
      } else {
        this._cachedHasEvent = this._parent ? this._parent.hasEvent : false;
      }
    }
    return this._cachedHasEvent;
  }
  get event() {
    if (!this._cachedEvent) {
      if (this._value.hasEvent) {
        this._cachedEvent = new ListenedEvent.WithParent(this._value.event, this._parent && this._parent.hasEvent ? this._parent.event : null);
      } else {
        this._cachedEvent = this._parent ? new ListenedEvent.WithParent(ListenedEvent.default, this._parent.event) : ListenedEvent.WithParent.default;
      }
    }
    return this._cachedEvent;
  }
  get selfParameters() {
    if (!this._selfParameters) {
      this._selfParameters = [];
      for (let i of this._value.parameters) {
        this._selfParameters.push(new TriggerParameter.WithParent(i, null));
      }
    }
    return this._selfParameters;
  }
  get inherentParameters() {
    if (!this._inherentParameters) {
      this._inherentParameters = this._parent ? this._parent.parameters : [];
    }
    return this._inherentParameters;
  }
  get parameters() {
    if (!this._allParameters) {
      this._allParameters = this._parent ? this._parent.parameters.concat(this.selfParameters) : this.selfParameters;
    }
    return this._allParameters;
  }
  get selfLocalVariables() {
    if (!this._selfLocalVariables) {
      this._selfLocalVariables = [];
      for (let i of this._value.localVariables) {
        this._selfLocalVariables.push(new VariableDefinition.WithParent(i, null));
      }
    }
    return this._selfLocalVariables;
  }
  get inherentLocalVariables() {
    if (!this._inherentLocalVariables) {
      this._inherentLocalVariables = this._parent ? this._parent.localVariables : [];
    }
    return this._inherentLocalVariables;
  }
  get localVariables() {
    if (!this._allLocalVariables) {
      this._allLocalVariables = this._parent ? this._parent.localVariables.concat(this.selfLocalVariables) : this.selfLocalVariables;
    }
    return this._allLocalVariables;
  }
  get selfConditions() {
    if (!this._selfConditions) {
      this._selfConditions = [];
      for (let i of this._value.conditions) {
        this._selfConditions.push(new Expression.WithParent(i, null));
      }
    }
    return this._selfConditions;
  }
  get inherentConditions() {
    if (!this._inherentConditions) {
      this._inherentConditions = this._parent ? this._parent.conditions : [];
    }
    return this._inherentConditions;
  }
  get conditions() {
    if (!this._allConditions) {
      this._allConditions = this._parent ? this._parent.conditions.concat(this.selfConditions) : this.selfConditions;
    }
    return this._allConditions;
  }
  get selfStatements() {
    if (!this._selfStatements) {
      this._selfStatements = [];
      for (let i of this._value.statements) {
        this._selfStatements.push(new Statement.WithParent(i, null));
      }
    }
    return this._selfStatements;
  }
  get inherentStatements() {
    if (!this._inherentStatements) {
      this._inherentStatements = this._parent ? this._parent.statements : [];
    }
    return this._inherentStatements;
  }
  get statements() {
    if (!this._allStatements) {
      this._allStatements = this._parent ? this._parent.statements.concat(this.selfStatements) : this.selfStatements;
    }
    return this._allStatements;
  }
  update(current, parent) {
    const result = new Trigger_WithParent(current, parent);
    if (this._cachedEvent && this._value.hasEvent && current.hasEvent) {
      if (this._value.event === current.event && this._parent === parent) {
        result._cachedEvent = this._cachedEvent;
      } else {
        result._cachedEvent = this._cachedEvent.update(current.event, parent && parent.hasEvent ? parent.event : null);
      }
    }
    if (this._selfParameters) {
      if (this._value.parameters === current.parameters) {
        result._selfParameters = this._selfParameters;
      } else {
        result._selfParameters = [];
        for (let i = 0; i < current.parameters.length; i++) {
          const oldValue = this._value.parameters[i];
          if (oldValue) {
            const oldCache = this._selfParameters[i];
            if (oldValue === current.parameters[i]) {
              result._selfParameters[i] = oldCache;
            } else {
              result._selfParameters[i] = oldCache.update(current.parameters[i], null);
            }
          } else {
            result._selfParameters[i] = new TriggerParameter.WithParent(current.parameters[i], null);
          }
        }
      }
    }
    if (this._selfLocalVariables) {
      if (this._value.localVariables === current.localVariables) {
        result._selfLocalVariables = this._selfLocalVariables;
      } else {
        result._selfLocalVariables = [];
        for (let i = 0; i < current.localVariables.length; i++) {
          const oldValue = this._value.localVariables[i];
          if (oldValue) {
            const oldCache = this._selfLocalVariables[i];
            if (oldValue === current.localVariables[i]) {
              result._selfLocalVariables[i] = oldCache;
            } else {
              result._selfLocalVariables[i] = oldCache.update(current.localVariables[i], null);
            }
          } else {
            result._selfLocalVariables[i] = new VariableDefinition.WithParent(current.localVariables[i], null);
          }
        }
      }
    }
    if (this._selfConditions) {
      if (this._value.conditions === current.conditions) {
        result._selfConditions = this._selfConditions;
      } else {
        result._selfConditions = [];
        for (let i = 0; i < current.conditions.length; i++) {
          const oldValue = this._value.conditions[i];
          if (oldValue) {
            const oldCache = this._selfConditions[i];
            if (oldValue === current.conditions[i]) {
              result._selfConditions[i] = oldCache;
            } else {
              result._selfConditions[i] = oldCache.update(current.conditions[i], null);
            }
          } else {
            result._selfConditions[i] = new Expression.WithParent(current.conditions[i], null);
          }
        }
      }
    }
    if (this._selfStatements) {
      if (this._value.statements === current.statements) {
        result._selfStatements = this._selfStatements;
      } else {
        result._selfStatements = [];
        for (let i = 0; i < current.statements.length; i++) {
          const oldValue = this._value.statements[i];
          if (oldValue) {
            const oldCache = this._selfStatements[i];
            if (oldValue === current.statements[i]) {
              result._selfStatements[i] = oldCache;
            } else {
              result._selfStatements[i] = oldCache.update(current.statements[i], null);
            }
          } else {
            result._selfStatements[i] = new Statement.WithParent(current.statements[i], null);
          }
        }
      }
    }
    return result;
  }
}
Trigger_WithParent.default = new Trigger_WithParent(Trigger.default, null);
Trigger.WithParent = Trigger_WithParent;
class Trigger_Descriptor {
  get event() {
    if (!this._event) {
      this._event = {
        name: "event",
        Name: "Event",
        number: 1,
        protoType: 11,
        protoName: "event",
        type: ListenedEvent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._event;
  }
  get parameters() {
    if (!this._parameters) {
      this._parameters = {
        name: "parameters",
        Name: "Parameters",
        number: 2,
        protoType: 11,
        protoName: "parameters",
        type: TriggerParameter,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parameters;
  }
  get localVariables() {
    if (!this._localVariables) {
      this._localVariables = {
        name: "localVariables",
        Name: "LocalVariables",
        number: 3,
        protoType: 11,
        protoName: "local_variables",
        type: VariableDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._localVariables;
  }
  get conditions() {
    if (!this._conditions) {
      this._conditions = {
        name: "conditions",
        Name: "Conditions",
        number: 4,
        protoType: 11,
        protoName: "conditions",
        type: Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._conditions;
  }
  get statements() {
    if (!this._statements) {
      this._statements = {
        name: "statements",
        Name: "Statements",
        number: 5,
        protoType: 11,
        protoName: "statements",
        type: Statement,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._statements;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.event,
        this.parameters,
        this.localVariables,
        this.conditions,
        this.statements,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEvent",
        Name: "DummyOneofForEvent",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
Trigger.descriptor = new Trigger_Descriptor();
export class CustomFunctionDefinition {
  get descriptor() {
    return CustomFunctionDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasInstanceId = false;
    this._instanceId = null;
    this._hasName = false;
    this._name = null;
    this._parameters = [];
    this._hasReturnType = false;
    this._returnType = null;
    this._hasReturnStringType = false;
    this._returnStringType = null;
    this._hasReturnVariableType = false;
    this._returnVariableType = null;
    this._localVariables = [];
    this._statements = [];
  }
  isEmpty() {
    if (this._hasInstanceId) return false;
    if (this._hasName) return false;
    if (this._parameters.length > 0) return false;
    if (this._hasReturnType) return false;
    if (this._hasReturnStringType) return false;
    if (this._hasReturnVariableType) return false;
    if (this._localVariables.length > 0) return false;
    if (this._statements.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CustomFunctionDefinition) {
      return value;
    }
    return CustomFunctionDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new CustomFunctionDefinition();
    if (json.instanceId != null) {
      result._hasInstanceId = true;
      result._instanceId = JsonToString.fromJson(json.instanceId);
    }
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    result._parameters = JsonToList(json.parameters, VariableDefinition);
    if (json.returnType != null) {
      result._hasReturnType = true;
      result._returnType = ValueType.fromJson(json.returnType);
    }
    if (json.returnStringType != null) {
      result._hasReturnStringType = true;
      result._returnStringType = JsonToString.fromJson(json.returnStringType);
    }
    if (json.returnVariableType != null) {
      result._hasReturnVariableType = true;
      result._returnVariableType = VariableType.fromJson(json.returnVariableType);
    }
    result._localVariables = JsonToList(json.localVariables, VariableDefinition);
    result._statements = JsonToList(json.statements, Statement);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasInstanceId) {
      result.instanceId = JsonToString.toJson(this._instanceId);
    }
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._parameters.length > 0) {
      result.parameters = ArrayToJson(this._parameters, VariableDefinition);
    }
    if (this._hasReturnType) {
      result.returnType = ValueType.toJson(this._returnType);
    }
    if (this._hasReturnStringType) {
      result.returnStringType = JsonToString.toJson(this._returnStringType);
    }
    if (this._hasReturnVariableType) {
      result.returnVariableType = VariableType.toJson(this._returnVariableType);
    }
    if (this._localVariables.length > 0) {
      result.localVariables = ArrayToJson(this._localVariables, VariableDefinition);
    }
    if (this._statements.length > 0) {
      result.statements = ArrayToJson(this._statements, Statement);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get instanceId() {
    return this._hasInstanceId ? this._instanceId : JsonToString.default;
  }
  get hasInstanceId() {
    return this._hasInstanceId;
  }
  setInstanceId(path, value) {
    return {type: 'SET', path: path.concat(['instanceId']), value};
  }
  deleteInstanceId(path) {
    return {type: 'DELETE', path: path.concat(['instanceId'])};
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {VariableDefinition[]}
   */
  get parameters() {
    return this._parameters;
  }
  addParameters(path, value) {
    return {type: 'ADD', path: path.concat(['parameters']), value: value.toJson()};
  }
  setParameters(path, value) {
    return {type: 'SET', path: path.concat(['parameters']), value: ArrayToJson(value, VariableDefinition)};
  }
  setParametersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['parameters', key]), value: value.toJson()};
  }
  deleteParameters(path) {
    return {type: 'DELETE', path: path.concat(['parameters'])};
  }
  deleteParametersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['parameters', key])};
  }
  /**
   * @returns {number}
   */
  get returnType() {
    return this._hasReturnType ? this._returnType : ValueType.default;
  }
  get hasReturnType() {
    return this._hasReturnType;
  }
  setReturnType(path, value) {
    return {type: 'SET', path: path.concat(['returnType']), value};
  }
  deleteReturnType(path) {
    return {type: 'DELETE', path: path.concat(['returnType'])};
  }
  /**
   * @returns {string}
   */
  get returnStringType() {
    return this._hasReturnStringType ? this._returnStringType : JsonToString.default;
  }
  get hasReturnStringType() {
    return this._hasReturnStringType;
  }
  setReturnStringType(path, value) {
    return {type: 'SET', path: path.concat(['returnStringType']), value};
  }
  deleteReturnStringType(path) {
    return {type: 'DELETE', path: path.concat(['returnStringType'])};
  }
  /**
   * @returns {number}
   */
  get returnVariableType() {
    return this._hasReturnVariableType ? this._returnVariableType : VariableType.default;
  }
  get hasReturnVariableType() {
    return this._hasReturnVariableType;
  }
  setReturnVariableType(path, value) {
    return {type: 'SET', path: path.concat(['returnVariableType']), value};
  }
  deleteReturnVariableType(path) {
    return {type: 'DELETE', path: path.concat(['returnVariableType'])};
  }
  /**
   * @returns {VariableDefinition[]}
   */
  get localVariables() {
    return this._localVariables;
  }
  addLocalVariables(path, value) {
    return {type: 'ADD', path: path.concat(['localVariables']), value: value.toJson()};
  }
  setLocalVariables(path, value) {
    return {type: 'SET', path: path.concat(['localVariables']), value: ArrayToJson(value, VariableDefinition)};
  }
  setLocalVariablesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['localVariables', key]), value: value.toJson()};
  }
  deleteLocalVariables(path) {
    return {type: 'DELETE', path: path.concat(['localVariables'])};
  }
  deleteLocalVariablesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['localVariables', key])};
  }
  /**
   * @returns {Statement[]}
   */
  get statements() {
    return this._statements;
  }
  addStatements(path, value) {
    return {type: 'ADD', path: path.concat(['statements']), value: value.toJson()};
  }
  setStatements(path, value) {
    return {type: 'SET', path: path.concat(['statements']), value: ArrayToJson(value, Statement)};
  }
  setStatementsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['statements', key]), value: value.toJson()};
  }
  deleteStatements(path) {
    return {type: 'DELETE', path: path.concat(['statements'])};
  }
  deleteStatementsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['statements', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "instanceId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._hasInstanceId = true;
              copy._instanceId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInstanceId) {
                return this;
              }
              const copy = new CustomFunctionDefinition(this);
              copy._hasInstanceId = false;
              copy._instanceId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new CustomFunctionDefinition(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parameters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._parameters = [];        for (let i of value) {
                copy._parameters.push(VariableDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CustomFunctionDefinition(this);
              copy._parameters = copy._parameters.concat([VariableDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._parameters.length === 0) {
                return this;
              }
              const copy = new CustomFunctionDefinition(this);
              copy._parameters = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._parameters = copy._parameters.slice();
              copy._parameters[path[1]] = VariableDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CustomFunctionDefinition(this);
              copy._parameters = copy._parameters.slice(0, path[1]).concat(copy._parameters.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._parameters.length) {
            return this;
          }
          const oldValue = this._parameters[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CustomFunctionDefinition(this);
          copy._parameters = copy._parameters.slice();
          copy._parameters[key] = newValue;
          return copy;
        }
      }
      case "returnType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._hasReturnType = true;
              copy._returnType = ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReturnType) {
                return this;
              }
              const copy = new CustomFunctionDefinition(this);
              copy._hasReturnType = false;
              copy._returnType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "returnStringType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._hasReturnStringType = true;
              copy._returnStringType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReturnStringType) {
                return this;
              }
              const copy = new CustomFunctionDefinition(this);
              copy._hasReturnStringType = false;
              copy._returnStringType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "returnVariableType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._hasReturnVariableType = true;
              copy._returnVariableType = VariableType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReturnVariableType) {
                return this;
              }
              const copy = new CustomFunctionDefinition(this);
              copy._hasReturnVariableType = false;
              copy._returnVariableType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "localVariables": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._localVariables = [];        for (let i of value) {
                copy._localVariables.push(VariableDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CustomFunctionDefinition(this);
              copy._localVariables = copy._localVariables.concat([VariableDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._localVariables.length === 0) {
                return this;
              }
              const copy = new CustomFunctionDefinition(this);
              copy._localVariables = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._localVariables.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._localVariables = copy._localVariables.slice();
              copy._localVariables[path[1]] = VariableDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CustomFunctionDefinition(this);
              copy._localVariables = copy._localVariables.slice(0, path[1]).concat(copy._localVariables.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._localVariables.length) {
            return this;
          }
          const oldValue = this._localVariables[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CustomFunctionDefinition(this);
          copy._localVariables = copy._localVariables.slice();
          copy._localVariables[key] = newValue;
          return copy;
        }
      }
      case "statements": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._statements = [];        for (let i of value) {
                copy._statements.push(Statement.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CustomFunctionDefinition(this);
              copy._statements = copy._statements.concat([Statement.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._statements.length === 0) {
                return this;
              }
              const copy = new CustomFunctionDefinition(this);
              copy._statements = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._statements.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CustomFunctionDefinition(this);
              copy._statements = copy._statements.slice();
              copy._statements[path[1]] = Statement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CustomFunctionDefinition(this);
              copy._statements = copy._statements.slice(0, path[1]).concat(copy._statements.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._statements.length) {
            return this;
          }
          const oldValue = this._statements[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CustomFunctionDefinition(this);
          copy._statements = copy._statements.slice();
          copy._statements[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CustomFunctionDefinition} other
   * @returns {CustomFunctionDefinition}
   */
  merge(other) {
    const copy = new CustomFunctionDefinition(this);
    if (other._hasInstanceId) {
      copy._hasInstanceId = true;
      copy._instanceId = other._instanceId;
    }
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    copy._parameters = this._parameters.concat(other._parameters);
    if (other._hasReturnType) {
      copy._hasReturnType = true;
      copy._returnType = other._returnType;
    }
    if (other._hasReturnStringType) {
      copy._hasReturnStringType = true;
      copy._returnStringType = other._returnStringType;
    }
    if (other._hasReturnVariableType) {
      copy._hasReturnVariableType = true;
      copy._returnVariableType = other._returnVariableType;
    }
    copy._localVariables = this._localVariables.concat(other._localVariables);
    copy._statements = this._statements.concat(other._statements);
    return copy;
  }
}
CustomFunctionDefinition.default = new CustomFunctionDefinition();
class CustomFunctionDefinition_Builder {
  constructor(value) {
    this._value = new CustomFunctionDefinition(value);
  }
  build() {
    return new CustomFunctionDefinition(this._value);
  }
  setInstanceId(value) {
    this._value._hasInstanceId = true;
    this._value._instanceId = value;
    return this;
  }
  deleteInstanceId() {
    this._value._hasInstanceId = false;
    this._value._instanceId = null;
    return this;
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  addAllParameters(values) {
    this._value._parameters = this._value._parameters.concat(values);
    return this;
  }
  addParameters(value) {
    this._value._parameters = this._value._parameters.concat([value]);
    return this;
  }
  setParameters(index, value) {
    this._value._parameters = this._value._parameters.concat();
    this._value._parameters[index] = value;
    return this;
  }
  clearParameters() {
    this._value._parameters = [];
    return this;
  }
  setReturnType(value) {
    this._value._hasReturnType = true;
    this._value._returnType = value;
    return this;
  }
  deleteReturnType() {
    this._value._hasReturnType = false;
    this._value._returnType = null;
    return this;
  }
  setReturnStringType(value) {
    this._value._hasReturnStringType = true;
    this._value._returnStringType = value;
    return this;
  }
  deleteReturnStringType() {
    this._value._hasReturnStringType = false;
    this._value._returnStringType = null;
    return this;
  }
  setReturnVariableType(value) {
    this._value._hasReturnVariableType = true;
    this._value._returnVariableType = value;
    return this;
  }
  deleteReturnVariableType() {
    this._value._hasReturnVariableType = false;
    this._value._returnVariableType = null;
    return this;
  }
  addAllLocalVariables(values) {
    this._value._localVariables = this._value._localVariables.concat(values);
    return this;
  }
  addLocalVariables(value) {
    this._value._localVariables = this._value._localVariables.concat([value]);
    return this;
  }
  setLocalVariables(index, value) {
    this._value._localVariables = this._value._localVariables.concat();
    this._value._localVariables[index] = value;
    return this;
  }
  clearLocalVariables() {
    this._value._localVariables = [];
    return this;
  }
  addAllStatements(values) {
    this._value._statements = this._value._statements.concat(values);
    return this;
  }
  addStatements(value) {
    this._value._statements = this._value._statements.concat([value]);
    return this;
  }
  setStatements(index, value) {
    this._value._statements = this._value._statements.concat();
    this._value._statements[index] = value;
    return this;
  }
  clearStatements() {
    this._value._statements = [];
    return this;
  }
}
CustomFunctionDefinition.Builder = CustomFunctionDefinition_Builder;
class CustomFunctionDefinition_WithParent {
  /**
   * @param {CustomFunctionDefinition} value
   * @param {CustomFunctionDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CustomFunctionDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasInstanceId() {
    if (this._cachedHasInstanceId === undefined) {
      if (this._value.hasInstanceId) {
        this._cachedHasInstanceId = true;
      } else {
        this._cachedHasInstanceId = this._parent ? this._parent.hasInstanceId : false;
      }
    }
    return this._cachedHasInstanceId;
  }
  get instanceId() {
    if (this._cachedInstanceId === undefined) {
      if (this._value.hasInstanceId) {
        this._cachedInstanceId = this._value.instanceId;
      } else {
        this._cachedInstanceId = this._parent ? this._parent.instanceId : this._value.instanceId;
      }
    }
    return this._cachedInstanceId;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get selfParameters() {
    if (!this._selfParameters) {
      this._selfParameters = [];
      for (let i of this._value.parameters) {
        this._selfParameters.push(new VariableDefinition.WithParent(i, null));
      }
    }
    return this._selfParameters;
  }
  get inherentParameters() {
    if (!this._inherentParameters) {
      this._inherentParameters = this._parent ? this._parent.parameters : [];
    }
    return this._inherentParameters;
  }
  get parameters() {
    if (!this._allParameters) {
      this._allParameters = this._parent ? this._parent.parameters.concat(this.selfParameters) : this.selfParameters;
    }
    return this._allParameters;
  }
  get hasReturnType() {
    if (this._cachedHasReturnType === undefined) {
      if (this._value.hasReturnType) {
        this._cachedHasReturnType = true;
      } else {
        this._cachedHasReturnType = this._parent ? this._parent.hasReturnType : false;
      }
    }
    return this._cachedHasReturnType;
  }
  get returnType() {
    if (this._cachedReturnType === undefined) {
      if (this._value.hasReturnType) {
        this._cachedReturnType = this._value.returnType;
      } else {
        this._cachedReturnType = this._parent ? this._parent.returnType : this._value.returnType;
      }
    }
    return this._cachedReturnType;
  }
  get hasReturnStringType() {
    if (this._cachedHasReturnStringType === undefined) {
      if (this._value.hasReturnStringType) {
        this._cachedHasReturnStringType = true;
      } else {
        this._cachedHasReturnStringType = this._parent ? this._parent.hasReturnStringType : false;
      }
    }
    return this._cachedHasReturnStringType;
  }
  get returnStringType() {
    if (this._cachedReturnStringType === undefined) {
      if (this._value.hasReturnStringType) {
        this._cachedReturnStringType = this._value.returnStringType;
      } else {
        this._cachedReturnStringType = this._parent ? this._parent.returnStringType : this._value.returnStringType;
      }
    }
    return this._cachedReturnStringType;
  }
  get hasReturnVariableType() {
    if (this._cachedHasReturnVariableType === undefined) {
      if (this._value.hasReturnVariableType) {
        this._cachedHasReturnVariableType = true;
      } else {
        this._cachedHasReturnVariableType = this._parent ? this._parent.hasReturnVariableType : false;
      }
    }
    return this._cachedHasReturnVariableType;
  }
  get returnVariableType() {
    if (this._cachedReturnVariableType === undefined) {
      if (this._value.hasReturnVariableType) {
        this._cachedReturnVariableType = this._value.returnVariableType;
      } else {
        this._cachedReturnVariableType = this._parent ? this._parent.returnVariableType : this._value.returnVariableType;
      }
    }
    return this._cachedReturnVariableType;
  }
  get selfLocalVariables() {
    if (!this._selfLocalVariables) {
      this._selfLocalVariables = [];
      for (let i of this._value.localVariables) {
        this._selfLocalVariables.push(new VariableDefinition.WithParent(i, null));
      }
    }
    return this._selfLocalVariables;
  }
  get inherentLocalVariables() {
    if (!this._inherentLocalVariables) {
      this._inherentLocalVariables = this._parent ? this._parent.localVariables : [];
    }
    return this._inherentLocalVariables;
  }
  get localVariables() {
    if (!this._allLocalVariables) {
      this._allLocalVariables = this._parent ? this._parent.localVariables.concat(this.selfLocalVariables) : this.selfLocalVariables;
    }
    return this._allLocalVariables;
  }
  get selfStatements() {
    if (!this._selfStatements) {
      this._selfStatements = [];
      for (let i of this._value.statements) {
        this._selfStatements.push(new Statement.WithParent(i, null));
      }
    }
    return this._selfStatements;
  }
  get inherentStatements() {
    if (!this._inherentStatements) {
      this._inherentStatements = this._parent ? this._parent.statements : [];
    }
    return this._inherentStatements;
  }
  get statements() {
    if (!this._allStatements) {
      this._allStatements = this._parent ? this._parent.statements.concat(this.selfStatements) : this.selfStatements;
    }
    return this._allStatements;
  }
  update(current, parent) {
    const result = new CustomFunctionDefinition_WithParent(current, parent);
    if (this._selfParameters) {
      if (this._value.parameters === current.parameters) {
        result._selfParameters = this._selfParameters;
      } else {
        result._selfParameters = [];
        for (let i = 0; i < current.parameters.length; i++) {
          const oldValue = this._value.parameters[i];
          if (oldValue) {
            const oldCache = this._selfParameters[i];
            if (oldValue === current.parameters[i]) {
              result._selfParameters[i] = oldCache;
            } else {
              result._selfParameters[i] = oldCache.update(current.parameters[i], null);
            }
          } else {
            result._selfParameters[i] = new VariableDefinition.WithParent(current.parameters[i], null);
          }
        }
      }
    }
    if (this._selfLocalVariables) {
      if (this._value.localVariables === current.localVariables) {
        result._selfLocalVariables = this._selfLocalVariables;
      } else {
        result._selfLocalVariables = [];
        for (let i = 0; i < current.localVariables.length; i++) {
          const oldValue = this._value.localVariables[i];
          if (oldValue) {
            const oldCache = this._selfLocalVariables[i];
            if (oldValue === current.localVariables[i]) {
              result._selfLocalVariables[i] = oldCache;
            } else {
              result._selfLocalVariables[i] = oldCache.update(current.localVariables[i], null);
            }
          } else {
            result._selfLocalVariables[i] = new VariableDefinition.WithParent(current.localVariables[i], null);
          }
        }
      }
    }
    if (this._selfStatements) {
      if (this._value.statements === current.statements) {
        result._selfStatements = this._selfStatements;
      } else {
        result._selfStatements = [];
        for (let i = 0; i < current.statements.length; i++) {
          const oldValue = this._value.statements[i];
          if (oldValue) {
            const oldCache = this._selfStatements[i];
            if (oldValue === current.statements[i]) {
              result._selfStatements[i] = oldCache;
            } else {
              result._selfStatements[i] = oldCache.update(current.statements[i], null);
            }
          } else {
            result._selfStatements[i] = new Statement.WithParent(current.statements[i], null);
          }
        }
      }
    }
    return result;
  }
}
CustomFunctionDefinition_WithParent.default = new CustomFunctionDefinition_WithParent(CustomFunctionDefinition.default, null);
CustomFunctionDefinition.WithParent = CustomFunctionDefinition_WithParent;
class CustomFunctionDefinition_Descriptor {
  get instanceId() {
    if (!this._instanceId) {
      this._instanceId = {
        name: "instanceId",
        Name: "InstanceId",
        number: 1,
        protoType: 9,
        protoName: "instance_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._instanceId;
  }
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 2,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get parameters() {
    if (!this._parameters) {
      this._parameters = {
        name: "parameters",
        Name: "Parameters",
        number: 3,
        protoType: 11,
        protoName: "parameters",
        type: VariableDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parameters;
  }
  get returnType() {
    if (!this._returnType) {
      this._returnType = {
        name: "returnType",
        Name: "ReturnType",
        number: 4,
        protoType: 14,
        protoName: "return_type",
        type: ValueType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._returnType;
  }
  get returnStringType() {
    if (!this._returnStringType) {
      this._returnStringType = {
        name: "returnStringType",
        Name: "ReturnStringType",
        number: 8,
        protoType: 9,
        protoName: "return_string_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._returnStringType;
  }
  get returnVariableType() {
    if (!this._returnVariableType) {
      this._returnVariableType = {
        name: "returnVariableType",
        Name: "ReturnVariableType",
        number: 7,
        protoType: 14,
        protoName: "return_variable_type",
        type: VariableType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._returnVariableType;
  }
  get localVariables() {
    if (!this._localVariables) {
      this._localVariables = {
        name: "localVariables",
        Name: "LocalVariables",
        number: 5,
        protoType: 11,
        protoName: "local_variables",
        type: VariableDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._localVariables;
  }
  get statements() {
    if (!this._statements) {
      this._statements = {
        name: "statements",
        Name: "Statements",
        number: 6,
        protoType: 11,
        protoName: "statements",
        type: Statement,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._statements;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.instanceId,
        this.name,
        this.parameters,
        this.returnType,
        this.returnStringType,
        this.returnVariableType,
        this.localVariables,
        this.statements,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForInstanceId",
        Name: "DummyOneofForInstanceId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReturnType",
        Name: "DummyOneofForReturnType",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReturnStringType",
        Name: "DummyOneofForReturnStringType",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReturnVariableType",
        Name: "DummyOneofForReturnVariableType",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
CustomFunctionDefinition.descriptor = new CustomFunctionDefinition_Descriptor();
class CompositeTypeDefinition_AssociatedTriggerDataType {
  get descriptor() {
    return CompositeTypeDefinition_AssociatedTriggerDataType.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasType = false;
    this._type = null;
  }
  isEmpty() {
    if (this._hasType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CompositeTypeDefinition_AssociatedTriggerDataType) {
      return value;
    }
    return CompositeTypeDefinition_AssociatedTriggerDataType.fromJson(value);
  }
  static fromJson(json) {
    const result = new CompositeTypeDefinition_AssociatedTriggerDataType();
    if (json.type != null) {
      result._hasType = true;
      result._type = TypeDeclaration_TriggerDataType.fromJson(json.type);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasType) {
      result.type = TypeDeclaration_TriggerDataType.toJson(this._type);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get type() {
    return this._hasType ? this._type : TypeDeclaration_TriggerDataType.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CompositeTypeDefinition_AssociatedTriggerDataType(this);
              copy._hasType = true;
              copy._type = TypeDeclaration_TriggerDataType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new CompositeTypeDefinition_AssociatedTriggerDataType(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CompositeTypeDefinition_AssociatedTriggerDataType} other
   * @returns {CompositeTypeDefinition_AssociatedTriggerDataType}
   */
  merge(other) {
    const copy = new CompositeTypeDefinition_AssociatedTriggerDataType(this);
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    return copy;
  }
}
CompositeTypeDefinition_AssociatedTriggerDataType.default = new CompositeTypeDefinition_AssociatedTriggerDataType();
class CompositeTypeDefinition_AssociatedTriggerDataType_Builder {
  constructor(value) {
    this._value = new CompositeTypeDefinition_AssociatedTriggerDataType(value);
  }
  build() {
    return new CompositeTypeDefinition_AssociatedTriggerDataType(this._value);
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
}
CompositeTypeDefinition_AssociatedTriggerDataType.Builder = CompositeTypeDefinition_AssociatedTriggerDataType_Builder;
class CompositeTypeDefinition_AssociatedTriggerDataType_WithParent {
  /**
   * @param {CompositeTypeDefinition_AssociatedTriggerDataType} value
   * @param {CompositeTypeDefinition_AssociatedTriggerDataType_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CompositeTypeDefinition_AssociatedTriggerDataType.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  update(current, parent) {
    const result = new CompositeTypeDefinition_AssociatedTriggerDataType_WithParent(current, parent);
    return result;
  }
}
CompositeTypeDefinition_AssociatedTriggerDataType_WithParent.default = new CompositeTypeDefinition_AssociatedTriggerDataType_WithParent(CompositeTypeDefinition_AssociatedTriggerDataType.default, null);
CompositeTypeDefinition_AssociatedTriggerDataType.WithParent = CompositeTypeDefinition_AssociatedTriggerDataType_WithParent;
class CompositeTypeDefinition_AssociatedTriggerDataType_Descriptor {
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 1,
        protoType: 14,
        protoName: "type",
        type: TypeDeclaration_TriggerDataType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.type,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CompositeTypeDefinition_AssociatedTriggerDataType.descriptor = new CompositeTypeDefinition_AssociatedTriggerDataType_Descriptor();
class CompositeTypeDefinition_MembersEntry {
  get descriptor() {
    return CompositeTypeDefinition_MembersEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CompositeTypeDefinition_MembersEntry) {
      return value;
    }
    return CompositeTypeDefinition_MembersEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new CompositeTypeDefinition_MembersEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = TypeDeclaration.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = TypeDeclaration.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {TypeDeclaration}
   */
  get value() {
    return this._hasValue ? this._value : TypeDeclaration.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CompositeTypeDefinition_MembersEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new CompositeTypeDefinition_MembersEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CompositeTypeDefinition_MembersEntry(this);
              copy._hasValue = true;
              copy._value = TypeDeclaration.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new CompositeTypeDefinition_MembersEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new CompositeTypeDefinition_MembersEntry(this);
            copy._hasValue = true;
            copy._value = TypeDeclaration.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new CompositeTypeDefinition_MembersEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CompositeTypeDefinition_MembersEntry} other
   * @returns {CompositeTypeDefinition_MembersEntry}
   */
  merge(other) {
    const copy = new CompositeTypeDefinition_MembersEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
CompositeTypeDefinition_MembersEntry.default = new CompositeTypeDefinition_MembersEntry();
class CompositeTypeDefinition_MembersEntry_Builder {
  constructor(value) {
    this._value = new CompositeTypeDefinition_MembersEntry(value);
  }
  build() {
    return new CompositeTypeDefinition_MembersEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
CompositeTypeDefinition_MembersEntry.Builder = CompositeTypeDefinition_MembersEntry_Builder;
class CompositeTypeDefinition_MembersEntry_WithParent {
  /**
   * @param {CompositeTypeDefinition_MembersEntry} value
   * @param {CompositeTypeDefinition_MembersEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CompositeTypeDefinition_MembersEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new TypeDeclaration.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new TypeDeclaration.WithParent(TypeDeclaration.default, this._parent.value) : TypeDeclaration.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new CompositeTypeDefinition_MembersEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
CompositeTypeDefinition_MembersEntry_WithParent.default = new CompositeTypeDefinition_MembersEntry_WithParent(CompositeTypeDefinition_MembersEntry.default, null);
CompositeTypeDefinition_MembersEntry.WithParent = CompositeTypeDefinition_MembersEntry_WithParent;
class CompositeTypeDefinition_MembersEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: TypeDeclaration,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CompositeTypeDefinition_MembersEntry.descriptor = new CompositeTypeDefinition_MembersEntry_Descriptor();
class CompositeTypeDefinition_AssociatedTriggerDataTypesEntry {
  get descriptor() {
    return CompositeTypeDefinition_AssociatedTriggerDataTypesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CompositeTypeDefinition_AssociatedTriggerDataTypesEntry) {
      return value;
    }
    return CompositeTypeDefinition_AssociatedTriggerDataTypesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = CompositeTypeDefinition_AssociatedTriggerDataType.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = CompositeTypeDefinition_AssociatedTriggerDataType.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {CompositeTypeDefinition_AssociatedTriggerDataType}
   */
  get value() {
    return this._hasValue ? this._value : CompositeTypeDefinition_AssociatedTriggerDataType.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry(this);
              copy._hasValue = true;
              copy._value = CompositeTypeDefinition_AssociatedTriggerDataType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry(this);
            copy._hasValue = true;
            copy._value = CompositeTypeDefinition_AssociatedTriggerDataType.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CompositeTypeDefinition_AssociatedTriggerDataTypesEntry} other
   * @returns {CompositeTypeDefinition_AssociatedTriggerDataTypesEntry}
   */
  merge(other) {
    const copy = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
CompositeTypeDefinition_AssociatedTriggerDataTypesEntry.default = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry();
class CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_Builder {
  constructor(value) {
    this._value = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry(value);
  }
  build() {
    return new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
CompositeTypeDefinition_AssociatedTriggerDataTypesEntry.Builder = CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_Builder;
class CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_WithParent {
  /**
   * @param {CompositeTypeDefinition_AssociatedTriggerDataTypesEntry} value
   * @param {CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CompositeTypeDefinition_AssociatedTriggerDataTypesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new CompositeTypeDefinition_AssociatedTriggerDataType.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new CompositeTypeDefinition_AssociatedTriggerDataType.WithParent(CompositeTypeDefinition_AssociatedTriggerDataType.default, this._parent.value) : CompositeTypeDefinition_AssociatedTriggerDataType.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_WithParent.default = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_WithParent(CompositeTypeDefinition_AssociatedTriggerDataTypesEntry.default, null);
CompositeTypeDefinition_AssociatedTriggerDataTypesEntry.WithParent = CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_WithParent;
class CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: CompositeTypeDefinition_AssociatedTriggerDataType,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CompositeTypeDefinition_AssociatedTriggerDataTypesEntry.descriptor = new CompositeTypeDefinition_AssociatedTriggerDataTypesEntry_Descriptor();
export class CompositeTypeDefinition {
  get descriptor() {
    return CompositeTypeDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._members = {};
    this._associatedTriggerDataTypes = {};
  }
  isEmpty() {
    if (Object.keys(this._members).length > 0) return false;
    if (Object.keys(this._associatedTriggerDataTypes).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CompositeTypeDefinition) {
      return value;
    }
    return CompositeTypeDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new CompositeTypeDefinition();
    result._members = JsonToMap(json.members, JsonToString, TypeDeclaration);
    result._associatedTriggerDataTypes = JsonToMap(json.associatedTriggerDataTypes, JsonToString, CompositeTypeDefinition_AssociatedTriggerDataType);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (Object.keys(this._members).length > 0) {
      result.members = MapToJson(this._members, JsonToString, TypeDeclaration);
    }
    if (Object.keys(this._associatedTriggerDataTypes).length > 0) {
      result.associatedTriggerDataTypes = MapToJson(this._associatedTriggerDataTypes, JsonToString, CompositeTypeDefinition_AssociatedTriggerDataType);
    }
    return result;
  }
  /**
   * @returns {Object<string, TypeDeclaration>}
   */
  get members() {
    return this._members;
  }
  setMembers(path, value) {
    return {type: 'SET', path: path.concat(['members']), value: MapToJson(value, JsonToString, TypeDeclaration)};
  }
  setMembersByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['members', key]), value: value.toJson()};
  }
  deleteMembers(path) {
    return {type: 'DELETE', path: path.concat(['members'])};
  }
  deleteMembersByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['members', key])};
  }
  /**
   * @returns {Object<string, CompositeTypeDefinition_AssociatedTriggerDataType>}
   */
  get associatedTriggerDataTypes() {
    return this._associatedTriggerDataTypes;
  }
  setAssociatedTriggerDataTypes(path, value) {
    return {type: 'SET', path: path.concat(['associatedTriggerDataTypes']), value: MapToJson(value, JsonToString, CompositeTypeDefinition_AssociatedTriggerDataType)};
  }
  setAssociatedTriggerDataTypesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['associatedTriggerDataTypes', key]), value: value.toJson()};
  }
  deleteAssociatedTriggerDataTypes(path) {
    return {type: 'DELETE', path: path.concat(['associatedTriggerDataTypes'])};
  }
  deleteAssociatedTriggerDataTypesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['associatedTriggerDataTypes', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "members": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._members).length === 0) {
                return this;
              }
              const copy = new CompositeTypeDefinition(this);
              copy._members = {};
              return copy;
            }
            case 'SET': {
              const copy = new CompositeTypeDefinition(this);
              copy._members = {};
              for (let key in value) {
                copy._members[key] = TypeDeclaration.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new CompositeTypeDefinition(this);
              copy._members = {...copy._members};
              copy._members[path[1]] = TypeDeclaration.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._members[path[1]]) {
                return this;
              }
              const copy = new CompositeTypeDefinition(this);
              copy._members = {...copy._members};
              delete copy._members[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._members[key] === undefined) {
            const copy = new CompositeTypeDefinition(this);
            copy._members = {...copy._members};
            copy._members[key] = TypeDeclaration.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._members[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CompositeTypeDefinition(this);
          copy._members = {...copy._members};
          copy._members[key] = newValue;
          return copy;
        }
      }
      case "associatedTriggerDataTypes": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._associatedTriggerDataTypes).length === 0) {
                return this;
              }
              const copy = new CompositeTypeDefinition(this);
              copy._associatedTriggerDataTypes = {};
              return copy;
            }
            case 'SET': {
              const copy = new CompositeTypeDefinition(this);
              copy._associatedTriggerDataTypes = {};
              for (let key in value) {
                copy._associatedTriggerDataTypes[key] = CompositeTypeDefinition_AssociatedTriggerDataType.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new CompositeTypeDefinition(this);
              copy._associatedTriggerDataTypes = {...copy._associatedTriggerDataTypes};
              copy._associatedTriggerDataTypes[path[1]] = CompositeTypeDefinition_AssociatedTriggerDataType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._associatedTriggerDataTypes[path[1]]) {
                return this;
              }
              const copy = new CompositeTypeDefinition(this);
              copy._associatedTriggerDataTypes = {...copy._associatedTriggerDataTypes};
              delete copy._associatedTriggerDataTypes[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._associatedTriggerDataTypes[key] === undefined) {
            const copy = new CompositeTypeDefinition(this);
            copy._associatedTriggerDataTypes = {...copy._associatedTriggerDataTypes};
            copy._associatedTriggerDataTypes[key] = CompositeTypeDefinition_AssociatedTriggerDataType.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._associatedTriggerDataTypes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CompositeTypeDefinition(this);
          copy._associatedTriggerDataTypes = {...copy._associatedTriggerDataTypes};
          copy._associatedTriggerDataTypes[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CompositeTypeDefinition} other
   * @returns {CompositeTypeDefinition}
   */
  merge(other) {
    const copy = new CompositeTypeDefinition(this);
    copy._members = {...this._members, ...other._members};
    copy._associatedTriggerDataTypes = {...this._associatedTriggerDataTypes, ...other._associatedTriggerDataTypes};
    return copy;
  }
}
CompositeTypeDefinition.default = new CompositeTypeDefinition();
CompositeTypeDefinition.AssociatedTriggerDataType = CompositeTypeDefinition_AssociatedTriggerDataType;
CompositeTypeDefinition.MembersEntry = CompositeTypeDefinition_MembersEntry;
CompositeTypeDefinition.AssociatedTriggerDataTypesEntry = CompositeTypeDefinition_AssociatedTriggerDataTypesEntry;
class CompositeTypeDefinition_Builder {
  constructor(value) {
    this._value = new CompositeTypeDefinition(value);
  }
  build() {
    return new CompositeTypeDefinition(this._value);
  }
  setMembers(key, value) {
    this._value._members = {...this._value._members, [key]: value};
    return this;
  }
  addAllMembers(values) {
    this._value._members = {...this._value._members, ...values};
    return this;
  }
  deleteMembers(key) {
    this._value._members = {...this._value._members};
    delete this._value._members[key];
    return this;
  }
  clearMembers() {
    this._value._members = {};
    return this;
  }
  setAssociatedTriggerDataTypes(key, value) {
    this._value._associatedTriggerDataTypes = {...this._value._associatedTriggerDataTypes, [key]: value};
    return this;
  }
  addAllAssociatedTriggerDataTypes(values) {
    this._value._associatedTriggerDataTypes = {...this._value._associatedTriggerDataTypes, ...values};
    return this;
  }
  deleteAssociatedTriggerDataTypes(key) {
    this._value._associatedTriggerDataTypes = {...this._value._associatedTriggerDataTypes};
    delete this._value._associatedTriggerDataTypes[key];
    return this;
  }
  clearAssociatedTriggerDataTypes() {
    this._value._associatedTriggerDataTypes = {};
    return this;
  }
}
CompositeTypeDefinition.Builder = CompositeTypeDefinition_Builder;
class CompositeTypeDefinition_WithParent {
  /**
   * @param {CompositeTypeDefinition} value
   * @param {CompositeTypeDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CompositeTypeDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfMembers() {
    if (!this._selfMembers) {
      this._selfMembers = {};
      for (let i in this._value.members) {
        this._selfMembers[i] = new TypeDeclaration.WithParent(this._value.members[i], null);
      }
    }
    return this._selfMembers;
  }
  get inherentMembers() {
    if (!this._inherentMembers) {
      this._inherentMembers = this._parent ? this._parent.members : {};
    }
    return this._inherentMembers;
  }
  get members() {
    if (!this._allMembers) {
      this._allMembers = this._parent ? {...this._parent.members, ...this.selfMembers} : this.selfMembers;
    }
    return this._allMembers;
  }
  get selfAssociatedTriggerDataTypes() {
    if (!this._selfAssociatedTriggerDataTypes) {
      this._selfAssociatedTriggerDataTypes = {};
      for (let i in this._value.associatedTriggerDataTypes) {
        this._selfAssociatedTriggerDataTypes[i] = new CompositeTypeDefinition_AssociatedTriggerDataType.WithParent(this._value.associatedTriggerDataTypes[i], null);
      }
    }
    return this._selfAssociatedTriggerDataTypes;
  }
  get inherentAssociatedTriggerDataTypes() {
    if (!this._inherentAssociatedTriggerDataTypes) {
      this._inherentAssociatedTriggerDataTypes = this._parent ? this._parent.associatedTriggerDataTypes : {};
    }
    return this._inherentAssociatedTriggerDataTypes;
  }
  get associatedTriggerDataTypes() {
    if (!this._allAssociatedTriggerDataTypes) {
      this._allAssociatedTriggerDataTypes = this._parent ? {...this._parent.associatedTriggerDataTypes, ...this.selfAssociatedTriggerDataTypes} : this.selfAssociatedTriggerDataTypes;
    }
    return this._allAssociatedTriggerDataTypes;
  }
  update(current, parent) {
    const result = new CompositeTypeDefinition_WithParent(current, parent);
    if (this._selfMembers) {
      if (this._value.members === current.members) {
        result._selfMembers = this._selfMembers;
      } else {
        result._selfMembers = {};
        for (let i in current.members) {
          const oldValue = this._value.members[i];
          if (oldValue) {
            const oldCache = this._selfMembers[i];
            if (oldValue === current.members[i]) {
              result._selfMembers[i] = oldCache;
            } else {
              result._selfMembers[i] = oldCache.update(current.members[i], null);
            }
          } else {
            result._selfMembers[i] = new TypeDeclaration.WithParent(current.members[i], null);
          }
        }
      }
    }
    if (this._selfAssociatedTriggerDataTypes) {
      if (this._value.associatedTriggerDataTypes === current.associatedTriggerDataTypes) {
        result._selfAssociatedTriggerDataTypes = this._selfAssociatedTriggerDataTypes;
      } else {
        result._selfAssociatedTriggerDataTypes = {};
        for (let i in current.associatedTriggerDataTypes) {
          const oldValue = this._value.associatedTriggerDataTypes[i];
          if (oldValue) {
            const oldCache = this._selfAssociatedTriggerDataTypes[i];
            if (oldValue === current.associatedTriggerDataTypes[i]) {
              result._selfAssociatedTriggerDataTypes[i] = oldCache;
            } else {
              result._selfAssociatedTriggerDataTypes[i] = oldCache.update(current.associatedTriggerDataTypes[i], null);
            }
          } else {
            result._selfAssociatedTriggerDataTypes[i] = new CompositeTypeDefinition_AssociatedTriggerDataType.WithParent(current.associatedTriggerDataTypes[i], null);
          }
        }
      }
    }
    return result;
  }
}
CompositeTypeDefinition_WithParent.default = new CompositeTypeDefinition_WithParent(CompositeTypeDefinition.default, null);
CompositeTypeDefinition.WithParent = CompositeTypeDefinition_WithParent;
class CompositeTypeDefinition_Descriptor {
  get members() {
    if (!this._members) {
      this._members = {
        name: "members",
        Name: "Members",
        number: 1,
        protoType: 11,
        protoName: "members",
        isMap: true,
        keyType: JsonToString,
        valueType: TypeDeclaration,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._members;
  }
  get associatedTriggerDataTypes() {
    if (!this._associatedTriggerDataTypes) {
      this._associatedTriggerDataTypes = {
        name: "associatedTriggerDataTypes",
        Name: "AssociatedTriggerDataTypes",
        number: 2,
        protoType: 11,
        protoName: "associated_trigger_data_types",
        isMap: true,
        keyType: JsonToString,
        valueType: CompositeTypeDefinition_AssociatedTriggerDataType,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._associatedTriggerDataTypes;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.members,
        this.associatedTriggerDataTypes,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CompositeTypeDefinition.descriptor = new CompositeTypeDefinition_Descriptor();
export class ValueType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "VOID": return 0;
        case "NUMBER": return 1;
        case "STRING": return 2;
        case "BOOLEAN": return 3;
        case "STRUCT": return 4;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ValueType.fromJson(value);
  }
  static fromReact(e) {
    return ValueType.fromJson(e);
  }
}
ValueType.VOID = 0;
ValueType.NUMBER = 1;
ValueType.STRING = 2;
ValueType.BOOLEAN = 3;
ValueType.STRUCT = 4;
ValueType.default = 0;
ValueType.values = {
  VOID: 0,
  NUMBER: 1,
  STRING: 2,
  BOOLEAN: 3,
  STRUCT: 4,
};
ValueType.names = {
  0: "VOID",
  1: "NUMBER",
  2: "STRING",
  3: "BOOLEAN",
  4: "STRUCT",
};
export class VariableType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "PRIMITIVE": return 0;
        case "ARRAY": return 1;
        case "TABLE": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return VariableType.fromJson(value);
  }
  static fromReact(e) {
    return VariableType.fromJson(e);
  }
}
VariableType.PRIMITIVE = 0;
VariableType.ARRAY = 1;
VariableType.TABLE = 2;
VariableType.default = 0;
VariableType.values = {
  PRIMITIVE: 0,
  ARRAY: 1,
  TABLE: 2,
};
VariableType.names = {
  0: "PRIMITIVE",
  1: "ARRAY",
  2: "TABLE",
};
export class FunctionSource {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "BUILD_IN": return 1;
        case "LOCAL": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return FunctionSource.fromJson(value);
  }
  static fromReact(e) {
    return FunctionSource.fromJson(e);
  }
}
FunctionSource.NONE = 0;
FunctionSource.BUILD_IN = 1;
FunctionSource.LOCAL = 2;
FunctionSource.default = 0;
FunctionSource.values = {
  NONE: 0,
  BUILD_IN: 1,
  LOCAL: 2,
};
FunctionSource.names = {
  0: "NONE",
  1: "BUILD_IN",
  2: "LOCAL",
};
